webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(333);
	
	__webpack_require__(337);
	
	var _compatibility = __webpack_require__(380);
	
	var _compatibility2 = _interopRequireDefault(_compatibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if ((0, _compatibility2.default)()) {
	  console.debug('Compatibility checking: SUCCESS');
	  __webpack_require__(458);
	  __webpack_require__(1269);
	} else {
	  console.error('Compatibility checking: FAILURE');
	  document.getElementById('noscript').style.display = 'block';
	  document.getElementById('app').style.display = 'none';
	}

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(338);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./default.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./default.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Old Style Bold;src:url(" + __webpack_require__(339) + ");src:url(" + __webpack_require__(339) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(340) + ") format(\"woff\"),url(" + __webpack_require__(341) + ") format(\"truetype\"),url(" + __webpack_require__(342) + "#RenaultLifeOldStyle-Bold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Regular;src:url(" + __webpack_require__(343) + ");src:url(" + __webpack_require__(343) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(344) + ") format(\"woff\"),url(" + __webpack_require__(345) + ") format(\"truetype\"),url(" + __webpack_require__(346) + "#RenaultLife) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Bold;src:url(" + __webpack_require__(347) + ");src:url(" + __webpack_require__(347) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(348) + ") format(\"woff\"),url(" + __webpack_require__(349) + ") format(\"truetype\"),url(" + __webpack_require__(350) + "#RenaultLife-Bold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Bold Italic;src:url(" + __webpack_require__(351) + ");src:url(" + __webpack_require__(351) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(352) + ") format(\"woff\"),url(" + __webpack_require__(353) + ") format(\"truetype\"),url(" + __webpack_require__(354) + "#RenaultLife-BoldItalic) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Italic;src:url(" + __webpack_require__(355) + ");src:url(" + __webpack_require__(355) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(356) + ") format(\"woff\"),url(" + __webpack_require__(357) + ") format(\"truetype\"),url(" + __webpack_require__(358) + "#RenaultLife-Italic) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Light;src:url(" + __webpack_require__(359) + ");src:url(" + __webpack_require__(359) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(360) + ") format(\"woff\"),url(" + __webpack_require__(361) + ") format(\"truetype\"),url(" + __webpack_require__(362) + "#RenaultLife-Light) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Renault Light Italic;src:url(" + __webpack_require__(363) + ");src:url(" + __webpack_require__(363) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(364) + ") format(\"woff\"),url(" + __webpack_require__(365) + ") format(\"truetype\"),url(" + __webpack_require__(366) + "#RenaultLife-LightItalic) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:icon-Renault-Global;src:url(" + __webpack_require__(367) + ");src:url(" + __webpack_require__(367) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(368) + ") format(\"woff\"),url(" + __webpack_require__(369) + ") format(\"truetype\"),url(" + __webpack_require__(370) + "#icomoon) format(\"svg\");font-weight:400;font-style:normal}*{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}body,html{-moz-text-size-adjust:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none}html{overflow-y:scroll;height:100%}body{font:100%/1.1 Arial,Helvetica,sans-serif;color:#000;background:#fff}a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,button,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,font,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,input,ins,kbd,label,legend,li,mark,menu,nav,object,ol,optgroup,output,p,pre,q,ruby,s,samp,section,select,small,span,strike,strong,sub,summary,sup,table,tbody,td,textarea,tfoot,th,thead,time,tr,tt,u,ul,var,video{border:0 none;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}ol,ul{list-style:none outside none;overflow:hidden}blockquote,q{quotes:none}table{width:100%;border-collapse:collapse;border-spacing:0}img{border:0}a{background-color:transparent}abbr[title]{border-bottom:1px dotted}svg:not(:root){overflow:hidden}p{line-height:1.3em}dfn{font-style:italic}mark{background:#ff0;color:#000}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}figure{margin:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,sans-serif;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit}button{overflow:visible;background-color:transparent;cursor:pointer}button,select{text-transform:none}button,input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],input[disabled]{cursor:default}input{line-height:normal}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:0 none;margin:0;padding:0}textarea{overflow:auto}html{font-size:1em;line-height:1.375em}body{font-family:Renault Regular,Helvetica,Arial,sans-serif;text-align:left;min-width:320px;font-size:.9em}a,a:link,a:visited{color:#000}a.button:focus:after,a.button:hover:after,button:focus:after,button:hover:after{text-decoration:underline;text-decoration:none}button:disabled{opacity:.5}a img{border:none}form{padding:2em 0}label{display:block;margin-bottom:.3em;color:#262625;text-align:left;padding:0 .2em}input[type=checkbox],input[type=date],input[type=email],input[type=number],input[type=password],input[type=text],select{border:1px solid #999}input[type=date],input[type=email],input[type=number],input[type=password],input[type=text],select{width:100%;padding:.7em;color:#262625}input[type=color]:focus,input[type=date]:focus,input[type=datetime-local]:focus,input[type=datetime]:focus,input[type=email]:focus,input[type=month]:focus,input[type=number]:focus,input[type=password]:focus,input[type=search]:focus,input[type=tel]:focus,input[type=text]:focus,input[type=time]:focus,input[type=url]:focus,input[type=week]:focus,textarea:focus{background-color:#fef7e5;border-color:#fc3;color:#262625}input[type=email]{box-shadow:none;-o-box-shadow:none;filter:progid:DXImageTransform.Microsoft.Shadow(enabled=false)}input[type=number]{-webkit-appearance:none;-moz-appearance:textfield;-ms-appearance:none;appearance:none;margin:0}strong{font-family:Renault Bold,Helvetica,Arial,sans-serif}.selectBloc{position:relative;height:3em;width:100%;overflow:hidden;background-color:#fff}.selectBloc:before{position:absolute;right:1px;z-index:1;content:\"\\E618\";font-family:icon-Renault-Global;speak:none;color:#fc0;font-size:1.5em;border-left:1px solid #544734;padding:.2em .5em;top:.2em;background-color:#fff;margin-top:2px}.selectBloc select{cursor:pointer;padding-right:4em;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;background-color:transparent;position:absolute;left:0;z-index:1;min-width:100%;height:100%;color:#262625}.selectBloc select::-ms-expand{display:none}section h1,section h2,section h3{text-align:center;font-weight:400}section h1{font-family:Renault Light,Helvetica,Arial,sans-serif}section h2,section h3{font-family:Renault Regular,Helvetica,Arial,sans-serif}[aria-hidden=true]{display:none}:focus{outline-color:#fc3}::-moz-selection{background:#fc3;text-shadow:none}::selection{background:#fc3;text-shadow:none}.desktop,.tablet{display:none}.mobile.tablet{display:block}.txtHidden{position:absolute;left:-99999px;top:0}.txtUppercase,.txtUppercase button{text-transform:uppercase}.txtTruncated{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.txtCenter{text-align:center}.floatedLeft{float:left}.floatedRight{float:right}.floatedLeft,.floatedRight{display:inline}.floatedLeft.desk,.floatedLeft.tab,.floatedRight.desk,.floatedRight.tab{float:none;display:block}.valignMiddle{vertical-align:middle}.limitContent,.limitContent2,.microContent,.miniContent,.pageContent{display:block;margin-left:auto;margin-right:auto;clear:both;overflow:visible}.pageContent{max-width:1500px}.limitContent{max-width:930px}.limitContent2{max-width:960px}.miniContent{max-width:570px}.microContent{max-width:400px}.classicArea{overflow:hidden;background-color:#e2e3e4}.classicArea:before{content:\"\";position:absolute;z-index:1;top:-10px;height:10px;left:0;display:block;width:100%;box-shadow:0 2px 5px 0 rgba(0,0,0,.22);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.22);-webkit-box-shadow:0 2px 7px 0 rgba(0,0,0,.22);-o-box-shadow:0 2px 5px 0 rgba(0,0,0,.22);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=5)}.paddingArea{padding-left:5%;padding-right:5%}.paddingLight{padding-left:1.1em;padding-right:1.1em}.separator{border-top:1px solid #9f907b}.buttonList{margin:1em 0;text-align:center}.buttonList li{display:inline-block;width:100%;margin:.7em 0;vertical-align:middle}.buttonList button,.buttonList li a.button,a.button.back,button[type=submit]{min-width:180px}.buttonList.reverseMobile{display:-ms-flexbox;display:flex;flex-direction:column-reverse;-moz-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-wrap:wrap;-moz-flex-wrap:wrap;-ms-flex-wrap:wrap;-webkit-flex-wrap:wrap}.buttonList.reverseMobile button[type=submit]{margin-top:0}.buttonList.reverseMobile button.cancel{margin-bottom:1em}a.button,button.button,button[type=submit],span.button{position:relative;width:100%;min-height:2.639em;display:block;font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase;padding:.75em 2.5em .7em;font-size:1em;text-align:center}a.button.back,a.button.next,span.button.back,span.button.next{padding:.7em 2em;display:block;margin:0}a.button.back{text-align:left}a.button.link{width:100%;border-top:2px solid #aaa}button.button.delete{display:block;padding:.7em 1em;margin:0 auto}a.button.back,a.button.back:focus,a.button.back:hover,a.button.back:link,a.button.back:visited,a.button.link,a.button.link:focus,a.button.link:hover,a.button.link:link,a.button.link:visited,a.button.more,a.button.more:focus,a.button.more:hover,a.button.more:link,a.button.more:visited,a.button.next,a.button.next:focus,a.button.next:hover,a.button.next:link,a.button.next:visited,button.button.collapseButton,button.button.collapseButton:focus,button.button.collapseButton:hover,button.button.delete,button.button.delete:focus,button.button.delete:hover{background-color:transparent}a.button.back:focus,a.button.back:hover,a.button.link:focus span,a.button.link:hover span,a.button.more:focus,a.button.more:hover,button.button.collapseButton:focus,button.button.collapseButton:hover,button.button.delete:focus span,button.button.delete:hover span{text-decoration:underline}a.button:after,button.button:after,button[type=submit]:after,span.button:after{position:absolute;right:.5em;content:\"\\E652\";font-family:icon-Renault-Global;speak:none;font-size:1em;font-weight:700}a.button.update:after{content:\"\\E651\"}a.button.show:after{content:\"\\2795\"}a.button.hide:after{content:\"\\2796\"}a.button.back:after,a.button.previous:after,span.button.back:after,span.button.previous:after{content:\"\\E685\";margin-left:0;left:.5em;right:auto;position:absolute}.button.cancel:after{position:absolute;right:.8em;content:\"\\E60E\";font-family:icon-Renault-Global;speak:none;font-size:.9em;font-weight:700}.button.cancel:focus:after,.button.cancel:hover:after{color:#fc3}.button.cancel:disabled:focus:after,.button.cancel:disabled:hover:after{color:#fff}a.button.link:after{color:#fc3;position:relative;right:inherit;margin-left:1em}button.button.delete:after{content:\"\\E674\";font-family:icon-Renault-Global;speak:none;color:#fc3;position:relative;right:inherit;font-size:1.5em;margin-left:.5em;font-weight:400;vertical-align:sub}a.button,a:link.button,a:visited.button,button.button,button[type=submit]{text-decoration:none;color:#000;background-color:#fc0}a:focus.button,a:hover.button,button.button:focus,button.button:hover,button[type=submit]:focus,button[type=submit]:hover{background-color:#ffde00}button.button:disabled:focus,button.button:disabled:hover,button[type=submit]:disabled:focus,button[type=submit]:disabled:hover{background-color:#fc0}a.button.dark,a:link.button.dark,a:visited.button.dark,button.cancel{color:#fff;background-color:#262625}a:focus.button.dark,a:hover.button.dark,button:focus.cancel,button:hover.cancel{background-color:#666}button:disabled:focus.cancel,button:disabled:hover.cancel{background-color:#262625}a.button.light,a:link.button.light,a:visited.button.light,button.light{background-color:#e2e3e4}a:focus.button.light,a:hover.button.light,button:focus.light,button:hover.light{background-color:#f6f6f6}button:disabled:focus.light,button:disabled:hover.light{background-color:#e2e3e4}button.button.collapseButton{padding:.75em 1em .7em}button.button.collapseButton:after{content:\"+\";font-family:Renault Regular,Helvetica,Arial,sans-serif;position:relative;right:inherit;display:inline-block;font-size:2.3em;margin-left:.3em;height:.6em;width:.6em;line-height:.45em;text-align:center;vertical-align:middle;color:#fc3}button.button.collapseButton:focus:after,button.button.collapseButton:hover:after{color:#000}.collapseBloc.active button.button.collapseButton:after{content:\"-\"}button.basket{position:absolute;right:0;bottom:0;background-color:#fff;width:2.5em;height:2.2em;font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase;-webkit-border-top-left-radius:.2em;-webkit-border-bottom-right-radius:.2em;-moz-border-radius-topleft:.2em;-moz-border-radius-bottomright:.2em;border-top-left-radius:.2em;border-bottom-right-radius:.2em;-o-box-shadow:inset 0 1px 1px 0 #656565;box-shadow:inset 0 1px 1px 0 #656565;filter:progid:DXImageTransform.Microsoft.Shadow(color=#656565,Direction=180,Strength=1)}button.basket:focus,button.basket:hover{background-color:#ffde00}button.basket.active{background-color:#38a104;color:#fff}button.basket.active:focus,button.basket.active:hover{background-color:#40b705}button.basket img{width:1.6em;height:auto;vertical-align:middle}p.buttonBloc{padding:0 1em}p.topBack{margin-top:1em;text-align:left;margin-bottom:-.5em}p.topBack a.button.back{display:inline-block;width:auto}p.topBack a.button.back,p.topBack a.button.back:link,p.topBack a.button.back:visited{background-color:#fc0}p.topBack a.button.back:focus,p.topBack a.button.back:hover{background-color:#ffde00;text-decoration:none}p.topBack a.button.back{min-width:100px;padding-right:1em}.radiusCircle{border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}img.sizeAjust{width:100%;height:auto}.card{background:#fff;-o-box-shadow:0 1px 1px 0 rgba(0,0,0,.4);box-shadow:0 1px 1px 0 rgba(0,0,0,.4);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=1);margin:1.875em 1px 0;padding:1em}.collapse{display:none}.collapseBloc.active>.collapse,.msgGood{display:block}.msgGood{position:relative;padding:1.5em 3em 1.5em 5em;color:#fff;text-align:center;width:120%;margin-left:-10%;font-size:.8em;background-color:#079201}.msgGood:before{content:\"\\E66E\";font-family:icon-Renault-Global;speak:none;font-size:1.3em;position:absolute;left:8%;top:1.1em}.dropDownMenu{position:relative;overflow:visible}.dropDownMenu ul{display:none;position:absolute;z-index:2}.dropDownMenu.floatedRight ul{right:0}.dropDownMenu.floatedRight ul li{text-align:right}.dropDownMenu ul li{white-space:nowrap}button.dropDown:after{content:\"\\E618\";font-family:icon-Renault-Global;speak:none;position:relative;right:inherit;top:inherit;display:inline-block;margin-left:.7em;vertical-align:middle;font-size:.7em}button.dropDown.active:after{content:\"\\E675\"}header{box-shadow:0 2px 5px 0 rgba(0,0,0,.22);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.22);-webkit-box-shadow:0 2px 7px 0 rgba(0,0,0,.22);-o-box-shadow:0 2px 5px 0 rgba(0,0,0,.22);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=5);background-color:#fff}header a,header a:link,header a:visited{text-decoration:none;color:#333}header a:focus,header a:hover,header button:focus,header button:hover{text-decoration:underline}a.skiplinks{display:block;margin-top:10px;text-align:center;padding:5px 12px;position:absolute;left:-99999px;top:0;z-index:101;width:100%;background-color:#fff}a.skiplinks:focus{left:0}a.skiplinks,a.skiplinks:link,a.skiplinks:visited{color:#666;text-decoration:none}button.hideMenu,button.showMenu{border:none;background-color:transparent}button.showMenu{width:4.6em;height:4.6em}button.hideMenu{width:4.3em;height:4.3em}button.hideMenu:before,button.showMenu:before{font-family:icon-Renault-Global;speak:none;color:#333}button.showMenu:before{content:\"\\E607\";font-size:2.5em}button.hideMenu:before{content:\"\\E60E\";font-size:1.5em}button.hideMenu{background-color:#fff;position:absolute;left:0;top:0;z-index:1}button.hideMenu:focus,button.hideMenu:hover,button.showMenu:focus,button.showMenu:hover{text-decoration:none}button.hideMenu:focus:before,button.hideMenu:hover:before,button.showMenu:focus:before,button.showMenu:hover:before{color:#ffde00}.navMask{overflow:hidden}.navMask:after{content:\"\";display:block;background:#000;bottom:0;left:0;opacity:.3;position:fixed;right:0;top:0;z-index:10}header div[role=navigation]{display:none}header div[role=navigation]>div{border-top:1px solid #5b5b5b}header div[role=navigation] a,header div[role=navigation] button{font-size:1.1em}header div[role=navigation].open{display:block;position:fixed;left:-100%;background-color:#fff;z-index:11;width:100%;padding-top:4.7em;margin-top:-1px}header div[role=navigation].open .floatedLeft,header div[role=navigation].open .floatedRight{display:block;float:none}header div[role=navigation] button.dropDown:after{position:absolute;right:1em;top:.8em;font-size:1.2em;display:block}header div[role=navigation] ul{overflow:visible}header div[role=navigation] .dropDownMenu ul{background-color:#ececec;min-width:15em;width:100%;position:relative}header div[role=navigation] .dropDownMenu ul li,header div[role=navigation] .dropDownMenu ul li:first-child{border-top:1px solid #ccc;padding:0}header div[role=navigation] .dropDownMenu ul li a{display:block}header div[role=navigation].open li{border-top:1px solid #ececec}header div[role=navigation].open button.dropDown,header div[role=navigation].open ul:first-child>li:first-child{border-top:none}header div[role=navigation].open .login{background-color:#ececec}header div[role=navigation] .search{font-size:1.1em;position:absolute;top:0;right:0;height:4.3em;padding-left:4.3em;width:100%;background-color:#333}header div[role=navigation] .search span{position:absolute;left:999999px}header div[role=navigation] .search form{padding:0;position:relative;overflow:hidden}header div[role=navigation] .search button{background-color:transparent;margin:0;min-height:auto;font-family:Renault Regular,Helvetica,Arial,sans-serif;text-transform:none;min-width:auto;position:absolute;right:0;top:0;padding:0;width:3.9em;height:3.9em;text-align:center}header div[role=navigation] .search button:after{content:\"\\E654\";position:relative;right:inherit;font-weight:400;color:#fc3;font-size:1.5em}header div[role=navigation] .search button:focus,header div[role=navigation] .search button:hover{text-decoration:none}header div[role=navigation] .search label{position:absolute;left:999999px;display:none}header div[role=navigation] .search input[type=text]{display:inline-block;border:none;background-color:transparent;font-size:1.1em;height:3.9em;color:#fff;padding:0 3.9em 0 1em}header div[role=navigation] a,header div[role=navigation] div button{display:block;width:100%;position:relative;padding:1em 2.5em 1em 1em;text-align:left}header div[role=navigation] a,header div[role=navigation] a:link,header div[role=navigation] a:visited{color:#000}header div[role=navigation] a:after{content:\"\\E652\";font-family:icon-Renault-Global;speak:none;font-size:1.2em;position:absolute;right:.95em;top:.8em}header div[role=navigation] a.user{text-transform:uppercase}header div[role=navigation] a.user img{width:2.2em;height:auto;margin-right:1em;float:left;margin-top:-.5em}header div[role=navigation] a.logout{border-top:1px solid #fff}header div[role=navigation] .login a:focus,header div[role=navigation] .login a:focus span.msgCount,header div[role=navigation] .login a:hover,header div[role=navigation] .login a:hover span.msgCount{text-decoration:none}header div[role=navigation] .login a:focus span,header div[role=navigation] .login a:hover span{text-decoration:underline}header div[role=navigation] a.msg:before{margin:0 .7em 0 .1em}.msg{position:relative}.msg:before{content:\"\\E61E\";font-family:icon-Renault-Global;speak:none;font-size:1.8em;vertical-align:middle}.msg span.msgCount{font-size:.7em;font-family:Renault Bold,Helvetica,Arial,sans-serif;position:absolute;display:block;top:1.6em;left:3.7em;padding:.2em .3em;background-color:#fc3;border-radius:1.3333333333em;line-height:1em}.titleLogo{overflow:hidden;position:relative}.titleLogo .logo{margin:1.1em 0}.titleLogo h1{font-weight:400;font-size:1.5em;text-align:center;position:absolute;z-index:0;width:50%;margin:1em 25% 0}.pageContent{position:relative;overflow:hidden;padding-bottom:2em}.pageContent.withNav{padding-top:2.5em}h2,h3{text-align:center;font-weight:400;font-family:Renault Light,Helvetica,Arial,sans-serif}h2{font-size:2.2em;padding:.7em}h3{font-size:.9em;margin-bottom:1em}h4{text-align:left;font-size:1.4em;margin:1em 0;font-weight:400;font-family:Renault Regular,Helvetica,Arial,sans-serif}.pageContent.withNav h2{padding:.5em}.pageContent.withNav section h3{margin:0;font-family:Renault Regular,Helvetica,Arial,sans-serif}.pageNavigation{position:absolute;top:0;left:0;z-index:1;width:100%;background-color:#262626;height:2.5em;line-height:2.5em;box-shadow:0 3px 5px rgba(0,0,0,.2);-moz-box-shadow:0 3px 5px rgba(0,0,0,.2);-webkit-box-shadow:0 3px 5px rgba(0,0,0,.2);-o-box-shadow:0 3px 5px rgba(0,0,0,.2);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=5)}.pageNavigation button.showMenu{text-align:left;color:#fff;height:100%;width:100%}.pageNavigation button.showMenu span{font-size:1.2em;font-family:Renault Bold,Helvetica,Arial,sans-serif;padding-left:.8em;padding-right:2em}.pageNavigation button.showMenu:before{content:\"\\E618\";font-family:icon-Renault-Global;speak:none;color:#fc3;position:absolute;right:12px;font-size:1rem}.pageNavigation nav{display:none}.pageNavigation nav li{position:relative;margin-right:2em;font-size:1.1em}.pageNavigation nav li.active:before{content:\"\";z-index:0;width:100%;position:absolute;border-bottom:3px solid #fc0;left:0;bottom:0}.pageNavigation nav a,.pageNavigation nav a:link,.pageNavigation nav a:visited{color:#fff;text-decoration:none}.pageNavigation nav a:focus,.pageNavigation nav a:hover{text-decoration:underline}.illustration{position:relative;overflow:hidden;border-bottom:1px solid #b4b5b6;margin-left:auto;margin-right:auto}.illustration:after{content:\"\";position:absolute;left:0;bottom:0;height:8px;width:100%;background:linear-gradient(180deg,transparent 0,rgba(61,61,61,.2));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#333d3d3d\",GradientType=0)}.illustration.large{position:relative;max-width:1500px}.illustration.large .popinChoice{margin:3% 0 25%}.illustration.large .limitContent{position:relative;margin-left:5%;margin-right:5%}.illustration img{width:100%;height:auto}.illustration aside{position:absolute;left:11%;top:4.5em}figure,figure.limitContent{overflow:hidden}figure{margin-top:40px;margin-bottom:2em;text-align:center}figure img.floatedLeft,figure img.floatedRight{max-width:400px}figure img.floatedLeft.desk,figure img.floatedLeft.tab,figure img.floatedRight.desk,figure img.floatedRight.tab{display:inline-block}figure figcaption{padding-top:1.5em}figure figcaption p{text-align:left}.popinChoice{background-color:#000;background-color:rgba(0,0,0,.8);color:#fff;padding:2em 1.5em 0;text-align:center}.popinChoice .buttonList{margin-left:0;margin-right:0}.popinChoice .buttonList a.button,.popinChoice .buttonList button{min-width:11.5em}.popinChoice h1{font-weight:400;font-size:1.5em}.popinChoice p{margin-top:1.2em;font-size:1em}form.separator{margin-top:2em;padding-top:2em}.formGroup{margin-top:2em}.formGroupLight,.formGroupMiddle{margin-top:1.5em}label.checkBox,label.radio{cursor:pointer}label.checkBox input[type=checkbox],label.radio input[type=radio]{position:absolute;left:-9000px}label.checkBox span,label.radio span{display:inline-block;position:relative;padding-left:1.35em}label.checkBox span:before,label.radio span:before{position:absolute;left:0;top:.2em;content:\"\";width:.7em;height:.7em;line-height:.8em;background-color:#fff;border:1px solid #999;display:inline-block;vertical-align:middle}label.radio span:before{border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}label.checkBox input[type=checkbox]:checked+span:before,label.checkBox input[type=checkbox]:focus+span:before,label.radio input[type=radio]:checked+span:before,label.radio input[type=radio]:focus+span:before{border-color:#fc3}label.radio input[type=radio]:checked+span:before{border-width:2px}label.checkBox input[type=checkbox]:checked+span:after,label.radio input[type=radio]:checked+span:after{content:\"\\E66E\";font-family:icon-Renault-Global;speak:none;color:#fc3;display:inline-block;position:absolute;left:.15em;top:.55em;font-size:.6em;font-weight:700}.toggle{align-items:center;border-radius:100px;display:flex;width:fit-content;margin-bottom:4px;margin-right:8px}.last .toggle{margin:0}.toggle__input{clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;width:1px;overflow:hidden;position:absolute;white-space:nowrap}.toggle-track{background:#666;border-radius:50px;cursor:pointer;display:flex;height:18px;width:30px;margin-right:4px;position:relative}.toggle-indicator{align-items:center;background:#e2e3e4;bottom:3px;display:flex;height:12px;width:12px;border-radius:6px;justify-content:center;left:2px;outline:2px solid transparent;position:absolute;transition:.2s}.toggle__input:checked+.toggle-track{background:#262625}.toggle__input:checked+.toggle-track .toggle-indicator{transform:translateX(12px);box-shadow:0 0 0 1px #e2e3e4;background:#e2e3e4}button[type=submit]{display:block;margin:2em auto}.buttonList button[type=submit]{margin:1em auto}input[type=date].errorField,input[type=email].errorField,input[type=number].errorField,input[type=password].errorField,input[type=text].errorField{border-color:#bd3632;background-color:#ebeae8;color:#bd3632}.errorMessageTop.active,input.errorField+.errorMessage{display:block}.errorMessageTop{display:none;position:relative;border:1px solid #bd3632;font-size:.9em;margin-bottom:1.5em;padding:1.5em 3em;text-align:center}.errorMessage{display:none;color:#bd3632;font-size:.8em;margin-top:.5em;text-align:left}.errorMessage:before,.errorMessageTop:before{content:\"\\E602\";font-family:icon-Renault-Global;speak:none}.errorMessage:before{display:inline-block;vertical-align:sub;font-size:1.3em;margin-right:.3em}.errorMessageTop:before{position:absolute;left:0;top:0;color:#bd3632;font-size:1.2em;margin:.3em .4em}p.emailSent{position:relative;font-size:.9em;text-align:left;border:1px solid #fc0;padding:1em 1em 1em 3em;line-height:1.2em;margin-bottom:1.5em}p.emailSent:before{position:absolute;left:.5em;content:\"\\E61E\";display:inline;font-size:1.5em;font-family:icon-Renault-Global;speak:none;color:#fc0}p.emailSent strong{font-weight:400;font-family:Renault Bold,Helvetica,Arial,sans-serif;display:block}aside.phoneTimes{font-size:.9em;text-align:center;background-color:#555;color:#fff;margin-top:2.5em;margin-bottom:2.5em;padding:1em 1em 1.8em}aside.phoneTimes h1,aside.phoneTimes span.phoneNumber{font-weight:400;font-family:Renault Light,Helvetica,Arial,sans-serif;font-size:1.5em;margin:.3em 0;line-height:1em}aside.phoneTimes p.availability{max-width:32em;margin:0 auto}aside.phoneTimes a,aside.phoneTimes span{display:block}aside.phoneTimes a{font-family:Renault Light,Helvetica,Arial,sans-serif;font-size:1.1em}aside.phoneTimes a,aside.phoneTimes a:link,aside.phoneTimes a:visited{color:#fff;text-decoration:underline}.stepBar{position:relative;text-align:center;counter-reset:section;width:100%;display:table;overflow:visible}.stepBar.card{padding:0;margin-top:3.5em}.stepBar li{position:relative;font-size:1.5em;text-align:center;font-family:Renault Light,Helvetica,Arial,sans-serif;display:table-cell;width:33.3%}.stepBar li.active{font-family:Renault Regular,Helvetica,Arial,sans-serif;position:static}.stepBar li a{border-bottom:3px solid #fff}.stepBar li.active a{border-bottom-color:#fc0;position:static}.stepBar li a{display:block}.stepBar li a:before{counter-increment:section;content:counter(section) \". \"}.stepBar li.finish a:after{content:\"\\E66E\";font-family:icon-Renault-Global;speak:none;color:#38a104;position:absolute;margin-left:.1em;bottom:.66em}.stepBar li span{display:none}.stepBar li.active a span{display:block;position:absolute;left:0;top:-1.5em;width:100%;text-align:center}.stepBar li a{position:relative;padding:.7em 0}.stepBar li a,.stepBar li a:link,.stepBar li a:visited{text-decoration:none}.stepBar li a:focus,.stepBar li a:hover{cursor:default}.stepBar li.finish a:focus,.stepBar li.finish a:hover{font-family:Renault Regular,Helvetica,Arial,sans-serif;cursor:pointer}.stepBar+.bottomButtonBar a.button,.stepBar+.bottomButtonBar span{padding-top:2em;padding-bottom:2em}.stepBar+.bottomButtonBar a.button:after,.stepBar+.bottomButtonBar span:after{right:1.2em}.stepBar+.bottomButtonBar a.button.back:after{left:1.2em}form.card.models{padding-left:0;padding-right:0}.models{text-align:center;margin-top:1em}.models ul{margin-top:2.5em;padding-bottom:2.5em}.models li{margin-top:1.5em;display:block}.models .modelType,.models li{position:relative;color:#262625}.models .modelType{display:inline-block;text-align:center;cursor:pointer;margin:0;padding:0 .2em}.models input[type=radio]:checked+.modelType,.models li .modelType:hover{font-family:Renault Bold,Helvetica,Arial,sans-serif;outline:none}.models .modelType>p{margin-top:.5em;padding:0 1em;max-width:25em}.models li .modelType:hover>p{font-family:Renault Regular,Helvetica,Arial,sans-serif}.models span.rlink{font-size:1.5em}.models span.direction{font-size:1.1em;display:block}.models img{width:215px;margin-top:1em;margin-bottom:2em;border:12px solid #fff;-o-box-shadow:0 8px 15px 0 #9b9b9b;box-shadow:0 8px 15px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=15)}.models input[type=radio]:checked+.modelType img,.models li .modelType:hover img{border-color:#fc0}.models .buttonList{padding:0 1em}.models button[type=submit]{min-width:280px;margin:0}.miniModel{position:relative;text-align:center}.miniModel span{position:absolute;top:0;display:block;width:100%;font-size:1.5em;text-transform:uppercase;font-family:Renault Light,Helvetica,Arial,sans-serif}.miniModel img{margin:2em 0 1em;width:115px;border:10px solid #fff;-o-box-shadow:0 4px 8px 0 #9b9b9b;box-shadow:0 4px 8px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=8)}.toolbox{margin-top:1em;text-align:center;margin-bottom:0}.toolbox figcaption{position:relative;font-family:Renault Bold,Helvetica,Arial,sans-serif;height:2.5em;line-height:2em;padding:0;text-align:left}.toolbox figcaption:before{position:absolute;top:-15px;left:1.5em;content:\"\";width:0;height:0;border-style:solid;border-width:0 15px 15px;border-color:transparent transparent #fff}p.toolboxText{text-align:justify;line-height:1.1em}p.toolboxDown{display:none;text-align:center}.toolboxDown a,.toolboxDown button{margin-top:1em;background-color:transparent;width:auto}.toolboxDown a,.toolboxDown a:link,.toolboxDown a:visited,.toolboxDown button{background-color:transparent}.toolboxDown a:focus,.toolboxDown a:hover,.toolboxDown button:focus,.toolboxDown button:hover{text-decoration:underline;background-color:transparent}.models input[type=radio]:checked+label .tootipBox button.open,.models li label:focus .tootipBox button.open{font-family:Renault Regular,Helvetica,Arial,sans-serif}.tootipBox{position:relative}.limitContent .card.models .tootipBox{width:auto;display:inline-block;margin-right:0}.tootipBox button.open{display:none;position:absolute;right:-2.5em;top:1.4em;margin-top:-.7em;z-index:2;height:1.35em;line-height:1em;width:1.35em;border:2px solid #fc0;color:#fc0;background-color:#fff}.limitContent .card.models .tootipBox button.open{right:-2em;top:50%}.tootipBox button.open:before{content:\"i\";font-family:Renault Bold,Helvetica,Arial,sans-serif;speak:none}.tootipBox button.open.active,.tootipBox button.open:focus,.tootipBox button.open:hover{background-color:#fc0;color:#fff;outline:none}.tooltipMessage.active{display:block}.tooltipMessage{display:none;position:absolute;left:0;top:0;z-index:3;background-color:#000;color:#fff;padding:1em;text-align:center;width:20em}.tooltipMessage.mobileShow{display:block;position:relative;background-color:transparent;color:#000;text-align:left;padding-left:0;padding-right:0;width:100%}.tooltipMessage:before{position:absolute;top:-15px;left:50%;margin-left:-15px;content:\"\";width:0;height:0;border-style:solid;border-width:0 15px 15px;border-color:transparent transparent #000}.tooltipMessage.mobileShow:before{display:none}.tooltipMessage h5{font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase;padding:.2em;font-size:1em}.tooltipMessage.mobileShow h5{display:none}.tooltipMessage button{position:absolute;right:0;top:0;height:2em;width:2em;margin:.3em}.tooltipMessage.mobileShow button{display:none}.tooltipMessage button:before{content:\"\\E60E\";font-size:1em;font-family:icon-Renault-Global;speak:none}.tooltipMessage button:focus:before,.tooltipMessage button:hover:before{color:#ffde00}.tooltipMessage button span{position:absolute;left:99999px}.tooltipMessage p{font-size:.8em;font-family:Renault Regular,Helvetica,Arial,sans-serif}.tooltipMessage.mobileShow p{font-size:1em;line-height:inherit}.profilNav{position:relative;overflow:hidden;padding-left:120px;min-height:6.875em}.profilNav img{position:absolute;left:1em;top:.5em;width:90px;height:auto}.profilNav h2{font-size:.9em;text-align:left;padding:0 0 0 .2em}.pageContent.withNav .profilNav h2{padding-bottom:0}.profilNav button{display:block}.profilNav .profil{font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase;padding:.3em 0 .7em;text-align:left}.profilNav .profil:after{content:\"\\E652\";font-family:icon-Renault-Global;speak:none;color:#fc3;vertical-align:middle;margin-left:.3em;font-weight:700;font-size:1.3em}.profilNav .profil:focus span,.profilNav .profil:hover span{text-decoration:underline}.profilNav .msg{border-top:1px solid #ececec;padding-top:.5em;width:100%;text-align:left}.profilNav .msg span.msgCount{top:.8em;left:2.4em}.slider{padding-right:2px}.slider .card{width:100%;position:relative;padding-left:0;padding-right:0}.slider .card.primary:before{position:absolute;top:-10px;margin-left:-10px;left:50%;content:\"\";width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent #fff}.slider .card.secondary{margin-bottom:2em}.slider .card .close{position:absolute;right:0;top:0;text-transform:uppercase;font-size:.8em;padding:1.3em}.slider .card .close:after{font-size:.7rem;content:\"\\E60E\";color:#fc3;margin-left:1em;display:inline-block;font-family:icon-Renault-Global;speak:none}.slider .card h2{font-size:1em;padding:0}.slider .card .contentTab h2{padding:1em 0}.slider .card .userName{font-family:Renault Light,Helvetica,Arial,sans-serif;font-size:2.5em;margin:0;padding:1em;text-align:center}.tabs{position:relative;text-align:center}.tabs .tabTitle{position:absolute;top:0;text-align:center;padding:0;margin:0;cursor:pointer}.tabs .tab1,.tabs .tab2{width:50%}.tabs .tab1{left:0;padding-left:1em}.tabs .tab2{right:0;padding-right:1em}.tabs .tabTitle span{display:block;padding:.7em .5em;background:#ececec;font-size:1.1em}.tabs .contentTab{display:none;background:#fff;padding:3em 0 1em}.pageContent.withNav section .tabs .contentTab>h3:first-child{margin-top:1em}.tabs [type=radio]:checked+.tabTitle span{background-color:#262625;color:#fff;text-decoration:underline;position:relative}.tabs [type=radio]:checked+.tabTitle span:before{position:absolute;bottom:-8px;margin-left:-13px;left:50%;content:\"\";width:0;height:0;border-style:solid;border-width:10px 13px 0;border-color:#262625 transparent transparent}.tabs [type=radio]:checked+.tabTitle+.contentTab{display:block}.tabs form{padding:0}.tabs form.edit,.tabs ul.cardList li button{border-bottom:1px solid #6c6c6c;position:relative}.tabs form.edit:not(.active) div.toggle:before,.tabs ul.cardList li button:before{font-family:icon-Renault-Global;speak:none;color:#fc3;position:absolute;cursor:pointer}.tabs form.edit:not(.active) div.toggle:before{content:\"\\E61B\";font-size:1.1em;right:1em;top:1.7em}.tabs ul.cardList li button:before{content:\"\\E674\";font-size:1.2em;right:.9em;top:1.6em}.tabs form.active .fieldsResult,.tabs form.active:before,.tabs form .buttonList,.tabs form .selectBloc,.tabs form input[type=date],.tabs form input[type=email],.tabs form input[type=number],.tabs form input[type=password],.tabs form input[type=text],.tabs input.errorField+.errorMessage{display:none}.tabs form label,.tabs ul.cardList li button{padding:1em 3em 1em 1.2em}.tabs form label{display:none;margin:0;cursor:pointer}.tabs form label:first-child,.tabs form label span{display:block}.tabs form label .fieldsResult{font-size:.9em;margin-top:.2em}.tabs form.active{padding:1em;background-color:#ececec;border-bottom:0}.tabs form.active .selectBloc,.tabs form.active input.errorField+.errorMessage,.tabs form.active input[type=date],.tabs form.active input[type=email],.tabs form.active input[type=number],.tabs form.active input[type=password],.tabs form.active input[type=text]{display:block}.tabs form.active .buttonList{display:table;width:100%}.tabs form.active label{display:block;margin-left:0;margin-bottom:.3em;padding:0 .2em;cursor:default}.tabs form.active label span{margin:.5em 0 0;padding:0}.tabs form.active label:first-child span{margin-top:0}.tabs .buttonList{margin:.5em 0 0}.tabs .buttonList button[type=submit]{margin:0}.tabs input.errorField[type=date],.tabs input.errorField[type=email],.tabs input.errorField[type=number],.tabs input.errorField[type=password],.tabs input.errorField[type=text]{background-color:#fff}.tabs h3{font-family:Renault Light,Helvetica,Arial,sans-serif;font-size:2em;margin:1em 0 0;padding:0 .5em}.tabs .whishlist{font-size:.9em;margin-top:.7em}.tabs ul.CheckboxList{margin:1.5em 0 0 1.5em}.tabs ul.CheckboxList li{font-size:.75em;margin-top:.5em}.tabs ul.CheckboxList label.checkBox span{padding-left:3em}.tabs ul.cardList,.tabs ul.CheckboxList+button{margin:1em 0}.tabs ul.cardList li button{display:block;width:100%;text-align:left}.tabs ul.cardList li button span{display:block;font-size:.75em;color:#999;margin-top:.2em}.myCar .carousel{padding:0 1em}.myCar .carousel>ul>li>img{max-width:660px;margin-bottom:1em}.myCar .carousel .indicators{position:relative;bottom:inherit}.myCar .carousel .controls{top:5em;margin-top:0}.myCar .carousel .controls button{padding:0}.myCar .carousel .carEditName.active>div{margin:1em}.myCar .carEditName{padding:0}.myCar .carEditName.active button.editBt,.myCar .carEditName.active span.carNumber{display:none}.myCar .carEditName.active>div{background-color:#ececec;margin:1em 2em;padding:0 1em}.myCar .carEditName.active h2>span{padding-top:1.15em;padding-bottom:.2em}.myCar .carEditName input[type=text]{display:none}.myCar .carEditName.active input[type=text]{display:block}.myCar .carEditName .buttonList{margin-top:.2em;margin-bottom:.2em;display:none}.myCar .carEditName.active .buttonList{display:table}.myCar h2{position:relative;font-size:1.4em;font-family:Renault Bold,Helvetica,Arial,sans-serif;padding:0}.myCar h2 .collapseBt,.myCar h2 a{display:block;width:100%;padding:1.5em 1em 1em}.myCar h2 .editBt:before{content:\"\\E61B\";font-family:icon-Renault-Global;speak:none;color:#fc3;font-size:.8em;padding-bottom:.1em;border-bottom:3px solid #fc3}.myCar h2 .collapseBt span{padding:0}.myCar h2>span{padding:1.5em 0 1em;display:inline-block}.myCar h2 .collapseBt:after{content:\"\\E64B\";font-family:icon-Renault-Global;speak:none;font-size:.5em;font-weight:700;margin-left:.5em;vertical-align:middle}.myCar h2 .collapseBt:focus:after,.myCar h2 .collapseBt:hover:after{color:#ffde00}.myCar h2 .carNumber{display:block;padding:0;position:absolute;width:100%;left:0;bottom:.5em;font-size:.6em;color:#999;font-family:Renault Light,Helvetica,Arial,sans-serif}.myCar.card{padding:0;margin-bottom:2em}.myCar.card.active h2 .collapseBt:after{content:\"\\E63B\"}.myCar h2 button span{text-decoration:underline}.myCar .collapse{overflow:hidden;max-width:660px;margin-left:auto;margin-right:auto;padding:0 1em;background:#000 url(" + __webpack_require__(371) + ") no-repeat top;background-size:100% auto}.myCar .addCar{margin:15% 0;max-width:400px;margin-left:auto;margin-right:auto;background-color:#fff;padding:2em 1em 0}.myCar .tootipBox{margin-right:2em}.myCar .tootipBox button.open{right:-2em}.myCar .buttonList button,.myCar .buttonList li a.button{min-width:170px}.myCar .buttonList button[type=submit]{margin-top:0}.myCar a.button{padding-left:1em;padding-right:1em}.myCar .popin button.button.delete{padding-left:0;padding-right:0}.myCar .idBox{margin-bottom:3em}.myCar .muidBox{margin-right:7em}.myCar .delete{margin-bottom:3em}.myCar .popin{max-width:400px;margin:1em auto 2em;padding:0 .9em}.myCar .popin.active{background-color:#eae9e7;border-radius:.5em;-webkit-border-radius:.5em;-moz-border-radius:.5em;-o-box-shadow:0 2px 1px 0 #9b9b9b;box-shadow:0 2px 1px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=1)}.myCar .popin .buttonList,.myCar .popin p{display:none}.myCar .popin.active .delete{margin-bottom:1em}.myCar .popin.active p{display:block;font-size:.95em;line-height:1.5em}.myCar .popin.active .buttonList{display:table;width:100%}.carousel{padding:0}.carousel>ul{text-align:center;position:relative;width:100%;height:100%}.carousel>ul.elements>li{display:none}.carousel>ul.elements>li.active{display:inline-block;width:100%;height:100%}.carousel>ul>li>img{width:100%;height:auto;vertical-align:bottom}.carousel .controls,.carousel .indicators{height:auto;position:absolute;width:100%;z-index:2}.carousel .indicators{bottom:2%}.carousel .controls{top:50%;margin-top:-4em}.carousel .controls li,.carousel .indicators li{display:inline-block}.carousel .indicators li button{padding:.1em}.carousel .indicators li button:before{content:\"\";display:inline-block;width:10px;height:10px;background-color:#cdcdcd;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}.carousel .indicators li.active button:before{background-color:#fc3}.carousel .controls{display:none}.carousel .controls .leftArrow{float:left}.carousel .controls .rightArrow{float:right}.carousel .controls button{height:64px;width:64px;overflow:hidden;background-repeat:no-repeat;background-color:transparent;background-position:0;background-size:200%}.carousel .controls .leftArrow button{background-image:url(" + __webpack_require__(372) + ")}.carousel .controls .rightArrow button{background-image:url(" + __webpack_require__(373) + ")}.carousel .controls button:focus,.carousel .controls button:hover{background-position:100%}.carousel .indicators button:focus:before,.carousel .indicators button:hover:before,.carousel .indicators li.active button:focus:before,.carousel .indicators li.active button:hover:before{background-color:#000}.carousel .popinChoice{position:absolute;left:0;top:0;max-width:27em;z-index:1}.limitContent .carousel .popinChoice{margin:3% 15% 11.3% 3%}.card.carousel{-o-box-shadow:0 4px 6px 0 rgba(0,0,0,.4);box-shadow:0 4px 6px 0 rgba(0,0,0,.4);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=6)}.carousel.apps{max-height:460px}.carousel.apps>ul>li>img{position:absolute;z-index:0;left:0}.updates{position:relative;display:table;width:100%;border-left:5px solid #fc3;border-right:5px solid #fc3;padding:6px 0}.updates>div{display:table-cell;text-align:center;vertical-align:middle;font-size:1em}.updates .carUp{font-size:1.1em}.carUp p{margin-top:.2em}.carUp .modele,.carUp .reference{text-transform:uppercase;line-height:1em}.carUp .modele{font-size:1.2em;margin-top:.2em}.carUp .reference{font-size:.8em;margin-bottom:.1em}.updates .countUp p{position:relative;display:inline-block;text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif;margin:.3em 1.5em 2em}.updates .countUp p .countNb{position:absolute;z-index:1;top:-.5em;right:-.8em;font-size:.8em;color:#fff;background-color:#000;display:inline-block;width:1.7em;height:1.7em;line-height:1.7em;-o-box-shadow:1px 1px 1px 0 #656565;box-shadow:1px 1px 1px 0 #656565;filter:progid:DXImageTransform.Microsoft.Shadow(color=#656565,Direction=134,Strength=1)}.updates .countUp p .countInfo{display:none}.updates .countUp p button{position:relative;display:block;width:3em;height:3em;background:#fc3 url(" + __webpack_require__(374) + ") no-repeat 50%;background-size:1.7em auto;border-radius:.7em;-webkit-border-radius:.7em;-moz-border-radius:.7em;-o-box-shadow:0 3px 1px 0 #656565;box-shadow:0 3px 1px 0 #656565;filter:progid:DXImageTransform.Microsoft.Shadow(color=#656565,Direction=180,Strength=1)}.updates .countUp p button:disabled{opacity:.5}.updates .countUp p button span{position:absolute;bottom:-3em;display:inline-block;text-transform:uppercase;font-size:.55em;width:8em;margin-left:-4em;line-height:1.1em}.updates .linkUp{display:none}.updates.active .linkUp{display:table-cell}.updates .linkUp{font-size:1em;position:fixed;left:0;top:0;width:100%;height:100%;z-index:10;background-color:#000;background-color:rgba(0,0,0,.3)}.updates .linkUp>div{position:absolute;left:0;bottom:0;width:100%;padding:.6em}.updates .linkUp p{padding:1em;margin:0 0 .4em;background-color:#fff;background-color:hsla(0,0%,100%,.95);-webkit-border-bottom-right-radius:.3em;-webkit-border-bottom-left-radius:.3em;-moz-border-radius-bottomright:.3em;-moz-border-radius-bottomleft:.3em;border-bottom-right-radius:.3em;border-bottom-left-radius:.3em}.updates .linkUp p:first-child{-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.updates .linkUp p.cancel,.updates .linkUp p:first-child{-webkit-border-top-right-radius:.3em;-webkit-border-top-left-radius:.3em;-moz-border-radius-topright:.3em;-moz-border-radius-topleft:.3em;border-top-right-radius:.3em;border-top-left-radius:.3em}.updates .linkUp p:first-child{margin-bottom:1px}.updates .linkUp a.button,.updates .linkUp button{display:block;width:100%;margin:0;padding:0;min-height:auto;background-color:transparent;text-transform:inherit;font-size:1.3em;font-family:Renault Regular,Helvetica,Arial,sans-serif}.updates .linkUp a.button:after,.updates .linkUp button:after{display:none}.updates .linkUp a,.updates .linkUp a:link,.updates .linkUp a:visited,.updates .linkUp button{color:#317eda;text-decoration:none}.updates .linkUp a:focus,.updates .linkUp a:hover,.updates .linkUp button:focus,.updates .linkUp button:hover{text-decoration:underline}.MenuAppCarto{text-align:center;width:120%;margin-left:-10%;font-size:.8em;padding:3em;font-family:Renault Bold,Helvetica,Arial,sans-serif;background-color:#ececec}.MenuAppCarto>button,.MenuAppCarto ul li{font-size:1.6em;text-transform:uppercase}.MenuAppCarto ul li{padding:.2em 0}.MenuAppCarto ul{text-align:center;margin-left:-15em;width:30em;left:50%;background-color:#ececec}.tabAppCarto>ul{text-align:center;white-space:nowrap;width:100%}.tabAppCarto>ul li{display:inline-block;position:relative;margin:0 1.5%;width:47%}.tabAppCarto>ul li a,.tabAppCarto>ul li a:link,.tabAppCarto>ul li a:visited{color:#aeaeaf}.tabAppCarto>ul li a{text-decoration:none}.tabAppCarto>ul li a:focus,.tabAppCarto>ul li a:hover,.tabAppCarto>ul li a[aria-selected=true],.tabAppCarto>ul li a[aria-selected=true]:link,.tabAppCarto>ul li a[aria-selected=true]:visited{color:#000}.tabAppCarto>ul li a[aria-selected=true]{font-family:Renault Bold,Helvetica,Arial,sans-serif}.tabAppCarto>ul li a:before{content:\"\";z-index:0;width:100%;position:absolute;border-bottom:3px solid #000;left:0;bottom:0}.tabAppCarto>ul li a[aria-selected=true]:before{border-bottom-color:#fc0}.tabAppCarto>ul li a{display:block;text-transform:uppercase;padding:.3em 1em;text-align:center;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-bottom:.3em}.tabAppCarto>ul li a[aria-selected=true]{text-overflow:inherit;padding:.3em 0}.tabClassic.card{padding:0;position:relative}.tabClassic>ul{overflow:visible}.tabClassic>ul>li{display:block}.tabClassic>ul>li>a{position:relative;display:block;text-align:center;font-size:1em;text-transform:uppercase;background-color:#262626;white-space:nowrap;padding:1.4em 1em;font-family:Renault Bold,Helvetica,Arial,sans-serif;overflow:visible;border-top:1px solid #fff;border-radius:.1em;-webkit-border-radius:.1em;-moz-border-radius:.1em}.tabClassic>ul>li:first-child>a{border-top:none}.tabClassic>ul>li>a,.tabClassic>ul>li>a:link,.tabClassic>ul>li>a:visited{color:#fff;text-decoration:none}.tabClassic>ul>li>a:focus,.tabClassic>ul>li>a:hover{text-decoration:underline}.tabClassic>ul>li>a[aria-selected=false]{display:none}.tabClassic>ul>li>a[aria-selected=true]:before{content:\"\";position:absolute;bottom:-8px;left:50%;margin-left:-9px;width:0;height:0;border-style:solid;border-width:8px 9px 0;border-color:#262626 transparent transparent}.tabClassic>ul>li>a[aria-selected=true] p:after{content:\"\\E618\";font-family:icon-Renault-Global;speak:none;margin-left:.7em;vertical-align:middle;font-size:.7em;display:inline-block}.tabClassic>ul>li>a p{text-decoration:none;text-overflow:ellipsis;overflow:hidden}.tabClassic>ul.open{position:relative;padding-top:2.8em;padding-bottom:1em;background-color:#262626}.tabClassic>ul.open>li>a[aria-selected=true]:before{display:none}.tabClassic>ul.open>li>a[aria-selected=true]{position:absolute;top:0;width:100%;padding-bottom:0}.tabClassic>ul.open>li>a[aria-selected=false]{display:block;padding:0 1em;border-top:none;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0}.choiceApp h2{margin-top:2em;font-size:1.3em}.choiceApp .tabClassic [role=tabpanel]{padding:2em 1em 1em;text-align:center}.filter button.dropDown{font-size:1.1em;display:block;margin:0 auto}.filter button.dropDown:after{color:#fc3}.filter.active button.dropDown:after{content:\"\\E675\"}.radioList{margin-top:1em;width:15em;text-align:left;margin-left:auto;margin-right:auto}.radioList li{display:inline-block;width:49%;margin-bottom:.5em}.radioList label.radio span{font-size:1.1em;font-family:Renault Light,Helvetica,Arial,sans-serif;padding-left:1.6em}.radioList label.radio span:before{top:0;width:1em;height:1em}.radioList label.radio input[type=radio]:checked+span:after{left:.45em;top:.45em;border-width:2px}.products{margin:1em 0}.products>ul{overflow:hidden;height:24.5em}.products>ul>li{position:relative;display:inline-block;vertical-align:top;width:115px;margin:8px 6px;border-radius:.2em;-webkit-border-radius:.2em;-moz-border-radius:.2em;-o-box-shadow:0 1px 1px 0 rgba(0,0,0,.4);box-shadow:0 1px 1px 0 rgba(0,0,0,.4);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=1)}.headband{display:none;text-transform:uppercase;left:-.35em;top:-.3em;width:5.5em;background:transparent url(" + __webpack_require__(375) + ") no-repeat 0 0;background-size:5em}.headband,.headband span{position:absolute;height:3.5em}.headband span{font-family:Renault Bold,Helvetica,Arial,sans-serif;font-size:.5em;left:-.3em;top:.8em;width:7em;transform:rotate(330deg);-webkit-transform:rotate(330deg);-moz-transform:rotate(330deg);-o-transform:rotate(330deg);writing-mode:lr-tb}.products>ul>li>img{width:100%;height:auto;vertical-align:top;-webkit-border-top-left-radius:.2em;-webkit-border-top-right-radius:.2em;-moz-border-radius-topleft:.2em;-moz-border-radius-topright:.2em;border-top-left-radius:.2em;border-top-right-radius:.2em}a.infosProd{display:block;position:relative;text-align:left;height:5em;padding:.3em .4em;background-color:#e2e3e5;text-decoration:none}a.infosProd:focus,a.infosProd:hover{background-color:#9a9a9a}a.infosProd .title{display:block;overflow:hidden;height:2.4em;text-transform:uppercase;font-size:.8em;font-family:Renault Bold,Helvetica,Arial,sans-serif}a.infosProd .price{margin-top:.1em}.price del,.price span{display:block}.price .crossout{font-size:.6em}.price .cost,.products button.cost{font-size:.7em;position:absolute;z-index:1;text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif;top:4.5em;left:.6em;padding:.3em .2em .3em 0;width:5.7em}.products button.cost{top:inherit;left:.5em;bottom:.6em;padding:.3em 1.3em .3em 0;background-color:#fff;-o-box-shadow:0 1px 1px 0 rgba(0,0,0,.4);box-shadow:0 1px 1px 0 rgba(0,0,0,.4);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=1);border-radius:.1em;-webkit-border-radius:.1em;-moz-border-radius:.1em;height:1.9em}.products button.cost:after{content:\"\";position:absolute;top:.6em;right:.4em;width:0;height:0;border-style:solid;border-width:6px 4px 0;border-color:#000 transparent transparent}.tooltipPrice{position:absolute;left:0;bottom:0;z-index:3}.tooltipCostChoice.active{display:block}.tooltipCostChoice{display:none;position:fixed;z-index:10;left:0;top:0;width:100%;height:100%;background-color:#000;background-color:rgba(0,0,0,.3);color:#fff;text-align:center;padding:.6em}.tooltipCostChoice>div{position:relative;height:100%}.tooltipCostChoice>div>ul{overflow:hidden;position:absolute;bottom:4.2em;left:0;width:100%}.tooltipCostChoice>div>ul>li:first-child label:after,.tooltipCostChoice>div>ul>li:first-child label:before{display:none;position:absolute;content:\"\";width:0;height:0;border-style:solid}.tooltipCostChoice>div>ul>li:first-child label:after{top:-15px;left:30px;border-width:0 15px 15px;border-color:transparent transparent #e2e3e5}.tooltipCostChoice>div>ul>li:first-child label:before{top:-16px;left:29px;border-width:0 16px 16px;border-color:transparent transparent #9f9f9f}.tooltipCostChoice>div>ul>li{position:relative;display:block;margin-bottom:1px;width:100%;background-color:#fff;background-color:hsla(0,0%,100%,.95)}.tooltipCostChoice>div>ul>li:first-child{border-top:none}.tooltipCostChoice>div>ul>li:first-child,.tooltipCostChoice>div>ul>li:first-child label{-webkit-border-top-right-radius:.3em;-webkit-border-top-left-radius:.3em;-moz-border-radius-topright:.3em;-moz-border-radius-topleft:.3em;border-top-right-radius:.3em;border-top-left-radius:.3em}.tooltipCostChoice>div>ul>li:last-child,.tooltipCostChoice>div>ul>li:last-child label{-webkit-border-bottom-right-radius:.3em;-webkit-border-bottom-left-radius:.3em;-moz-border-radius-bottomright:.3em;-moz-border-radius-bottomleft:.3em;border-bottom-right-radius:.3em;border-bottom-left-radius:.3em}.tooltipCostChoice input[type=radio]{position:absolute;right:0;visibility:hidden}.tooltipCostChoice input[type=radio]:checked+label{background-color:#262626;color:#fff;text-decoration:none}.tooltipCostChoice label{cursor:pointer;margin:0;padding:.7em;font-size:1.3em;font-family:Renault Regular,Helvetica,Arial,sans-serif;text-align:center;color:#317eda}.tooltipCostChoice label:focus,.tooltipCostChoice label:hover{text-decoration:underline}.tooltipCostChoice button[type=submit]{position:absolute;bottom:.4em;margin:0;z-index:1;min-width:auto;padding:.5em;border-radius:.3em}.tooltipCostChoice button[type=submit]:after{display:none}.tooltipCostChoice button[type=submit] img{width:2.8em;height:auto;vertical-align:middle}.rlinkManage h2{font-size:1.5em;margin-top:.5em;padding-bottom:0}.rlinkManage .filter{border-bottom:2px solid #aaa;padding:1em 0}.historical{padding-bottom:1em}.historical>ul>li{text-align:left;border-top:2px solid #aaa;padding:.5em .5em 1.5em}.historical>ul>li:first-child{border-top:none}.historical>ul>li>ul{font-size:0}.historical>ul>li>ul>li{font-size:1rem;display:inline-block;vertical-align:middle}.historical .appName{width:60%}.historical .appName img{width:35px;height:auto;vertical-align:top}.historical .appName>div{padding-top:.3em;display:inline-block;font-size:.9em;width:70%}.historical a.download{display:block;margin-top:.3em;padding-left:.15em}.historical a.download,.historical a.download:link,.historical a.download:visited{text-decoration:none}.historical a.download:focus,.historical a.download:hover{text-decoration:underline}.historical a.download:after{content:url(" + __webpack_require__(376) + ");display:inline-block;vertical-align:middle;margin-left:.8em}.historical .name{display:block;margin-top:.2em;font-size:.8em;text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif}.historical button.name{margin:0;padding:0;min-height:auto;width:auto}.historical .appName>div button{display:block;text-align:left;margin-top:.2em}.historical .appName>div>p{padding-left:.15em}.historical .appName>div button:focus.dropDown,.historical .appName>div button:hover.dropDown{text-decoration:underline}.historical .appType{width:40%;vertical-align:top;padding-top:.25em}.historical .appType p{display:block;text-align:center;font-size:.75em;line-height:1.1em}.historical .appType p span{display:block;margin:.1em 0}.historical .stateOk{color:#38a104}.historical .stateKo{color:#c42720}.historical .stateKo:before,.historical .stateOk:before{content:\"\";display:inline-block;margin-right:.5em;width:.8em;height:.8em;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}.historical .stateOk:before{background-color:#38a104}.historical .stateKo:before{background-color:#c42720}.historical .buttons{display:block;text-align:center;padding-top:1em}.historical .buttons a,.historical .buttons button{font-size:.8em;min-width:13em;width:auto;display:inline-block}.historical.upd .appType p span:first-child,.historical.upd .name{color:#c42720}.historical.upd a.button.link:after{color:#000}.historical.upd .updateAll{border-top:2px solid #aaa}.historical.upd .updateAll button,.historical.upd a.button.link{border-top:none}.historical.upd .updateAll{padding:1em;text-align:center}.historical.upd .updateAll a.button:after{top:50%;margin-top:-.75em}.tabTransfert h3{font-size:.9em;margin-top:2em;padding:1em}.tabTransfert h3 span{display:block;font-size:1.6em;margin-top:.5em}.tabTransfert form{padding-top:0;text-align:center}.tabTransfert form div.choose{display:block;width:11em;margin:0 auto 1em}.tabTransfert label{text-align:left;font-size:.9em}.tabTransfert .selectBloc:before{color:#000;border-left:none;top:.8em;right:1.5em;padding:0;font-size:1.2em}.tabTransfert select{font-family:Renault Bold,Helvetica,Arial,sans-serif;padding:0 .7em 0 0;border:none;font-size:1.5em}.tabTransfert .button.more:after{color:#fc3}.tabTransfert button[type=submit]{margin-bottom:0}.packs{margin-top:2em}.packs button.dropDown{text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif}.packs button.dropDown:after{color:#fc3;font-size:1em;vertical-align:inherit}.packs.active button.dropDown:after{content:\"\\E675\"}.packs .collapse{width:80%;margin:1.5em auto 0}.packs ul{text-align:center;overflow:hidden;max-height:6.5em;font-size:.55em}.packs ul li{display:inline-block;vertical-align:top;margin:.5em;width:35px;text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif}.packs ul li span{display:block;width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.packs ul li img{width:100%;height:auto;margin-bottom:.2em;border-radius:.2em;-webkit-border-radius:.2em;-moz-border-radius:.2em;-o-box-shadow:0 1px 1px 0 rgba(0,0,0,.4);box-shadow:0 1px 1px 0 rgba(0,0,0,.4);filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=1)}.userGuides{text-align:center}.userGuides ul{margin:1em 0 2em}.userGuides ul li{display:none;text-align:left;vertical-align:top}.userGuides ul li.video3{display:inline-block;width:100%}.userGuides .video{text-align:center}.userGuides .video img{width:100%;height:auto}.userGuides h3{margin:0;text-align:left;font-size:1.1em;font-family:Renault Regular,Helvetica,Arial,sans-serif;padding:.7em 1em}.userGuides p{font-size:.8em;padding:0 1.5em}.userGuides a.button.more{display:inline-block;width:auto;padding:.75em 2.5em .7em 2em;font-size:.9em}.datasheet{text-align:center}.datasheet .carUp,.sheet{margin-bottom:2em;float:none;display:block;width:100%}.datasheet .carUp{margin-left:0;border-right:7px solid #fc3;font-size:1.1em}.sheet{position:relative;padding:1.2em 1em 5em;text-align:left}.sheet h2{font-size:1.5em;padding:.5em 0;clear:both}.sheet>dl{font-size:.9em}.sheet dl.from{padding-top:1.1em}.sheet dl.from>dt{display:none}.sheet>dl>dt{float:left;margin-right:1.2em}.sheet>dl>dt img{width:115px;height:auto;margin-bottom:1em}.sheet>dl>dd>span{font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase}.sheet dl.price{padding-top:0;margin-top:.2em;height:auto}.sheet dl.price.from dt{display:block;font-size:.85em;margin-top:2em}.sheet dl.price.from.noChoice dd.time,.sheet dl.price.from.noChoice dt{display:none}.sheet dl.price.from.noChoice dd{margin-top:0}.sheet dl.price dt{display:none}.sheet dl.price dd{font-size:1.1em;margin-top:-4.8em}.sheet>dl>dd>dl>dd{font-family:Renault Bold,Helvetica,Arial,sans-serif}.sheet dl.left dd,.sheet dl.left dt,.sheet dl.right dd,.sheet dl.right dt{display:inline;font-size:.85em;float:left;margin-bottom:.4em}.sheet dl.left dt,.sheet dl.right dt{clear:left;margin-right:.2em}.sheet dl.price dd.time{display:inline-block;margin-top:.4em;right:2em;top:0}.sheet dl.price dd.time button.open{position:relative;border-radius:.2em;-webkit-border-radius:.2em;-moz-border-radius:.2em;background-color:#e2e3e5;box-shadow:0 1px 1px 0 rgba(0,0,0,.4);padding:.2em 2em .2em .5em;font-size:.85em;height:2.5em}.sheet dl.price dd.time button.open span{padding:.3em .8em .3em 0;border-right:1px solid #999}.sheet dl.price dd.time button.open:after{content:\"\";position:absolute;top:1em;right:.7em;width:0;height:0;border-style:solid;border-width:7px 5px 0;border-color:#000 transparent transparent}.sheet dl.price dd.time button.open:focus,.sheet dl.price dd.time button.open:hover{background-color:#9a9a9a}.sheet dl.price dd.time button.open:focus span,.sheet dl.price dd.time button.open:hover span{border-right-color:#ccc}.sheet p.details{text-align:left;font-size:1em}.sheet .collapseBloc{text-align:center;margin:.5em 0}.sheet button.collapseButton{font-size:.9em}.sheet button.basket{border-bottom-right-radius:0;width:auto;height:auto;background-color:#e2e3e4;padding:.5em .8em .5em .3em}.sheet button.basket:focus,.sheet button.basket:hover{background-color:#ffde00}.sheet button.basket.active{background-color:#38a104}.sheet button.basket.active:focus,.sheet button.basket.active:hover{background-color:#40b705}.sheet button.basket img{width:2.5em;height:auto;margin-right:.4em}.datasheet .description{margin-top:0;clear:both;padding:0 1em 3em}.datasheet .description>p{text-align:left;width:278px;margin:1em auto 0}.datasheet .carousel{position:relative;padding-bottom:3em}.datasheet .carousel>ul{overflow:hidden;max-height:23.5em}.datasheet .carousel ul.elements>li{margin:.3em;display:inline-block}.datasheet .carousel>ul>li>img{width:17.3em}.datasheet .carousel ul.elements>li.active{display:inline-block}.datasheet .carousel ul.controls{display:none}.datasheet .carousel .indicators{width:100%;height:auto}.tabChapt{text-align:center}.tabChapt li{position:relative;display:block;padding-bottom:.8em}.tabChapt li:first-child{margin-left:0}.tabChapt li:last-child{margin-right:0}.tabChapt li a{font-family:Renault Bold,Helvetica,Arial,sans-serif;font-size:.8em;text-transform:uppercase;padding:.625em 0 .375em;display:block;position:relative;border-bottom:1px solid #ccc}.tabChapt li a,.tabChapt li a:link,.tabChapt li a:visited{text-decoration:none}.tabChapt li a:after{content:\"\";position:absolute;bottom:-8px;left:50%;margin-left:-5px;width:0;height:0;border-style:solid;border-width:8px 5px 0;border-color:#ccc transparent transparent}.tabChapt li a:focus,.tabChapt li a:hover{color:#ffde00;border-color:#ffde00}.tabChapt li a:focus:after,.tabChapt li a:hover:after{border-color:#ffde00 transparent transparent}.infoPage>section>p{white-space:pre-line}.infoPage h3{padding-top:1.5em;font-size:2em}.infoPage h3 span{font-family:Renault Bold,Helvetica,Arial,sans-serif;display:block;font-size:.6em;margin-bottom:1.5em}.infoPage p{margin-top:1em}.infoPage hr{border-color:#fc3;margin:2.8em auto 0;width:90%;display:block;height:1px;border:0;border-top:2px solid #fc3;padding:0;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box}.tutorial{background-color:#e2e3e5}.tutorial .pageContent{text-align:center;padding:2em 0;font-size:1em}.tutorial h1{font-size:1.2em;font-family:Renault Light,Helvetica,Arial,sans-serif;padding:0 3em}.tutorial .carousel{position:relative;margin:1em 0;padding-bottom:3em}.tutorial h2{position:relative;font-size:1.4em;font-family:Renault Regular,Helvetica,Arial,sans-serif;text-transform:uppercase;height:3em}.tutorial h2 span{position:absolute;display:inline-block;background-color:#e2e3e5;width:7em;top:1em;left:50%;margin-left:-3.5em}.tutorial h2:before{content:\"\";border-top:1px solid #000;width:100%;height:5px;position:absolute;left:0;top:50%;z-index:0}.tutorial p{padding:0 1em;font-size:1.05em}.tutorial .pageContent>a.button{display:inline-block;width:auto;margin-bottom:.5em}.bottomClose{background-color:#666;position:fixed;bottom:0;left:0;width:100%;z-index:3;color:#fff;font-size:1.1em;text-transform:uppercase;padding:.6em}.bottomClose:focus,.bottomClose:hover{color:#ffde00}.bottomClose:focus:before,.bottomClose:hover:before{border-color:#ffde00}.bottomClose:before{content:\"\\E60E\";font-family:icon-Renault-Global;speak:none;font-size:1em;padding:.5em;border:2px solid #fff;vertical-align:middle;display:inline-block;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;margin-right:.5em}footer.pageContent{padding-bottom:0}.footerServices{background-color:#333}.footerServices nav{overflow:hidden}.footerServices nav dl{width:100%;float:left;border-top:1px solid #696969;padding-bottom:.5em;cursor:pointer}.footerServices nav dl:first-child{border-top:none}.footerServices nav dd,.footerServices nav dt{font-family:Renault Bold,Helvetica,Arial,sans-serif}.footerServices nav dt{position:relative;color:#fff;font-size:1.3em;display:block;padding:1em 3em 1em .5em}.footerServices nav dl dt:after{content:\"\\E618\";font-family:icon-Renault-Global;speak:none;color:#fc3;font-size:1em;position:absolute;top:1em;right:1em}.footerServices nav dl dt.active:after{content:\"\\E675\"}.footerServices nav dl dt:focus:after,.footerServices nav dl dt:hover:after{color:#fff}.footerServices nav dd{display:none;font-size:.9em;margin-bottom:.6em;padding:0 1em 0 2em;cursor:pointer}.footerServices a,.footerServices a:link,.footerServices a:visited{color:#ccc;text-decoration:none}.footerServices a:focus,.footerServices a:hover{text-decoration:underline}.footerServices .media{padding-left:2em;cursor:default;position:relative;overflow:hidden}.footerServices .media dt{padding-left:0;margin-left:-1em}.footerServices .media dt:after{display:none}.footerServices .media dd{display:inline-block;margin-right:.5em;vertical-align:top;font-size:1.2em;padding:0}.footerServices .media a{display:inline-block}.footerServices .media a:before{font-size:1.5em;font-family:icon-Renault-Global;speak:none;color:#fff}.footerServices .media a:focus:before,.footerServices .media a:hover:before{color:#ccc}.footerServices .media a.facebook:before{content:\"\\E65B\"}.footerServices .media a.twitter:before{content:\"\\E667\"}.footerServices .media a.google:before{content:\"\\E65D\"}.footerServices .media a.youtube:before{content:\"\\E66B\"}.footerServices .media a,.footerServices .media a:link,.footerServices .media a:visited{color:#333}.footerServices .media span{position:absolute;left:999999px}.footerServices p.asterisk{display:none;text-align:center;color:#ccc;padding:1em 1em 2em;font-style:italic;font-size:1.1em}.footerLegal{background-color:#000;min-height:3.5em}.infoCompany{overflow:hidden;padding:.5em 0}.infoCompany ul:first-child{margin-bottom:0}.infoCompany li{display:block;width:100%;font-size:.9em}.infoCompany li a,.infoCompany li span{display:block;width:100%;padding:.7em 1em}.infoCompany li a,.infoCompany li a:link,.infoCompany li a:visited{color:#fff;text-decoration:none}.infoCompany li a:focus,.infoCompany li a:hover{text-decoration:underline}.infoCompany li span{color:#c4c6cd}.bottomButtonBar{background-color:#333;position:fixed;bottom:0;left:0;width:100%;z-index:3;font-size:0;line-height:inherit;-o-box-shadow:0 -3px 3px 0 #9b9b9b;box-shadow:0 -3px 3px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=90,Strength=3)}.bottomButtonBar a.button,.bottomButtonBar span.button{display:inline-block;width:50%;font-size:.8rem;text-align:center;min-height:inherit;padding:1em 2em;min-width:inherit}.bottomButtonBar a.button.left,.bottomButtonBar span.button.left{float:left;text-align:left;padding-left:3em;padding-right:1em}.bottomButtonBar a.button.right,.bottomButtonBar span.button.right{float:right;text-align:right;padding-right:3em;padding-left:1em}.bottomButtonBar span.button{opacity:.5}.bottomButtonBar a.button,.bottomButtonBar a:link.button,.bottomButtonBar a:visited.button,.bottomButtonBar span.button{color:#fff}.bottomButtonBar a:focus.button,.bottomButtonBar a:hover.button{color:#ffde00;text-decoration:none}.infoCookies{position:fixed;left:0;top:6.2em;width:100%;background-color:#fc3;padding:.6em;font-size:.75em;z-index:4}.infoCookies p:first-child{font-family:Renault Bold,Helvetica,Arial,sans-serif;font-size:1.2em}.infoCookies ul{position:absolute;right:0;top:0;padding:.6em}.infoCookies ul li{display:inline-block;border-left:1px solid #000;padding-left:.5em}.infoCookies ul li:first-child{padding-right:.5em;border-left:none}.infoCookies .closePopin:focus,.infoCookies .closePopin:hover{text-decoration:underline}.infoCookies .closePopin:after{font-size:.6rem;content:\"\\E60E\";margin-left:.5em;display:inline-block;font-family:icon-Renault-Global;speak:none;font-weight:700}.infoCookies .toggles{float:left}.cookie-choice{float:none}.cookie-choice:last-of-type{margin:0}.infoCookies .buttons{position:absolute;float:right;bottom:0;right:0;margin:12px}.infoCookies .buttons button{display:inline-block;width:auto}.infoDocument{position:fixed;left:50%;top:40%;min-width:700px;margin-left:-350px;background-color:#fff;padding:2em;padding-bottom:0;font-size:.9em;z-index:4}.infoDocument h3{font-weight:700}.info p:first-child{font-family:Renault Bold,Helvetica,Arial,sans-serif;font-size:1.2em}.infoDocument ul{position:relative;left:50%;width:500px;margin-left:-250px;top:0;padding:.6em}.infoDocument ul li{display:inline-block;padding-left:.5em;width:170px}.infoDocument ul li:first-child{padding-right:.5em;border-left:none}.infoDocument .closePopin:focus,.infoDocument .closePopin:hover{text-decoration:underline}.infoDocument .closePopin:after{font-size:.6rem;content:\"\\E60E\";margin-left:.5em;display:inline-block;font-family:icon-Renault-Global;speak:none;font-weight:700}.infoDocument table{margin-top:1.5em}.infoDocument table tr{border-bottom:1px solid #e2e3e4}.infoDocument table th{font-weight:700;vertical-align:top;text-align:left;padding:.5em 0 1em .5em}.infoDocument table td{padding:.5em 0;vertical-align:middle}.updatePage{counter-reset:section}.updatePage ul{list-style:none;display:-ms-flexbox;display:flex;flex-flow:row wrap;justify-content:center;-webkit-justify-content:center;margin-left:-2em;margin-top:-3em}.updatePage ul li{margin-top:3em;width:293px;margin-left:1.7em}.updatePage ul li img{width:100%;height:auto;max-width:293px}.updatePage h2{font-size:1.7em;margin:.5em 0}.updatePage h2,.updatePage h3{font-family:Renault Regular,Helvetica,Arial,sans-serif}.updatePage h3{font-size:1.1em;text-align:left;padding:.5em .7em;margin-bottom:0;margin-top:0}.updatePage ul li h3:after{counter-increment:section;content:counter(section) \" \"}.updatePage p.topBack{font-size:1em}.updatePage p{padding:0 .7em}.updatePage .buttonList{margin-top:2.5em}.updatePage .buttonList a.link{border-top:none}.updatePage .buttonList a{width:auto;min-width:250px;margin-top:.5em}.paypage h2{display:none;font-family:Renault Regular,Helvetica,Arial,sans-serif;font-size:2.5em}.paypage .stepBar.card{margin-top:4em}.paypage .stepBar li.active a span{top:-1.8em}.ticket.card{margin-top:1em;padding:1em 0 0;position:relative}.ticket:after{content:\"\";display:block;clear:both}.ticket>.priceHead{position:relative;min-height:7em;padding-left:1em}.ticket>.priceHead>dl{font-size:.9em}.ticket>.priceHead>dl>dt{float:left;margin-right:1em}.ticket>.priceHead>dl>dt img{width:115px;height:auto;margin-bottom:.5em;border-radius:.2em;-webkit-border-radius:.2em;-moz-border-radius:.2em}.ticket>.priceHead>dl>dd>dl{float:left;clear:right;text-align:left;margin-bottom:.7em;margin-right:1.5em;font-family:Renault Bold,Helvetica,Arial,sans-serif;width:30%}.ticket>.priceHead>dl>dd{font-size:1.1em;padding-top:.3em}.ticket>.priceHead>dl>dd>span{font-family:Renault Bold,Helvetica,Arial,sans-serif;text-transform:uppercase;display:block}.ticket>.priceHead>dl>dd>dl>dd,.ticket>.priceHead>dl>dd>dl>dt{display:inline-block}.ticket>.priceHead>dl>dd>dl.price>dt,.ticket>.priceHead>dl>dd>dl.promotion>dt{display:none}.ticket>.priceHead>dl>dd>dl>dd{min-width:6.3em}.ticket .voucherName{float:left;margin-bottom:.5em}.ticket button.voucher{font-size:.95em;margin-bottom:.5em}.ticket .collapseBloc.active button.voucher{margin-bottom:0}.ticket .voucherName:before,.ticket button.voucher:before{content:\"\\E63F\";font-family:icon-Renault-Global;speak:none;font-size:1.3em;font-weight:700;vertical-align:middle;margin-right:.2em}.ticket .collapseBloc{margin-top:.5em}.ticket .voucherBloc{padding:0 1em}.ticket .voucherBloc input[type=text]{margin-top:.5em;width:100%;background-color:#eae9e7;border-color:#dfdfdf;-o-box-shadow:inset 1px 1px 1px 0 #9b9b9b;box-shadow:inset 1px 1px 1px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=134,Strength=1)}.ticket .voucherBloc .buttonList{margin:.5em 0 0}.ticket .voucherBloc .buttonList li:first-child{margin-left:0}.ticket .voucherBloc .buttonList li button{width:100%}.ticket .dropDown:after{content:\"+\";font-family:Renault Regular,Helvetica,Arial,sans-serif;speak:none;font-weight:700;position:relative;right:inherit;display:inline-block;font-size:1.9em;margin-left:.1em;height:.6em;width:.6em;line-height:.45em;text-align:center;vertical-align:middle;color:#fc3}.ticket .collapseBloc.active>.dropDown:after{content:\"-\"}.ticket legend.dropDown{cursor:pointer}.ticket .collapseBloc>legend.dropDown:after{font-size:2rem;margin-left:.28em;margin-right:.15em}.ticket .collapseBloc.active>legend.dropDown:after{font-size:3rem;margin-left:.1em;margin-right:0}.ticket .total{font-size:1em;clear:both;border-top:1px solid #e2e3e4;border-bottom:1px solid #e2e3e4;font-family:Renault Bold,Helvetica,Arial,sans-serif;text-align:right;padding:.7em}.ticket form{padding:2em 1em .5em}.ticket fieldset{text-align:center;margin-bottom:2em}.ticket fieldset legend{display:block;width:100%;font-family:Renault Light,Helvetica,Arial,sans-serif;font-size:1.9em;text-align:center}.ticket fieldset p{margin-top:.2em;font-size:.95em}.ticket .selectBloc{width:100%;margin:1.6em auto 0}.ticket .selectBloc select{border-color:#4c4c4c}.ticket .selectBloc:before{content:\"\\E619\";color:#a2a5a4;font-size:.7rem;border-left-color:#4c4c4c;padding:.5em 1.4em;top:.8em}.ticket fieldset ul.listCard{margin-bottom:1em}.ticket fieldset .listCard li{display:inline-block;margin-top:1em;position:relative;overflow:hidden}.ticket fieldset .listCard li:first-child{margin-left:-2em}.ticket fieldset .listCard li label{cursor:pointer;padding:0}.ticket fieldset .listCard input[type=radio]{visibility:hidden}.ticket fieldset .listCard span{display:inline-block;position:relative}.ticket fieldset .listCard span:before{content:\"\";width:16px;height:16px;border:2px solid #e2e3e4;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;display:inline-block;vertical-align:middle;margin-right:.2em}.ticket .cardBloc label.checkBox span:before{font-size:.8em}.ticket fieldset .listCard span img{vertical-align:middle;width:auto;height:28px}.ticket fieldset .listCard input[type=radio]:checked+span:before,.ticket fieldset .listCard li label:hover span:before{border-color:#ffde00}.ticket fieldset .listCard input[type=radio]:checked+span:after{content:\"\";width:12px;height:12px;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;display:inline-block;background-color:#ffde00;position:absolute;left:4px;top:8px}.ticket fieldset table.listCard{margin-top:1.5em}.ticket fieldset table.listCard tr{border-bottom:1px solid #e2e3e4}.ticket fieldset table.listCard th{font-weight:400;vertical-align:top;text-align:left;padding:.5em 0 1em .5em}.ticket fieldset table.listCard th:first-child{width:68%}.ticket fieldset table.listCard td{padding:.5em 0;vertical-align:middle}.ticket fieldset table.listCard tbody td:first-child{text-align:left}.ticket fieldset table.listCard label,.ticket fieldset table.listCard p{display:inline-block;vertical-align:middle}.ticket fieldset table.listCard input[type=radio]{margin-left:-1em}.ticket fieldset table.listCard label{margin-bottom:0;cursor:pointer}.ticket fieldset table.listCard p{line-height:1em}.ticket fieldset table.listCard p span{display:block;text-align:left;font-size:.8em}.ticket fieldset table.listCard p span:before{display:none}.ticket .CheckboxList{font-size:.8em;margin:3.5em 0 2em}.ticket .CheckboxList li{display:block;width:100%;min-height:3.5em;vertical-align:middle;padding-bottom:.5em}.ticket .CheckboxList label.checkBox span{padding-left:3em}.ticket .CheckboxList label.checkBox span a{font-family:Renault Bold,Helvetica,Arial,sans-serif}.ticket label.checkBox span:before{border:2px solid #e2e3e4;width:1em;height:1em;top:0;margin-top:0}.ticket label.checkBox input[type=checkbox]:checked+span:after{top:.5em;left:.6em;font-weight:700}.ticket .cardBloc label.checkBox input[type=checkbox]:checked+span:after{font-size:.45rem}.ticket .cardBloc label.checkBox{font-size:.95em;width:100%;margin:0 auto}.ticket .cardBloc label.checkBox span{padding-left:2.5em}.ticket .buttonList button[type=submit]{margin:0}.ticket .otherPay{margin-top:2em}.confirmation{padding-left:0;padding-right:0}.confirmation h3{padding-top:.5em;margin:0 auto;font-size:1.1em;max-width:22em;padding:0 .5em}.confirmation h3 span{display:block;font-size:1.4em;font-family:Renault Regular,Helvetica,Arial,sans-serif}.confirmation table{margin-top:1em;font-size:.9em}.confirmation table tbody tr,.confirmation table thead{border-bottom:1px solid #e2e3e4}.confirmation table thead th{font-weight:400;color:#7e7e7e}.confirmation table td,.confirmation table th{padding:.5em 1.2em}.confirmation p.emailConfirm{text-align:center;padding:1em 1.5em;margin-top:1em;line-height:1em}.confirmation p.emailConfirm:before{content:\"\\E61E\";display:inline-block;font-size:1.3em;font-family:icon-Renault-Global;speak:none;color:#fc0;vertical-align:middle;margin-right:.5em}.confirmation h4{text-align:center}.confirmation .setup{padding:0 1em}.confirmation .setup li{margin-bottom:1.5em}.confirmation .toolbox{margin-top:0;text-align:left}.confirmation .toolbox figcaption{font-family:Renault Regular,Helvetica,Arial,sans-serif;padding:0 .5em}.confirmation .toolbox figcaption:before{display:none}.confirmation .toolbox p{font-size:.8em;padding:0 .7em}.confirmation .toolbox a.button.link{display:none;border-top:none;font-size:.7em;width:100%;margin:1.3em 0 2.5em;padding:0 .8em}a.button.link:after{color:#000}.confirmation .lastText{font-size:.9em;padding:0 1.2em;margin-bottom:2em}.confirmation .lastText a{display:inline-block;margin-top:1.5em}.confirmation .toolbox a.button.link:focus span,.confirmation .toolbox a.button.link:hover span{text-decoration:underline}.lastText span{display:block}.paiement h3{margin:0 0 .5em;font-size:1.4em;padding:0 .5em}.paiement dl{font-size:.9em;text-align:center;padding-bottom:.2em}.paiement dl dt{font-family:Renault Bold,Helvetica,Arial,sans-serif}.paiement dl dd,.paiement dl dt{display:inline}.paiement p.secure{font-size:.8em;text-align:center;margin:1em 0 2em;line-height:1.1em}.paiement p.secure img{width:4em;height:auto;margin:0 1em;vertical-align:middle}.paiement form{padding:.5em 0 0;font-size:.8em}.paiement form>div{position:relative}.paiement form .errorMessage{position:absolute;bottom:1em;font-size:1em;margin:0}.paiement form label{position:relative;padding:0;margin:0 0 .5em}.paiement form input[type=text],.paiement form select{margin-bottom:1em;width:100%;background-color:#eae9e7;border-color:#dfdfdf;-o-box-shadow:inset 1px 1px 1px 0 #9b9b9b;box-shadow:inset 1px 1px 1px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=134,Strength=1);font-size:1.4em}.paiement .focus input[type=text],.paiement .focus select{border-color:#fc3}.paiement input[type=text].errorField{border-color:#bd3632;background-color:#eae9e7;color:#bd3632}.paiement .focus [type=text],.paiement .selectBloc.focus{background-color:#fef7e5}.paiement form input[type=text].errorField,.paiement form select.errorField{margin-bottom:2em}.paiement .selectBloc{position:relative;overflow:visible;height:3.634em;background-color:#eae9e7;margin-bottom:1.2em}.paiement form select{background-color:transparent;padding-right:2em}.paiement .selectBloc:before{z-index:1;content:\"\\E619\";color:#fc0;font-size:.7rem;border-left-color:#c3c4c3;padding:.6em .8em;top:.6em;background-color:transparent}.paiement form .required:after{content:\"\";position:absolute;right:-1px;top:1.3em;z-index:2;width:1.1em;height:1.1em;display:inline-block;background-color:transparent;background-repeat:no-repeat;background-position:100% 0;background-image:url(" + __webpack_require__(377) + ");background-size:1.1em;border-top:3px solid #fff}.paiement .buttonList{font-size:1.2em;margin-bottom:0}.paiement .buttonList li{margin:0}iframe.sips{margin:1.5em 0 0;padding:0;overflow:auto;height:710px;width:100%}p.conditions{margin-top:1.7em;font-size:.8em;color:#262625}p.conditions a,p.conditions a:link,p.conditions a:visited{color:#555}p.imageError{max-width:934px;margin:0 auto 3em}p.txtLight{font-size:.9em;line-height:1.3em;margin:0 auto 2em}@media (min-width:350px){.datasheet .carousel>ul>li>img{width:100%}.datasheet .carousel>ul{max-height:26em}.ticket>.priceHead>dl>dd>dl{width:48%}.ticket fieldset table.listCard label{padding-right:.5em}.ticket fieldset table.listCard p span:first-child{font-size:1em}}@media (min-width:500px){.buttonList li{width:auto;margin:.7em}.buttonList.maxLarge{margin-left:0;margin-right:0;width:100%;display:table}.buttonList.maxLarge.tablet{display:none}.buttonList.maxLarge li{margin-left:0;margin-right:0;display:table-cell;text-align:left;padding-left:.5em}.buttonList.maxLarge li:first-child{text-align:right;padding-left:0;padding-right:.5em}.buttonList.maxLarge a.button,.buttonList.maxLarge button{width:100%}.tabs .buttonList button{margin:1em 0}.myCar .buttonList button[type=submit]{margin-top:1em}.myCar .carousel{padding:0}.myCar .carousel .carEditName.active>div{margin:1em 2em}.tabAppCarto>ul li{width:37%}.myCar .carousel .controls{top:4.5em}.ticket .voucherBloc .buttonList li{width:100%;margin:.7em 0}.paiement .buttonList li{margin:0 .7em}.paiement .buttonList button[type=submit]{margin-top:0;margin-bottom:0}.buttonList.reverseMobile li{margin:0}.buttonList.reverseMobile button[type=submit],.ticket .buttonList.reverseMobile button[type=button]{margin-bottom:1em}}@media (min-width:600px){body{font-size:1em}h2{font-size:2.9em}h2,h3{padding:1em}h3{font-size:1.5em;margin-top:-2em;margin-bottom:0}h4{font-size:1.8em}form{padding:2em .5em}section h1{font-size:2.1em;margin-top:.5em}.formGroup{margin-top:3em}.formGroupLight{margin-top:1em}.buttonList.formGroupMiddle,.formGroupMiddle{margin-top:2em}.buttonList{margin:1em;clear:both}.buttonList.maxLarge.tablet{display:table}a.button,button.button,button[type=submit]{width:auto;display:inline-block;padding:.75em 2em .7em 1em;font-size:.9em}a.button.previous{padding:.75em 1em .7em 2em}a.button.back{width:180px;text-align:left;padding:.7em 1em .7em 2.5em}button.showMenu{margin-top:1px;width:4.3em;height:4.3em}button.showMenu:before{font-size:2.5em}p.topBack{margin-bottom:-1.5em}p.topBack a.button.back,p.topBack a.button.back:link,p.topBack a.button.back:visited{background-color:transparent}p.topBack a.button.back:focus,p.topBack a.button.back:hover{text-decoration:underline}p.topBack a.button.back{min-width:180px;padding-right:2em}.titleLogo h1{font-size:1.7em;margin-top:.8em}.mobile{display:none}.mobile.tablet,.tablet{display:block}.floatedLeft.tab,.floatedLeft.tablet.desk,.floatedRight.tab,.floatedRight.tablet.desk{display:inline}.floatedLeft.tab,.floatedLeft.tablet.desk{float:left}.floatedRight.tab,.floatedRight.tablet.desk{float:right}figure{text-align:left}figure img.floatedLeft{margin-right:2em;margin-bottom:1em}figure img.floatedRight{margin-left:2em}button[type=submit]{margin-left:0;margin-right:0}header div[role=navigation] a,header div[role=navigation] button{font-size:1em}header div[role=navigation].open{left:-50%;width:50%;padding-top:4.3em}header div[role=navigation] .search{height:3.9em;padding-left:3.9em}header div[role=navigation] .search input[type=text]{font-size:1em}p.txtLight{font-size:1.1em;line-height:1.5em;margin-top:-1.5em}p.emailSent{font-size:1em;text-align:center;border:2px solid #fc0;padding:1em 3em;line-height:1.5em}p.emailSent:before{position:relative;left:inherit;font-size:2em;display:block;margin:.3em}.errorMessageTop{text-align:left;padding:1.8em 6em}label.checkBox span:before{width:1.3em;height:1.3em}label.checkBox input[type=checkbox]:checked+span:after,label.checkBox input[type=radio]:checked+span:after{font-size:.75rem;top:.15em;left:.25em;font-weight:400}aside.phoneTimes{font-size:1em}aside.phoneTimes h1,aside.phoneTimes span.phoneNumber{font-size:2em;margin:.5em 0}aside.phoneTimes a{font-size:1.3em}p.conditions{font-size:.75em}footer ol.lineList li,footer ul.lineList li{float:left}.infoCompany{padding:0}.infoCompany ul{margin:1.2em 0}.infoCompany li{display:inline;width:auto;margin:0 1em .5em}.infoCompany li a,.infoCompany li span{display:inline;width:auto;padding:0}.infoCompany ul.floatedRight.tab,.infoCookies .cookie-choice{float:left}.infoCookies .toggles p{margin-bottom:8px}.pageNavigation nav li.active a:before,.stepBar li.active a:after{border-bottom-width:4px}.stepBar.card{margin-top:1.875em}.stepBar li{font-size:1.5em;padding:0}.stepBar li.active{font-family:Renault Regular,Helvetica,Arial,sans-serif;position:relative}.stepBar li a{display:inline-block;padding:.575em 0}.stepBar li span{display:inline}.stepBar li.active a{position:relative}.stepBar li.active a:after{bottom:0}.stepBar li.finish a:after{font-size:.7em;margin-left:.5em;bottom:.85em}.stepBar li.active a span{display:inline;position:relative;left:inherit;top:inherit;width:auto}.models li{display:inline-block;margin:0 .4em}form.card .miniContent{padding:0 .7em}p.toolboxText{text-align:left}label.checkBox span{padding-left:2em}label.checkBox span:before{top:0}.carousel .controls .leftArrow button:before,.carousel .controls .rightArrow button:before{font-size:5rem}.updates{padding:12px 0}.updates .carUp{border-right:1px solid #000;font-size:1.2em}.updates .carUp,.updates .countUp{padding:0 .5em}.carUp,.sheet,.updates>div{font-size:1.2em}.carUp .modele{font-size:1.4em}.carUp .reference{font-size:.9em}.myCar h2{font-size:2.5em}.updates .countUp p{padding-top:2.2em;background-color:transparent;background-position:top;background-image:url(" + __webpack_require__(374) + ");background-repeat:no-repeat;background-size:2.15em auto;margin:0;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0;-o-box-shadow:none;box-shadow:none;filter:progid:DXImageTransform.Microsoft.Shadow(enabled=false)}.updates .countUp p .countNb{top:-.3em;right:.9em;width:1.7em;height:1.7em;line-height:1.7em;-o-box-shadow:2px 2px 4px 0 #656565;box-shadow:2px 2px 4px 0 #656565;filter:progid:DXImageTransform.Microsoft.Shadow(color=#656565,Direction=134,Strength=4)}.updates .countUp p .countInfo{display:inline;font-size:.8em}.updates .countUp p button{display:none}.updates .linkUp{display:block}.updates .linkUp,.updates .linkUp>div{position:relative;left:inherit;top:inherit;bottom:inherit;width:auto;background-color:transparent;padding:0}.updates .linkUp p,.updates .linkUp p.cancel,.updates .linkUp p:first-child{border-radius:0;background-color:transparent;margin:0;padding:0}.updates .linkUp a.button,.updates .linkUp button{display:inline-block;width:auto;margin:.2em 0;padding:.75em 2em .7em 1em;min-height:2.639em;text-transform:uppercase;font-size:.9em;font-family:Renault Bold,Helvetica,Arial,sans-serif}.updates .linkUp button{background-color:#fc0}.updates .linkUp button:disabled{opacity:.5}.updates .linkUp a.button:focus,.updates .linkUp a.button:hover,.updates .linkUp button:focus,.updates .linkUp button:hover{background-color:#ffde00;text-decoration:none}.updates .linkUp button:disabled:focus,.updates .linkUp button:disabled:hover{background-color:#fc0}.updates .linkUp a.button:focus,.updates .linkUp a.button:hover{background-color:transparent;text-decoration:underline}.updates .linkUp a,.updates .linkUp a:link,.updates .linkUp a:visited,.updates .linkUp button{color:#000}.updates .linkUp a.button:after,.updates .linkUp button:after{display:inline}.updates .linkUp .cancel{display:none}.carousel .popinChoice{font-size:1em}.popinChoice h1{font-size:2.5em}.popinChoice p{font-size:1.4em}.choiceApp h2{margin-top:1em;font-size:2.2em}.tabAppCarto>ul li{width:47.5%}.tabAppCarto>ul li a,.tabAppCarto>ul li a[aria-selected=true]{font-family:Renault Regular,Helvetica,Arial,sans-serif;font-size:1.8em}.tabAppCarto>ul li a:before,.tabAppCarto>ul li a[aria-selected=true]:before{border-bottom-width:4px}.tabClassic>ul{display:table;width:100%;border-bottom:1px solid #a8a8a8;table-layout:fixed}.tabClassic>ul>li{display:table-cell;text-align:center}.tabClassic>ul>li [role=tabpanel]{position:absolute;left:0;top:0;z-index:0;width:100%}.tabClassic>ul>li>a{border-top:none;font-size:1.2em;padding:.9em .8em;background-color:#f3f3f3}.tabClassic>ul>li>a,.tabClassic>ul>li>a:link,.tabClassic>ul>li>a:visited{color:#000}.tabClassic>ul>li>a[aria-selected=true],.tabClassic>ul>li>a[aria-selected=true]:link,.tabClassic>ul>li>a[aria-selected=true]:visited{color:#fff}.tabClassic>ul>li>a[aria-selected=false]{display:block}.tabClassic>ul>li>a[aria-selected=true]{background-color:#262626}.tabClassic>ul.open{padding-top:0;padding-bottom:0;background-color:transparent}.tabClassic>ul.open>li>a[aria-selected=true]:before{display:block}.tabClassic>ul>li>a[aria-selected=true]:before{border-width:16px 18px 0;bottom:-13px;margin-left:-18px}.tabClassic>ul>li>a[aria-selected=true] p:after{display:none}.tabClassic>ul.open>li>a[aria-selected=true]{position:relative;top:inherit;width:auto;padding-bottom:.9em}.tabClassic>ul.open>li>a[aria-selected=false]{padding:.9em .8em}.filter button.dropDown{font-size:1.5em;font-family:Renault Light,Helvetica,Arial,sans-serif}.filter button.dropDown:after{font-size:.8em}.filter .radioList li{margin:0 1em}.filter .radioList li label,.radioList{text-align:center}.radioList{width:auto;margin-left:0;margin-right:0;font-size:.8em}.radioList li{margin-left:5%;width:auto}.radioList label.radio span{font-size:1.5em}.rlinkManage h2{font-size:2.2em}.historical>ul>li{padding:1.3em}.historical .appName img{width:70px;margin-right:.5em}.historical .name{font-size:1.2em;margin-top:.5em}.historical .appType p{font-size:1em;line-height:1.3em}.historical .stateKo:before,.historical .stateOk:before{width:1.1em;height:1.1em;vertical-align:sub}.historical .buttons a,.historical .buttons button{font-size:.9em}.userGuides h3{font-size:1.2em;font-family:Renault Bold,Helvetica,Arial,sans-serif}.userGuides a.button.more{padding:.75em 2.5em .7em;font-size:1em}.userGuides ul li.video2,.userGuides ul li.video3{display:inline-block;width:46%}.userGuides ul li.video2{margin-right:3%}.userGuides ul li.video3{margin-left:3%}.tabTransfert select{font-size:3.5vw}.datasheet .carousel>ul{max-height:24em}.sheet>dl{font-size:.85em}.sheet>dl>dt{margin-right:.8em}.sheet>dl>dt img{width:173px;margin-bottom:0}.sheet dl.price{height:4em;padding-top:.5em}.sheet dl.price.from{padding-top:0;position:relative}.sheet dl.price.from dt{font-size:.9em;margin-top:0}.sheet dl.price dd{font-size:1.6em;margin-top:0}.sheet dl.price dd.time{position:absolute;font-size:1em;right:0;top:0;margin:0}.sheet dl.price dd.time button.open{border-radius:.4em;-webkit-border-radius:.4em;-moz-border-radius:.4em;padding:0 2em 0 .5em}.sheet dl.price dd.time button.open span{padding-right:1.3em}.sheet dl.price dd.time button.open:after{border-width:8px 6px 0}.sheet dl.left{float:left}.sheet dl.right{float:right}.sheet dl.left dd,.sheet dl.left dt,.sheet dl.right dd,.sheet dl.right dt{font-size:.75em;margin-bottom:.2em}.sheet p.details{font-size:.85em}.sheet button.collapseButton{font-size:.7em}.sheet button.basket{padding:.3em .8em .3em .3em}.sheet button.basket img{width:auto;height:inherit;margin-right:.8em}.tabChapt li{display:inline-block;margin:0 1.5em;padding-bottom:.5em}.infoPage h3{font-size:1.5em}.infoPage h3 span{font-size:.85em}.infoPage p{text-align:justify;margin-top:.5em}.infoPage hr{width:50%;border-top-width:3px}.msgGood{font-size:1em;padding:1em 8em}.msgGood:before{position:relative;left:inherit;top:inherit;margin-right:.5em;vertical-align:sub}.footerServices nav{padding:2em 1em 1em}.footerServices nav dl{width:33%;padding-left:1em;padding-bottom:0;border-top:none;cursor:default}.footerServices nav dl:first-child{padding-left:0}.footerServices nav dt{height:3.5em;display:inline-block;padding:0}.footerServices nav dl dt:after{display:none}.footerServices nav dd{display:block;padding:0}.footerServices .media{display:block;width:100%;padding-left:0;margin-top:1em}.footerServices .media dt{display:block;height:auto;margin-left:0}.footerServices .media dd{margin:1em .4em 1.4em 0}.bottomButtonBar{display:none}.tutorial h1{font-size:1.7em;padding:1em}.tutorial h2{font-size:1.8em}.tutorial h2:before{border-top:2px solid #000}.tutorial p{font-size:1.3em;padding:0 8em}.bottomClose{font-size:1.5em}.tootipBox button.open{display:inline-block}.infoCookies{top:inherit;bottom:0}.MenuAppCarto{font-size:1em;padding:2.7em 8em}.models li{margin-top:0}.models img{width:238px;border-width:16px;-o-box-shadow:0 20px 40px 0 #9b9b9b;box-shadow:0 20px 40px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=40)}.miniModel span{display:inline;position:relative;top:auto;width:auto;font-size:1.7em;font-family:Renault Regular,Helvetica,Arial,sans-serif}.miniModel img{vertical-align:middle;margin:.5em 1.5em 1em 0;-o-box-shadow:0 6px 12px 0 #9b9b9b;box-shadow:0 6px 12px 0 #9b9b9b;filter:progid:DXImageTransform.Microsoft.Shadow(color=#9b9b9b,Direction=180,Strength=12)}.limitContent .card .tootipBox{margin-right:3.5em}.tooltipMessage.mobileShow{display:none}.tooltipMessage.active.mobileShow{display:block;position:absolute;background-color:#000;color:#fff;text-align:center;padding-left:1em;padding-right:1em;width:20em}.tooltipMessage.mobileShow h5{display:block}.tooltipMessage.mobileShow:before,.tooltipMessage.mobileShow button{display:inline}.tooltipMessage.mobileShow p{font-size:.8em;line-height:1.3em}.tabs .tabTitle span{font-size:1em}.myCar h2 .carNumber{font-size:.35em;margin-bottom:1.5em}.tabTransfert h3 span{margin-top:1em}.tabTransfert .selectBloc:before{right:0}.tooltipCostChoice{position:absolute;left:0;top:.6em;width:25em;height:auto;background-color:#e2e3e5;border:1px solid #9f9f9f;border-radius:.2em;-webkit-border-radius:.2em;-moz-border-radius:.2em;padding:0}.tooltipCostChoice>div{height:auto}.tooltipCostChoice>div>ul{overflow:visible;position:relative;bottom:inherit;left:inherit;width:auto}.tooltipCostChoice>div>ul>li{border-top:1px solid #656364;background-color:transparent;margin:0}.tooltipCostChoice>div>ul>li:first-child,.tooltipCostChoice>div>ul>li:first-child label{-webkit-border-top-right-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-top-left-radius:0}.tooltipCostChoice>div>ul>li:last-child,.tooltipCostChoice>div>ul>li:last-child label{-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.tooltipCostChoice>div>ul>li:first-child label:after,.tooltipCostChoice>div>ul>li:first-child label:before{display:block}.tooltipCostChoice input[type=radio]{visibility:visible}.tooltipCostChoice input[type=radio]:checked+label{background-color:#262626;color:#fff}.tooltipCostChoice label{text-align:left;padding:.7em 1.2em;font-size:.9em;font-family:Renault Bold,Helvetica,Arial,sans-serif;color:#262625}.tooltipCostChoice input[type=radio]:checked+label:after{border-color:transparent transparent #262626}.tooltipCostChoice label:focus,.tooltipCostChoice label:hover{background-color:#9a9a9a;text-decoration:none}.tooltipCostChoice button[type=submit]{width:9em;height:100%;right:0;top:0;bottom:inherit;left:inherit;margin:0;border-radius:0;vertical-align:inherit}.packs ul{font-size:1em}.packs ul li{width:70px}.myCar .carousel .controls{top:22em}.myCar .carousel>ul>li>img{margin-top:0}.carousel .controls{display:block}.carousel .controls button{height:64px;width:64px}.paypage h2{display:block}.paypage .stepBar.card{margin-top:1.2em}.paypage .stepBar li.active a span{top:inherit}.ticket form{padding:2em 0 .5em}.ticket .selectBloc{width:20em}.ticket .voucherBloc{padding:0}.ticket .voucherBloc input[type=text]{width:20em}.ticket .voucherBloc .buttonList{display:inline-block}.ticket .voucherBloc .buttonList li{width:auto;margin:.7em}.ticket .voucherBloc .buttonList li:last-child{margin-right:0}.ticket .voucherBloc .buttonList li button{min-width:10.2em;width:auto}.ticket.card{padding-top:1.5em}.ticket>.priceHead>dl{font-size:1em}.ticket>.priceHead>dl>dt{margin:0;position:absolute}.ticket>.priceHead>dl>dt img{width:173px;margin-left:.5em}.ticket>.priceHead>dl>dd>dl{float:right;text-align:right;width:auto}.ticket>.priceHead>dl>dd{padding-top:1em;overflow:hidden;padding-left:11.5em}.ticket .priceHead .collapseBloc{margin:0;padding-left:12.5em;margin-bottom:.5em}.ticket>.priceHead>dl>dd>span{display:inline}.ticket .total{font-size:1.1em;padding:1.2em 1.5em}.ticket .CheckboxList{font-size:.75em}.ticket .CheckboxList li{display:inline-block;width:49%;padding-left:1em;vertical-align:top}.ticket label.checkBox span:before{width:1.2em;height:1.2em}.ticket label.checkBox input[type=checkbox]:checked+span:after{top:.3em;left:.25em}.ticket fieldset ul.listCard{margin-bottom:1.8em}.ticket .cardBloc label.checkBox{max-width:43em;margin-bottom:2em;padding:0 1em}.ticket .cardBloc label.checkBox input[type=checkbox]:checked+span:after{font-size:.75rem}.ticket fieldset .listCard span img{height:52px}.ticket fieldset .listCard li{margin-left:1em;margin-top:2.2em}.ticket fieldset .listCard li label{padding:0 .2em}.ticket fieldset .listCard span:before{margin-right:1em;width:1em;height:1em}.ticket fieldset .listCard input[type=radio]:checked+span:after{width:.75em;height:.75em;left:.25em;top:1.25em}.ticket form button{width:16em}.ticket .buttonList button[type=submit]{margin:1em auto}.confirmation h3{font-size:1.9em}.confirmation h3 span{font-family:Renault Light,Helvetica,Arial,sans-serif}.confirmation p.emailConfirm{line-height:1.3em;padding:1em}.confirmation p.emailConfirm:before{font-size:1.5em}.confirmation h4{font-family:Renault Light,Helvetica,Arial,sans-serif;margin:1em 0 2em}.confirmation .setup{padding:0 .25em}.confirmation .setup li{text-align:center;padding:0 5.5em}.confirmation .toolbox figcaption{font-size:1.25em;padding:0 .3em}.confirmation .toolbox p{font-size:.9em;padding:0 .6em;text-align:left}.confirmation .toolbox a.button.link{font-size:.8em}.confirmation .lastText{font-size:1em;padding:0 1.7em;margin-bottom:3em;text-align:center}.paiement h3{font-size:1.9em}.paiement dl{font-size:1em}.paiement p.secure{font-size:1em;border-bottom:1px solid #c4c5c4;margin:1em auto;padding-bottom:1.5em;max-width:600px}.paiement p.secure img{width:4.5em;margin:0 .8em}.paiement form{padding:1em 1em 0;margin:0 auto;max-width:600px}.paiement form label{font-size:1.2em}.paiement .selectBloc{height:3.25em}.paiement .alone{width:25em;margin:0 auto 1em}.paiement .col1,.paiement .col2,.paiement .col3{display:inline-block;vertical-align:middle}.paiement .col1{width:42.5%;margin-right:2.5%}.paiement .col2{width:23%;margin-right:2.5%}.paiement .col3{width:28%}.paiement form input[type=text],.paiement form select{font-size:1.2em}.paiement .buttonList{margin:2.5em 0}.paiement .buttonList button{width:16em}.paiement form .errorMessage{bottom:.5em}.ticket fieldset table.listCard{width:600px;margin:2.5em auto 0}.ticket fieldset table.listCard th{font-size:.9em;padding:.5em;text-align:center}.ticket fieldset table.listCard th:first-child{padding-right:4em;text-align:left}.ticket fieldset table.listCard td{padding:.8em .5em}.ticket fieldset table.listCard td:first-child{padding-right:3.5em;font-size:1em}.ticket fieldset table.listCard td,.ticket fieldset table.listCard td:first-child p{font-size:.9em}.ticket fieldset table.listCard td p{line-height:1.1em}.ticket fieldset table.listCard p span{font-size:1em}.ticket>.priceHead{min-height:8.5em}.ticket .voucherName{position:absolute;top:2.5em;left:13.5em;float:none}.ticket .buttonList.reverseMobile button[type=submit]{margin-top:0}.ticket .buttonList.reverseMobile button[type=button]{margin-bottom:0}.ticket .selectBloc:before{top:1em}.ticket .otherPay{margin-top:4.5em}.pageContent.withNav section .tabs .contentTab>h3:first-child{margin-top:0}.pageContent.withNav h2{margin:1em 0}.updatePage p{font-size:.8em;padding:0 1.1em}iframe.sips{margin:0}.buttonList.reverseMobile{display:block}.buttonList.reverseMobile li{margin:0 .7em}.buttonList.reverseMobile button.cancel,.buttonList.reverseMobile button[type=submit]{margin-bottom:0}}@media (min-width:650px){.products>ul{height:33em}.products>ul>li{width:170px;margin:12px 10px}.headband{display:block;width:125px;height:77px;background-size:100%;left:-10px;top:-7px}.headband span{font-size:14px;height:17px;left:-7px;top:18px;width:100px}a.infosProd{padding:.8em .6em .6em;height:7em}a.infosProd .title{font-size:1em;line-height:.9em;height:2em}a.infosProd .price{margin-top:.6em}.price .crossout{font-size:.7em}.price del.crossout{font-family:Renault Bold,Helvetica,Arial,sans-serif}.price .cost,.products button.cost{font-size:.9em;left:.6em}.price .cost{top:5.3em}.products button.cost{height:2.1em}.products button.cost:after{border-width:8px 6px 0}.products button.basket{width:3.5em;height:3em}.products button.cost:after{top:.9em}.products button.basket img{width:2.5em}.datasheet .description>p{width:570px}}@media (min-width:700px){.limitContent .card .tootipBox{width:100%;margin-right:0}.carousel .controls .leftArrow button:before,.carousel .controls .rightArrow button:before{font-size:6rem}.updates .carUp{padding:0 1em}.tabAppCarto>ul li{margin:0 .5em;width:auto}.tabTransfert form{padding-top:2em;background:transparent url(" + __webpack_require__(378) + ") no-repeat center 4em}.tabTransfert form div.choose{display:inline-block;width:24%;margin:0}.tabTransfert form div.choose:first-child{margin-right:30%}.tabTransfert .selectBloc:before{font-size:1.5em}.stepBar li{font-size:1.8em}.tabAppCarto>ul li a[aria-selected=true]{padding:.3em 1em}}@media (min-width:706px){.radioList{font-size:1em}}@media (min-width:800px){.infoCompany ul.floatedRight.tab{float:right}.ticket .voucherBloc input[type=text]{width:25em}.ticket .voucherBloc .buttonList li button{min-width:180px;width:12.98em}}@media (min-width:900px){.updates .carUp{padding:0 3em}.updates .countUp{padding:0 2em}.historical>ul>li>ul{display:table;width:100%}.historical>ul>li>ul>li{display:table-cell;vertical-align:middle}.historical .appName{width:40%;vertical-align:top}.historical .appType{width:auto}.historical .appType p{display:inline-block}.historical .buttons{display:table-cell;text-align:right;padding-top:0;vertical-align:top;padding-top:1em}.userGuides ul li.video1,.userGuides ul li.video2,.userGuides ul li.video3{display:inline-block;width:31.5%}.userGuides ul li.video1,.userGuides ul li.video2{margin-right:1%}.userGuides ul li.video2,.userGuides ul li.video3{margin-left:1%}.footerServices nav dl{width:25%}.footerServices .media{display:inline-block;width:25%;margin-top:0;padding-left:2em}.footerServices .media dt{display:inline-block;height:3.5em}.footerServices .media dd{margin:-1em .4em 1.4em 0}.footerServices p.asterisk{display:block}}@media (min-width:1024px){.datasheet .carUp{float:right;display:inline;width:33%;margin-left:2%}.sheet{float:left;display:inline;width:64.4%}.datasheet .carousel ul.controls{display:block}.ticket>.priceHead>dl>dd>dl{margin-right:3.5em}.ticket>.priceHead>dl>dd>dl.price>dt,.ticket>.priceHead>dl>dd>dl.promotion>dt{display:inline-block}.ticket .total{padding-right:3.5em}.confirmation table{font-size:1em}.confirmation h4{margin:1.5em 0}.confirmation .setup li{float:left;width:50%;padding:0 .5em;margin-bottom:0}.confirmation .toolbox{text-align:left}.confirmation .toolbox figcaption{font-size:1.3em;padding:0 .5em}.confirmation .toolbox p{font-size:.9em;padding:0 1em;text-align:left}.confirmation .toolbox a.button.link{font-size:.9em;margin:1.5em 2em 2em 1em}.confirmation .lastText{margin:0 0 8em}.confirmation .toolbox a.button.link{margin-left:0;margin-right:0;text-align:left;display:block}}@media (min-width:1030px){.illustration.large .limitContent{margin-left:auto;margin-right:auto}}@media (min-width:1200px){.mobile,.mobile.tablet,.tablet{display:none}.desktop{display:block}.floatedLeft.desk,.floatedRight.desk{display:inline}.floatedLeft.desk{float:left}.floatedRight.desk{float:right}ol.lineList>li,ul.lineList>li{float:left}.lang button{text-transform:none}header div[role=navigation].open{padding-top:0;margin-top:0}header div[role=navigation].open button.dropDown{border-bottom:none}header div[role=navigation] button.dropDown:after{position:relative;right:inherit;top:inherit;margin-left:.7em;vertical-align:middle;font-size:.7em;display:inline-block}header div[role=navigation] .search{width:auto;position:relative;height:auto;padding-left:1.9em;background-color:transparent}header div[role=navigation] .search input[type=text]{display:none}header div[role=navigation] .search button{position:relative;right:inherit;top:inherit;width:auto;height:auto}header div[role=navigation] .search button:after{content:url(" + __webpack_require__(379) + ");display:inline-block;height:1.4em;margin-left:.5em;vertical-align:bottom;font-size:1em}header div[role=navigation] .search button:focus,header div[role=navigation] .search button:hover{text-decoration:underline}header div[role=navigation] .navCenter button.dropDown:after{font-size:.9em;font-weight:700}header .login a,header .services a,header .services button{text-transform:uppercase}header button{margin:-1px}header div[role=navigation],header div[role=navigation].open{position:relative;display:block;background-color:#ececec;color:#333;height:2em;line-height:1.9em;font-size:.9em;width:100%;border:1px solid #ececec}header div[role=navigation].open>div,header div[role=navigation]>div{border-top:none;position:relative}header div[role=navigation] .dropDownMenu ul{width:auto;position:absolute;right:0}header div[role=navigation] .dropDownMenu ul li a{text-align:right;padding:.4em 1.4em}header div[role=navigation].open .floatedLeft,header div[role=navigation].open .floatedRight{display:inline}header div[role=navigation].open .floatedRight{float:right}header div[role=navigation].open .floatedLeft{float:left}header div[role=navigation] a,header div[role=navigation] div button{display:inline;width:auto;padding:0}header div[role=navigation] a:after{display:none}header div[role=navigation] .login a.user:after{display:inline;font-size:.8em;position:relative;top:inherit;right:inherit;vertical-align:middle}header div[role=navigation].open li,header div[role=navigation] a.logout{border-top:none}header div[role=navigation].open .login{background-color:transparent}header .login span{margin-left:.3em}header div[role=navigation] .login a{font-family:Renault Bold,Helvetica,Arial,sans-serif;display:inline-block;padding:0 1.2em}header div[role=navigation] .login a.logout{border-left:1px solid #c5c8ca}header div[role=navigation] a,header div[role=navigation] a:link,header div[role=navigation] a:visited{color:#333}header div[role=navigation] .login li:first-child a{padding-left:0}header ul li{padding-left:1.5em}header ul.login li{padding-right:0;padding-left:0}header ul.cars{position:absolute;top:6.3em;z-index:1}header ul.cars li{float:left;padding:0 1.5em 0 0;font-size:1.2em;text-transform:none}header ul.cars li a.active{font-family:Renault Bold,Helvetica,Arial,sans-serif}header ul.navCenter{position:absolute;z-index:1;left:20em;top:4.55em}header ul.navCenter li{float:left;font-size:1.1em;padding-left:1.9em}header ul.navCenter li:first-child{padding-left:0}.titleLogo h1{float:left;position:relative;margin:0;width:auto;margin:.9em 0 0}.titleLogo.noNavUnder h1{margin-top:1.25em}.titleLogo .logo{margin-right:0}.pageNavigation nav{display:block}.navMask{overflow:auto}.navMask:after{display:none}p.toolboxDown{display:block}header div[role=navigation] a.user img{width:1.389em;height:auto;margin:0;float:none}header div[role=navigation] a.msg span.msgLabel{position:absolute;left:99999px}header div[role=navigation] a.msg span.msgCount{top:.2em}header div[role=navigation] .search span{position:relative;left:inherit}.profilNav{float:left;width:14.75em;padding-left:1em;text-align:center}.profilNav img{position:relative;left:inherit;top:inherit}.profilNav h2{padding:.5em 0;text-align:center}.profilNav button{display:inline}.profilNav .profil{font-size:.8em;text-align:center}.profilNav .msg{width:auto}.myCar,.slider{position:relative;padding-left:30px;padding-right:0;width:692px;overflow:hidden;white-space:nowrap;margin-bottom:2em;padding-bottom:2px}.myCar{margin-left:40px;padding:0;width:660px;white-space:inherit}.slider .card{width:36.25em;display:inline-block;padding:1em 0 0;vertical-align:top}.slider .card.primary:before{position:absolute;content:\" \";left:0;top:6em;box-shadow:-1px 1px 1px 0 rgba(0,0,0,.2);background:0 0;border-top:10px solid #fff;border-left:10px solid #fff;width:0;height:0;transform:translateZ(0) rotate(45deg)}.slider .secondary{margin-left:23px}.slider .card h2{margin-top:1em}.slider .card .close{top:1.2em}.slider .card .contentTab h2{padding:2em 0 1em}.contentTab{padding-bottom:3em}.updates{border-left-width:7px;border-right-width:7px}.tabTransfert select{font-size:2.5em}.stepBar li.active a:after{bottom:-1px}.carousel .controls button{height:107px;width:107px}}", ""]);
	
	// exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLifeOldStyle-Bold.eot";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLifeOldStyle-Bold.woff";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLifeOldStyle-Bold.ttf";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLifeOldStyle-Bold.svg";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Regular.eot";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Regular.woff";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Regular.ttf";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Regular.svg";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Bold.eot";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Bold.woff";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Bold.ttf";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Bold.svg";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-BoldItalic.eot";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-BoldItalic.woff";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-BoldItalic.ttf";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-BoldItalic.svg";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Italic.eot";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Italic.woff";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Italic.ttf";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Italic.svg";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Light.eot";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Light.woff";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Light.ttf";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-Light.svg";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-LightItalic.eot";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-LightItalic.woff";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-LightItalic.ttf";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/RenaultLife-LightItalic.svg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/Renault-Global.eot";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/Renault-Global.woff";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/Renault-Global.ttf";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/Renault-Global.svg";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/vehicule_000.jpg";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/previous.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/next.png";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/reload.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/headband.png";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/download.png";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/required.gif";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/transfert.png";

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/search.png";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(381);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _uaParserJs = __webpack_require__(456);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blackListedBrowser = new _set2.default(['Amaya', 'Android Browser', 'Arora', 'Avant', 'Baidu', 'Blazer', 'Bolt', 'Camino', 'Chimera', 'Chromium', 'Comodo Dragon', 'Conkeror', 'Dillo', 'Dolphin', 'Doris', 'Epiphany', 'Fennec', 'Firebird', 'Flock', 'GoBrowser', 'iCab', 'ICE Browser', 'IceApe', 'IceCat', 'IceDragon', 'Iceweasel', 'Iron', 'Jasmine', 'K-Meleon', 'Konqueror', 'Kindle', 'Links', 'Lunascape', 'Lynx', 'Maemo', 'Maxthon', 'Midori', 'Minimo', 'MIUI Browser', 'Mosaic', 'Netfront', 'Netscape', 'NetSurf', 'Nokia', 'OmniWeb', 'Phoenix', 'Polaris', 'QQBrowser', 'RockMelt', 'Silk', 'Skyfire', 'SeaMonkey', 'SlimBrowser', 'Swiftfox', 'Tizen', 'UCBrowser', 'Vivaldi', 'w3m', 'WeChat', 'Yandex']);
	
	var parseVersion = function parseVersion(str) {
	  if (typeof str !== 'string') {
	    return false;
	  }
	  var x = str.split('.');
	  var major = parseInt(x[0]) || 0;
	  var minor = parseInt(x[1]) || 0;
	  var patch = parseInt(x[2]) || 0;
	  return { major: major, minor: minor, patch: patch };
	};
	
	var upperOrEqual = function upperOrEqual(v, from) {
	  var vFrom = parseVersion(from);
	  return v.major > vFrom.major || v.major === vFrom.major && v.minor >= vFrom.minor || v.major === vFrom.major && v.minor === vFrom.minor && v.patch >= vFrom.patch;
	};
	
	var check = function check() {
	  var parser = new _uaParserJs2.default();
	  var p = parser.getResult();
	  // console.debug(p)
	  var browserName = p.browser.name;
	  var browserVersion = parseVersion(p.browser.version);
	  var osName = p.os.name;
	  var osVersion = parseVersion(p.os.version);
	  switch (true) {
	    case blackListedBrowser.has(browserName):
	      return false;
	    case /^Android/i.test(osName):
	      return upperOrEqual(osVersion, '4.0');
	    case /^iOS/i.test(osName):
	      return upperOrEqual(osVersion, '8.3');
	    case /^Windows (Phone|Tablet)/i.test(osName):
	      return upperOrEqual(osVersion, '8.1');
	    case /^Chrome/i.test(browserName):
	      return upperOrEqual(browserVersion, '48');
	    case /^Firefox/i.test(browserName):
	      return upperOrEqual(browserVersion, '44');
	    case /^Opera/i.test(browserName):
	      return upperOrEqual(browserVersion, '35');
	    case /^IE/i.test(browserName):
	      return upperOrEqual(browserVersion, '11');
	    case /Safari$/i.test(browserName):
	      return upperOrEqual(browserVersion, '8');
	    default:
	      console.log('Unable to test the compatibility of this browser. Test assumed to be positive.', p);
	      return true;
	  }
	};
	
	exports.default = check;

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularMessages = __webpack_require__(556);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _app = __webpack_require__(558);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _common = __webpack_require__(559);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _pages = __webpack_require__(746);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _services = __webpack_require__(1228);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _app3 = __webpack_require__(1263);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _angularMessages2.default, _app2.default, _common2.default, _pages2.default, _services2.default])
	
	// Directive to use a fallback source when an image fails to load while complying with CSP policies
	.directive('fallbackSrc', function () {
	  return {
	    link: function postLink(scope, iElement, iAttrs) {
	      iElement.bind('error', function () {
	        _angular2.default.element(this).attr('src', iAttrs.fallbackSrc);
	      });
	    }
	  };
	}).config(["$locationProvider", "$httpProvider", "$qProvider", "$sceDelegateProvider", function ($locationProvider, $httpProvider, $qProvider, $sceDelegateProvider) {
	  'ngInject';
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	
	  // Add API interceptor
	  $httpProvider.interceptors.push('ApiInterceptor');
	
	  $qProvider.errorOnUnhandledRejections(false);
	
	  $sceDelegateProvider.resourceUrlWhitelist(['self', // Allow same origin resource loads.
	  'https://www.youtube.com/**' // Allow loading from our assets domain.
	  ]);
	}]).run(["$log", "$transitions", "Localization", "StoreTypes", function ($log, $transitions, Localization, StoreTypes) {
	  'ngInject';
	
	  if (Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE) {
	    $log.info('R-LINK Store embedded in an iframe...');
	    __webpack_require__(1268)(Localization.getLocalizedAppConfig().rootUrl);
	  }
	
	  var redirectToAuthentication = function redirectToAuthentication(trans) {
	    $log.info('User isn\'t authenticated! Redirecting...');
	    return trans.router.stateService.target('authentication');
	  };
	
	  $transitions.onStart({ to: function to(state) {
	      return state.authenticate;
	    } }, function (trans) {
	    $log.debug('Restricted page. Checking authentication...');
	    var userService = trans.injector().get('UserService');
	    var myRenaultResolver = trans.injector().get('MyRenaultResolver');
	    if (myRenaultResolver.isMyRenault()) {
	      $log.debug('Helios, One or MyRenault website. Checking token...');
	      return _promise2.default.resolve();
	    } else {
	      $log.debug('Standalone or RSite website. Fetching current user...');
	      if (userService.getCurrentToken()) {
	        return userService.getCurrentUser().then(function (user) {
	          $log.debug('User found: ', user);
	          if (!user) {
	            return redirectToAuthentication(trans);
	          } else {
	            // password expired
	            if (userService.isPasswordExpired(user.lastPasswordUpdate, Localization.getLocalizedAppConfig().passwordExpirationDay) && trans.targetState().identifier() !== 'changePassword') {
	              // Redirect to the change password page
	              return trans.router.stateService.target('changePassword');
	            }
	          }
	        });
	      } else {
	        return redirectToAuthentication(trans);
	      }
	    }
	  });
	
	  $transitions.onStart({ to: function to(state) {
	      return state.authenticatedForbidden;
	    } }, function (trans) {
	    $log.debug('Page forbidden if authenticated. Checking authentication...');
	    var userService = trans.injector().get('UserService');
	    var vehicleService = trans.injector().get('VehicleService');
	    var myRenaultResolver = trans.injector().get('MyRenaultResolver');
	    if (myRenaultResolver.isMyRenault()) {
	      $log.debug('Helios, One or MyRenault website. Not concerned...');
	      return _promise2.default.resolve();
	    } else {
	      $log.debug('Standalone or RSite website. Fetching current user...');
	      if (userService.getCurrentToken()) {
	        return userService.getCurrentUser().then(function (user) {
	          if (user) {
	            // password expired
	            if (userService.isPasswordExpired(user.lastPasswordUpdate, Localization.getLocalizedAppConfig().passwordExpirationDay)) {
	              // Redirect to the change password page
	              return trans.router.stateService.target('changePassword');
	            } else {
	              // Redirect to the catalog page
	              return vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	                $log.info('User is authenticated! Redirecting...');
	                if (vehicle) {
	                  return trans.router.stateService.target('vehicle', { vin: vehicle.vin, sync: true });
	                }
	                return trans.router.stateService.target('profile');
	              });
	            }
	          }
	        });
	      }
	    }
	  });
	}]).component('app', _app4.default);

/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var configModule = _angular2.default.module('app.config', []).constant('AppConfig', {
	  'default': {
	    'type': 'standalone',
	    'endpoint': 'https://rcs-store-api.renault.worldline-solutions.com/api',
	    'country': 'ch',
	    'locales': ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hr', 'hu', 'it', 'lt', 'lv', 'nl', 'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'tr', 'uk'],
	    'useCache': true,
	    'guide': 'http://www.e-guide.renault.com',
	    'rlinkModels': [{
	      'id': 'model1Landscape',
	      'title': 'rlink',
	      'huType': 'MM12',
	      'toolbox': {
	        'windowsUrl': 'https://cdn.sa.services.tomtom.com/static/rltb/Windows/InstallRLinkToolbox.exe',
	        'osxUrl': 'https://cdn.sa.services.tomtom.com/static/rltb/Mac/RLinkToolbox.dmg',
	        'imageUrl': 'img/toolbox.jpg',
	        'titleKey': 'registration.toolboxForm.fields.download.rlink.title',
	        'descriptionKey': 'registration.toolboxForm.fields.download.rlink.description'
	      },
	      'type': 'landscape'
	    }, {
	      'id': 'model2Portrait',
	      'title': 'rlink2',
	      'huType': 'RADNAV',
	      'toolbox': {
	        'windowsUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
	        'osxUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
	        'imageUrl': 'img/toolbox_2.jpg',
	        'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
	        'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
	      },
	      'type': 'portrait'
	    }, {
	      'id': 'model2Landscape',
	      'title': 'rlink2',
	      'huType': 'RADNAV',
	      'toolbox': {
	        'windowsUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
	        'osxUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
	        'imageUrl': 'img/toolbox_2.jpg',
	        'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
	        'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
	      },
	      'type': 'landscape'
	    }],
	    'googleRecaptchaClientKey': '6LcMcBEUAAAAANcj-ngWfpWhORUdieg0P7eXtZi0',
	    'freeProductsOnly': false,
	    'currency': 'EUR',
	    'passwordExpirationDay': 1080
	  },
	  'fr': {
	    'type': 'helios',
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-38',
	    'errorUrl': 'https://www.renault.fr/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.fr',
	    'gdprLink': 'https://easyconnect.renault.fr/pages/privacy'
	  },
	  'be': {
	    'locales': ['fr', 'nl'],
	    'trackingIdGA': 'UA-66069168-1',
	    'gdprLink': 'https://easyconnect.renault.be/pages/privacy'
	  },
	  'lu': {
	    'locales': ['fr', 'en'],
	    'trackingIdGA': 'UA-66069168-2',
	    'gdprLink': 'https://easyconnect.renault.lu/pages/privacy'
	  },
	  're': {
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-3',
	    'gdprLink': 'https://easyconnect.renault.fr/pages/privacy'
	  },
	  'mq': {
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-4'
	  },
	  'yt': {
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-5'
	  },
	  'gp': {
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-6'
	  },
	  'gf': {
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-7'
	  },
	  'ch': {
	    'locales': ['fr', 'de', 'it'],
	    'trackingIdGA': 'UA-66069168-42'
	  },
	  'at': {
	    'locales': ['de'],
	    'trackingIdGA': 'UA-66069168-43',
	    'gdprLink': 'https://easyconnect.renault.at/pages/privacy'
	  },
	  'ar': {
	    'locales': ['en', 'es'],
	    'trackingIdGA': 'UA-66069168-18'
	  },
	  'br': {
	    'locales': ['en', 'pb'],
	    'trackingIdGA': 'UA-66069168-21'
	  },
	  'cl': {
	    'locales': ['en', 'es'],
	    'trackingIdGA': 'UA-66069168-20',
	    'freeProductsOnly': true
	  },
	  'mx': {
	    'locales': ['en', 'es'],
	    'trackingIdGA': 'UA-66069168-19'
	  },
	  'ee': {
	    'locales': ['en', 'et'],
	    'trackingIdGA': 'UA-66069168-26'
	  },
	  'lt': {
	    'locales': ['en', 'lt'],
	    'trackingIdGA': 'UA-66069168-24'
	  },
	  'lv': {
	    'locales': ['en', 'lv'],
	    'trackingIdGA': 'UA-66069168-23'
	  },
	  'gr': {
	    'locales': ['en', 'el'],
	    'trackingIdGA': 'UA-66069168-25'
	  },
	  'bg': {
	    'locales': ['en', 'bg'],
	    'trackingIdGA': 'UA-66073389-2'
	  },
	  'ua': {
	    'locales': ['en', 'uk'],
	    'trackingIdGA': 'UA-66069168-22'
	  },
	  'co': {
	    'locales': ['en', 'es'],
	    'trackingIdGA': 'UA-66073389-1'
	  },
	  'hu': {
	    'locales': ['hu'],
	    'trackingIdGA': 'UA-66069168-34',
	    'gdprLink': 'https://easyconnect.renault.hu/pages/privacy'
	  },
	  'cz': {
	    'locales': ['cs'],
	    'trackingIdGA': 'UA-66069168-33',
	    'gdprLink': 'https://easyconnect.renault.cz/pages/privacy'
	  },
	  'sk': {
	    'locales': ['sk'],
	    'trackingIdGA': 'UA-66069168-35',
	    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
	  },
	  'de': {
	    'type': 'helios',
	    'locales': ['de'],
	    'trackingIdGA': 'UA-66069168-39',
	    'errorUrl': 'https://www.renault.de/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.de',
	    'gdprLink': 'https://easyconnect.renault.de/pages/privacy'
	  },
	  'es': {
	    'type': 'helios',
	    'locales': ['es'],
	    'trackingIdGA': 'UA-66069168-40',
	    'errorUrl': 'https://www.renault.es/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.es',
	    'gdprLink': 'https://easyconnect.renault.es/pages/privacy'
	  },
	  'ae': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-27'
	  },
	  'bh': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-28'
	  },
	  'kw': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-29'
	  },
	  'om': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-30'
	  },
	  'qa': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-31'
	  },
	  'sa': {
	    'locales': ['en', 'ar'],
	    'trackingIdGA': 'UA-66069168-32'
	  },
	  'it': {
	    'type': 'helios',
	    'locales': ['it'],
	    'trackingIdGA': 'UA-66069168-41',
	    'errorUrl': 'https://www.renault.it/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.it'
	  },
	  'ma': {
	    'type': 'helios',
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-36',
	    'errorUrl': 'https://www.renault.ma/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.ma'
	  },
	  'dz': {
	    'type': 'helios',
	    'locales': ['fr'],
	    'trackingIdGA': 'UA-66069168-37',
	    'errorUrl': 'https://www.renault.dz/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.dz'
	  },
	  'gb': {
	    'locales': ['en'],
	    'trackingIdGA': 'UA-66069168-8',
	    'currency': 'GBP',
	    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
	  },
	  'ie': {
	    'locales': ['en'],
	    'trackingIdGA': 'UA-66069168-9',
	    'gdprLink': 'https://easyconnect.renault.co.ie/pages/privacy'
	  },
	  'in': {
	    'locales': ['en'],
	    'trackingIdGA': 'UA-66069168-11'
	  },
	  'au': {
	    'locales': ['en'],
	    'trackingIdGA': 'UA-66069168-10'
	  },
	  'za': {
	    'locales': ['en'],
	    'trackingIdGA': 'UA-66069168-12'
	  },
	  'se': {
	    'locales': ['sv'],
	    'trackingIdGA': 'UA-66069168-13',
	    'gdprLink': 'https://easyconnect.renault.se/pages/privacy'
	  },
	  'no': {
	    'locales': ['no'],
	    'trackingIdGA': 'UA-66069168-14'
	  },
	  'fi': {
	    'locales': ['en', 'fi', 'sv'],
	    'trackingIdGA': 'UA-66069168-16',
	    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
	  },
	  'dk': {
	    'locales': ['da'],
	    'trackingIdGA': 'UA-66069168-15',
	    'gdprLink': 'https://easyconnect.renault.dk/pages/privacy'
	  },
	  'si': {
	    'type': 'helios',
	    'locales': ['sl'],
	    'trackingIdGA': 'UA-66069168-45',
	    'errorUrl': 'https://www.renault.si/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.si',
	    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
	  },
	  'hr': {
	    'type': 'helios',
	    'locales': ['hr'],
	    'trackingIdGA': 'UA-66069168-44',
	    'errorUrl': 'https://www.renault.hr/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.hr',
	    'gdprLink': 'https://easyconnect.renault.hr/pages/privacy'
	  },
	  'nl': {
	    'locales': ['nl'],
	    'trackingIdGA': 'UA-66069168-46',
	    'gdprLink': 'https://easyconnect.renault.nl/pages/privacy'
	  },
	  'pl': {
	    'type': 'helios',
	    'locales': ['pl'],
	    'trackingIdGA': 'UA-66069168-47',
	    'errorUrl': 'https://www.renault.pl/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.pl',
	    'gdprLink': 'https://easyconnect.renault.pl/pages/privacy'
	  },
	  'pt': {
	    'type': 'helios',
	    'locales': ['pt'],
	    'trackingIdGA': 'UA-66069168-48',
	    'errorUrl': 'https://www.renault.pt/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.pt',
	    'gdprLink': 'https://easyconnect.renault.pt/pages/privacy'
	  },
	  'ro': {
	    'type': 'helios',
	    'locales': ['ro'],
	    'trackingIdGA': 'UA-66069168-49',
	    'errorUrl': 'https://www.renault.ro/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.ro',
	    'gdprLink': 'https://easyconnect.renault.at/pages/privacy'
	  },
	  'ru': {
	    'type': 'helios',
	    'locales': ['ru', 'en'],
	    'trackingIdGA': 'UA-66069168-50',
	    'currency': 'RUB',
	    'errorUrl': 'https://www.renault.ru/esc/rlink/store/error.action?error=',
	    'rootUrl': 'https://myr.renault.ru'
	  },
	  'tr': {
	    'locales': ['tr'],
	    'trackingIdGA': 'UA-66069168-17'
	  },
	  'zz': {
	    'locales': ['fr', 'en'],
	    'trackingIdGA': 'UA-xxxxxxxx-xx'
	  },
	  'pages': {
	    'home': {
	      'slides': ['photo_001', 'photo_002', 'photo_003', 'photo_004', 'photo_005', 'photo_006'],
	      'paragraphs': ['illustration_01', 'illustration_02']
	    }
	  }
	}).name;
	
	exports.default = configModule;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _error = __webpack_require__(560);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _appMessage = __webpack_require__(571);
	
	var _appMessage2 = _interopRequireDefault(_appMessage);
	
	var _spinner = __webpack_require__(577);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cookiesConsent = __webpack_require__(582);
	
	var _cookiesConsent2 = _interopRequireDefault(_cookiesConsent);
	
	var _documentConsent = __webpack_require__(604);
	
	var _documentConsent2 = _interopRequireDefault(_documentConsent);
	
	var _emailLinkRedirect = __webpack_require__(613);
	
	var _emailLinkRedirect2 = _interopRequireDefault(_emailLinkRedirect);
	
	var _filters = __webpack_require__(614);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _footer = __webpack_require__(620);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _googleAnalytics = __webpack_require__(626);
	
	var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);
	
	var _header = __webpack_require__(628);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _helpBlock = __webpack_require__(634);
	
	var _helpBlock2 = _interopRequireDefault(_helpBlock);
	
	var _i18n = __webpack_require__(644);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _iframeRedirect = __webpack_require__(651);
	
	var _iframeRedirect2 = _interopRequireDefault(_iframeRedirect);
	
	var _inputTooltip = __webpack_require__(652);
	
	var _inputTooltip2 = _interopRequireDefault(_inputTooltip);
	
	var _interceptors = __webpack_require__(658);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _localization = __webpack_require__(662);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _myRenault = __webpack_require__(715);
	
	var _myRenault2 = _interopRequireDefault(_myRenault);
	
	var _navbar = __webpack_require__(717);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _rlinkAppsStatus = __webpack_require__(723);
	
	var _rlinkAppsStatus2 = _interopRequireDefault(_rlinkAppsStatus);
	
	var _storeTypes = __webpack_require__(733);
	
	var _storeTypes2 = _interopRequireDefault(_storeTypes);
	
	var _tooltip = __webpack_require__(734);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _validators = __webpack_require__(737);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.common', [_error2.default, _appMessage2.default, _spinner2.default, _cookiesConsent2.default, _documentConsent2.default, _emailLinkRedirect2.default, _filters2.default, _googleAnalytics2.default, _header2.default, _myRenault2.default, _helpBlock2.default, _i18n2.default, _iframeRedirect2.default, _inputTooltip2.default, _interceptors2.default, _localization2.default, _navbar2.default, _rlinkAppsStatus2.default, _storeTypes2.default, _tooltip2.default, _validators2.default, _footer2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _error = __webpack_require__(561);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('appError', []).component('appError', _error2.default).name;
	
	exports.default = _module;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _error = __webpack_require__(562);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _error3 = __webpack_require__(563);
	
	var _error4 = _interopRequireDefault(_error3);
	
	__webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    error: '<',
	    title: '@',
	    description: '@'
	  },
	  template: _error2.default,
	  controller: _error4.default
	};
	
	exports.default = component;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.error \">\n<h2>{{$ctrl.title | translate}}</h2>\n<p>{{$ctrl.description | translate}}</p>\n<pre ng-if=\"$ctrl.details\">{{$ctrl.details}}</pre>\n</div>\n"

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorController = function () {
	  function ErrorController() {
	    (0, _classCallCheck3.default)(this, ErrorController);
	  }
	
	  (0, _createClass3.default)(ErrorController, [{
	    key: 'title',
	    set: function set(title) {
	      this._title = title;
	    },
	    get: function get() {
	      if (this._title) {
	        return this._title;
	      }
	      if (!this.error) {
	        return null;
	      }
	      var status = this.error.status;
	
	      if (status) {
	        return 'error.' + status + '.title';
	      }
	      return 'error.500.title';
	    }
	  }, {
	    key: 'description',
	    set: function set(desc) {
	      this._description = desc;
	    },
	    get: function get() {
	      if (this._description) {
	        return this._description;
	      }
	      if (!this.error) {
	        return null;
	      }
	      var status = this.error.status;
	
	      if (status) {
	        return 'error.' + status + '.description';
	      }
	      return 'error.500.description';
	    }
	  }, {
	    key: 'details',
	    get: function get() {
	      var data = this.error.data;
	
	      return data;
	    }
	  }]);
	  return ErrorController;
	}();
	
	exports.default = ErrorController;

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(570);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./error.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./error.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "app-error>div{background-color:#c42720;border:1px solid #ab0700;color:#fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.4)}app-error>div h2{margin:0}app-error>div pre{display:none}", ""]);
	
	// exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _appMessage = __webpack_require__(572);
	
	var _appMessage2 = _interopRequireDefault(_appMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('appMessageModule', []).component('appMessage', _appMessage2.default).name;
	
	exports.default = _module;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appMessage = __webpack_require__(573);
	
	var _appMessage2 = _interopRequireDefault(_appMessage);
	
	var _appMessage3 = __webpack_require__(574);
	
	var _appMessage4 = _interopRequireDefault(_appMessage3);
	
	__webpack_require__(575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    success: '<',
	    error: '<',
	    info: '<',
	    delay: '<'
	  },
	  template: _appMessage2.default,
	  controller: _appMessage4.default
	};
	
	exports.default = component;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<p class=\"app-message animate-show-hide ng-hide-animate\"\n   ng-class=\"{error: $ctrl.error, success: $ctrl.success, info: $ctrl.info, delay: $ctrl.delay}\"\n   ng-if=\"($ctrl.success || $ctrl.error || ($ctrl.info && $ctrl.info.message && !$ctrl.getConsent($ctrl.info.cookieKey)))\">\n   <span>{{ ($ctrl.error.message || $ctrl.success || $ctrl.info.message) | translate }}</span>\n   <a href=\"#\" ng-click=\"$ctrl.hide()\">x</a>\n</p>\n\n<pre ng-if=\"$ctrl.error\" style=\"display: none;\">{{$ctrl.error.cause}}</pre>\n"

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppMessageController = function () {
	  AppMessageController.$inject = ["$timeout", "$log", "$window"];
	  function AppMessageController($timeout, $log, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AppMessageController);
	    this.$timeout = $timeout;
	    this.$log = $log;
	    this.$window = $window;
	    if (!this.delay) {
	      this.delay = 5000;
	    } else {
	      this.delay = parseInt(this.delay);
	    }
	  }
	
	  (0, _createClass3.default)(AppMessageController, [{
	    key: '$onChanges',
	    value: function $onChanges(changes) {
	      var _this = this;
	
	      // this.$log.debug('$onChanges', changes)
	      var _error = changes.error;
	      var _success = changes.success;
	      if (_error && _error.currentValue || _success && _success.currentValue) {
	        if (_error && _error.currentValue) this.error = _error.currentValue;
	        if (_success && _success.currentValue) this.success = _success.currentValue;
	        if (this.error && !isNaN(this.error.delay)) this.delay = this.error.delay;else if (this.success && !isNaN(this.success.delay)) this.delay = this.success.delay;
	        if (this.delay > 0) {
	          this.$timeout(function () {
	            _this.error = null;
	            _this.success = null;
	          }, this.delay);
	        }
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (!this.error && !this.success && this.info) {
	        this.setConsent(this.info.cookieKey);
	      }
	      this.error = null;
	      this.success = null;
	    }
	  }, {
	    key: 'setConsent',
	    value: function setConsent(cookieKey) {
	      try {
	        if (this.$window.localStorage) {
	          this.$window.localStorage[cookieKey] = true;
	        }
	      } catch (e) {
	        this.$log.error('Error while closing info', cookieKey);
	      }
	    }
	  }, {
	    key: 'getConsent',
	    value: function getConsent(cookieKey) {
	      try {
	        if (this.$window.localStorage) {
	          return this.$window.localStorage[cookieKey] ? JSON.parse(this.$window.localStorage[cookieKey]) : false;
	        }
	      } catch (e) {
	        this.$log.error('Error while hiding info', cookieKey);
	      }
	    }
	  }]);
	  return AppMessageController;
	}();
	
	exports.default = AppMessageController;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(576);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./app-message.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./app-message.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "app-message p{transition:all 1s linear;position:relative;display:block;padding:1.5em 3em 1.5em 5em;color:#fff;text-align:center;font-size:.8em;background-color:#000;opacity:1}app-message p.animate-show-hide.ng-hide{opacity:0}app-message p.animate-show-hide.ng-hide-add,app-message p.animate-show-hide.ng-hide-remove{transition:all .5s linear}app-message p.info{background-color:#ffde00}app-message p.success{background-color:#079201}app-message p.success:before{content:\"\\E66E\"!important}app-message p.error{background-color:#bd3632}app-message p.error:before{content:\"\\E602\"!important}app-message p:before{content:\"\";font-family:icon-Renault-Global;speak:none;left:10%}app-message p:before,app-message p a{font-size:1.3em;position:absolute;top:1.1em}app-message p a{color:#fff!important;right:5%;text-decoration:none}", ""]);
	
	// exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _spinner = __webpack_require__(578);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('spinner', []).component('appSpinner', _spinner2.default).name;
	
	exports.default = _module;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _spinner = __webpack_require__(579);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	__webpack_require__(580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _spinner2.default
	};
	
	exports.default = component;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dimmer\">\n  <div class=\"spinner\"></div>\n</div>\n"

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(581);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./spinner.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./spinner.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".dimmer{background:#fff;opacity:.8;top:0;left:0;width:100%;height:100%;z-index:9999;display:flex;align-items:center;justify-content:center}.dimmer,.spinner{position:absolute}.spinner{height:60px;width:60px;margin:0 auto;top:50%;margin-top:-30px;left:50%;margin-left:-30px;animation:rotation .6s infinite linear;border-left:6px solid rgba(0,174,239,.15);border-right:6px solid rgba(0,174,239,.15);border-bottom:6px solid rgba(0,174,239,.15);border-top:6px solid rgba(0,174,239,.8);border-radius:100%}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);
	
	// exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cookiesConsent = __webpack_require__(583);
	
	var _cookiesConsent2 = _interopRequireDefault(_cookiesConsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('cookiesConsent', []).component('cookiesConsent', _cookiesConsent2.default).name;
	
	exports.default = _module;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookiesConsent = __webpack_require__(584);
	
	var _cookiesConsent2 = _interopRequireDefault(_cookiesConsent);
	
	var _cookiesConsent3 = __webpack_require__(585);
	
	var _cookiesConsent4 = _interopRequireDefault(_cookiesConsent3);
	
	__webpack_require__(602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _cookiesConsent2.default,
	  controller: _cookiesConsent4.default
	};
	
	exports.default = component;

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.shouldBeOpen\" id=\"cookies-consent\" class=\"infoCookies popin\" aria-hidden=\"false\">\n  <div class=\"toggles\">\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      {{ 'cookiesConsent.use' | translate }}\n    </p>\n    <div ng-repeat=\"(key, value) in $ctrl.consent\" ng-class=\"{'last': $last}\" class=\"cookie-choice\">\n      <label class=\"toggle\" for=\"cookie-form-{{key}}\">\n        <input id=\"cookie-form-{{key}}\" type=\"checkbox\" ng-model='value' class=\"toggle__input\" />\n        <span class=\"toggle-track\"><span class=\"toggle-indicator\"></span></span>\n        {{ 'cookiesConsent.' + key | translate }}\n      </label>\n    </div>\n  </div>\n  <a href=\"/cookies\" title=\"{{ 'cookiesConsent.knowMore.title' | translate }}\" ga-track-event=\"['Cookies Banner', 'Click', 'Know More']\">{{ 'cookiesConsent.knowMore.text' | translate }}</a>\n  <div class=\"buttons\" ng-class=\"{'arabCookiesConsent':  $ctrl.I18n.isArLocale()}\">\n      <button class=\"button light\" title=\"{{ 'cookiesConsent.save' | translate }}\" ng-click=\"$ctrl.save()\">{{ 'cookiesConsent.save' | translate }}</button>\n      <button class=\"button light\" title=\"{{ 'cookiesConsent.acceptAll' | translate }}\" ng-click=\"$ctrl.acceptAll()\">{{ 'cookiesConsent.acceptAll' | translate }}</button>\n      <button class=\"button dark\" title=\"{{ 'cookiesConsent.refuseAll' | translate }}\" ng-click=\"$ctrl.rejectAll()\">{{ 'cookiesConsent.refuseAll' | translate }}</button>\n  </div>\n</div>\n"

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(586);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COOKIE_CONSENT_BUTTON_FORM_PREFIX = 'cookie-form-';
	var COOKIES_KEYS = ['audienceMeasurement', 'captcha'];
	
	var CookiesConsentController = function () {
	  CookiesConsentController.$inject = ["$rootScope", "$window", "I18n", "CookiesService"];
	  function CookiesConsentController($rootScope, $window, I18n, CookiesService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CookiesConsentController);
	    this.COOKIES_KEYS = COOKIES_KEYS;
	    this.CookiesService = CookiesService;
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	    this.I18n = I18n;
	  }
	
	  (0, _createClass3.default)(CookiesConsentController, [{
	    key: 'save',
	    value: function save() {
	      this.CookiesService.consent = COOKIES_KEYS.reduce(function (result, item) {
	        result[item] = document.getElementById(COOKIE_CONSENT_BUTTON_FORM_PREFIX + item).checked;
	        return result;
	      }, {});
	      this.onUpdate();
	    }
	  }, {
	    key: 'acceptAll',
	    value: function acceptAll() {
	      this.CookiesService.consent = COOKIES_KEYS.reduce(function (result, item) {
	        result[item] = true;
	        return result;
	      }, {});
	      this.onUpdate();
	    }
	  }, {
	    key: 'rejectAll',
	    value: function rejectAll() {
	      this.CookiesService.consent = COOKIES_KEYS.reduce(function (result, item) {
	        result[item] = false;
	        return result;
	      }, {});
	      this.onUpdate();
	    }
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate() {
	      this.CookiesService.requestEdit = false;
	      this.open = false;
	      this.$rootScope.$broadcast('cookieConsentUpdated');
	    }
	  }, {
	    key: 'consent',
	    get: function get() {
	      var consent = this.CookiesService.consent;
	      if (consent === null || (typeof consent === 'undefined' ? 'undefined' : (0, _typeof3.default)(consent)) !== 'object') {
	        consent = {};
	      }
	      for (var key in consent) {
	        if (COOKIES_KEYS.indexOf(key) === -1) {
	          delete consent[key];
	        }
	      }
	      for (var i = 0; i < COOKIES_KEYS.length; i++) {
	        var cookieskey = COOKIES_KEYS[i];
	        if (!consent.hasOwnProperty(cookieskey) || typeof consent[cookieskey] !== 'boolean') {
	          consent[cookieskey] = false;
	        }
	      }
	      return consent;
	    }
	  }, {
	    key: 'shouldBeOpen',
	    get: function get() {
	      return !this.consentUpToDate || this.CookiesService.requestEdit;
	    }
	  }, {
	    key: 'consentUpToDate',
	    get: function get() {
	      var consent = this.CookiesService.consent;
	      // migration from the old way of managing consent
	      // if a key is missing, the consent is ask again (old values are kept)
	      if (consent !== null && (typeof consent === 'undefined' ? 'undefined' : (0, _typeof3.default)(consent)) === 'object') {
	        for (var i = 0; i < COOKIES_KEYS.length; i++) {
	          if (!consent.hasOwnProperty(COOKIES_KEYS[i])) {
	            return false;
	          }
	        }
	        return true;
	      }
	      return false;
	    }
	  }]);
	  return CookiesConsentController;
	}();
	
	exports.default = CookiesConsentController;

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./cookies-consent.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./cookies-consent.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:200px){cookies-consent .infoCookies{top:inherit;bottom:0;z-index:100}cookies-consent .infoCookies a{float:right;margin-top:-5px;margin-right:-5px}cookies-consent button{padding:.75em 1em .7em!important}cookies-consent button:after{content:none!important}cookies-consent .dark{background-color:#262625!important;color:#fff!important}cookies-consent .dark:hover{background-color:#666!important}}", ""]);
	
	// exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _documentConsent = __webpack_require__(605);
	
	var _documentConsent2 = _interopRequireDefault(_documentConsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('documentConsent', []).component('documentConsent', _documentConsent2.default).name;
	
	exports.default = _module;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _documentConsent = __webpack_require__(606);
	
	var _documentConsent2 = _interopRequireDefault(_documentConsent);
	
	var _documentConsent3 = __webpack_require__(607);
	
	var _documentConsent4 = _interopRequireDefault(_documentConsent3);
	
	__webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _documentConsent2.default,
	  controller: _documentConsent4.default
	};
	
	exports.default = component;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.consent\" id=\"document-consent\" class=\"infoDocument popin card\" aria-hidden=\"false\">\n  <h3 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n    {{ 'legal_documents.title' | translate }}\n  </h3>\n  <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n    {{ 'legal_documents.description' | translate }}\n  </p>\n  <table>\n    <table>\n      <thead>\n      <tr>\n        <th>{{ 'legal_documents.type' | translate }}</th>\n        <th>{{ 'legal_documents.version' | translate }}</th>\n        <th>{{ 'legal_documents.lastVersion' | translate }}</th>\n        <th>{{ 'legal_documents.link' | translate }}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"document in $ctrl.documents\">\n        <td>{{ document.type }}</td>\n        <td>{{ document.version }}</td>\n        <td>{{ document.lastVersion }}</td>\n        <td><a href=\"{{ $ctrl.makeLink(document) }}\" target=\"_blank\">{{ $ctrl.makeName(document) }}</a></td>\n      </tr>\n      </tbody>\n    </table>\n  </table>\n  <ul class=\"buttonList\">\n    <li>\n      <button class=\"button submit\" type=\"submit\" ng-click=\"$ctrl.validateConsents()\" ga-track-event=\"['Document Popup', 'Click', 'Validate']\">\n        {{ 'legal_documents.validate' | translate }}\n      </button>\n    </li>\n    <li>\n      <button class=\"button cancel\" ng-click=\"$ctrl.disableConsent()\" ga-track-event=\"['Document Popup', 'Click', 'Close']\" type=\"button\">\n        {{ 'legal_documents.close' | translate }}\n      </button>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(608);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentConsentController = function () {
	  DocumentConsentController.$inject = ["$window", "I18n", "$scope", "$rootScope", "DocumentsService"];
	  function DocumentConsentController($window, I18n, $scope, $rootScope, DocumentsService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DocumentConsentController);
	    this.$window = $window;
	    this.I18n = I18n;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    // show variable is just for cosmetic, without that the popup would be displayed on login and hidden after page load
	    this.show = false;
	    this.documentsService = DocumentsService;
	    this.documentsService.getUntreatedDocuments().then(function (result) {
	      _this.documents = result;
	      console.log(_this.documents);
	      if (_this.documents.length !== 0) {
	        _this.show = true;
	      } else {
	        _this.show = false;
	        _this.$rootScope.$broadcast('checkDocumentConsent:off');
	      }
	    }).catch(function () {
	      _this.documents = [];
	      _this.show = false;
	    });
	  }
	
	  (0, _createClass3.default)(DocumentConsentController, [{
	    key: 'disableConsent',
	    value: function disableConsent() {
	      this.$rootScope.$broadcast('checkDocumentConsent:off');
	    }
	  }, {
	    key: 'validateConsents',
	    value: function validateConsents() {
	      var idToVcalidate = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.documents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var document = _step.value;
	
	          idToVcalidate.push(document.id);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.documentsService.sendDocumentConsent(idToVcalidate);
	      this.$rootScope.$broadcast('checkDocumentConsent:off');
	    }
	  }, {
	    key: 'makeName',
	    value: function makeName(document) {
	      var prefix;
	      switch (document.type) {
	        case 'EULA':
	          prefix = 'legalInformation';
	          break;
	        case 'GTC':
	          prefix = 'generalTermsAndConditions';
	          break;
	        case 'WITHDRAWAL':
	          prefix = 'withdrawalRights';
	          break;
	        default:
	          prefix = 'UNKNOWN';
	      }
	      var documentName = prefix + '_' + document.country + '_' + this.I18n.getLanguage() + '_latest.pdf';
	
	      return documentName;
	    }
	  }, {
	    key: 'makeLink',
	    value: function makeLink(document) {
	      var path;
	      var prefix;
	      switch (document.type) {
	        case 'EULA':
	          prefix = 'legalInformation';
	          path = 'pdf/published-pdf/EULA/';
	          break;
	        case 'GTC':
	          prefix = 'generalTermsAndConditions';
	          path = 'pdf/published-pdf/GTC/';
	          break;
	        case 'WITHDRAWAL':
	          prefix = 'withdrawalRights';
	          path = 'pdf/published-pdf/WITHDRAWAL/';
	          break;
	        default:
	          prefix = 'UNKNOWN';
	          path = '/';
	      }
	      var documentName = path + prefix + '_' + document.country + '_' + this.I18n.getLanguage() + '_latest.pdf';
	
	      return documentName;
	    }
	  }, {
	    key: 'consent',
	    get: function get() {
	      return this.show;
	    }
	  }]);
	  return DocumentConsentController;
	}();
	
	exports.default = DocumentConsentController;

/***/ }),
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(612);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./document-consent.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./document-consent.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:100px){.infoDocument{z-index:10}}", ""]);
	
	// exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TARGET_RESET_PASSWORD = 'account/ValidateResetPassword/';
	var TARGET_VALIDATE_EMAIL = 'account/ValidateMail/';
	
	var _module = _angular2.default.module('emailLinkRedirect', []).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('standaloneRedirections', {
	    url: '/:country/home?target&locale',
	    redirectTo: function redirectTo(trans) {
	      var target = trans.params().target;
	      var locale = void 0;
	      var I18n = trans.injector().get('I18n');
	      // Reset password confirmation
	      if (target && target.startsWith(TARGET_RESET_PASSWORD)) {
	        target = target.replace(TARGET_RESET_PASSWORD, '');
	        if (target.includes('?locale=')) {
	          locale = target.split('?locale=')[1];
	          target = target.split('?')[0];
	        }
	        if (target) {
	          var params = target.split('/');
	          if (params && params.length === 2) {
	            var email = params[0];
	            var token = params[1];
	            if (email && token) {
	              if (locale) {
	                return I18n.changeLanguage(locale).then(function () {
	                  return { state: 'authentication', params: { email: email, token: token } };
	                });
	              } else {
	                return { state: 'authentication', params: { email: email, token: token } };
	              }
	            }
	          }
	        }
	        // Registration confirmation
	      } else if (target && target.startsWith(TARGET_VALIDATE_EMAIL)) {
	        target = target.replace(TARGET_VALIDATE_EMAIL, '');
	        if (target.includes('?locale=')) {
	          locale = target.split('?locale=')[1];
	          target = target.split('?')[0];
	        }
	        if (target) {
	          var _params = target.split('/');
	          if (_params && _params.length === 3) {
	            var _email = _params[0];
	            var _token = _params[1];
	            var huType = _params[2];
	            if (_email && _token && huType) {
	              if (locale) {
	                return I18n.changeLanguage(locale).then(function () {
	                  return { state: 'authentication', params: { email: _email, token: _token, huType: huType } };
	                });
	              } else {
	                return { state: 'authentication', params: { email: _email, token: _token, huType: huType } };
	              }
	            }
	          }
	        }
	      }
	      return 'home';
	    }
	  }).state('validateMailRSiteRedirectionWithLocale', {
	    url: '/{country}/' + TARGET_VALIDATE_EMAIL + ':email/:token/:huType',
	    redirectTo: function redirectTo(trans) {
	      var _trans$params = trans.params(),
	          country = _trans$params.country,
	          email = _trans$params.email,
	          token = _trans$params.token,
	          huType = _trans$params.huType;
	
	      if (email && token && huType) {
	        var I18n = trans.injector().get('I18n');
	        return I18n.changeLanguage(country).then(function () {
	          return { state: 'authentication', params: { email: email, token: token, huType: huType } };
	        });
	      }
	      return 'home';
	    }
	  }).state('validateMailRSiteRedirection', {
	    url: '/' + TARGET_VALIDATE_EMAIL + ':email/:token/:huType',
	    redirectTo: function redirectTo(trans) {
	      var _trans$params2 = trans.params(),
	          email = _trans$params2.email,
	          token = _trans$params2.token,
	          huType = _trans$params2.huType;
	
	      if (email && token && huType) {
	        return { state: 'authentication', params: { email: email, token: token, huType: huType } };
	      }
	      return 'home';
	    }
	  }).state('validateResetPasswordRSiteRedirectionWithLocale', {
	    url: '/{country}/' + TARGET_RESET_PASSWORD + ':email/:token',
	    redirectTo: function redirectTo(trans) {
	      var _trans$params3 = trans.params(),
	          country = _trans$params3.country,
	          email = _trans$params3.email,
	          token = _trans$params3.token;
	
	      if (email && token) {
	        var I18n = trans.injector().get('I18n');
	        return I18n.changeLanguage(country).then(function () {
	          return { state: 'authentication', params: { email: email, token: token } };
	        });
	      }
	      return 'home';
	    }
	  }).state('validateResetPasswordRSiteRedirection', {
	    url: '/' + TARGET_RESET_PASSWORD + ':email/:token',
	    redirectTo: function redirectTo(trans) {
	      var _trans$params4 = trans.params(),
	          email = _trans$params4.email,
	          token = _trans$params4.token;
	
	      if (email && token) {
	        return { state: 'authentication', params: { email: email, token: token } };
	      }
	      return 'home';
	    }
	  });
	}]).name;
	
	exports.default = _module;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _currencies = __webpack_require__(619);
	
	var _currencies2 = _interopRequireDefault(_currencies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('filtersModule', []).filter('trustHtml', ["$sce", function ($sce) {
	  'ngInject';
	
	  return function (html) {
	    return $sce.trustAsHtml(html);
	  };
	}]).filter('escapeSingleQuote', function () {
	  return function (label) {
	    return label.replace(/'/g, '\\\'');
	  };
	}).filter('price', ["$filter", "$locale", "Localization", function ($filter, $locale, Localization) {
	  'ngInject';
	
	  return function (price) {
	    $locale.NUMBER_FORMATS = (0, _assign2.default)({}, _currencies2.default[Localization.getLocalizedAppConfig().currency]['NUMBER_FORMATS']);
	    if (!price) return price;
	    return price.match(/free/i) || parseFloat(price.replace(/,/g, '.')) === 0 ? 'catalog.product.free' : $filter('currency')(parseFloat(price.replace(/,/g, '.')));
	  };
	}]).filter('orderTranslate', ["$translate", function ($translate) {
	  'ngInject';
	
	  return function (key) {
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    return key.map(function (k) {
	      return {
	        k: k,
	        v: $translate.instant(prefix + k.toLowerCase())
	      };
	    }).sort(function (a, b) {
	      return a.v > b.v ? 1 : -1;
	    }).map(function (o) {
	      return o.k;
	    });
	  };
	}]).name;
	
	exports.default = _module;

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */
/***/ (function(module, exports) {

	module.exports = {"EUR":{"NUMBER_FORMATS":{"CURRENCY_SYM":"€","DECIMAL_SEP":",","GROUP_SEP":" ","PATTERNS":[{"gSize":3,"lgSize":3,"maxFrac":3,"minFrac":0,"minInt":1,"negPre":"-","negSuf":"","posPre":"","posSuf":""},{"gSize":3,"lgSize":3,"maxFrac":2,"minFrac":2,"minInt":1,"negPre":"-","negSuf":" ¤","posPre":"","posSuf":" ¤"}]}},"GBP":{"NUMBER_FORMATS":{"CURRENCY_SYM":"£","DECIMAL_SEP":".","GROUP_SEP":",","PATTERNS":[{"gSize":3,"lgSize":3,"maxFrac":3,"minFrac":0,"minInt":1,"negPre":"-","negSuf":"","posPre":"","posSuf":""},{"gSize":3,"lgSize":3,"maxFrac":2,"minFrac":2,"minInt":1,"negPre":"-¤","negSuf":"","posPre":"¤","posSuf":""}]}},"RUB":{"NUMBER_FORMATS":{"CURRENCY_SYM":"руб.","DECIMAL_SEP":",","GROUP_SEP":" ","PATTERNS":[{"gSize":3,"lgSize":3,"maxFrac":3,"minFrac":0,"minInt":1,"negPre":"-","negSuf":"","posPre":"","posSuf":""},{"gSize":3,"lgSize":3,"maxFrac":2,"minFrac":2,"minInt":1,"negPre":"-","negSuf":" ¤","posPre":"","posSuf":" ¤"}]}}}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _footer = __webpack_require__(621);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('footer', [_angularUiRouter2.default]).component('appFooter', _footer2.default).name;
	
	exports.default = _module;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _footer = __webpack_require__(622);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _footer3 = __webpack_require__(623);
	
	var _footer4 = _interopRequireDefault(_footer3);
	
	__webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _footer2.default,
	  controller: _footer4.default
	};
	
	exports.default = component;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"pageContent\">\n  <div class=\"footerLegal\">\n    <div class=\"infoCompany limitContent\">\n      <ul class=\"floatedLeft lineList tab desk\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n        <li><a ng-href=\"pdf/published-pdf/EULA/legalInformation_{{$ctrl.country}}_{{$ctrl.I18n.getLanguage()}}_latest.pdf\" target=\"_blank\" ga-track-event=\"['Footer', 'Click', 'Legal Info']\">{{'footer.legalInformation' | translate }}</a></li>\n        <li><a ng-href=\"pdf/published-pdf/GTC/generalTermsAndConditions_{{$ctrl.country}}_{{$ctrl.I18n.getLanguage()}}_latest.pdf\" target=\"_blank\" ga-track-event=\"['Footer', 'Click', 'General terms and conditions of sale']\">{{'footer.generalTermsAndConditions' | translate }}</a></li>\n        <li ng-if=\"!$ctrl.isMaintenance()\"><a ng-href=\"/cookies\" ga-track-event=\"['Footer', 'Click', 'Cookies']\">{{'footer.cookies' | translate}}</a></li>\n      </ul>\n      <ul class=\"floatedRight lineList tab desk\">\n        <li><a href=\"http://www.renault.com\" target=\"_blank\" ga-track-event=\"['Footer', 'Click', 'Renault Link']\">www.renault.com</a></li>\n        <li><span>{{ $ctrl.clock | date:'short' }} {{'footer.info' | translate}} {{ $ctrl.clock | date:'yyyy' }}</span></li>\n      </ul>\n    </div>\n  </div>\n</footer>\n"

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterController = function () {
	  FooterController.$inject = ["$interval", "$state", "Localization", "I18n"];
	  function FooterController($interval, $state, Localization, I18n) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FooterController);
	    this.I18n = I18n;
	    this.country = Localization.getCountry().toUpperCase();
	    var tick = function tick() {
	      if (!_this.clock) {
	        _this.clock = Date.now();
	        return;
	      }
	      var now = new Date();
	      if (new Date(_this.clock).getMinutes() !== now.getMinutes()) {
	        _this.clock = now.getTime();
	      }
	    };
	    tick();
	    $interval(tick, 1000);
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(FooterController, [{
	    key: 'isMaintenance',
	    value: function isMaintenance() {
	      return this.$state.is('maintenance');
	    }
	  }]);
	  return FooterController;
	}();
	
	exports.default = FooterController;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./footer.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./footer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "app-footer footer.pageContent{position:static}", ""]);
	
	// exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularGoogleAnalytics = __webpack_require__(627);
	
	var _angularGoogleAnalytics2 = _interopRequireDefault(_angularGoogleAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('googleAnalytics', [_angularGoogleAnalytics2.default]).config(["AnalyticsProvider", function (AnalyticsProvider) {
	  'ngInject';
	
	  AnalyticsProvider.useAnalytics(false);
	  AnalyticsProvider.startOffline(true);
	  AnalyticsProvider.setAccount([]);
	}]).run(["$rootScope", "Analytics", "Localization", "CookiesService", function ($rootScope, Analytics, Localization, CookiesService) {
	  'ngInject';
	
	  var account = {
	    tracker: Localization.getLocalizedAppConfig().trackingIdGA,
	    trackEvent: true
	  };
	
	  $rootScope.$on('cookieConsentUpdated', function () {
	    var consentValue = CookiesService.consentForCookie('audienceMeasurement');
	    Analytics.offline(!consentValue);
	  });
	
	  Analytics.configuration.accounts.push(account);
	  Analytics.registerScriptTags();
	  Analytics.registerTrackers();
	  var consentForGa = CookiesService.consentForCookie('audienceMeasurement');
	  Analytics.offline(!consentForGa);
	}]).name;
	
	exports.default = _module;

/***/ }),
/* 627 */,
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _header = __webpack_require__(629);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('header', [_angularUiRouter2.default]).component('appHeader', _header2.default).name;
	
	exports.default = _module;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(630);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _header3 = __webpack_require__(631);
	
	var _header4 = _interopRequireDefault(_header3);
	
	__webpack_require__(632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _header2.default,
	  controller: _header4.default
	};
	
	exports.default = component;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <a class=\"skiplinks txtUppercase\" href=\"#container\" ga-track-event=\"['Header', 'Click', 'Skip to content']\">{{'header.content' | translate}}</a>\n  <div role=\"navigation\" aria-label=\"Global navigation\" ng-class=\"{'open openHeader': $ctrl.showHeader}\">\n    <button class=\"hideMenu mobile tablet\" ng-click=\"$ctrl.showHeader = false; $ctrl.showLangList = false\" ga-track-event=\"['Header', 'Click', 'Hide Mobile Menu']\">\n      <span class=\"txtHidden\">{{'header.hideMenu' | translate}}</span>\n    </button>\n    <div class=\"limitContent\">\n      <ul class=\"cars\" ng-if=\"$ctrl.vehicles.length\">\n        <li ng-repeat=\"vehicle in $ctrl.vehicles\">\n          <a ui-sref=\"vehicle({vin: '{{vehicle.vin}}', sync: true})\" ng-class=\"{'active': $ctrl.vehicleService.getCurrentVin() === '{{vehicle.vin}}'}\" ng-click=\"$ctrl.showHeader = false\" ga-track-event=\"['Header', 'Click', 'Select VIN']\">{{vehicle.friendlyName}}</a>\n        </li>\n      </ul>\n      <ul class=\"login floatedLeft lineList\" ng-if=\"$ctrl.user\">\n        <li>\n          <a class=\"user\" ui-sref=\"profile\" ng-click=\"$ctrl.showHeader = false\" ga-track-event=\"['Header', 'Click', 'Profile']\">\n            <img class=\"valignMiddle\" src=\"img/avatar.png\" width=\"20\" height=\"20\" alt=\"Picto profil\" />\n            <span>{{$ctrl.user.firstName}} {{$ctrl.user.lastName}}</span>\n          </a>\n        </li>\n        <li>\n          <a class=\"logout\" href=\"#\" ng-click=\"$ctrl.handleLogout()\" ga-track-event=\"['Header', 'Click', 'Logout']\"><span>{{'common.logout' | translate}}</span></a>\n        </li>\n      </ul>\n      <div class=\"lang dropDownMenu floatedRight\">\n        <button class=\"dropDown ng-class:{active : $ctrl.showLangList}\" title=\"{{ 'common.clickToUnfoldMenu' | translate }}\" ng-click=\"$ctrl.showLangList = !$ctrl.showLangList\" ga-track-event=\"['Header', 'Click', 'Show Language Menu {{$ctrl.locale}}']\">{{ 'common.languages.' + $ctrl.locale | translate }}</button>\n        <ul ng-class=\"{active: $ctrl.showLangList}\">\n          <li ng-repeat=\"locale in $ctrl.locales\" ng-if=\"locale != $ctrl.locale\" ng-click=\"[$ctrl.locale = locale, $ctrl.showLangList = false, $ctrl.showHeader = false]\"><a href=\"#\" ga-track-event=\"['Header', 'Click', 'Choose Language {{locale}}']\" hreflang=\"{{locale}}\">{{ 'common.languages.' + locale | translate }}</a></li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"titleLogo noNavUnder limitContent\">\n    <button class=\"showMenu floatedLeft mobile tablet\" ng-click=\"$ctrl.showHeader = true\" ga-track-event=\"['Header', 'Click', 'Show Mobile Menu']\">\n      <span class=\"txtHidden\">{{'header.showMenu' | translate}}</span>\n    </button>\n    <a href=\"#\" class=\"logo floatedRight\" ga-track-event=\"['Header', 'Click', 'Renault Logo']\">\n      <img class=\"desktop\" src=\"img/logo-desktop-en.jpg\" alt=\"Renault, Passion for life\" width=\"190\" height=\"62\" />\n      <img class=\"mobile tablet\" src=\"img/logo-mobile.jpg\" width=\"55\" height=\"35\" alt=\"Renault\" />\n    </a>\n    <h1 class=\"txtTruncated\"><a ng-click=\"$ctrl.returnHome()\" href=\"\">{{'header.title' | translate}}</a></h1>\n  </div>\n</header>\n"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderController = function () {
	  HeaderController.$inject = ["Localization", "I18n", "$state", "$rootScope", "$scope", "UserService", "VehicleService", "$log"];
	  function HeaderController(Localization, I18n, $state, $rootScope, $scope, UserService, VehicleService, $log) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HeaderController);
	    this.I18n = I18n;
	    this.locales = Localization.getLocalizedAppConfig().locales;
	    this.passwordExpirationDay = Localization.getLocalizedAppConfig().passwordExpirationDay;
	    this.userService = UserService;
	    this.vehicleService = VehicleService;
	    this.$state = $state;
	    this.$log = $log;
	    this.$rootScope = $rootScope;
	    $scope.$on('user:login', function (event, data) {
	      _this.init().then(function () {
	        _this.$rootScope.$broadcast('checkDocumentConsent:on');
	      });
	    });
	    $scope.$on('user:logout', function (event, data) {
	      _this.user = null;
	      _this.vehicles = null;
	      _this.vehicle = null;
	      _this.$rootScope.$broadcast('checkDocumentConsent:off');
	    });
	    $scope.$on('vehicles:update', function (event, data) {
	      _this.vehicleService.getCurrentUserVehicles().then(function (vehicles) {
	        _this.vehicles = vehicles;
	        return _this.vehicleService.getCurrentSelectedVehicle();
	      }).then(function (vehicle) {
	        _this.vehicle = vehicle;
	      }).catch(function (err) {
	        _this.$log.error('Unable to load HeaderController', err);
	      });
	    });
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(HeaderController, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      if (!this.userService.getCurrentToken()) {
	        return _promise2.default.resolve();
	      }
	      return this.userService.getCurrentUser().then(function (user) {
	        _this2.user = user;
	        _this2.$log.debug('Header user: ', user);
	        if (_this2.userService.isPasswordExpired(user.lastPasswordUpdate, _this2.passwordExpirationDay)) {
	          _this2.$log.debug('Header password expired');
	          return _promise2.default.reject({ passwordExpired: true });
	        } else {
	          _this2.$log.debug('Header password not expired');
	          return _this2.vehicleService.synchronizeCurrentUserVehicles();
	        }
	      }).then(function () {
	        _this2.$log.info('Vehicles synchronized from CSDB');
	        return _this2.vehicleService.getCurrentUserVehicles(false);
	      }, function (err) {
	        _this2.$log.error('Vehicles not synchronized from CSDB', err);
	        if (err && err.passwordExpired) {
	          return _promise2.default.reject();
	        } else {
	          return _this2.vehicleService.getCurrentUserVehicles(false);
	        }
	      }).then(function (vehicles) {
	        _this2.vehicles = vehicles;
	        return _this2.vehicleService.getCurrentSelectedVehicle(false);
	      }).then(function (vehicle) {
	        _this2.vehicle = vehicle;
	      }).catch(function (err) {
	        if (err && !err.passwordExpired) {
	          _this2.user = null;
	        }
	        _this2.vehicles = null;
	        _this2.vehicle = null;
	        _this2.$log.error('Unable to load HeaderController', err);
	      });
	    }
	  }, {
	    key: 'returnHome',
	    value: function returnHome() {
	      document.location = document.location.origin;
	    }
	  }, {
	    key: 'isMaintenance',
	    value: function isMaintenance() {
	      return this.$state.is('maintenance');
	    }
	  }, {
	    key: 'handleLogout',
	    value: function handleLogout() {
	      var _this3 = this;
	
	      this.userService.logout().then(function () {
	        return _this3.$state.go('home');
	      });
	    }
	  }, {
	    key: 'locale',
	    get: function get() {
	      return this.I18n.getLanguage();
	    },
	    set: function set(locale) {
	      this.I18n.changeLanguage(locale);
	    }
	  }]);
	  return HeaderController;
	}();
	
	exports.default = HeaderController;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(633);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./header.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./header.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "app-header .openHeader{left:0!important}@media (min-width:1200px){app-header header ul.cars li a{max-width:170px;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}app-header header ul.cars .active{font-weight:700}app-header .dropDownMenu{line-height:2em}app-header .dropDownMenu .dropDown{margin:0!important;padding:0!important}app-header .dropDownMenu ul{z-index:11}@media (max-width:1199px){app-header .dropDownMenu .dropDown{padding:1em 2.5em 1em 1em!important}app-header div[role=navigation].open{overflow-y:scroll;height:100vh}}@media (min-width:1200px){app-header header div[role=navigation]{line-height:2em!important}}app-header .dropDownMenu ul.active{display:block!important;line-height:1.5em!important}app-header button.dropDown{line-height:1.5em!important}.rsite app-header button{float:right}.rsite app-header .showMenu:before{width:1em;height:1em;background-image:url(\"/img/avatar.png\");background-size:1em 1em;display:inline-block;content:\"\"}.rsite app-header .hideMenu{right:0;left:auto}.rsite app-header .dropDownMenu ul{top:3.3em}@media (-ms-high-contrast:active),(max-width:1199px) and (-ms-high-contrast:none){app-header button.showMenu:before{font-size:.4em}}", ""]);
	
	// exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _helpBlock = __webpack_require__(635);
	
	var _helpBlock2 = _interopRequireDefault(_helpBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('helpBlockModule', []).component('helpBlock', _helpBlock2.default).name;
	
	exports.default = _module;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpBlock = __webpack_require__(636);
	
	var _helpBlock2 = _interopRequireDefault(_helpBlock);
	
	var _helpBlock3 = __webpack_require__(637);
	
	var _helpBlock4 = _interopRequireDefault(_helpBlock3);
	
	__webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _helpBlock2.default,
	  controller: _helpBlock4.default
	};
	
	exports.default = component;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.sections.length\">\n<h2>\n  {{ 'helpBlock.title' | translate }}\n</h2>\n<ul>\n  <li ng-repeat=\"section in $ctrl.sections\">\n    <div class=\"video\">\n      <iframe width=\"400\" height=\"220\" ng-src=\"{{ section.video | translate }}\" frameborder=\"0\"></iframe>\n    </div>\n    <h3 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ section.title | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ section.text | translate }}</p>\n  </li>\n</ul>\n<a class=\"button more\" ng-href=\"http://www.e-guide.renault.com\" target=\"_blank\" ga-track-event=\"['Help', 'Click', 'All Guides']\">\n  {{ 'helpBlock.allGuides' | translate }}\n</a>\n</div>\n"

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _from = __webpack_require__(638);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlockController = function () {
	  HelpBlockController.$inject = ["VehicleService", "$translate", "I18n"];
	  function HelpBlockController(VehicleService, $translate, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HelpBlockController);
	    this.vehicleService = VehicleService;
	    this.$translate = $translate;
	    this.I18n = I18n;
	
	    this.sections = [];
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(HelpBlockController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	        _this.model = vehicle ? vehicle.huType : null;
	        return _this.loadSections((0, _from2.default)({ length: 3 }, function (v, i) {
	          return i + 1;
	        }));
	      });
	    }
	  }, {
	    key: 'getTranslateKey',
	    value: function getTranslateKey(sectionNumber, field) {
	      var section = 'section' + sectionNumber;
	      return 'helpBlock.' + this.model + '.' + section + '.' + field;
	    }
	  }, {
	    key: 'loadSections',
	    value: function loadSections(_sections) {
	      var _this2 = this;
	
	      return _promise2.default.all(_sections.map(function (section) {
	        var key = _this2.getTranslateKey(section, 'title');
	        return _this2.$translate(key).then(function (trans) {
	          return trans ? section : null;
	        }, function () {
	          return _promise2.default.resolve(null);
	        });
	      })).then(function (sections) {
	        _this2.sections = sections.filter(function (section) {
	          return !!section;
	        }).map(function (section) {
	          return {
	            title: _this2.getTranslateKey(section, 'title'),
	            text: _this2.getTranslateKey(section, 'text'),
	            video: _this2.getTranslateKey(section, 'video')
	          };
	        });
	        return _promise2.default.resolve(_this2.sections);
	      });
	    }
	  }]);
	  return HelpBlockController;
	}();
	
	exports.default = HelpBlockController;

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(643);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./help-block.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./help-block.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "help-block h2{font-size:1.7em;padding:.5em;margin:1em 0}help-block ul{list-style:none;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:center;justify-content:center;margin-left:-2em;margin-top:-3em}help-block ul li{margin-top:3em;margin-left:1.7em;width:290px}help-block ul li>p{font-size:.8em;padding:0 1.1em}@media (min-width:600px){help-block ul li:first-child{margin-left:0}}help-block ul iframe{width:100%;height:auto;max-width:290px}help-block ul h3{font-family:Renault Regular,Helvetica,Arial,sans-serif;font-size:1.1em;text-align:left;padding:.5em .7em;margin-bottom:0;margin-top:0}help-block a.button{width:100%;text-transform:lowercase}help-block a.button.more{padding:.75em 5em .7em 2.5em;font-size:1.4em}help-block a.button:after{position:relative;right:.1em;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularTranslate = __webpack_require__(645);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _angularTranslateLoaderStaticFiles = __webpack_require__(646);
	
	var _angularTranslateLoaderStaticFiles2 = _interopRequireDefault(_angularTranslateLoaderStaticFiles);
	
	var _angularDynamicLocale = __webpack_require__(647);
	
	var _angularDynamicLocale2 = _interopRequireDefault(_angularDynamicLocale);
	
	var _angularSanitize = __webpack_require__(648);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _i18n = __webpack_require__(650);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('i18n', [_angularTranslate2.default, _angularTranslateLoaderStaticFiles2.default, _angularDynamicLocale2.default, _angularSanitize2.default]).config(["$translateProvider", "tmhDynamicLocaleProvider", function ($translateProvider, tmhDynamicLocaleProvider) {
	  'ngInject';
	
	  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
	
	  $translateProvider.useStaticFilesLoader({
	    prefix: 'i18n/translations_',
	    suffix: '.json'
	  });
	
	  tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
	}]).run(["$translate", "tmhDynamicLocale", "Localization", "I18n", function ($translate, tmhDynamicLocale, Localization, I18n) {
	  'ngInject';
	
	  $translate.preferredLanguage(I18n.getDefaultLanguage());
	  $translate.fallbackLanguage('en');
	  $translate.use(I18n.getDefaultLanguage());
	  $translate.refresh();
	  tmhDynamicLocale.set(I18n.getDefaultLanguage());
	}]).factory('I18n', _i18n2.default).name;
	
	exports.default = _module;

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18nFactory = function I18nFactory($translate, tmhDynamicLocale, Localization, $rootScope, $log, $state, $location) {
	  'ngInject';
	
	  var config = Localization.getLocalizedAppConfig();
	
	  var isLocaleInAppConfig = function isLocaleInAppConfig(locale) {
	    return config.locales.find(function (lang) {
	      return lang === locale;
	    });
	  };
	
	  var getDefaultLanguage = function getDefaultLanguage() {
	    var lang = navigator.language.split('-')[0];
	    var defaultLanguage = isLocaleInAppConfig(lang) ? lang : config.locales[0];
	    return defaultLanguage;
	  };
	
	  var changeLanguage = function changeLanguage(locale) {
	    if (isLocaleInAppConfig(locale)) {
	      return $translate.use(locale).then(function () {
	        tmhDynamicLocale.set(locale);
	        $log.debug('New locale: ', $translate.use());
	        $rootScope.$broadcast('language:changed', locale);
	        if ($state.current.name && !$location.url().includes('locale')) {
	          return $state.reload();
	        } else {
	          return _promise2.default.resolve();
	        }
	      });
	    } else {
	      return _promise2.default.resolve();
	    }
	  };
	
	  var getLanguage = function getLanguage() {
	    return $translate.use() || getDefaultLanguage();
	  };
	
	  var isArLocale = function isArLocale() {
	    return getLanguage() === 'ar';
	  };
	  return { getDefaultLanguage: getDefaultLanguage, changeLanguage: changeLanguage, getLanguage: getLanguage, isArLocale: isArLocale };
	};
	I18nFactory.$inject = ["$translate", "tmhDynamicLocale", "Localization", "$rootScope", "$log", "$state", "$location"];
	
	exports.default = I18nFactory;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('iframeRedirect', []).config(["$urlRouterProvider", function ($urlRouterProvider) {
	  'ngInject';
	
	  // Redirect MyRenault
	
	  $urlRouterProvider.when('/store/home', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle', $location);
	  }]).when('/store/selectedproducts', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle', $location);
	  }]).when('/product/slisthistory', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.myPurchaseRecords', $location);
	  }]).when('/store/update', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.myUpdates', $location);
	  }]).when('/store/transferproducts', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.transferMyServices', $location);
	  }]).when('/account/myprofile', ["$state", function ($state) {
	    'ngInject';
	
	    return $state.go('profile');
	  }]).when('/account/mygarage', ["$state", function ($state) {
	    'ngInject';
	
	    return $state.go('profile.myGarage');
	  }]).when('/purchase/{idProduct}/confirmation', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'managePurchase.confirmation', $location);
	  }]).when('/store/help', ["$state", "VehicleService", "MyRenaultResolver", "$location", function ($state, VehicleService, MyRenaultResolver, $location) {
	    'ngInject';
	
	    checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'help', $location);
	  }]);
	}]).run(["$transitions", "$location", "MyRenaultResolver", "I18n", function ($transitions, $location, MyRenaultResolver, I18n) {
	  'ngInject';
	
	  // Change language if locale is set in query parameters
	
	  $transitions.onStart({}, function (trans) {
	    var locale = $location.search().locale;
	    I18n.changeLanguage(locale);
	  });
	}]).name;
	
	var checkMyRenaultTokenAndRedirect = function checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, to, $location) {
	  if (MyRenaultResolver.isMyRenault()) {
	    return MyRenaultResolver.verifyToken(to === 'vehicle').then(function () {
	      return redirectTo($state, VehicleService, to, $location);
	    });
	  }
	  return redirectTo($state, VehicleService, to, $location);
	};
	
	var redirectTo = function redirectTo($state, VehicleService, to, $location) {
	  return VehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	    if (vehicle) {
	      if (to === 'managePurchase.confirmation') {
	        var productId = $location.path().split('/')[2];
	        return $state.go(to, { 'productId': productId, 'status': $location.search().status, 'reduction': $location.search().reduction, 'voucher': $location.search().voucher });
	      } else {
	        return $state.go(to, { 'vin': vehicle.vin, sync: true });
	      }
	    } else {
	      return $state.go('home');
	    }
	  });
	};
	
	exports.default = _module;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _inputTooltip = __webpack_require__(653);
	
	var _inputTooltip2 = _interopRequireDefault(_inputTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('inputTooltipModule', []).component('inputTooltip', _inputTooltip2.default).name;
	
	exports.default = _module;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputTooltip = __webpack_require__(654);
	
	var _inputTooltip2 = _interopRequireDefault(_inputTooltip);
	
	var _inputTooltip3 = __webpack_require__(655);
	
	var _inputTooltip4 = _interopRequireDefault(_inputTooltip3);
	
	__webpack_require__(656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    text: '@',
	    name: '@'
	  },
	  controller: _inputTooltip4.default,
	  template: _inputTooltip2.default
	};
	
	exports.default = component;

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "<button type=\"button\" ng-click=\"$ctrl.toggleTooltip()\" ga-track-event=\"['Input Tooltip', 'Click', 'Show {{ $ctrl.name | translate | escapeSingleQuote }}']\">\n</button>\n<tooltip show=\"$ctrl.showTooltip\"\n         text=\"$ctrl.text\"\n         name=\"$ctrl.name\">\n</tooltip>\n"

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputTooltipController = function () {
	  InputTooltipController.$inject = ["$rootScope"];
	  function InputTooltipController($rootScope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, InputTooltipController);
	    this.$rootScope = $rootScope;
	
	    $rootScope.$on('tooltip:open', function () {
	      _this.showTooltip = false;
	    });
	  }
	
	  (0, _createClass3.default)(InputTooltipController, [{
	    key: 'toggleTooltip',
	    value: function toggleTooltip() {
	      if (!this.showTooltip) this.$rootScope.$broadcast('tooltip:open');
	      this.showTooltip = !this.showTooltip;
	    }
	  }]);
	  return InputTooltipController;
	}();
	
	exports.default = InputTooltipController;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(657);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./input-tooltip.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./input-tooltip.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:600px){input-tooltip{position:absolute;top:2em;right:-2em}input-tooltip>button{height:1.35em;width:1.35em;border:2px solid #fc0;border-radius:50%;color:#fc0;background-color:#fff}input-tooltip>button:before{content:\"i\";font-family:Renault Bold,Helvetica,Arial,sans-serif}input-tooltip>button:focus{outline:none}input-tooltip tooltip{position:absolute;left:-18.35em;top:40px}input-tooltip tooltip p{white-space:normal}input-tooltip tooltip .tooltipMessage:before{left:100%;margin-left:-30px}input-tooltip tooltip button:focus{outline:none}}", ""]);
	
	// exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _apiInterceptor = __webpack_require__(659);
	
	var _apiInterceptor2 = _interopRequireDefault(_apiInterceptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('interceptors', []).factory('ApiInterceptor', _apiInterceptor2.default.factory).name;
	
	exports.default = _module;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApiInterceptorService = function () {
	  function ApiInterceptorService($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory) {
	    (0, _classCallCheck3.default)(this, ApiInterceptorService);
	
	    this.$log = $log;
	    this.$window = $window;
	    this.Localization = Localization;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$rootScope = $rootScope;
	    this.$q = $q;
	    this.BufferFactory = BufferFactory;
	    this.endpoint = Localization.getLocalizedAppConfig().endpoint;
	    this.request = this.request.bind(this);
	    this.response = this.response.bind(this);
	    this.responseError = this.responseError.bind(this);
	  }
	
	  (0, _createClass3.default)(ApiInterceptorService, [{
	    key: 'request',
	    value: function request(req) {
	      if (req.url.startsWith(this.endpoint)) {
	        req.withCredentials = true;
	        req.headers = (0, _assign2.default)({
	          'X-Country': this.Localization.getCountry()
	        }, req.headers);
	        if (req.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
	          req.data = this.$httpParamSerializerJQLike(req.data);
	        }
	        if (this.$window.sessionStorage['token']) {
	          var tokens = JSON.parse(this.$window.sessionStorage['token']);
	          req.headers['Authorization'] = 'Bearer ' + tokens.access_token;
	        }
	        if (this.$window.sessionStorage['user']) {
	          var user = JSON.parse(this.$window.sessionStorage['user']);
	          var customer = user.customer;
	          var email = customer.email;
	          req.headers['X-Email'] = email;
	        }
	        if (this.$window.sessionStorage['vin']) {
	          var vin = this.$window.sessionStorage['vin'];
	          req.headers['X-Vin'] = vin;
	        }
	        this.$log.debug('API REQUEST', req);
	      }
	      return req;
	    }
	  }, {
	    key: 'response',
	    value: function response(res) {
	      if (res.config.url.startsWith(this.endpoint)) {
	        this.$log.debug('API BUSINESS RESPONSE', res);
	        // Save token into the sessionStorage
	        if (res.data.token) {
	          this.$window.sessionStorage['token'] = (0, _stringify2.default)(res.data.token);
	        }
	      }
	      return _promise2.default.resolve(res);
	    }
	  }, {
	    key: 'responseError',
	    value: function responseError(rejection) {
	      if (rejection.config.url.startsWith(this.endpoint)) {
	        this.$log.error('API ERROR: [', rejection.status, '] - ', rejection.message);
	        var logoutUrl = this.endpoint + '/logout';
	        var refreshTokenUrl = this.endpoint + '/refresh';
	        if (rejection.status === 502 && rejection.data && rejection.data.meta && rejection.data.meta.code === 'ECONNREFUSED') {
	          this.$log.error('API ERROR ECONNREFUSED: R-LINK Store not started');
	          this.$rootScope.$broadcast('service:stopped');
	        }
	        if (rejection.status === 503) {
	          this.$log.error('API IN MAINTENANCE');
	          this.$rootScope.$broadcast('service:maintenance');
	        }
	        if ((rejection.status === 401 || rejection.data && rejection.data.meta && rejection.data.meta.statusCode === 401) && !rejection.config.url.match(new RegExp(logoutUrl)) && !rejection.config.url.match(new RegExp(refreshTokenUrl))) {
	          // Try to obtain a new access_token with the refresh_token
	          var config = rejection.config || {};
	          var deferred = this.$q.defer();
	          var bufferLength = this.BufferFactory.append(config, deferred);
	          this.$log.debug('Buffer length: ', bufferLength);
	          if (bufferLength === 1) {
	            this.$log.error('API ERROR 401: broadcasting user:unauthorized to try and get and new access token');
	            this.$rootScope.$broadcast('user:unauthorized', rejection);
	          }
	          return deferred.promise;
	        }
	        return _promise2.default.reject(rejection);
	      }
	      return _promise2.default.reject(rejection);
	    }
	  }], [{
	    key: 'factory',
	    value: ["$log", "$window", "Localization", "$httpParamSerializerJQLike", "$rootScope", "$q", "BufferFactory", function factory($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory) {
	      'ngInject';
	
	      return new ApiInterceptorService($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory);
	    }]
	  }]);
	  return ApiInterceptorService;
	}();
	
	exports.default = ApiInterceptorService;

/***/ }),
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _localization = __webpack_require__(663);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('localization', []).factory('Localization', _localization2.default).name;
	
	exports.default = _module;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(664);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocalizationFactory = function LocalizationFactory(AppConfig, $location) {
	  'ngInject';
	
	  // expected : https://lu.pp.rlinkstore.com/... to extract "lu"
	
	  var getCountry = function getCountry() {
	    var host = $location.host();
	    var country = 'default';
	    if (host.includes('rlinkstore')) {
	      country = $location.host().split('.')[0];
	    } else {
	      country = $location.host().split('-')[2];
	    }
	    if (!country || country !== 'default' && country.length !== 2 && country !== 'beta' && country !== 'belux' && country !== 'chat') {
	      country = AppConfig.default.country;
	    }
	    if (country === 'beta') {
	      country = 'zz';
	    }
	    if (country === 'belux') {
	      country = 'be';
	    }
	    if (country === 'chat') {
	      country = 'ch';
	    }
	    return country;
	  };
	
	  var getLocalizedAppConfig = function getLocalizedAppConfig() {
	    return (0, _assign3.default)({}, AppConfig.default, AppConfig[getCountry()]);
	  };
	
	  return { getCountry: getCountry, getLocalizedAppConfig: getLocalizedAppConfig };
	};
	LocalizationFactory.$inject = ["AppConfig", "$location"];
	
	exports.default = LocalizationFactory;

/***/ }),
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myRenault = __webpack_require__(716);
	
	var _myRenault2 = _interopRequireDefault(_myRenault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MYRENAULT_ERROR_CODES = {
	  TOKEN_EXPIRED: 1,
	  545: 1, // LsfErrorType.TOKEN_MYRENAULT_EXPIRED
	  552: 1, // LsfErrorType.TOKEN_MYRENAULT_WRONGDATEFORMAT
	  INVALID_SIGNATURE: 2,
	  546: 2, // LsfErrorType.TOKEN_MYRENAULT_SIGNATURE_INVALID
	  UNKNOWN_EMAIL: 3,
	  524: 3, // LsfErrorType.USER_NOT_FOUND
	  508: 3, // LsfErrorType.LOGIN_FAILED
	  VIN_EMAIL_ASSOCIATION: 4,
	  TOKEN_NOT_PRESENT: 5,
	  551: 5, // LsfErrorType.TOKEN_MYRENAULT_NOTPRESENT
	  SESSION_TIMEOUT: 6,
	  VIN_NOT_PRESENT: 7,
	  VIN_IS_NULL: 8,
	  UNKNOWN_VIN: 9,
	  594: 9 // LsfErrorType.UNKNOWN_VIN
	};
	
	var _module = _angular2.default.module('myRenault', [])
	
	// Keep MyRenault token between pages
	.run(["$transitions", "$location", "MyRenaultResolver", "Localization", "$window", function ($transitions, $location, MyRenaultResolver, Localization, $window) {
	  'ngInject';
	
	  if (MyRenaultResolver.isMyRenault()) {
	    var token = void 0;
	
	    $transitions.onBefore({ to: function to(state) {
	        return state.myRenaultForbidden;
	      } }, function (trans) {
	      $window.top.location.href = Localization.getLocalizedAppConfig().errorUrl + '403';
	    });
	
	    $transitions.onStart({}, function (trans) {
	      token = $location.search().token;
	    });
	
	    $transitions.onSuccess({}, function (trans) {
	      $location.search('token', token);
	    });
	  }
	}]).service('MyRenaultResolver', _myRenault2.default).constant('MyRenaultErrorCodes', MYRENAULT_ERROR_CODES).name;
	
	exports.default = _module;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyRenaultResolver = function () {
	  MyRenaultResolver.$inject = ["Localization", "UserService", "VehicleService", "IdsService", "$log", "$window", "$location", "StoreTypes", "MyRenaultErrorCodes", "MetricsService"];
	  function MyRenaultResolver(Localization, UserService, VehicleService, IdsService, $log, $window, $location, StoreTypes, MyRenaultErrorCodes, MetricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyRenaultResolver);
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.errorUrl = Localization.getLocalizedAppConfig().errorUrl;
	    this.UserService = UserService;
	    this.VehicleService = VehicleService;
	    this.IdsService = IdsService;
	    this.$log = $log;
	    this.$window = $window;
	    this.$location = $location;
	    this.StoreTypes = StoreTypes;
	    this.myRenaultErrorCodes = MyRenaultErrorCodes;
	    this.metricsService = MetricsService;
	  }
	
	  (0, _createClass3.default)(MyRenaultResolver, [{
	    key: 'isMyRenault',
	    value: function isMyRenault() {
	      return this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.ONE;
	    }
	  }, {
	    key: 'verifyToken',
	    value: function verifyToken(saveMetrics) {
	      var _this = this;
	
	      var token = this.$location.search().token ? this.$location.search().token : this.$window.localStorage.getItem('token');
	      if (token) {
	        if (saveMetrics) {
	          this.metricsService.startPageLoadTime();
	        }
	        if (!this.$location.search().token) {
	          this.$location.search('token', token);
	        }
	        var vinInToken = token.match(/<vin>(.+?)<\/vin>/);
	        var vin = vinInToken ? vinInToken[1] : null;
	        var emailInToken = token.match(/<login_id>(.+?)<\/login_id>/);
	        var email = emailInToken ? emailInToken[1] : null;
	        if (this.UserService.getCurrentToken()) {
	          this.$log.debug('Token found in session storage');
	          return this.UserService.getCurrentUser().then(function (user) {
	            if (!(user && user.email)) {
	              _this.$log.warn('Current user not found, call login');
	              return _this.login(token, vin);
	            } else {
	              if (email === user.email) {
	                _this.$log.debug('Current user found, call verifyVin');
	                return _this.verifyVin(vin);
	              } else {
	                _this.$log.debug('Current user doesn\'t match with helios token, call login');
	                return _this.login(token, vin);
	              }
	            }
	          }, function (err) {
	            _this.$log.error('Error while retrieving current user, call login', err);
	            return _this.login(token, vin);
	          });
	        } else {
	          this.$log.debug('Current token not found, call login');
	          return this.login(token, vin);
	        }
	      } else {
	        // Error 5
	        this.$log.error('Token not found! Redirecting...');
	        this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.TOKEN_NOT_PRESENT);
	        return this.metricsService.endPageLoadTime(500).then(function () {
	          return _promise2.default.reject();
	        });
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login(token, vin) {
	      var _this2 = this;
	
	      return this.UserService.login({ token: token }).then(function () {
	        _this2.$log.debug('Login OK, call synchronizeCurrentUserVehicles');
	        return _this2.VehicleService.synchronizeCurrentUserVehicles().then(function () {
	          _this2.$log.debug('Vehicles synchronized from CSDB, call verifyVin');
	          return _this2.verifyVin(vin);
	        }, function (err) {
	          _this2.$log.error('Vehicles not synchronized from CSDB, call verifyVin', err);
	          return _this2.verifyVin(vin);
	        });
	      }, function (err) {
	        // Error 1, 2, 3 or not treated
	        _this2.$log.error('User authentication failed! Redirecting...', err);
	        var errorCode = err.data && err.data.meta && err.data.meta.code && _this2.myRenaultErrorCodes.hasOwnProperty(err.data.meta.code) ? _this2.myRenaultErrorCodes[err.data.meta.code] : '';
	        _this2.$window.top.location.href = _this2.errorPage(errorCode);
	        return _this2.metricsService.endPageLoadTime(500).then(function () {
	          return _promise2.default.reject();
	        });
	      });
	    }
	  }, {
	    key: 'verifyVin',
	    value: function verifyVin(vin) {
	      var _this3 = this;
	
	      // Error 7, 8, 9
	      if (vin === null) {
	        this.$log.error('Vin is null! Redirecting...');
	        this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.VIN_IS_NULL);
	        return this.metricsService.endPageLoadTime(500).then(function () {
	          return _promise2.default.reject();
	        });
	      }
	      if (!vin) {
	        this.$log.error('Vin not present! Redirecting...');
	        this.$window.top.location.href = this.errorPage(this.myRenaultErrorCodes.VIN_NOT_PRESENT);
	        return this.metricsService.endPageLoadTime(500).then(function () {
	          return _promise2.default.reject();
	        });
	      }
	      return this.IdsService.encode(vin).then(function (svin) {
	        _this3.$log.debug('Vin encoded, call getCurrentSelectedVehicle');
	        _this3.svin = svin;
	        return _this3.VehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	          if (vehicle && vehicle.vin === _this3.svin) {
	            _this3.$log.debug('Current selected vehicle OK, return');
	            return _promise2.default.resolve();
	          } else {
	            _this3.$log.debug('Current selected vehicle NOK, switching vehicle');
	            return _this3.VehicleService.setCurrentSelectedVehicle(_this3.svin);
	          }
	        }).catch(function (err) {
	          _this3.$log.warn('Unable to switch to vehicle, call synchronizeCurrentUserVehicles', err);
	          return _this3.VehicleService.synchronizeCurrentUserVehicles().then(function () {
	            _this3.$log.debug('Vehicles synchronized from CSDB, call getCurrentUserVehicles');
	            return _this3.VehicleService.getCurrentUserVehicles(false);
	          }, function (err) {
	            _this3.$log.warn('Vehicles not synchronized from CSDB, call getCurrentUserVehicles', err);
	            return _this3.VehicleService.getCurrentUserVehicles(false);
	          }).then(function () {
	            _this3.$log.debug('Vehicles fetched, switching vehicle');
	            return _this3.VehicleService.setCurrentSelectedVehicle(_this3.svin);
	          }).catch(function (err) {
	            _this3.$log.error('Vin is not associated to email! Redirecting...', err);
	            _this3.$window.top.location.href = _this3.errorPage(_this3.myRenaultErrorCodes.VIN_EMAIL_ASSOCIATION);
	            return _this3.metricsService.endPageLoadTime(500).then(function () {
	              return _promise2.default.reject();
	            });
	          });
	        });
	      }, function (err) {
	        _this3.$log.error('Vin unknown! Redirecting...', err);
	        _this3.$window.top.location.href = _this3.errorPage(_this3.myRenaultErrorCodes.UNKNOWN_VIN);
	        return _this3.metricsService.endPageLoadTime(500).then(function () {
	          return _promise2.default.reject();
	        });
	      });
	    }
	  }, {
	    key: 'errorPage',
	    value: function errorPage(errorCode) {
	      this.UserService.clearSession();
	      return this.errorUrl + errorCode;
	    }
	  }]);
	  return MyRenaultResolver;
	}();
	
	exports.default = MyRenaultResolver;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(718);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = _module;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(719);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(720);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = component;

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageNavigation ng-class:{'openPageNavigation': $ctrl.showPageNavigation}\" ng-if=\"$ctrl.showNavbar && $ctrl.isLogged\">\n  <button class=\"showMenu mobile tablet\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-click=\"$ctrl.showPageNavigation = !$ctrl.showPageNavigation\" ga-track-event=\"['Navbar', 'Click', 'Show/Hide Menu']\">\n    <span ng-if=\"$ctrl.vehicles && !$ctrl.$state.is('vehicle.productDetails') && !$ctrl.$state.is('managePurchase.myPurchase') && !$ctrl.$state.is('managePurchase.confirmation')\" class=\"limitContent txtTruncated\" ui-sref=\"vehicle.catalog({vin: '{{$ctrl.vehicle.vin}}'})\" ui-sref-active=\"showPageTitle\">{{ 'navbar.appsAndMaps' | translate }}</span>\n    <span ng-if=\"$ctrl.vehicles && ($ctrl.$state.is('vehicle.productDetails') || $ctrl.$state.is('managePurchase.myPurchase') || $ctrl.$state.is('managePurchase.confirmation'))\" class=\"limitContent txtTruncated showPageTitle\" ui-sref=\"vehicle.catalog({vin: '{{$ctrl.vehicle.vin}}'})\">{{ 'navbar.appsAndMaps' | translate }}</span>\n    <span ng-if=\"$ctrl.vehicles\" class=\"limitContent txtTruncated\" ui-sref=\"vehicle.manageMyRlink({vin: '{{$ctrl.vehicle.vin}}'})\" ui-sref-active=\"showPageTitle\">{{ 'navbar.manageRLINK' | translate }}</span>\n    <span class=\"limitContent txtTruncated\" ui-sref=\"profile\" ui-sref-active=\"showPageTitle\">{{ 'navbar.dashboard' | translate }}</span>\n    <span ng-if=\"$ctrl.vehicles\" class=\"limitContent txtTruncated\" ui-sref=\"help\" ui-sref-active=\"showPageTitle\">{{ 'navbar.help' | translate }}</span>\n    <span ng-if=\"$ctrl.$state.is('installation')\" class=\"limitContent txtTruncated showPageTitle\">{{ 'installationGuide.title' | translate }}</span>\n    <span ng-if=\"$ctrl.$state.is('cookies')\" class=\"limitContent txtTruncated showPageTitle\">{{ 'cookies.title' | translate }}</span>\n  </button>\n  <nav class=\"limitContent\" aria-label=\"main navigation\">\n    <ul class=\"floatedLeft lineList\" ng-class=\"{'arabDirectionFloat':  $ctrl.I18n.isArLocale()}\">\n      <li ng-if=\"$ctrl.vehicles && !$ctrl.$state.is('vehicle.productDetails') && !$ctrl.$state.is('managePurchase.myPurchase') && !$ctrl.$state.is('managePurchase.confirmation')\" ui-sref=\"vehicle.catalog({vin: '{{$ctrl.vehicle.vin}}'})\" ui-sref-active=\"active\"><a href ng-click=\"$ctrl.showPageNavigation = false\" ga-track-event=\"['Navbar', 'Click', 'My Catalog']\">{{ 'navbar.appsAndMaps' | translate }}</a></li>\n      <li ng-if=\"$ctrl.vehicles && ($ctrl.$state.is('vehicle.productDetails') || $ctrl.$state.is('managePurchase.myPurchase') || $ctrl.$state.is('managePurchase.confirmation'))\" ui-sref=\"vehicle.catalog({vin: '{{$ctrl.vehicle.vin}}'})\" class=\"active\"><a href ng-click=\"$ctrl.showPageNavigation = false\" ga-track-event=\"['Navbar', 'Click', 'My Catalog']\">{{ 'navbar.appsAndMaps' | translate }}</a></li>\n      <li ng-if=\"$ctrl.vehicles\" ui-sref=\"vehicle.manageMyRlink({vin: '{{$ctrl.vehicle.vin}}'})\" ui-sref-active=\"active\"><a href ng-click=\"$ctrl.showPageNavigation = false\" ga-track-event=\"['Navbar', 'Click', 'Manage My Rlink']\">{{ 'navbar.manageRLINK' | translate }}</a></li>\n      <li ui-sref=\"profile\" ui-sref-active=\"active\"><a href ng-click=\"$ctrl.showPageNavigation = false\" ga-track-event=\"['Navbar', 'Click', 'My Dashboard']\">{{ 'navbar.dashboard' | translate }}</a></li>\n      <li ng-if=\"$ctrl.vehicles\" ui-sref=\"help\" ui-sref-active=\"active\"><a href ng-click=\"$ctrl.showPageNavigation = false\" ga-track-event=\"['Navbar', 'Click', 'Help']\">{{ 'navbar.help' | translate }}</a></li>\n    </ul>\n  </nav>\n</div>\n"

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["VehicleService", "UserService", "$scope", "$state", "StoreTypes", "Localization", "I18n", "$log"];
	  function NavbarController(VehicleService, UserService, $scope, $state, StoreTypes, Localization, I18n, $log) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    this.vehicleService = VehicleService;
	    this.userService = UserService;
	    this.I18n = I18n;
	    this.isLogged = this.userService.getCurrentToken();
	    this.StoreTypes = StoreTypes;
	    this.$state = $state;
	    this.$log = $log;
	    this.type = Localization.getLocalizedAppConfig().type;
	    if (this.isLogged) {
	      this.loaded = this.init();
	    }
	
	    $scope.$on('vehicles:update', function (event, data) {
	      _this.vehicleService.getCurrentUserVehicles().then(function (vehicles) {
	        _this.vehicles = vehicles.length > 0;
	        return _this.vehicleService.getCurrentSelectedVehicle();
	      }).then(function (v) {
	        _this.vehicle = v;
	        return _this.vehicle;
	      }).catch(function (err) {
	        _this.$log.error('Unable to load Navbar', err);
	      });
	    });
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      return this.vehicleService.getCurrentUserVehicles().then(function (vehicles) {
	        _this2.vehicles = vehicles.length > 0;
	        return _this2.vehicleService.getCurrentSelectedVehicle();
	      }).then(function (v) {
	        _this2.vehicle = v;
	        return _this2.vehicle;
	      }).catch(function (err) {
	        _this2.$log.error('Unable to load Navbar', err);
	      });
	    }
	  }, {
	    key: 'showNavbar',
	    get: function get() {
	      return this.type === this.StoreTypes.STANDALONE;
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(722);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:1199px){.pageNavigation nav ul li.active{display:none}}.pageNavigation.openPageNavigation{height:auto!important;z-index:11!important}.pageNavigation.openPageNavigation nav{display:block!important}.pageNavigation.openPageNavigation nav ul li a{padding-left:.8em}.pageNavigation button span{display:none}.pageNavigation button .showPageTitle{display:block!important;pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _rlinkAppsStatus = __webpack_require__(724);
	
	var _rlinkAppsStatus2 = _interopRequireDefault(_rlinkAppsStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('rlinkAppsStatus', [_angularUiRouter2.default]).component('rlinkAppsStatus', _rlinkAppsStatus2.default).name;
	
	exports.default = _module;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rlinkAppsStatus = __webpack_require__(725);
	
	var _rlinkAppsStatus2 = _interopRequireDefault(_rlinkAppsStatus);
	
	var _rlinkAppsStatus3 = __webpack_require__(726);
	
	var _rlinkAppsStatus4 = _interopRequireDefault(_rlinkAppsStatus3);
	
	__webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _rlinkAppsStatus2.default,
	  controller: _rlinkAppsStatus4.default
	};
	
	exports.default = component;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "<app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.errorNoMoreConnectedProduct\" info=\"$ctrl.fakeVar\" class=\"error\"></app-message>\n<app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\" class=\"error\"></app-message>\n<app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.errorSimCancelled\" info=\"$ctrl.fakeVar\" class=\"error\"></app-message>\n<div class=\"limitContent\" ng-if=\"$ctrl.vehicle\">\n  <app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n  <aside class=\"updates card\" ng-class=\"{ 'active': $ctrl.mobileMenuActive }\" ng-init=\"$ctrl.mobileMenuActive=false\">\n    <div class=\"carUp\">\n      <p>{{ 'rlinkAppsStatus.vehicleRLink' | translate }}</p>\n      <p class=\"modele\">{{ $ctrl.vehicle.friendlyName }}</p>\n      <p class=\"reference\">{{ $ctrl.vehicle.registrationNumber }}</p>\n    </div>\n    <div class=\"countUp\">\n      <p class=\"countBlock\">\n        <span class=\"countNb radiusCircle\" ng-class=\"{'arabRadiusCircle':  $ctrl.I18n.isArLocale()}\">{{ $ctrl.nbProductToUpdate }}</span>\n        <button class=\"notMobile\" ng-disabled=\"$ctrl.nbProductToUpdate <= 0\" ng-click=\"$ctrl.goToMyUpdates()\" ga-track-event=\"['Rlink Apps Status', 'Click', 'My Updates']\"></button>\n        <span class=\"countInfo\">{{ 'rlinkAppsStatus.update' | translate }}</span>\n        <button ng-click=\"$ctrl.mobileMenuActive = !$ctrl.mobileMenuActive\" ga-track-event=\"['Rlink Apps Status', 'Click', 'Mobile Updates']\"><span>{{ 'rlinkAppsStatus.update' | translate }}</span></button>\n      </p>\n    </div>\n    <div class=\"linkUp\">\n      <div ng-class=\"{'iframeUpdateBlock': $ctrl.isIframe}\">\n        <p><a href=\"#\" class=\"button update\" ng-class=\"{ 'disabled': $ctrl.nbProductToUpdate <= 0 }\" ng-disabled=\"$ctrl.nbProductToUpdate <= 0\" ng-click=\"$ctrl.askForUpdate()\" ga-track-event=\"['Rlink Apps Status', 'Click', 'Request Update']\">{{ 'rlinkAppsStatus.requestUpdate' | translate }}</a></p>\n        <p><a class=\"mobile button more\" ui-sref=\"vehicle.manageMyRlink.myUpdates({vin: '{{$ctrl.vehicle.vin}}'})\" ng-click=\"$ctrl.mobileMenuActive = !$ctrl.mobileMenuActive\" ga-track-event=\"['Rlink Apps Status', 'Click', 'Know More']\">{{ 'rlinkAppsStatus.knowMore' | translate }}</a></p>\n        <p><a class=\"button more\" ui-sref=\"installation\" ng-click=\"$ctrl.mobileMenuActive = !$ctrl.mobileMenuActive\" ga-track-event=\"['Rlink Apps Status', 'Click', 'More Infos']\">{{ 'rlinkAppsStatus.more_info' | translate }}</a></p>\n        <p class=\"cancel\"><button ng-click=\"$ctrl.mobileMenuActive = !$ctrl.mobileMenuActive\" ga-track-event=\"['Rlink Apps Status', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button></p>\n      </div>\n    </div>\n  </aside>\n</div>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sweetalert = __webpack_require__(727);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RlinkAppsStatusController = function () {
	  RlinkAppsStatusController.$inject = ["$log", "VehicleService", "ProductService", "IdsService", "$state", "$translate", "I18n", "Localization", "StoreTypes"];
	  function RlinkAppsStatusController($log, VehicleService, ProductService, IdsService, $state, $translate, I18n, Localization, StoreTypes) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RlinkAppsStatusController);
	    this.productService = ProductService;
	    this.vehicleService = VehicleService;
	    this.idsService = IdsService;
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	    this.$translate = $translate;
	    this.I18n = I18n;
	    this.$state = $state;
	    this.$log = $log;
	    this.nbProductToUpdate = 0;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(RlinkAppsStatusController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.errorNoMoreConnectedProduct = {
	        message: 'message.errorNoMoreConnectedProducts',
	        cause: 'No More Connected Products',
	        delay: 0
	      };
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (v) {
	        _this.vehicle = v;
	
	        if (_this.vehicle.hasDealerSdSub) {
	          _this.displayDealerSdActivation();
	        }
	
	        if (_this.vehicle.isGdcActivationPopinNeedToBeDisplay) {
	          _this.displayGdcActivation(_this.vehicle.vin);
	        }
	
	        if (_this.vehicle.simStatus === 'CANCELLED' || _this.vehicle.simStatus === 'CANCELLING' || _this.vehicle.simStatus === 'CANCEL_PENDING') {
	          _this.displaySimCancelled();
	        }
	
	        return _this.idsService.decode(_this.vehicle.vin).then(function (res) {
	          _this.vehicle.registrationNumber = res;
	          return _this.productService.getNumberProductToUpdate(_this.vehicle.vin).then(function (res) {
	            _this.nbProductToUpdate = res.nb;
	            return res.nb;
	          }, function (err) {
	            _this.$log.error('getNumberProductToUpdate error', err);
	            _this.error = {
	              message: 'rlinkAppsStatus.productToUpdateError',
	              cause: err
	            };
	            return _promise2.default.reject(err);
	          });
	        }, function (err) {
	          _this.$log.error('Error while decoding svin', err);
	          return _promise2.default.reject(err);
	        });
	      }).then(function () {
	        _this.displayMusAlertMessage();
	      });
	    }
	  }, {
	    key: 'displayDealerSdActivation',
	    value: function displayDealerSdActivation() {
	      if (this.$state.is('vehicle.catalog.appsAndServices')) {
	        this.success = 'message.dealerSdActivation';
	        this.vehicle.hasDealerSdSub = false;
	      } else {
	        this.success = null;
	      }
	    }
	  }, {
	    key: 'displayGdcActivation',
	    value: function displayGdcActivation(vin) {
	      if (this.$state.is('vehicle.catalog.appsAndServices')) {
	        this.success = 'message.gdcActivationMail';
	        this.vehicleService.changeDisplayGdcActivation(vin);
	        this.vehicle.isGdcActivationPopinNeedToBeDisplay = false;
	      } else {
	        this.success = null;
	      }
	    }
	  }, {
	    key: 'displaySimCancelled',
	    value: function displaySimCancelled() {
	      this.errorSimCancelled = {
	        message: 'message.simCancelled',
	        cause: 'Sim card is cancelled',
	        delay: 0
	      };
	    }
	  }, {
	    key: 'displayMusAlertMessage',
	    value: function displayMusAlertMessage() {
	      var _this2 = this;
	
	      console.log('Get Map Alert Message for VIN ' + this.vehicle.vin);
	      return this.vehicleService.getMapAlertMessage(this.vehicle.vin).then(function (data) {
	        var alertMessage = '';
	        var pMsgs = [];
	        var idList = [];
	        for (var i in data) {
	          if (pMsgs.indexOf(data[i].message) === -1) {
	            pMsgs.push(data[i].message);
	            alertMessage += _this2.$translate.instant(data[i].message) + '\n';
	          }
	          idList.push(data[i].id);
	        }
	        if (alertMessage) {
	          (0, _sweetalert2.default)({
	            text: alertMessage,
	            icon: 'info',
	            closeOnClickOutside: false,
	            content: true
	          }).then(function (confirmed) {
	            _this2.vehicleService.markAlertMessageRead(_this2.vehicle.vin, idList.toString()).then(function () {
	              _this2.$log.debug('MUS alert message marked as read');
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'goToMyUpdates',
	    value: function goToMyUpdates() {
	      this.$state.go('vehicle.manageMyRlink.myUpdates', { vin: this.vehicle.vin, sync: true });
	    }
	  }, {
	    key: 'askForUpdate',
	    value: function askForUpdate() {
	      var _this3 = this;
	
	      this.success = null;
	      this.isProcessing = true;
	      return this.productService.updateProducts(this.vehicle.vin).then(function (res) {
	        _this3.isProcessing = false;
	        return _this3.$state.go('installation', { success: 'my-updates.update_success' });
	      }, function (err) {
	        _this3.isProcessing = false;
	        _this3.error = {
	          message: 'my-updates.update_error',
	          cause: err
	        };
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'isIframe',
	    get: function get() {
	      return this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.ONE || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.RSITE;
	    }
	  }]);
	  return RlinkAppsStatusController;
	}();
	
	exports.default = RlinkAppsStatusController;

/***/ }),
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(732);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./rlink-apps-status.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./rlink-apps-status.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:600px){.updates .countUp p button.notMobile{display:none}}@media (min-width:600px){.update{text-decoration:none!important;color:#000!important;background-color:#fc0!important}a:hover.update{background-color:#ffde00!important}.countBlock{width:210px;height:50px}.updates .countUp p{padding-top:0;position:relative;display:inline-block;text-transform:uppercase;font-family:Renault Bold,Helvetica,Arial,sans-serif;margin:0;background-color:transparent;background-position:0;background-image:none;background-repeat:no-repeat}.updates .countUp p .countNb{position:absolute;z-index:1;top:.7em;right:4.2em!important;font-size:.8em;color:#fff;background-color:#000;display:inline-block;width:1.7em;height:1.7em;line-height:1.7em;-o-box-shadow:1px 1px 1px 0 #656565;box-shadow:1px 1px 1px 0 #656565}.updates .countUp p button{position:relative;margin:1em -1em .2em 4em;width:3emar;height:3em;background:#fc3 url(\"/img/reload.png\") no-repeat 50%;border-radius:.7em;-webkit-border-radius:.7em;-moz-border-radius:.7em;-o-box-shadow:0 3px 1px 0 #656565;box-shadow:0 3px 1px 0 #656565}.updates .countUp p button.notMobile{display:block}.updates .countUp p button:disabled{opacity:.5;margin-bottom:-.4em;background-color:transparent;-webkit-box-shadow:none}.updates .countUp p button span{position:absolute;bottom:-3em;display:inline-block;text-transform:uppercase;font-size:.55em;width:8em;margin-left:-4em;line-height:1.1em}.updates .linkUp a.mobile{display:none}}div .limitContent{padding-left:1.1em;padding-right:1.1em}.disabled{opacity:.5;pointer-events:none}aside.updates.card div.carUp{max-width:12em}aside.updates.card div.carUp p.modele{overflow:hidden;text-overflow:ellipsis}.arabRadiusCircle{right:-1em!important}.updates .countUp p button span{margin-left:0;left:-1.3em}.iframeUpdateBlock{top:16%}", ""]);
	
	// exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORE_TYPES = {
	  STANDALONE: 'standalone',
	  MYRENAULT: 'myrenault',
	  HELIOS: 'helios',
	  ONE: 'one',
	  RSITE: 'rsite'
	};
	
	var _module = _angular2.default.module('storeTypes', []).constant('StoreTypes', STORE_TYPES).name;
	
	exports.default = _module;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tooltip = __webpack_require__(735);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('tooltipModule', []).component('tooltip', _tooltip2.default).name;
	
	exports.default = _module;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltip = __webpack_require__(736);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    text: '<',
	    name: '<',
	    show: '='
	  },
	  template: _tooltip2.default
	};
	
	exports.default = component;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"tooltipMessage\" aria-hidden=\"false\" ng-class=\"{'active': $ctrl.show}\">\n  <button type=\"button\" ng-click=\"$ctrl.show=false\" ga-track-event=\"['Tooltip', 'Click', 'Close {{ ($ctrl.name || 'common.help') | translate | escapeSingleQuote }}']\">\n    <span>{{ 'common.close' | translate }}</span>\n  </button>\n  <h5>{{ ($ctrl.name || 'common.help') | translate }}</h5>\n  <p>{{ $ctrl.text | translate }}</p>\n</div>\n<p class=\"mobile\">{{ $ctrl.text | translate }}</p>\n"

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _validationRules = __webpack_require__(738);
	
	var _validationRules2 = _interopRequireDefault(_validationRules);
	
	var _vin = __webpack_require__(739);
	
	var _vin2 = _interopRequireDefault(_vin);
	
	var _compareTo = __webpack_require__(740);
	
	var _compareTo2 = _interopRequireDefault(_compareTo);
	
	var _differentFrom = __webpack_require__(741);
	
	var _differentFrom2 = _interopRequireDefault(_differentFrom);
	
	var _iframeLoad = __webpack_require__(742);
	
	var _iframeLoad2 = _interopRequireDefault(_iframeLoad);
	
	var _submitForm = __webpack_require__(743);
	
	var _submitForm2 = _interopRequireDefault(_submitForm);
	
	var _autoFill = __webpack_require__(744);
	
	var _autoFill2 = _interopRequireDefault(_autoFill);
	
	var _password = __webpack_require__(745);
	
	var _password2 = _interopRequireDefault(_password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('validators', []).constant('ValidationRules', _validationRules2.default).directive('checkVin', _vin2.default).directive('compareTo', _compareTo2.default).directive('differentFrom', _differentFrom2.default).directive('iframeLoad', _iframeLoad2.default).directive('submitForm', _submitForm2.default).directive('autoFill', _autoFill2.default).directive('checkPassword', _password2.default).name;
	
	exports.default = _module;

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = {"vin":{"length":"17"},"muid":{"pattern":"^(.){12}$|^(.){16}$"},"friendlyName":{"maxlength":"64"},"civility":[{"id":"1","translationKey":"common.fields.civilities.1"},{"id":"2","translationKey":"common.fields.civilities.2"}],"firstName":{"maxlength":"64"},"lastName":{"maxlength":"64"},"address1":{"maxlength":"50"},"address2":{"maxlength":"50"},"address3":{"maxlength":"50"},"city":{"maxlength":"50"},"zipCode":{"maxlength":"50"},"phoneNumber":{"pattern":"^\\+[0-9]{2}[0-9]{9}$|^[0-9]{10}$"},"password":{"minlength":"8","maxlength":"32","pattern":"^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,15}$"},"email":{"pattern":"^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$"},"vat":{"pattern":"^[A-Za-z]{2}[0-9A-Za-z\\+\\*\\.]{2,12}$"}}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VinValidator = function VinValidator(VehicleService) {
	  'ngInject';
	
	  var require = 'ngModel';
	
	  var link = function link(scope, element, attrs, ctrl) {
	    ctrl.$asyncValidators.checkVin = function (modelValue, viewValue) {
	      return VehicleService.checkVin(modelValue.toUpperCase());
	    };
	  };
	
	  return { require: require, link: link };
	};
	VinValidator.$inject = ["VehicleService"];
	
	exports.default = VinValidator;

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CompareToValidator = function CompareToValidator() {
	  var require = 'ngModel';
	
	  var scope = { otherModelValue: '=compareTo' };
	
	  var link = function link(scope, element, attrs, ctrl) {
	    ctrl.$validators.compareTo = function (modelValue, viewValue) {
	      return modelValue === scope.otherModelValue;
	    };
	    scope.$watch('otherModelValue', function () {
	      return ctrl.$validate();
	    });
	  };
	
	  return { require: require, scope: scope, link: link };
	};
	
	exports.default = CompareToValidator;

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DifferentFromValidator = function DifferentFromValidator() {
	  var require = 'ngModel';
	
	  var scope = { otherModelValue: '=differentFrom' };
	
	  var link = function link(scope, element, attrs, ctrl) {
	    ctrl.$validators.differentFrom = function (modelValue, viewValue) {
	      return modelValue !== scope.otherModelValue;
	    };
	    scope.$watch('otherModelValue', function () {
	      return ctrl.$validate();
	    });
	  };
	
	  return { require: require, scope: scope, link: link };
	};
	
	exports.default = DifferentFromValidator;

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IframeLoad = function IframeLoad() {
	  var scope = { callBack: '&iframeLoad' };
	
	  var link = function link(scope, element, attrs) {
	    element.on('load', function () {
	      return scope.callBack();
	    });
	  };
	
	  return { scope: scope, link: link };
	};
	
	exports.default = IframeLoad;

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SubmitForm = function SubmitForm() {
	  var link = function link(scope, element, attrs) {
	    scope.$on('SubmitInvoiceForm', function (event, data) {
	      if (data.formName === attrs.name) {
	        element.submit();
	      }
	    });
	  };
	  return { link: link };
	};
	
	exports.default = SubmitForm;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AutoFill = function AutoFill($timeout) {
	  'ngInject';
	
	  var require = 'ngModel';
	  var link = function link(scope, element, attrs, ngModel) {
	    var origVal = element.val();
	    $timeout(function () {
	      var newVal = element.val();
	      if (ngModel.$pristine && origVal !== newVal) {
	        ngModel.$setViewValue(newVal);
	      }
	    }, 500);
	  };
	  return { require: require, link: link };
	};
	AutoFill.$inject = ["$timeout"];
	
	exports.default = AutoFill;

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PasswordValidator = function PasswordValidator(UserService) {
	  'ngInject';
	
	  var require = 'ngModel';
	
	  var link = function link(scope, element, attrs, ctrl) {
	    ctrl.$asyncValidators.checkPassword = function (modelValue, viewValue) {
	      return UserService.checkPassword(modelValue);
	    };
	  };
	
	  return { require: require, link: link };
	};
	PasswordValidator.$inject = ["UserService"];
	
	exports.default = PasswordValidator;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authentication = __webpack_require__(747);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _cookies = __webpack_require__(753);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _error = __webpack_require__(757);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _help = __webpack_require__(761);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _home = __webpack_require__(767);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _installation = __webpack_require__(788);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	var _installationGuide = __webpack_require__(794);
	
	var _installationGuide2 = _interopRequireDefault(_installationGuide);
	
	var _maintenance = __webpack_require__(887);
	
	var _maintenance2 = _interopRequireDefault(_maintenance);
	
	var _managePurchase = __webpack_require__(890);
	
	var _managePurchase2 = _interopRequireDefault(_managePurchase);
	
	var _profile = __webpack_require__(948);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _registration = __webpack_require__(1006);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	var _registrationConfirmation = __webpack_require__(1048);
	
	var _registrationConfirmation2 = _interopRequireDefault(_registrationConfirmation);
	
	var _resetPassword = __webpack_require__(1052);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _vehicle = __webpack_require__(1056);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _changePassword = __webpack_require__(1224);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.pages', [_authentication2.default, _cookies2.default, _error2.default, _help2.default, _home2.default, _installation2.default, _installationGuide2.default, _maintenance2.default, _managePurchase2.default, _profile2.default, _registration2.default, _registrationConfirmation2.default, _resetPassword2.default, _vehicle2.default, _changePassword2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(586);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(748);
	
	var _authentication = __webpack_require__(750);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('authentication', [_angularUiRouter2.default, 'vcRecaptcha']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('authentication', {
	    url: '/authentication?email&token&huType',
	    component: 'authentication',
	    myRenaultForbidden: true,
	    authenticatedForbidden: true
	  });
	}]).component('authentication', _authentication2.default).name;
	
	// Get out of the iFrame if in payment iFrame
	if (window.top !== window && window.name === 'iframe_payment') {
	  window.parent.postMessage({ 'id': 'navigate', 'url': window.location.pathname + window.location.search }, '*');
	} else {
	  window.addEventListener('message', function (event) {
	    if ((0, _typeof3.default)(event.data) === 'object' && event.data !== null && event.data.id === 'navigate') {
	      console.log('Reload event', event);
	      window.location.href = event.data.url;
	    }
	  });
	}
	
	exports.default = _module;

/***/ }),
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authentication = __webpack_require__(751);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _authentication3 = __webpack_require__(752);
	
	var _authentication4 = _interopRequireDefault(_authentication3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _authentication2.default,
	  controller: _authentication4.default
	};
	
	exports.default = component;

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight\">\n  <h2 ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">{{ 'authentication.title' | translate }}</h2>\n  <p class=\"txtCenter txtUppercase\" ng-if=\"!$ctrl.success\">\n    {{ 'authentication.notRegistered' | translate }}<a ui-sref=\"registration\" ga-track-event=\"['Authentication', 'Click', 'Create my personal space']\">{{ 'common.register' | translate }}</a>\n  </p>\n  <p class=\"txtCenter txtUppercase miniContent\" ng-if=\"$ctrl.success\">\n    <span ng-if=\"!$ctrl.$stateParams.huType\">{{ 'authentication.resetPasswordConfirmation' | translate }}</span>\n    <span ng-if=\"$ctrl.$stateParams.huType\">{{ 'authentication.registrationConfirmation' | translate }}</span>\n  </p>\n  <form name=\"loginForm\" class=\"miniContent separator\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" ng-submit=\"$ctrl.login(this)\" novalidate>\n    <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n    <p class=\"errorMessageTop\" ng-class=\"{ 'active' : $ctrl.error }\">\n      {{ 'authentication.emailOrPasswordIncorrect' | translate }}\n    </p>\n    <div>\n      <label for=\"loginField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.email.label' | translate }}</label>\n      <input id=\"loginField\"\n             ng-model=\"$ctrl.credentials.username\"\n             name=\"username\"\n             type=\"email\"\n             required auto-fill />\n      <div class=\"field-errors\"\n           ng-messages=\"loginForm.username.$error\"\n           ng-if=\"loginForm.username.$touched\">\n        <p ng-message=\"required\">{{ 'common.fields.email.validation.required' | translate }}</p>\n        <p ng-message=\"email\">{{ 'common.fields.email.validation.invalid' | translate }}</p>\n      </div>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"passwordField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.password.label' | translate }}</label>\n      <input id=\"passwordField\"\n             ng-model=\"$ctrl.credentials.password\"\n             name=\"password\"\n             type=\"password\"\n             required auto-fill />\n      <div class=\"field-errors\"\n           ng-messages=\"loginForm.password.$error\"\n           ng-if=\"loginForm.password.$touched\">\n        <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n      </div>\n    </div>\n    <div ng-if=\"$ctrl.userService.getCaptchaNeeded()\">\n      <div ng-if=\"! $ctrl.captchaConsent\">\n        <p style=\"color: red;text-align: justify;white-space: pre-wrap;\">{{ 'authentication.needCaptcha' | translate}}</p>\n      </div>\n      <div ng-if=\"$ctrl.captchaConsent\">\n        <p class=\"conditions\">{{ 'authentication.captcha' | translate }}</p>\n        <div\n          vc-recaptcha\n          ng-model=\"$ctrl.credentials.gRecaptchaResponse\"\n          theme=\"light\"\n          size=\"normal\"\n          key=\"$ctrl.siteKey\"\n          on-create=\"$ctrl.setWidgetId(widgetId)\"\n          lang=\"$ctrl.lang\"\n        ></div>\n      </div>\n    </div>\n    <p class=\"conditions\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      {{ 'authentication.termOfUse.label' | translate }} <a ng-href=\"pdf/published-pdf/EULA/legalInformation_{{$ctrl.country}}_{{$ctrl.I18n.getLanguage()}}_latest.pdf\" target=\"_blank\" ga-track-event=\"['Authentication', 'Click', 'Terms of Use']\">{{ 'authentication.termOfUse.link' | translate }}</a>\n    </p>\n    <button type=\"submit\" ng-disabled=\"$ctrl.formInvalid(this)\" ga-track-event=\"['Authentication', 'Click', 'Login']\">{{ 'common.login' | translate }}</button>\n    <p class=\"txtCenter txtUppercase\">\n      <a ui-sref=\"resetPassword\" ga-track-event=\"['Authentication', 'Click', 'Forgotten password']\">{{ 'authentication.forgottenPassword' | translate }}</a>\n    </p>\n  </form>\n</div>\n"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthenticationController = function () {
	  AuthenticationController.$inject = ["Localization", "UserService", "VehicleService", "RegistrationService", "MetricsService", "$window", "$state", "$location", "$stateParams", "$rootScope", "I18n", "vcRecaptchaService", "CookiesService"];
	  function AuthenticationController(Localization, UserService, VehicleService, RegistrationService, MetricsService, $window, $state, $location, $stateParams, $rootScope, I18n, vcRecaptchaService, CookiesService) {
	    'ngInject';
	
	    // Set injections
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AuthenticationController);
	    this.userService = UserService;
	    this.vehicleService = VehicleService;
	    this.registrationService = RegistrationService;
	    this.metricsService = MetricsService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$window = $window;
	    this.country = Localization.getCountry().toUpperCase();
	    this.I18n = I18n;
	    this.cookiesService = CookiesService;
	    this.vcRecaptchaService = this.captchaConsent ? vcRecaptchaService : undefined;
	    $rootScope.$on('cookieConsentUpdated', function () {
	      _this.vcRecaptchaService = _this.captchaConsent ? vcRecaptchaService : undefined;
	    });
	    this.setWidgetId = function (widgetId) {
	      this.widgetId = widgetId;
	    };
	    this.passwordExpirationDay = Localization.getLocalizedAppConfig().passwordExpirationDay;
	    this.siteKey = Localization.getLocalizedAppConfig().googleRecaptchaClientKey;
	
	    // Init. proccessing value
	    this.isProcessing = false;
	
	    // Reset password case
	    if ($stateParams.email && $stateParams.token) {
	      if ($stateParams.huType) {
	        this.loaded = this.registrationConfirmation($stateParams.email, $stateParams.token, $stateParams.huType);
	      } else {
	        this.loaded = this.resetPasswordConfirmation($stateParams.email, $stateParams.token);
	      }
	    }
	  }
	
	  (0, _createClass3.default)(AuthenticationController, [{
	    key: 'resetPasswordConfirmation',
	    value: function resetPasswordConfirmation(email, token) {
	      var _this2 = this;
	
	      this.isProcessing = true;
	      return this.userService.resetPasswordConfirmation(email, token).then(function (success) {
	        _this2.success = success;
	        _this2.isProcessing = false;
	        return success;
	      }, function (err) {
	        _this2.error = err;
	        _this2.isProcessing = false;
	        return err;
	      });
	    }
	  }, {
	    key: 'registrationConfirmation',
	    value: function registrationConfirmation(email, token, huType) {
	      var _this3 = this;
	
	      this.isProcessing = true;
	      return this.registrationService.confirmRegistration({ email: email, token: token, huType: huType }).then(function (success) {
	        _this3.success = success;
	        _this3.isProcessing = false;
	        return success;
	      }, function (err) {
	        _this3.error = err;
	        _this3.isProcessing = false;
	        return err;
	      });
	    }
	
	    // Function to call on submit
	
	  }, {
	    key: 'login',
	    value: function login(form) {
	      var _this4 = this;
	
	      if (form.loginForm.$valid) {
	        this.isProcessing = true;
	        this.metricsService.startPageLoadTime();
	        return this.userService.login(this.credentials).then(function (success) {
	          _this4.isProcessing = false;
	          if (_this4.userService.isPasswordExpired(success.customer.lastPasswordUpdate, _this4.passwordExpirationDay)) {
	            // Redirect to the change password page
	            return _this4.$state.go('changePassword');
	          } else {
	            // Redirect to the catalog page
	            return _this4.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	              if (vehicle) {
	                return _this4.$state.go('vehicle', { vin: vehicle.vin, sync: false });
	              }
	              return _this4.$state.go('profile.myGarage');
	            });
	          }
	        }, function (err) {
	          _this4.error = err;
	          _this4.isProcessing = false;
	          return _this4.metricsService.endPageLoadTime(500);
	        });
	      }
	    }
	  }, {
	    key: 'formInvalid',
	    value: function formInvalid(form) {
	      if (this.userService.getCaptchaNeeded()) {
	        if (!this.captchaConsent) {
	          return true;
	        }
	      }
	      return form.loginForm.$invalid;
	    }
	  }, {
	    key: 'lang',
	    get: function get() {
	      if (typeof this.widgetId !== 'undefined' && this.vcRecaptchaService && this.vcRecaptchaService.useLang(this.widgetId) !== this.I18n.getLanguage()) {
	        this.vcRecaptchaService.useLang(this.widgetId, this.I18n.getLanguage());
	      }
	      return this.I18n.getLanguage();
	    }
	  }, {
	    key: 'captchaConsent',
	    get: function get() {
	      return this.cookiesService.consentForCookie('captcha');
	    }
	  }]);
	  return AuthenticationController;
	}();
	
	exports.default = AuthenticationController;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cookies = __webpack_require__(754);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('cookies', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('cookies', {
	    url: '/cookies?token',
	    component: 'cookies'
	  });
	}]).component('cookies', _cookies2.default).name;
	
	exports.default = _module;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookies = __webpack_require__(755);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _cookies3 = __webpack_require__(756);
	
	var _cookies4 = _interopRequireDefault(_cookies3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  controller: _cookies4.default,
	  template: _cookies2.default
	};
	
	exports.default = component;

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight withNav\">\n  <navbar></navbar>\n  <div class=\"infoPage limitContent\">\n    <h2>{{ 'cookies.title' | translate }}</h2>\n    <ul class=\"tabChapt\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n      <li><a href=\"#whoAreWe\" ga-track-event=\"['Cookies', 'Click', 'Who Are We']\">{{ 'cookies.whoAreWe.title' | translate }}</a></li>\n      <li><a href=\"#cookiesChoices\" ga-track-event=\"['Cookies', 'Click', 'Manage']\">{{ 'cookies.manage' | translate }}</a></li>\n      <li><a href=\"#cookiesUse\" ga-track-event=\"['Cookies', 'Click', 'Use']\">{{ 'cookies.use.title' | translate }}</a></li>\n      <li><a href=\"#cookiesBenefit\" ga-track-event=\"['Cookies', 'Click', 'Benefits']\">{{ 'cookies.benefit.title' | translate }}</a></li>\n      <li><a href=\"#cookiesInfo\" ga-track-event=\"['Cookies', 'Click', 'More Info']\">{{ 'cookies.moreInfo.title' | translate }}</a></li>\n    </ul>\n    <section id=\"whoAreWe\">\n      <h3>{{ 'cookies.whoAreWe.title' | translate }}</h3>\n      <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n        {{ 'cookies.whoAreWe.text' | translate }}\n      </p>\n    </section>\n    <hr />\n    <section id=\"cookiesChoices\">\n      <h3><span>{{ 'cookies.choices.title' | translate }}</span>{{ 'cookies.manage' | translate }}</h3>\n      <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.choices.text' | translate }}<br />\"{{ 'exerciseChoices' | translate }}\".</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">(a) {{ 'cookies.consent.title' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.consent.text' | translate }}</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">(b) {{ 'cookies.refusal.title' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.refusal.text' | translate }}</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">(c) {{ 'cookies.exerciseChoices' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.exercerciseChoice.ie' | translate }}<br/>{{ 'cookies.exercerciseChoice.safari' | translate }}<br/>{{ 'cookies.exercerciseChoice.chrome' | translate }}<br/>{{ 'cookies.exercerciseChoice.firefox' | translate }}<br/>{{ 'cookies.exercerciseChoice.opera' | translate }}<br/>{{ 'cookies.exercerciseChoice.etc' | translate }}</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.adobeFlash.title' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.adobeFlash.text' | translate }}</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.informUsChoices.title' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.informUsChoices.text' | translate }}</p>\n        <h4 ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.informPlatformChoices.title' | translate }}</h4>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.informPlatformChoices.text' | translate }}</p>\n      </section>\n      <section id=\"cookiesUse\">\n        <h3>{{ 'cookies.use.title' | translate }}</h3>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.use.text' | translate }}</p>\n      </section>\n      <section id=\"cookiesBenefit\">\n        <h3>{{ 'cookies.benefit.title' | translate }}</h3>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.benefit.text' | translate }}</p>\n      </section>\n      <section id=\"cookiesInfo\">\n        <h3>{{ 'cookies.moreInfo.title' | translate }}</h3>\n        <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'cookies.moreInfo.text' | translate }}</p>\n      </section>\n      <section id=\"manage\" style=\"text-align: center\">\n        <button type=\"submit\" ng-click=\"$ctrl.openCookiesBanner()\">{{ 'cookiesConsent.open' | translate }}</button>\n      </section>\n  </div>\n</div>\n"

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookiesController = function () {
	  CookiesController.$inject = ["I18n", "CookiesService"];
	  function CookiesController(I18n, CookiesService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CookiesController);
	    this.I18n = I18n;
	    this.cookiesService = CookiesService;
	  }
	
	  (0, _createClass3.default)(CookiesController, [{
	    key: 'openCookiesBanner',
	    value: function openCookiesBanner() {
	      this.cookiesService.requestEdit = true;
	    }
	  }]);
	  return CookiesController;
	}();
	
	exports.default = CookiesController;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _error = __webpack_require__(758);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('error', [_angularUiRouter2.default]).config(["$urlRouterProvider", function ($urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('error/404');
	}]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('error', {
	    url: '/error/:errorCode',
	    component: 'error'
	  });
	}]).component('error', _error2.default).name;
	
	exports.default = _module;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _error = __webpack_require__(759);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _error3 = __webpack_require__(760);
	
	var _error4 = _interopRequireDefault(_error3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _error2.default,
	  controller: _error4.default
	};
	
	exports.default = component;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight\">\n  <h2>{{'error.' + $ctrl.errorCode | translate}}</h2>\n  <p class=\"txtCenter imageError\">\n    <img class=\"sizeAjust\" src=\"img/photos/gamme.jpg\" width=\"934\" height=\"526\" alt=\"Gamme Renault\" />\n  </p>\n</div>\n"

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorController = function ErrorController($stateParams) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, ErrorController);
	  this.errorCode = '0';
	  if ($stateParams.errorCode !== undefined) {
	    this.errorCode = $stateParams.errorCode;
	  }
	};
	ErrorController.$inject = ["$stateParams"];
	
	exports.default = ErrorController;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _help = __webpack_require__(762);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('help', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('help', {
	    url: '/help?token',
	    component: 'help',
	    authenticate: true
	  });
	}]).component('help', _help2.default).name;
	
	exports.default = _module;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _help = __webpack_require__(763);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _help3 = __webpack_require__(764);
	
	var _help4 = _interopRequireDefault(_help3);
	
	__webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _help2.default,
	  controller: _help4.default
	};
	
	exports.default = component;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight withNav\">\n  <navbar></navbar>\n  <div class=\"infoPage limitContent\">\n      <h2>{{ 'help.title' | translate }}</h2>\n      <ul class=\"tabChapt\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n        <li><a href=\"#help-tutorial\" ga-track-event=\"['Help', 'Click', 'Tutorial']\">{{ 'help.tutorial.title' | translate }}</a></li>\n        <li><a href=\"#help-multimedia\" ga-track-event=\"['Help', 'Click', 'Multimedia']\">{{ 'help.multimedia.title' | translate }}</a></li>\n        <li><a href=\"#help-installation\" ga-track-event=\"['Help', 'Click', 'Installation']\">{{ 'help.installation.title' | translate }}</a></li>\n      </ul>\n      <section id=\"help-tutorial\">\n        <help-block></help-block>\n      </section>\n      <hr />\n      <section id=\"help-multimedia\">\n        <h3>{{ 'help.multimedia.title' | translate }}</h3>\n        <p ng-class=\"{'arabDirectionDesc': $ctrl.I18n.isArLocale()}\">\n          <p>\n            <a href=\"{{ 'help.multimedia.link' | translate }}\" target=\"_blank\" class=\"button link desktop\"><span>{{ 'help.multimedia.linktext' | translate }}</span></a>\n          </p>\n          <p ng-if=\"$ctrl.gdprLink\">\n            <a href=\"{{ $ctrl.gdprLink }}\" target=\"_blank\" class=\"button link desktop\"><span>{{ 'help.gdpr.linktext' | translate }}</span></a>\n          </p>\n        </p>\n      </section>\n      <hr />\n      <section id=\"help-installation\">\n        <div class=\"updatePage limitContent\">\n          <installation-guide></installation-guide>\n        </div>\n      </section>\n    </div>\n</div>\n"

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpController = function () {
	  HelpController.$inject = ["$window", "$state", "$log", "I18n", "Localization", "VehicleService", "MetricsService"];
	  function HelpController($window, $state, $log, I18n, Localization, VehicleService, MetricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HelpController);
	    this.$log = $log;
	    this.$state = $state;
	    this.$window = $window;
	    this.I18n = I18n;
	    this.Localization = Localization;
	    this.VehicleService = VehicleService;
	    this.metricsService = MetricsService;
	    this.init();
	  }
	
	  (0, _createClass3.default)(HelpController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.gdprLink = this.Localization.getLocalizedAppConfig().gdprLink;
	      if (this.gdprLink) {
	        this.$log.debug('GDPR link: ' + this.gdprLink);
	      } else {
	        this.$log.debug('No GDPR link found');
	      }
	
	      this.VehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	        // Get the current vehicle or the first in list if not set
	        if (!vehicle) {
	          _this.$log.debug('No vehicle found. Redirecting to my garage');
	          return _this.$state.go('profile.myGarage');
	        }
	      }, function () {
	        _this.$log.error('No vehicle found. Redirecting to my garage');
	        return _this.$state.go('profile.myGarage');
	      });
	    }
	  }]);
	  return HelpController;
	}();
	
	exports.default = HelpController;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(766);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./help.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./help.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "help a.button.link{border-top:none;font-size:.9em;width:auto;margin:1.3em 0 2.5em;padding:0 .8em}help a.button.link:after{color:#000!important}help a.button.link:focus span,help a.button.link:hover span{text-decoration:underline}help p{text-align:justify}help p.downloadLinks{width:100%;text-align:left}help .updatePage ul li{width:276px}@media (min-width:600px){help .updatePage ul li:first-child{margin-left:0}}help #help-multimedia p{text-align:center}@media (max-width:1023px){help #help-multimedia p a.button.link{display:block}}@media (max-width:1023px){help a.button.link{display:none}}", ""]);
	
	// exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(768);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _slider = __webpack_require__(773);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _description = __webpack_require__(784);
	
	var _description2 = _interopRequireDefault(_description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('home', [_angularUiRouter2.default, _slider2.default, _description2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('home', {
	    url: '/',
	    component: 'home',
	    params: {
	      redirect: null,
	      redirectParams: null
	    },
	    myRenaultForbidden: true,
	    authenticatedForbidden: true
	  });
	}]).component('home', _home2.default).name;
	
	exports.default = _module;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(769);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(770);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(771);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  controller: _home4.default,
	  template: _home2.default
	};
	
	exports.default = component;

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent classicArea\">\n  <div class=\"illustration large carousel\" id=\"home-carousel\">\n    <ul class=\"elements\">\n      <li class=\"active\">\n        <div class=\"limitContent paddingArea\">\n          <aside class=\"popinChoice eltInitHeight\">\n            <h1 ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">{{ 'home.welcome.title' | translate }}</h1>\n            <p>\n              {{ 'home.welcome.text' | translate }}\n            </p>\n            <ul class=\"buttonList\">\n              <li><a class=\"button light\" ui-sref=\"authentication\" ga-track-event=\"['Home', 'Click', 'Login']\">{{ 'common.login' | translate }}</a></li>\n              <li><a class=\"button\" ui-sref=\"registration\" ga-track-event=\"['Home', 'Click', 'Create my personal space']\">{{ 'common.register' | translate }}</a></li>\n            </ul>\n          </aside>\n        </div>\n        <home-slider></home-slider>\n      </li>\n    </ul>\n  </div>\n  <div class=\"paddingArea\">\n    <home-description></home-description>\n    <ul class=\"buttonList\">\n      <li><a class=\"button dark\" ui-sref=\"authentication\" ga-track-event=\"['Home', 'Click', 'Login']\">{{ 'common.login' | translate }}</a></li>\n      <li><a class=\"button\" ui-sref=\"registration\" ga-track-event=\"['Home', 'Click', 'Create my personal space']\">{{ 'common.register' | translate }}</a></li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REDIRECT_RSITE = 'redirectRsite';
	
	var HomeController = function () {
	  HomeController.$inject = ["$window", "$state", "I18n"];
	  function HomeController($window, $state, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HomeController);
	    this.$window = $window;
	    this.$state = $state;
	    this.I18n = I18n;
	    this.redirectRsite();
	  }
	
	  (0, _createClass3.default)(HomeController, [{
	    key: 'redirectRsite',
	    value: function redirectRsite() {
	      if (this.$window.localStorage && this.$window.localStorage[REDIRECT_RSITE] === 'true') {
	        this.$window.localStorage[REDIRECT_RSITE] = 'false';
	        return this.$state.go('authentication');
	      }
	    }
	  }]);
	  return HomeController;
	}();
	
	exports.default = HomeController;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(772);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".helios navbar,.myrenault navbar,.one navbar{display:none}", ""]);
	
	// exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(774);
	
	__webpack_require__(775);
	
	__webpack_require__(777);
	
	var _homeSlider = __webpack_require__(779);
	
	var _homeSlider2 = _interopRequireDefault(_homeSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('homeSlider', [_angularUiRouter2.default, 'angular-carousel']).component('homeSlider', _homeSlider2.default).name;
	
	exports.default = _module;

/***/ }),
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _homeSlider = __webpack_require__(780);
	
	var _homeSlider2 = _interopRequireDefault(_homeSlider);
	
	var _homeSlider3 = __webpack_require__(781);
	
	var _homeSlider4 = _interopRequireDefault(_homeSlider3);
	
	__webpack_require__(782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _homeSlider2.default,
	  controller: _homeSlider4.default
	};
	
	exports.default = component;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"carousel\">\n  <ul class=\"elements\" rn-carousel-duration=\"300\" rn-carousel rn-carousel-pause-on-hover rn-carousel-auto-slide=\"$ctrl.duration\" rn-carousel-controls-allow-loop rn-carousel-index=\"carouselIndex\" >\n      <li ng-repeat=\"slide in $ctrl.slides\">\n        <style scoped>\n          @media (max-width: 599px){\n            .slide-{{$index}}{\n              background-image:url(img/photos/home/{{slide}}_small.jpg);\n            }\n          }\n          @media (min-width: 600px) and (max-width: 959px){\n            .slide-{{$index}}{\n              background-image:url(img/photos/home/{{slide}}_medium.jpg);\n            }\n          }\n          @media (min-width: 960px){\n            .slide-{{$index}}{\n              background-image:url(img/photos/home/{{slide}}.jpg);\n            }\n          }\n        </style>\n        <div class=\"autoresize\" ng-class=\"'slide-' + $index\">\n      </li>\n  </ul>\n  <div class=\"indicators\" rn-carousel-indicators ng-if=\"$ctrl.slides.length > 1\" slides=\"$ctrl.slides\" rn-carousel-index=\"carouselIndex\"></div>\n</div>\n"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSliderController = function HomeSliderController(AppConfig) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, HomeSliderController);
	  this.slides = AppConfig.pages.home.slides;
	};
	HomeSliderController.$inject = ["AppConfig"];
	
	exports.default = HomeSliderController;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(783);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./home-slider.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./home-slider.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:599px){home-slider .carousel{height:272px!important}}@media (min-width:600px){home-slider .carousel{height:460px!important}}@media (min-width:900px){home-slider .carousel{height:650px!important}}", ""]);
	
	// exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _homeDescription = __webpack_require__(785);
	
	var _homeDescription2 = _interopRequireDefault(_homeDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('homeDescription', [_angularUiRouter2.default]).component('homeDescription', _homeDescription2.default).name;
	
	exports.default = _module;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _homeDescription = __webpack_require__(786);
	
	var _homeDescription2 = _interopRequireDefault(_homeDescription);
	
	var _homeDescription3 = __webpack_require__(787);
	
	var _homeDescription4 = _interopRequireDefault(_homeDescription3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _homeDescription2.default,
	  controller: _homeDescription4.default
	};
	
	exports.default = component;

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	module.exports = "<figure class=\"limitContent\" ng-repeat=\"paragraph in $ctrl.paragraphs\">\n  <img ng-class-odd=\"'floatedLeft'\" ng-class-even=\"'floatedRight'\" class=\"sizeAjust tab desk\" ng-src=\"img/photos/{{paragraph}}.jpg\" width=\"400\" height=\"225\" alt=\"photo à décrire\">\n  <figcaption>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      {{ 'home.description.' + paragraph | translate }}\n    </p>\n  </figcaption>\n</figure>\n"

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeDescriptionController = function HomeDescriptionController(AppConfig, I18n) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, HomeDescriptionController);
	  this.paragraphs = AppConfig.pages.home.paragraphs;
	  this.I18n = I18n;
	};
	HomeDescriptionController.$inject = ["AppConfig", "I18n"];
	
	exports.default = HomeDescriptionController;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _installation = __webpack_require__(789);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('installation', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('installation', {
	    url: '/installation?token',
	    params: { success: null },
	    component: 'installation',
	    authenticate: true
	  });
	}]).component('installation', _installation2.default).name;
	
	exports.default = _module;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installation = __webpack_require__(790);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	var _installation3 = __webpack_require__(791);
	
	var _installation4 = _interopRequireDefault(_installation3);
	
	__webpack_require__(792);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _installation2.default,
	  controller: _installation4.default
	};
	
	exports.default = component;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\" class=\"error\"></app-message>\n  <div class=\"limitContent updatePage\">\n    <p class=\"topBack\">\n      <a class=\"button back\" ng-click=\"$ctrl.$window.history.back()\" href=\"#\">{{ 'common.return' | translate }}</a>\n    </p>\n    <installation-guide></installation-guide>\n  </div>\n</div>\n"

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstallationController = function InstallationController($window, $stateParams) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, InstallationController);
	  this.$window = $window;
	  this.success = $stateParams.success;
	};
	InstallationController.$inject = ["$window", "$stateParams"];
	
	exports.default = InstallationController;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(793);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./installation.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./installation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "installation div .limitContent{padding-left:0;padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _installationGuide = __webpack_require__(795);
	
	var _installationGuide2 = _interopRequireDefault(_installationGuide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('installationGuide', [_angularUiRouter2.default]).component('installationGuide', _installationGuide2.default).name;
	
	exports.default = _module;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installationGuide = __webpack_require__(796);
	
	var _installationGuide2 = _interopRequireDefault(_installationGuide);
	
	var _installationGuide3 = __webpack_require__(797);
	
	var _installationGuide4 = _interopRequireDefault(_installationGuide3);
	
	__webpack_require__(885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _installationGuide2.default,
	  controller: _installationGuide4.default
	};
	
	exports.default = component;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = "<h2>{{ 'installationGuide.title' | translate }}</h2>\n<h2>{{ 'installationGuide.section.toolbox.title' | translate }}</h2>\n<ul>\n  <li>\n    <img src=\"img/updates/step1.jpg\" alt=\"\" />\n    <h3>{{ 'installationGuide.section.toolbox.step1.title' | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-bind-html=\"'installationGuide.section.toolbox.step1.text' | translate | trustHtml\"></p>\n  </li>\n  <li>\n    <img ng-src=\"img/updates/step2_{{$ctrl.model}}.jpg\" alt=\"\" />\n    <h3>{{ 'installationGuide.section.toolbox.step2.title' | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-bind-html=\"'installationGuide.section.toolbox.step2.text' | translate | trustHtml\"></p>\n  </li>\n  <li>\n    <img ng-src=\"img/updates/step3_{{$ctrl.model}}.jpg\" alt=\"\" />\n    <h3>{{ 'installationGuide.section.toolbox.step3.title' | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-bind-html=\"'installationGuide.section.toolbox.step3.text' | translate | trustHtml\"></p>\n  </li>\n</ul>\n<br>\n<p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" class=\"lastText\" ng-bind-html=\"'installationGuide.section.toolbox.lastText' | translate | trustHtml\"></p>\n<br>\n<p class=\"downloadLinks\">\n  <a ng-if=\"$ctrl.downloadLinks\" ng-href=\"{{$ctrl.downloadLinks.windowsUrl}}\" target=\"_blank\" class=\"button link desktop\" ga-track-event=\"['Installation Guide', 'Click', 'Toolbox for Windows']\"><span>{{ 'installationGuide.section.toolbox.download.windows' | translate }}</span></a>\n  <a ng-if=\"$ctrl.downloadLinks\" ng-href=\"{{$ctrl.downloadLinks.osxUrl}}\" target=\"_blank\" class=\"button link desktop\" ga-track-event=\"['Installation Guide', 'Click', 'Toolbox for Mac']\"><span>{{ 'installationGuide.section.toolbox.download.mac' | translate }}</span></a>\n</p>\n<h2>{{ 'installationGuide.section.update.title' | translate }}</h2>\n<ul>\n  <li>\n    <img ng-src=\"img/updates/step4_{{$ctrl.model}}.jpg\" alt=\"\" />\n    <h3>{{ 'installationGuide.section.update.step1.title' | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-bind-html=\"'installationGuide.section.update.step1.text' | translate | trustHtml\"></p>\n  </li>\n  <li>\n    <img ng-src=\"img/updates/step5_{{$ctrl.model}}.jpg\" alt=\"\" />\n    <h3>{{ 'installationGuide.section.update.step2.title' | translate }}</h3>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\" ng-bind-html=\"'installationGuide.section.update.step2.text' | translate | trustHtml\"></p>\n  </li>\n</ul>\n"

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _find2 = __webpack_require__(798);
	
	var _find3 = _interopRequireDefault(_find2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstallationGuideController = function () {
	  InstallationGuideController.$inject = ["Localization", "VehicleService", "I18n"];
	  function InstallationGuideController(Localization, VehicleService, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InstallationGuideController);
	    this.appConfig = Localization.getLocalizedAppConfig();
	    this.VehicleService = VehicleService;
	    this.I18n = I18n;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(InstallationGuideController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.VehicleService.getCurrentSelectedVehicle().then(function (v) {
	        _this.model = v ? v.huType : null;
	        _this.downloadLinks = (0, _find3.default)(_this.appConfig.rlinkModels, ['huType', _this.model]).toolbox;
	        return v;
	      });
	    }
	  }]);
	  return InstallationGuideController;
	}();
	
	exports.default = InstallationGuideController;

/***/ }),
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(886);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./installation-guide.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./installation-guide.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "installation-guide ul li h3:after{content:none!important}installation-guide a.button.link{border-top:none;font-size:.9em;width:auto;margin:1.3em 0 2.5em;padding:0 .8em}installation-guide a.button.link:after{color:#000!important}installation-guide a.button.link:focus span,installation-guide a.button.link:hover span{text-decoration:underline}installation-guide p{text-align:justify}installation-guide p.downloadLinks{width:100%;text-align:center}@media (max-width:1023px){installation-guide a.button.link{display:none}}", ""]);
	
	// exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _maintenance = __webpack_require__(888);
	
	var _maintenance2 = _interopRequireDefault(_maintenance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('maintenancePage', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('maintenance', {
	    url: '/maintenance?token',
	    component: 'maintenance'
	  });
	}]).component('maintenance', _maintenance2.default).name;
	
	exports.default = _module;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maintenance = __webpack_require__(889);
	
	var _maintenance2 = _interopRequireDefault(_maintenance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _maintenance2.default
	};
	
	exports.default = component;

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <h2>{{ 'maintenance.message' | translate }}</h2>\n  <p class=\"txtCenter imageError\">\n    <img class=\"sizeAjust\" src=\"img/photos/gamme.jpg\" width=\"934\" height=\"526\" alt=\"Gamme Renault\" />\n  </p>\n</div>\n"

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _managePurchase = __webpack_require__(891);
	
	var _managePurchase2 = _interopRequireDefault(_managePurchase);
	
	var _myPurchase = __webpack_require__(895);
	
	var _myPurchase2 = _interopRequireDefault(_myPurchase);
	
	var _confirmation = __webpack_require__(942);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('managePurchase', [_angularUiRouter2.default, _myPurchase2.default, _confirmation2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('managePurchase', {
	    url: '/purchase?token',
	    component: 'managePurchase',
	    redirectTo: 'managePurchase.myPurchase',
	    authenticate: true
	  });
	}]).component('managePurchase', _managePurchase2.default).name;
	
	exports.default = _module;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managePurchase = __webpack_require__(892);
	
	var _managePurchase2 = _interopRequireDefault(_managePurchase);
	
	__webpack_require__(893);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _managePurchase2.default
	};
	
	exports.default = component;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n\t<div class=\"pageNavigation\">\n\t\t<button class=\"showMenu mobile tablet\" ga-track-event=\"['Manage Purchase', 'Click', 'Show/Hide Mobile Menu']\">\n\t\t\t<span class=\"limitContent txtTruncated\">{{ 'managePurchase.viewMenu' | translate }}</span>\n\t\t</button>\n\t\t<navbar></navbar>\n\t</div>\n  <ui-view />\n</div>\n"

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(894);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./manage-purchase.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./manage-purchase.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "manage-purchase a.back{background-color:#fc0!important;text-decoration:none;text-align:center!important}manage-purchase a.back:hover{background-color:#ffde00!important;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myPurchase = __webpack_require__(896);
	
	var _myPurchase2 = _interopRequireDefault(_myPurchase);
	
	var _managePurchaseNavbar = __webpack_require__(902);
	
	var _managePurchaseNavbar2 = _interopRequireDefault(_managePurchaseNavbar);
	
	var _managePurchaseTopblock = __webpack_require__(908);
	
	var _managePurchaseTopblock2 = _interopRequireDefault(_managePurchaseTopblock);
	
	var _infosProduct = __webpack_require__(912);
	
	var _infosProduct2 = _interopRequireDefault(_infosProduct);
	
	var _buyProduct = __webpack_require__(918);
	
	var _buyProduct2 = _interopRequireDefault(_buyProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myPurchase', [_angularUiRouter2.default, _managePurchaseNavbar2.default, _managePurchaseTopblock2.default, _infosProduct2.default, _buyProduct2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('managePurchase.myPurchase', {
	    url: '/mypurchase/:productId',
	    component: 'myPurchase',
	    authenticate: true
	  });
	}]).component('myPurchase', _myPurchase2.default).name;
	
	exports.default = _module;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myPurchase = __webpack_require__(897);
	
	var _myPurchase2 = _interopRequireDefault(_myPurchase);
	
	var _myPurchase3 = __webpack_require__(898);
	
	var _myPurchase4 = _interopRequireDefault(_myPurchase3);
	
	__webpack_require__(900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myPurchase2.default,
	  controller: _myPurchase4.default
	};
	
	exports.default = component;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"limitContent paypage\">\n  <manage-purchase-topblock disable-back=\"$ctrl.disableBack\"></manage-purchase-topblock>\n  <manage-purchase-navbar active-tab=\"$ctrl.activeTab\"></manage-purchase-navbar>\n  <div class=\"ticket card\" ng-if=\"!$ctrl.iframeOnLoad\">\n    <infos-product product-ref=\"$ctrl.productRef\" voucher-infos=\"$ctrl.voucherInfos\" is-free-product=\"$ctrl.isFreeProduct\" class=\"ticket card\"></infos-product>\n    <buy-product class=\"ticket card\" voucher-infos=\"$ctrl.voucherInfos\" is-free-product=\"$ctrl.isFreeProduct\" product-ref=\"$ctrl.productRef\"></buy-product>\n  </div>\n  <div class=\"ticket card\" id=\"iframePayment\" ng-hide=\"!$ctrl.iframeOnLoad\">\n    <iframe iframe-load=\"$ctrl.isEmptyIframe()\" name=\"iframe_payment\" id=\"iframe_payment\"></iframe>\n  </div>\n</div>\n"

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPurchaseController = function () {
	  MyPurchaseController.$inject = ["$stateParams", "$window", "$timeout"];
	  function MyPurchaseController($stateParams, $window, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyPurchaseController);
	    this.productRef = $stateParams.productId;
	    this.voucherInfos = {
	      'isPurchaseUsingVoucher': false
	    };
	    this.isFreeProduct = false;
	    this.iframeOnLoad = false;
	    this.activeTab = 'mypurchase';
	    this.$window = $window;
	    this.disableBack = false;
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(MyPurchaseController, [{
	    key: 'isEmptyIframe',
	    value: function isEmptyIframe() {
	      var isFrame = '';
	      try {
	        isFrame = (0, _jquery2.default)('#iframe_payment').contents().find('body').html();
	        if (isFrame !== '') {
	          if (!this.iframeOnLoad) {
	            this.$timeout(function () {
	              document.getElementById('iframe_payment').scrollIntoView();
	            });
	          }
	          this.iframeOnLoad = true;
	          this.disableBack = true;
	          this.activeTab = 'payment';
	        }
	      } catch (e) {
	        this.iframeOnLoad = true;
	        this.disableBack = true;
	        this.activeTab = 'payment';
	      }
	      (0, _jquery2.default)('#cardBlocSips').find('legend').trigger('click');
	    }
	  }]);
	  return MyPurchaseController;
	}();
	
	exports.default = MyPurchaseController;

/***/ }),
/* 899 */,
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(901);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-purchase.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-purchase.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "#iframe_payment{height:920px;width:100%}", ""]);
	
	// exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _managePurchaseNavbar = __webpack_require__(903);
	
	var _managePurchaseNavbar2 = _interopRequireDefault(_managePurchaseNavbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('managePurchaseNavbar', [_angularUiRouter2.default]).component('managePurchaseNavbar', _managePurchaseNavbar2.default).name;
	
	exports.default = _module;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managePurchaseNavbar = __webpack_require__(904);
	
	var _managePurchaseNavbar2 = _interopRequireDefault(_managePurchaseNavbar);
	
	var _managePurchaseNavbar3 = __webpack_require__(905);
	
	var _managePurchaseNavbar4 = _interopRequireDefault(_managePurchaseNavbar3);
	
	__webpack_require__(906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    activeTab: '='
	  },
	  controller: _managePurchaseNavbar4.default,
	  template: _managePurchaseNavbar2.default
	};
	
	exports.default = component;

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"stepBar card\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n  <li ng-class=\"{'finish' : $ctrl.activeTab !== 'mypurchase', 'finishAr': $ctrl.activeTab !== 'mypurchase' && $ctrl.I18n.isArLocale()}\">\n    <a class=\"disabledClick\" ng-href=\"purchase/mypurchase\" aria-selected=\"{{ $ctrl.activeTab === 'mypurchase' }}\" ga-track-event=\"['Manage Purchase Navbar', 'Click', 'My Purchase']\"><span>{{ 'managePurchase.navbar.myPurchase' | translate }}</span></a>\n  </li>\n  <li ng-class=\"{'finish' : $ctrl.activeTab === 'confirmation', 'finishAr': $ctrl.activeTab === 'confirmation' && $ctrl.I18n.isArLocale()}\">\n    <a class=\"disabledClick\" ng-href=\"purchase/payment\" aria-selected=\"{{ $ctrl.activeTab === 'payment' }}\" ga-track-event=\"['Manage Purchase Navbar', 'Click', 'Payment']\"><span>{{ 'managePurchase.navbar.payment' | translate }}</span></a>\n  </li>\n  <li>\n    <a class=\"disabledClick\" ng-href=\"purchase/confirmation\" aria-selected=\"{{ $ctrl.activeTab === 'confirmation' }}\" ga-track-event=\"['Manage Purchase Navbar', 'Click', 'Confirmation']\"><span>{{ 'managePurchase.navbar.confirmation' | translate }}</span></a>\n  </li>\n</ul>\n"

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagePurchaseNavbar = function ManagePurchaseNavbar(I18n) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, ManagePurchaseNavbar);
	  this.I18n = I18n;
	};
	ManagePurchaseNavbar.$inject = ["I18n"];
	
	exports.default = ManagePurchaseNavbar;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(907);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./manage-purchase-navbar.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./manage-purchase-navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "manage-purchase-navbar>ul>li>a[aria-selected=true]{border-bottom-color:#fc0;font-family:Renault Regular,Helvetica,Arial,sans-serif}.disabledClick{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _managePurchaseTopblock = __webpack_require__(909);
	
	var _managePurchaseTopblock2 = _interopRequireDefault(_managePurchaseTopblock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('managePurchaseTopblock', []).component('managePurchaseTopblock', _managePurchaseTopblock2.default).name;
	
	exports.default = _module;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managePurchaseTopblock = __webpack_require__(910);
	
	var _managePurchaseTopblock2 = _interopRequireDefault(_managePurchaseTopblock);
	
	var _managePurchaseTopblock3 = __webpack_require__(911);
	
	var _managePurchaseTopblock4 = _interopRequireDefault(_managePurchaseTopblock3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    disableBack: '<'
	  },
	  template: _managePurchaseTopblock2.default,
	  controller: _managePurchaseTopblock4.default
	};
	
	exports.default = component;

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports = "<p class=\"topBack\" ng-if=\"!$ctrl.disableBack\">\n  <a ng-click=\"$ctrl.goToCatalog()\" class=\"button back\" ga-track-event=\"['Manage Purchase', 'Click', 'Back']\">{{ 'common.return' | translate }}</a>\n</p>\n<h2>{{ 'managePurchase.myPurchase' | translate }}</h2>\n"

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagePurchaseTopblockController = function () {
	  ManagePurchaseTopblockController.$inject = ["VehicleService", "UserService", "$log", "$state"];
	  function ManagePurchaseTopblockController(VehicleService, UserService, $log, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagePurchaseTopblockController);
	    this.vehicleService = VehicleService;
	    this.userService = UserService;
	    this.$state = $state;
	    this.$log = $log;
	    this.isLogged = this.userService.getCurrentToken();
	    if (this.isLogged) {
	      this.loaded = this.init();
	    }
	  }
	
	  (0, _createClass3.default)(ManagePurchaseTopblockController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentUserVehicles().then(function (vehicles) {
	        _this.vehicles = vehicles.length > 0;
	        return _this.vehicleService.getCurrentSelectedVehicle();
	      }).then(function (v) {
	        _this.vehicle = v;
	        return _this.vehicle;
	      }).catch(function (err) {
	        _this.$log.error('Unable to load Navbar', err);
	      });
	    }
	  }, {
	    key: 'goToCatalog',
	    value: function goToCatalog() {
	      this.$state.go('vehicle.catalog', { vin: this.vehicle.vin, sync: true });
	    }
	  }]);
	  return ManagePurchaseTopblockController;
	}();
	
	exports.default = ManagePurchaseTopblockController;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _infosProduct = __webpack_require__(913);
	
	var _infosProduct2 = _interopRequireDefault(_infosProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('infosProduct', [_angularUiRouter2.default]).component('infosProduct', _infosProduct2.default).factory('PurchaseInfos', function () {
	  return {
	    loadingB2BPrice: false
	  };
	}).name;
	
	exports.default = _module;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _infosProduct = __webpack_require__(914);
	
	var _infosProduct2 = _interopRequireDefault(_infosProduct);
	
	var _infosProduct3 = __webpack_require__(915);
	
	var _infosProduct4 = _interopRequireDefault(_infosProduct3);
	
	__webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    productRef: '<',
	    voucherInfos: '=',
	    isFreeProduct: '='
	  },
	  template: _infosProduct2.default,
	  controller: _infosProduct4.default
	};
	
	exports.default = component;

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports = "<app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n<div class=\"priceHead\">\n  <dl>\n    <dt>\n      <img ng-src=\"{{ $ctrl.product.icon }}.gif\" alt=\"{{ $ctrl.product.title }}\" fallback-src=\"/img/products/icon/sample.gif\"/>\n    </dt>\n    <dd>\n      <span>{{ $ctrl.product.title }} {{$ctrl.locale}}</span>\n      <dl class=\"price\" ng-class=\"{'arabDirectionDescLeft':  $ctrl.i18n.isArLocale()}\">\n        <dt>{{ 'infosProduct.price' | translate }}</dt>\n        <dd>{{ $ctrl.priceProductLabel | price | translate }}</dd>\n      </dl>\n      <dl class=\"promotion\" ng-if=\"$ctrl.product.isPromoted\" ng-class=\"{'arabDirectionDescLeft':  $ctrl.i18n.isArLocale()}\">\n        <dt>{{ 'infosProduct.promotion' | translate }}</dt>\n        <dd>{{ $ctrl.pricePromotionLabel | price | translate }} </dd>\n      </dl>\n      <dl class=\"promotion\" ng-if=\"$ctrl.voucherValid\" ng-class=\"{'arabDirectionDescLeft':  $ctrl.i18n.isArLocale()}\">\n        <dt>{{ 'infosProduct.promotionVoucher' | translate }}</dt>\n        <dd>{{ $ctrl.priceVoucher | price | translate }}</dd>\n      </dl>\n    </dd>\n  </dl>\n  <p class=\"voucherName\" ng-if=\"$ctrl.voucherValid\">\n\t\t{{ 'infosProduct.voucher.purchaseVoucher' | translate }} <span>{{ $ctrl.vouchercode }}</span>\n\t</p>\n  <div ng-if=\"!$ctrl.isFreeProduct && $ctrl.priceProduct > 0\" class=\"collapseBloc\" ng-class=\"{'active' : $ctrl.activeVoucher}\" ng-init=\"$ctrl.activeVoucher=false\">\n    <button class=\"collapseBt dropDown voucher\" ng-click=\"$ctrl.activeVoucher=!$ctrl.activeVoucher\" title=\"{{ 'common.clickToUnfoldMenu' | translate }}\" ga-track-event=\"['Product Info', 'Click', 'Use Voucher']\">{{ 'infosProduct.voucher.useGiftCertificate' | translate }}</button>\n    <form class=\"collapse voucherBloc\" name=\"voucherForm\" ng-submit=\"$ctrl.voucherSubmit(this)\" novalidate>\n      <app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n        <input type=\"text\" name=\"vouchercode\" ng-model=\"$ctrl.vouchercode\" required/>\n        <ul class=\"buttonList\">\n          <li class=\"errorMessage\" ng-show=\"voucherForm.$submitted && voucherForm.vouchercode.$error.required\">\n            <span>{{ 'infosProduct.voucher.requiredVoucherCode'  | translate }}</span>\n          </li>\n          <li class=\"errorMessage\" ng-show=\"$ctrl.messageErrorVoucher\">\n            <span>{{ 'infosProduct.voucher.error.'+$ctrl.messageErrorVoucher  | translate }}</span>\n          </li>\n          <li class=\"voucherButtons\">\n            <button type=\"reset\"  ng-click=\"$ctrl.cancelVoucher()\" class=\"button cancel\" ga-track-event=\"['Product Info', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button>\n          </li>\n          <li class=\"voucherButtons\">\n            <button type=\"submit\" ng-disabled=\"$ctrl.isProcessing\" ga-track-event=\"['Product Info', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n          </li>\n        </ul>\n    </form>\n  </div>\n</div>\n<p class=\"total\" ng-if=\"!$ctrl.isTryAndBuy\" ng-class=\"{'arabDirectionDescLeft':  $ctrl.i18n.isArLocale()}\">\n  <span ng-if=\"$ctrl.voucherValid\">\n    <span ng-if=\"$ctrl.isPro\">{{ 'infosProduct.totalWithVoucherExcludingTaxes' | translate }}</span>\n    <span ng-if=\"! $ctrl.isPro\">{{ 'infosProduct.totalWithVoucherIncludingTaxes' | translate }}</span>\n  </span>\n  <span ng-if=\"! $ctrl.voucherValid\">\n    <span ng-if=\"$ctrl.isPro\">{{ 'infosProduct.totalExcludingTaxes' | translate }}</span>\n    <span ng-if=\"! $ctrl.isPro\">{{ 'infosProduct.totalIncludingTaxes' | translate }}</span>\n  </span>\n  <span ng-if=\"$ctrl.purchaseInfos.loadingB2BPrice\" style=\"display: inline-block; padding-right: 10px\">\n    <app-spinner >\n  </span>\n  <span ng-if=\"! $ctrl.purchaseInfos.loadingB2BPrice\">\n    <span> {{ $ctrl.totalToPay | price | translate }} </span>\n  </span>\n</p>\n<p class=\"total\" ng-if=\"$ctrl.isTryAndBuy\" ng-class=\"{'arabDirectionDescLeft':  $ctrl.i18n.isArLocale()}\">\n  <span class=\"tryAndBuyMessage\">{{ 'infosProduct.tryAndBuyLabel' | translate: { duration: $ctrl.product.tryDuration } }}</span>\n</p>\n"

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfosProductController = function () {
	  InfosProductController.$inject = ["$scope", "Localization", "VoucherFactory", "ProductService", "VoucherService", "VehicleService", "$location", "I18n", "ProductUtilsService", "$log", "PurchaseInfos"];
	  function InfosProductController($scope, Localization, VoucherFactory, ProductService, VoucherService, VehicleService, $location, I18n, ProductUtilsService, $log, PurchaseInfos) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, InfosProductController);
	    this.country = Localization.getCountry();
	    this.voucherFactory = VoucherFactory;
	    this.productService = ProductService;
	    this.voucherService = VoucherService;
	    this.vehicleService = VehicleService;
	    this.productUtilsService = ProductUtilsService;
	    this.i18n = I18n;
	    this.isProcessing = false;
	    this.$location = $location;
	    this.voucherValid = false;
	    this.isTryAndBuy = false;
	    this.$log = $log;
	    this.purchaseInfos = PurchaseInfos;
	    this.voucherFree = false;
	    this.B2BPrice = NaN;
	    this.isPro = false;
	    this.isFreeProduct = false;
	    this.buyingCountry = null;
	    $scope.$on('buy-product:countryChanged', function (evt, data) {
	      _this.buyingCountry = data;
	      _this.B2BPriceComputationTriggered();
	    });
	    $scope.$on('buy-product:proToggled', function (evt, data) {
	      _this.isPro = data;
	      _this.B2BPriceComputationTriggered();
	    });
	  }
	
	  (0, _createClass3.default)(InfosProductController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getProduct();
	    }
	  }, {
	    key: 'B2BPriceComputationTriggered',
	    value: function B2BPriceComputationTriggered() {
	      var _this2 = this;
	
	      if (!this.product) return;
	      if (!this.buyingCountry) return;
	      if (this.shouldComputeB2BPrice()) {
	        if (!this.purchaseInfos.loadingB2BPrice) {
	          this.purchaseInfos.loadingB2BPrice = true;
	          this.productService.getB2BPrice(this.productRef, this.buyingCountry).then(function (res) {
	            _this2.product.B2BPrice = res;
	            _this2.purchaseInfos.loadingB2BPrice = false;
	            _this2.computeProductPrice();
	            if (_this2.voucherValid) {
	              _this2.updateVoucher();
	            }
	          }, function (err) {
	            // FIXME error
	            _this2.error = err;
	            _this2.purchaseInfos.loadingB2BPrice = false;
	          });
	        }
	      } else {
	        this.computeProductPrice();
	        if (this.voucherValid) {
	          this.updateVoucher();
	        }
	      }
	    }
	  }, {
	    key: 'getProduct',
	    value: function getProduct() {
	      var _this3 = this;
	
	      if (!isNaN(parseInt(this.productRef, 10))) {
	        var vin = this.vehicleService.getCurrentVin();
	        return this.productService.getProduct(this.productRef, vin, this.i18n.getLanguage()).then(function (success) {
	          _this3.product = success;
	          _this3.product.B2BPrice = NaN;
	          _this3.isTryAndBuy = _this3.productUtilsService.getTryAndBuy(_this3.product);
	          _this3.isFreeProduct = _this3.isFree();
	          _this3.computeProductPrice();
	        }, function (err) {
	          _this3.$log.error('error get product ', err);
	          _this3.error = err;
	        });
	      } else {
	        this.$location.path('/error');
	      }
	    }
	  }, {
	    key: 'shouldComputeB2BPrice',
	    value: function shouldComputeB2BPrice() {
	      return this.isPro && !(this.isFreeProduct || this.voucherFree);
	    }
	  }, {
	    key: 'computeProductPrice',
	    value: function computeProductPrice() {
	      this.priceProductLabel = this.getPriceLabel(this.product.price);
	      if (this.priceProductLabel !== 'catalog.product.free') {
	        this.currency = this.product.price.substring(this.product.price.indexOf(' '));
	        this.priceProduct = parseFloat(this.product.price);
	        if (!isNaN(this.product.B2BPrice) && this.shouldComputeB2BPrice()) {
	          this.priceProduct = this.product.B2BPrice;
	          this.priceProductLabel = this.product.B2BPrice + this.currency;
	        }
	        if (this.product.isPromoted) {
	          this.pricePromotionLabel = this.getPriceLabel(this.product.promotedPrice);
	          if (this.pricePromotionLabel !== 'catalog.product.free') {
	            this.voucherFree = false;
	            this.pricePromotion = Math.round((parseFloat(this.product.promotedPrice) - parseFloat(this.product.price)) * 100) / 100;
	            this.pricePromotionLabel = this.pricePromotion.toFixed(2) + this.currency;
	            this.totalToPay = (Math.round((this.priceProduct + this.pricePromotion) * 100) / 100).toFixed(2) + this.currency;
	          } else {
	            this.voucherFree = true;
	            this.totalToPay = this.pricePromotionLabel;
	          }
	        } else {
	          this.totalToPay = this.priceProductLabel;
	        }
	      } else {
	        this.totalToPay = this.priceProductLabel;
	      }
	      this.totalPrice = this.totalToPay;
	    }
	  }, {
	    key: 'getPriceLabel',
	    value: function getPriceLabel(price) {
	      return price && (price.match(/free/i) || parseFloat(price.replace(/,/g, '.')) === 0) ? 'catalog.product.free' : price;
	    }
	
	    /**
	     * Calculation of the price after a voucher has been applied
	     * @param price Initial price of the product
	     */
	
	  }, {
	    key: 'doCalcPriceWithVoucher',
	    value: function doCalcPriceWithVoucher(price) {
	      this.amountReduction = this.voucherFactory.getReductionPrice(this.voucherResponse.value, price);
	      this.priceVoucher = (Math.round((parseFloat(this.amountReduction) - parseFloat(price)) * 100) / 100).toFixed(2) + this.currency;
	      this.totalToPay = (Math.round((parseFloat(price) + parseFloat(this.priceVoucher)) * 100) / 100).toFixed(2) + this.currency;
	      if (parseFloat(this.totalToPay) === 0) {
	        this.totalToPay = 'catalog.product.free';
	      }
	    }
	  }, {
	    key: 'voucherSubmit',
	    value: function voucherSubmit(form) {
	      var _this4 = this;
	
	      if (form.voucherForm.$valid) {
	        this.isProcessing = true;
	        return this.voucherService.consulteVoucherCode(this.vouchercode).then(function (res) {
	          _this4.error = null;
	          _this4.isProcessing = false;
	          _this4.voucherResponse = res;
	          _this4.voucherValid = false;
	          _this4.updateVoucher();
	        }, function (err) {
	          _this4.isProcessing = false;
	          _this4.$log.error('error voucher ', err);
	          _this4.voucherResponse = err.data;
	        });
	      }
	      if ('error'.indexOf(this.messageErrorVoucher) === 0) {
	        this.cancelVoucher();
	      }
	    }
	  }, {
	    key: 'updateVoucher',
	    value: function updateVoucher() {
	      if (!this.voucherResponse.error) {
	        this.messageErrorVoucher = '';
	        if (this.voucherFactory.validateCountryVoucher(this.country, this.voucherResponse.country)) {
	          if (this.voucherResponse.productList === undefined || this.voucherResponse.productList.length === 0 || this.voucherFactory.validateProductRefFromVoucher(this.voucherResponse.productList, this.productRef)) {
	            this.voucherValid = true;
	            // New price calculation
	            if (this.product.isPromoted) {
	              this.$log.debug('this.voucherResponse.availableOnAllProducts', this.voucherResponse.availableOnAllProducts);
	              if (this.voucherResponse.availableOnAllProducts) {
	                this.doCalcPriceWithVoucher(this.product.promotedPrice);
	              } else {
	                this.voucherValid = false;
	                this.messageErrorVoucher = 'productAlreadyPromotion';
	              }
	            } else {
	              this.doCalcPriceWithVoucher(this.priceProduct + ' ' + this.currency);
	            }
	            this.activeVoucher = false;
	          } else {
	            this.messageErrorVoucher = 'noMatchForProduct';
	          }
	        } else {
	          this.messageErrorVoucher = 'noMatchForCountry';
	        }
	        // infos voucher
	        this.voucherInfos.isPurchaseUsingVoucher = this.voucherValid;
	        this.voucherInfos.amountReduction = this.amountReduction;
	        this.voucherInfos.canalCode = this.voucherResponse.canal;
	        this.voucherInfos.voucherCode = this.vouchercode;
	      } else {
	        this.messageErrorVoucher = this.voucherResponse.error.errorCode;
	      }
	    }
	  }, {
	    key: 'cancelVoucher',
	    value: function cancelVoucher() {
	      this.activeVoucher = false;
	      this.isProcessing = false;
	      this.voucherResponse = {};
	      this.messageErrorVoucher = '';
	      this.vouchercode = '';
	      this.voucherValid = false;
	      this.totalToPay = this.totalPrice;
	      this.initVoucherInfos();
	    }
	  }, {
	    key: 'initVoucherInfos',
	    value: function initVoucherInfos() {
	      this.voucherInfos.isPurchaseUsingVoucher = false;
	      this.voucherInfos.amountReduction = '';
	      this.voucherInfos.canalCode = '';
	      this.voucherInfos.voucherCode = '';
	    }
	  }, {
	    key: 'isFree',
	    value: function isFree() {
	      return this.isTryAndBuy || this.isFreePrice(this.product.price) || this.product.isPromoted && this.isFreePrice(this.product.promotedPrice);
	    }
	  }, {
	    key: 'isFreePrice',
	    value: function isFreePrice(price) {
	      var priceProduct = price.replace(/,/g, '.');
	      return price.match(/free/i) || parseFloat(priceProduct) === 0;
	    }
	  }]);
	  return InfosProductController;
	}();
	
	exports.default = InfosProductController;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(917);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./infos-product.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./infos-product.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "infos-product .errorMessage{display:block!important}infos-product .buttonList{margin-left:-1%!important}infos-product .tryAndBuyMessage{color:#c42720}infos-product .dimmer{position:relative}infos-product .spinner{height:20px;width:20px;border-width:4px;left:unset;right:-22px;top:-14px;margin-top:unset;margin-left:unset}infos-product .voucherButtons{vertical-align:unset;float:left;margin-top:0!important}infos-product .voucherButtons .cancel{margin:1em auto}infos-product .voucherButtons button{margin-top:0!important}@media (min-width:350px) and (max-width:390px){.voucher{float:left}}", ""]);
	
	// exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _buyProduct = __webpack_require__(919);
	
	var _buyProduct2 = _interopRequireDefault(_buyProduct);
	
	var _countryOfResidence = __webpack_require__(924);
	
	var _countryOfResidence2 = _interopRequireDefault(_countryOfResidence);
	
	var _paymentWorldpay = __webpack_require__(930);
	
	var _paymentWorldpay2 = _interopRequireDefault(_paymentWorldpay);
	
	var _paymentSips = __webpack_require__(936);
	
	var _paymentSips2 = _interopRequireDefault(_paymentSips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('buyProduct', [_angularUiRouter2.default, _countryOfResidence2.default, _paymentWorldpay2.default, _paymentSips2.default]).component('buyProduct', _buyProduct2.default).name;
	
	exports.default = _module;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buyProduct = __webpack_require__(920);
	
	var _buyProduct2 = _interopRequireDefault(_buyProduct);
	
	var _buyProduct3 = __webpack_require__(921);
	
	var _buyProduct4 = _interopRequireDefault(_buyProduct3);
	
	__webpack_require__(922);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    productRef: '<',
	    voucherInfos: '<',
	    isFreeProduct: '<'
	  },
	  template: _buyProduct2.default,
	  controller: _buyProduct4.default
	};
	
	exports.default = component;

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	module.exports = "<app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n<form name=\"buyProductForm\" ng-submit=\"$ctrl.buyProduct($event)\" novalidate>\n  <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n  <country-of-residence code-country=\"$ctrl.codeCountry\" disabled=\"$ctrl.validForm\"></country-of-residence>\n  <div class=\"centerErrorMessage\">\n    <p class=\"errorMessage\" ng-show=\"!$ctrl.codeCountry\">\n      <span>{{ 'buyProduct.countryOfResidence.select' | translate }}</span>\n    </p>\n  </div>\n  <ul class=\"CheckboxList\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n    <li>\n      <label for=\"offers\" class=\"checkBox\" ng-class=\"{'disabled': $ctrl.validForm}\">\n        <input id=\"offers\" name=\"offers\" type=\"checkbox\" ng-model=\"$ctrl.legalInfos.offers\" ng-disabled=\"$ctrl.validForm\">\n        <span>{{ 'buyProduct.receiveOffers' | translate }}</span>\n      </label>\n    </li>\n    <li ng-if=\"$ctrl.isCountryConcerned\">\n      <label for=\"retraction\" class=\"checkBox\" ng-class=\"{'disabled': $ctrl.validForm}\">\n        <input id=\"retraction\" name=\"retraction\" type=\"checkbox\" ng-model=\"$ctrl.legalInfos.retraction\" required ng-disabled=\"$ctrl.validForm\">\n          <span>{{ 'buyProduct.retraction.text' | translate }}\n            <a ng-href=\"pdf/published-pdf/WITHDRAWAL/withdrawalRights_{{$ctrl.countryUpper}}_{{$ctrl.I18n.getLanguage()}}_latest.pdf\" target=\"_blank\" ga-track-event=\"['Buy Product', 'Click', 'Retraction']\">\n              {{ 'buyProduct.retraction.link' | translate }}</a>.\n          </span>\n      </label>\n    </li>\n    <li>\n      <label for=\"cgv\" class=\"checkBox\" ng-class=\"{'disabled': $ctrl.validForm}\">\n        <input id=\"cgv\" name=\"cgv\" type=\"checkbox\" ng-model=\"$ctrl.legalInfos.cgv\" required  ng-disabled=\"$ctrl.validForm\">\n        <span>{{ 'buyProduct.cgv.text' | translate }}\n          <a ng-href=\"pdf/published-pdf/GTC/generalTermsAndConditions_{{$ctrl.countryUpper}}_{{$ctrl.I18n.getLanguage()}}_latest.pdf\" target=\"_blank\" ga-track-event=\"['Buy Product', 'Click', 'Sales Terms']\">{{ 'buyProduct.cgv.link' | translate }}</a>\n          {{ 'buyProduct.cgv.countryOfResidence' | translate }}\n        </span>\n      </label>\n    </li>\n    <li>\n      <label for=\"pro\" class=\"checkBox\" ng-class=\"{'disabled': $ctrl.validForm}\">\n        <input id=\"pro\" name=\"pro\" type=\"checkbox\" ng-model=\"$ctrl.legalInfos.pro\" ng-click=\"$ctrl.updatePrice()\" ng-disabled=\"$ctrl.validForm\">\n          <span>{{ 'buyProduct.professionalPurchase.text' | translate }}</span>\n      </label>\n    </li>\n  </ul>\n\n  <div class=\"miniContent\" ng-if=\"$ctrl.legalInfos.pro\" ng-hide=\"$ctrl.validForm\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n    <div>\n      <label for=\"nameField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.company' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.name.$invalid && buyProductForm.$submitted }\" id=\"nameField\" ng-model=\"$ctrl.company.name\" name=\"name\" type=\"text\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"vatField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.vatNumber' | translate }}</label>\n      <input ng-if=\"!$ctrl.isEuropeanUnion\" ng-class=\"{ 'errorField' : buyProductForm.vat.$invalid && buyProductForm.$submitted }\" id=\"vatField\" ng-model=\"$ctrl.company.tvaNumber\" name=\"vat\" type=\"text\" required>\n      <input ng-if=\"$ctrl.isEuropeanUnion\" ng-class=\"{ 'errorField' : buyProductForm.vat.$invalid && buyProductForm.$submitted }\" id=\"vatField\" ng-model=\"$ctrl.company.tvaNumber\" name=\"vat\" type=\"text\" ng-pattern=\"$ctrl.validationRules.vat.pattern\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"addressField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.address' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.address.$invalid && buyProductForm.$submitted }\" id=\"addressField\" ng-model=\"$ctrl.company.address\" name=\"address\" type=\"text\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"postcodeField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.postalCode' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.zipcode.$invalid && buyProductForm.$submitted }\" id=\"postcodeField\" ng-model=\"$ctrl.company.zipCode\" name=\"zipcode\" type=\"text\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"cityField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.city' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.city.$invalid && buyProductForm.$submitted }\" id=\"cityField\" ng-model=\"$ctrl.company.city\" name=\"city\" type=\"text\" required>\n    </div>\n  </div>\n\n  <div class=\"miniContent\" ng-if=\"!$ctrl.legalInfos.pro\" ng-hide=\"$ctrl.validForm\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n    <p style=\"text-align: center;\">{{ 'buyProduct.customerPurchase.text' | translate }}</p>\n    <div class=\"formGroup\">\n      <div>\n        <label for=\"nameField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.lastName.label' | translate }}</label>\n        <input ng-class=\"{ 'errorField' : buyProductForm.lastName.$invalid && buyProductForm.$submitted }\" id=\"lastNameField\" ng-model=\"$ctrl.billingAddress.lastName\" name=\"lastName\" type=\"text\" required>\n      </div>\n    </div>\n    <div class=\"formGroup\">\n      <div>\n        <label for=\"nameField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.firstName.label' | translate }}</label>\n        <input ng-class=\"{ 'errorField' : buyProductForm.firstName.$invalid && buyProductForm.$submitted }\" id=\"firstNameField\" ng-model=\"$ctrl.billingAddress.firstName\" name=\"firstName\" type=\"text\" required>\n      </div>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"addressField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.address' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.address.$invalid && buyProductForm.$submitted }\" id=\"addressField\" ng-model=\"$ctrl.billingAddress.address\" name=\"address\" type=\"text\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"postcodeField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.postalCode' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.zipCode.$invalid && buyProductForm.$submitted }\" id=\"postcodeField\" ng-model=\"$ctrl.billingAddress.zipCode\" name=\"zipCode\" type=\"text\" required>\n    </div>\n    <div class=\"formGroup\">\n      <label for=\"cityField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'buyProduct.professionalPurchase.city' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : buyProductForm.city.$invalid && buyProductForm.$submitted }\" id=\"cityField\" ng-model=\"$ctrl.billingAddress.city\" name=\"city\" type=\"text\" required>\n    </div>\n  </div>\n\n  <div class=\"centerErrorMessage\">\n    <p class=\"errorMessage\" ng-show=\"$ctrl.purchaseInfos.beginLoadingB2BPrice && buyProductForm.$submitted\">\n      <span>{{ 'buyProduct.waitB2BPrice.error' | translate }}</span>\n    </p>\n    <p class=\"errorMessage\" ng-show=\"buyProductForm.retraction.$invalid && buyProductForm.$submitted\">\n      <span>{{ 'buyProduct.retraction.error' | translate }}</span>\n    </p>\n    <p class=\"errorMessage\" ng-show=\"buyProductForm.cgv.$invalid && buyProductForm.$submitted\">\n      <span>{{ 'buyProduct.cgv.error' | translate }}</span>\n    </p>\n    <p class=\"errorMessage\" ng-show=\"($ctrl.legalInfos.pro && (buyProductForm.name.$invalid\n                                    || buyProductForm.vat.$invalid\n                                    || buyProductForm.address.$invalid\n                                    || buyProductForm.zipcode.$invalid\n                                    || buyProductForm.city.$invalid\n                                    || buyProductForm.country.$invalid) && !buyProductForm.vat.$error.pattern) ||\n                                    ((!$ctrl.legalInfos.pro) && (buyProductForm.lastName.$invalid\n                                    || buyProductForm.firstName.$invalid\n                                    || buyProductForm.address.$invalid\n                                    || buyProductForm.zipCode.$invalid\n                                    || buyProductForm.city.$invalid\n                                    || buyProductForm.country.$invalid))\">\n      <span>{{ 'buyProduct.professionalPurchase.error.message' | translate }}</span>\n    </p>\n    <p class=\"errorMessage\" ng-show=\"$ctrl.legalInfos.pro && buyProductForm.vat.$error.pattern\">\n        <span>{{ 'buyProduct.professionalPurchase.error.vat' | translate }}</span>\n    </p>\n  </div>\n\n  <ul class=\"buttonList\" ng-if=\"!$ctrl.validForm\">\n    <li>\n      <button ng-click=\"$ctrl.goBack()\" type=\"button\" class=\"button cancel\" ga-track-event=\"['Buy Product', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button>\n    </li>\n    <li>\n      <button type=\"submit\" ng-class=\"{'disabled':!$ctrl.codeCountry}\" ga-track-event=\"['Buy Product', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n    </li>\n  </ul>\n</form>\n\n<payment-worldpay ng-if=\"$ctrl.isPspWorldpay && $ctrl.validForm\" product-ref=\"$ctrl.productRef\" voucher-infos=\"$ctrl.voucherInfos\" purchase-infos=\"$ctrl.purchaseInfos\" valid-form=\"$ctrl.validForm\" error-purchase=\"$ctrl.errorPurchase\"></payment-worldpay>\n<payment-sips ng-if=\"$ctrl.isPspSips && $ctrl.validForm\" product-ref=\"$ctrl.productRef\" voucher-infos=\"$ctrl.voucherInfos\" purchase-infos=\"$ctrl.purchaseInfos\" valid-form=\"$ctrl.validForm\" error-purchase=\"$ctrl.errorPurchase\"></payment-sips>\n<app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.errorPurchase\" info=\"$ctrl.fakeVar\" delay=\"99999\" ng-if=\"$ctrl.errorPurchase\" class=\"error\"></app-message>\n"

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(608);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BuyProductController = function () {
	  BuyProductController.$inject = ["$rootScope", "$scope", "UserService", "Localization", "ProductService", "ValidationRules", "I18n", "$window", "$log", "StoreTypes", "DocumentsService", "PurchaseInfos", "$translate"];
	  function BuyProductController($rootScope, $scope, UserService, Localization, ProductService, ValidationRules, I18n, $window, $log, StoreTypes, DocumentsService, PurchaseInfos, $translate) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, BuyProductController);
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.country = Localization.getCountry();
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.userService = UserService;
	    this.validationRules = ValidationRules;
	    this.documentsService = DocumentsService;
	    this.isProcessing = false;
	    this.init();
	    this.codeCountry = '';
	    this.productService = ProductService;
	    this.company = this.userService.getCurrentCompany();
	    this.billingAddress = {};
	    this.isCountryConcerned = false;
	    this.isEuropeanUnion = false;
	    this.countryConcerned();
	    this.I18n = I18n;
	    this.countryUpper = Localization.getCountry().toUpperCase();
	    this.$window = $window;
	    this.$log = $log;
	    this.StoreTypes = StoreTypes;
	    this.purchaseInfos = PurchaseInfos;
	    this.$scope.$watch('$ctrl.codeCountry', function () {
	      $rootScope.$broadcast('buy-product:countryChanged', $scope.$ctrl.codeCountry);
	    });
	    this.documentsService.getUntreatedDocuments().then(function (result) {
	      _this.documentGtcId = -1;
	      _this.documentWithdrawalId = -1;
	      if (result.size !== 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(result), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var doc = _step.value;
	
	            if (doc.type === 'GTC') {
	              _this.documentGtcId = doc.id;
	            }
	            if (doc.type === 'WITHDRAWAL') {
	              _this.documentWithdrawalId = doc.id;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }).catch(function () {
	      _this.documentGtcId = -1;
	      _this.documentWithdrawalId = -1;
	    });
	  }
	
	  (0, _createClass3.default)(BuyProductController, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      return this.userService.getCurrentUser().then(function (user) {
	        _this2.user = user;
	        _this2.codeCountry = _this2.userService.getCountryOfResidence();
	        _this2.billingAddress = {
	          'firstName': user.firstName,
	          'lastName': user.lastName,
	          'zipCode': user.zipCode,
	          'address': user.address,
	          'city': user.city
	        };
	        _this2.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'updatePrice',
	    value: function updatePrice() {
	      var isPro = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.legalInfos !== undefined ? this.legalInfos.pro : undefined;
	
	      if (isPro === undefined) return;
	      this.$rootScope.$broadcast('buy-product:proToggled', isPro);
	      this.isEuropeanUnionCountry(isPro);
	    }
	  }, {
	    key: 'isEuropeanUnionCountry',
	    value: function isEuropeanUnionCountry(isPro) {
	      var _this3 = this;
	
	      if (isPro) {
	        this.userService.isEuropeanUnionCountry(this.country).then(function (res) {
	          _this3.error = null;
	          _this3.isEuropeanUnion = res === 'true';
	          _this3.$log.debug(_this3.isEuropeanUnion);
	        }, function (err) {
	          _this3.error = err;
	        });
	      }
	    }
	  }, {
	    key: 'countryConcerned',
	    value: function countryConcerned() {
	      var _this4 = this;
	
	      this.userService.countryConcernedByWithdrawalRights(this.country).then(function (res) {
	        _this4.error = null;
	        _this4.isCountryConcerned = res === 'true';
	      }, function (err) {
	        _this4.error = err;
	      });
	    }
	  }, {
	    key: 'isFreeVoucherProduct',
	    value: function isFreeVoucherProduct() {
	      return this.voucherInfos.isPurchaseUsingVoucher && parseFloat(this.voucherInfos.amountReduction) === 0;
	    }
	  }, {
	    key: 'buyProduct',
	    value: function buyProduct(event) {
	      var _this5 = this;
	
	      if (this.$scope.buyProductForm.$valid && !this.purchaseInfos.beginLoadingB2BPrice) {
	        var pspType = this.userService.getPspType();
	        this.validForm = true;
	        if (!this.isFreeProduct) {
	          this.isFreeProduct = this.isFreeVoucherProduct();
	        }
	        this.updateCountryOfResidence().then(function () {
	          if (pspType === 'SIPS' || _this5.isFreeProduct) {
	            _this5.isPspSips = true;
	          } else {
	            _this5.isPspWorldpay = true;
	          }
	        });
	        this.company.country = this.codeCountry;
	        this.billingAddress.country = this.codeCountry;
	        var companyCopy = JSON.parse((0, _stringify2.default)(this.company));
	        companyCopy.vatNumber = companyCopy.tvaNumber;
	        delete companyCopy.tvaNumber;
	        this.purchaseInfos = {
	          isPro: this.legalInfos.pro,
	          optIn: this.legalInfos.offers ? this.legalInfos.offers : false,
	          withdrawalRights: this.legalInfos.retraction,
	          buyer: {
	            company: this.legalInfos.pro ? companyCopy : null,
	            billingAddress: this.legalInfos.pro ? null : this.billingAddress
	          },
	          isFreeProduct: this.isFreeProduct
	        };
	        if (this.documentGtcId !== -1) {
	          this.documentsService.sendDocumentConsent([this.documentGtcId]);
	        }
	        if (this.documentWithdrawalId !== -1) {
	          this.documentsService.sendDocumentConsent([this.documentWithdrawalId]);
	        }
	      }
	      event.preventDefault();
	    }
	  }, {
	    key: 'updateCountryOfResidence',
	    value: function updateCountryOfResidence() {
	      var _this6 = this;
	
	      return this.userService.putCountryOfResidence(this.codeCountry).then(function () {
	        // MAJ session storage
	        return _this6.userService.setCurrentUserCountryOfResidence(_this6.codeCountry);
	      }, function (err) {
	        _this6.error = err;
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.$window.history.back();
	    }
	  }]);
	  return BuyProductController;
	}();
	
	exports.default = BuyProductController;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(923);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./buy-product.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./buy-product.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "buy-product .centerErrorMessage{margin:auto;width:50%;margin-bottom:3px}buy-product .centerErrorMessage>p{text-align:center!important}buy-product .formGroup{margin-top:1em!important}buy-product .centerErrorMessage .errorMessage{display:block}.error p.error{padding:1.5em 15%!important}.error p.error span{padding:initial!important}", ""]);
	
	// exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _countryOfResidence = __webpack_require__(925);
	
	var _countryOfResidence2 = _interopRequireDefault(_countryOfResidence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('countryOfResidence', [_angularUiRouter2.default]).component('countryOfResidence', _countryOfResidence2.default).name;
	
	exports.default = _module;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _countryOfResidence = __webpack_require__(926);
	
	var _countryOfResidence2 = _interopRequireDefault(_countryOfResidence);
	
	var _countryOfResidence3 = __webpack_require__(927);
	
	var _countryOfResidence4 = _interopRequireDefault(_countryOfResidence3);
	
	__webpack_require__(928);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    codeCountry: '=',
	    disabled: '<'
	  },
	  template: _countryOfResidence2.default,
	  controller: _countryOfResidence4.default
	};
	
	exports.default = component;

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports = "<app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n<fieldset>\n  <legend>{{ 'buyProduct.countryOfResidence.select' | translate }}</legend>\n  <p>{{ 'buyProduct.countryOfResidence.certify' | translate }}</p>\n  <div class=\"selectBloc\">\n    <select id=\"countryField\" required ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" name=\"country\" title=\"{{ 'buyProduct.countryOfResidence.select' | translate }}\" ng-model=\"$ctrl.codeCountry\" ng-disabled=\"$ctrl.disabled\">\n      <option disabled value=\"{{null}}\">{{ 'buyProduct.countryOfResidence.select' | translate }}</option>\n      <option ng-repeat=\"c in $ctrl.countries | orderTranslate: 'countries.'\" value=\"{{c}}\" ng-selected=\"c == $ctrl.codeCountry\">{{ 'countries.' + c | lowercase | translate }}</option>\n    </select>\n  </div>\n</fieldset>\n"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountryOfResidenceController = function () {
	  CountryOfResidenceController.$inject = ["$scope", "CountriesService", "Localization", "$log", "I18n", "$filter"];
	  function CountryOfResidenceController($scope, CountriesService, Localization, $log, I18n, $filter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CountryOfResidenceController);
	    this.countriesService = CountriesService;
	    this.I18n = I18n;
	    this.$log = $log;
	    this.countries = [];
	    this.getCountries();
	    $scope.translateCountry = function (p) {
	      return $filter('translate')('countries.' + p);
	    };
	  }
	
	  (0, _createClass3.default)(CountryOfResidenceController, [{
	    key: 'getCountries',
	    value: function getCountries() {
	      var _this = this;
	
	      return this.countriesService.getCountries().then(function (res) {
	        _this.error = null;
	        _this.countries = JSON.parse(res);
	      }, function (err) {
	        _this.$log.error('getCountries error', err);
	        _this.error = err;
	      });
	    }
	  }]);
	  return CountryOfResidenceController;
	}();
	
	exports.default = CountryOfResidenceController;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(929);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./country-of-residence.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./country-of-residence.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "#countryField.ng-invalid{border-color:#bd3632;color:#bd3632}#countryField.ng-invalid option:not([disabled]){color:#000}", ""]);
	
	// exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentWorldpay = __webpack_require__(931);
	
	var _paymentWorldpay2 = _interopRequireDefault(_paymentWorldpay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('paymentWorldpay', [_angularUiRouter2.default]).filter('cardSubstring', function () {
	  return function (card) {
	    var res = card.substring(0, card.indexOf('-')); // EX: VISA-SSL
	    return res;
	  };
	}).component('paymentWorldpay', _paymentWorldpay2.default).name;
	
	exports.default = _module;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentWorldpay = __webpack_require__(932);
	
	var _paymentWorldpay2 = _interopRequireDefault(_paymentWorldpay);
	
	var _paymentWorldpay3 = __webpack_require__(933);
	
	var _paymentWorldpay4 = _interopRequireDefault(_paymentWorldpay3);
	
	__webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    productRef: '<',
	    voucherInfos: '<',
	    purchaseInfos: '<',
	    validForm: '=',
	    errorPurchase: '='
	  },
	  template: _paymentWorldpay2.default,
	  controller: _paymentWorldpay4.default
	};
	
	exports.default = component;

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports = "<app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\"></app-message>\n<app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n<form class=\"paymentWorldpay\" ng-if=\"$ctrl.walletWorldpay && !$ctrl.error\" name=\"directPayment\" ng-submit=\"$ctrl.directPaymentSubmit()\">\n  <fieldset class=\"cardBloc collapseBloc\" ng-class=\"{'active' : $ctrl.activeWallet}\" ng-init=\"$ctrl.activeWallet=true\">\n    <legend class=\"collapseBt dropDown\" ng-click=\"$ctrl.activeWallet=!$ctrl.activeWallet\">{{ 'buyProduct.worldpay.wallet.title' | translate }}</legend>\n    <div div class=\"collapse\" aria-hidden=\"false\">\n      <table class=\"listCard\">\n        <thead>\n          <tr>\n            <th>{{ 'buyProduct.worldpay.wallet.cardNumber' | translate }}</th>\n            <th>{{ 'buyProduct.worldpay.wallet.expiryDate' | translate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"card in $ctrl.walletWorldpay\">\n            <td>\n              <label for=\"{{card.id}}\">\n                <input id=\"{{card.id}}\" type=\"radio\" ng-model=\"$ctrl.cardId\" value=\"{{card.id}}\" name=\"selectCardDirectPayment\" ng-change=\"$ctrl.controlCheckDirectPayment()\"/>\n                <span>\n                  <img ng-src=\"img/payment/{{ card.cardType | lowercase }}.gif\" alt=\"paiement par carte Visa\" />\n                </span>\n      \t\t\t  </label>\n              <p>\n                <span>{{ card.maskedPan }}</span>\n                <span>{{ card.alias }}</span>\n              </p>\n            </td>\n            <td>{{ card.expiryDate | date : 'MM/yyyy' }}</td>\n          </tr>\n        </tbody>\n      </table>\n      <ul class=\"buttonList\">\n        <li>\n          <button class=\"button\" type=\"submit\" ng-class=\"{'disabled':!$ctrl.cardId}\" ga-track-event=\"['WorldPay Payment', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n        </li>\n      </ul>\n    </div>\n  </fieldset>\n</form>\n\n<form class=\"paymentWorldpay\" name=\"redirectPaymentTokenisable\" ng-submit=\"$ctrl.redirectPaymentTokenisableSubmit()\">\n  <fieldset class=\"cardBloc collapseBloc\" ng-class=\"{'active' : $ctrl.paymentTokenisable}\" ng-init=\"$ctrl.paymentTokenisable=true\">\n  \t<legend class=\"collapseBt dropDown\" ng-click=\"$ctrl.blockTokenisableControl()\">{{ 'buyProduct.worldpay.tokenisableMeans.select' | translate }}</legend>\n  \t<div div class=\"collapse\" aria-hidden=\"false\">\n  \t\t<ul class=\"listCard\">\n  \t\t\t<li ng-repeat=\"mean in $ctrl.meansTokenisable\">\n          <label for=\"{{mean}}\">\n            <input id=\"{{mean}}\" type=\"radio\" ng-model=\"$ctrl.selectedMeansTokenisable\" value=\"{{mean}}\" name=\"selectCardPaymentTokenisable\" ng-change=\"$ctrl.controlCheckTokenisable()\"/>\n            <span>\n              <img ng-src=\"img/payment/{{ mean | cardSubstring | lowercase}}.gif\" alt=\"paiement par carte Visa\" />\n  \t\t\t\t  </span>\n  \t\t\t  </label>\n        </li>\n  \t\t</ul>\n  \t\t<label for=\"saveInfo\" class=\"checkBox\">\n        <input id=\"saveInfo\" value=\"infoSaved\" type=\"checkbox\" ng-model=\"$ctrl.saveCard\">\n        <span>{{ 'buyProduct.worldpay.tokenisableMeans.saveCard' | translate }}</span>\n      </label>\n      <ul class=\"buttonList reverseMobile\">\n      \t<li>\n      \t\t<button type=\"button\" ng-click=\"$ctrl.goBack()\" class=\"button cancel\" ga-track-event=\"['WorldPay Payment', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button>\n      \t</li>\n      \t<li>\n      \t\t<button class=\"button\" type=\"submit\" ng-class=\"{'disabled':!$ctrl.selectedMeansTokenisable}\" ga-track-event=\"['WorldPay Payment', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n      \t</li>\n      </ul>\n  \t</div>\n  </fieldset>\n</form>\n\n<form class=\"paymentWorldpay\" name=\"redirectPaymentNoTokenisable\" ng-submit=\"$ctrl.redirectPaymentNoTokenisableSubmit()\">\n  <fieldset class=\"cardBloc collapseBloc\" ng-class=\"{'active' : $ctrl.paymentNoTokenisable}\" ng-init=\"$ctrl.paymentNoTokenisable=false\">\n  \t<legend class=\"collapseBt dropDown\" ng-click=\"$ctrl.blockNoTokenisableControl()\">{{ 'buyProduct.worldpay.notTokenisableMeansTitle' | translate }}</legend>\n  \t<div div class=\"collapse\" aria-hidden=\"false\">\n  \t\t<ul class=\"listCard\">\n  \t\t\t<li ng-repeat=\"mean in $ctrl.meansNoTokenisable\">\n          <label for=\"{{mean}}\">\n            <input id=\"{{mean}}\" type=\"radio\" ng-model=\"$ctrl.selectedMeansNoTokenisable\" value=\"{{mean}}\" name=\"selectCardPaymentNoTokenisable\" ng-change=\"$ctrl.controlCheckNoTokenisable()\"/>\n              <span>\n                <img ng-src=\"img/payment/{{ mean | cardSubstring | lowercase }}.gif\" alt=\"paiement par Ynadex\" />\n  \t\t\t\t    </span>\n  \t\t\t  </label>\n        </li>\n  \t\t</ul>\n  \t\t<ul class=\"buttonList reverseMobile\">\n  \t\t\t<li>\n  \t\t\t\t<button type=\"button\" ng-click=\"$ctrl.goBack()\" class=\"button cancel\" ga-track-event=\"['WorldPay Payment', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button>\n  \t\t\t</li>\n  \t\t\t<li>\n  \t\t\t\t<button class=\"button\" type=\"submit\" ng-class=\"{'disabled':!$ctrl.selectedMeansNoTokenisable}\" ga-track-event=\"['WorldPay Payment', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n  \t\t\t</li>\n  \t\t</ul>\n  \t</div>\n  </fieldset>\n</form>\n"

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentWorldpayController = function () {
	  PaymentWorldpayController.$inject = ["$log", "UserService", "PaymentService", "VehicleService", "ProductService", "$window", "$state"];
	  function PaymentWorldpayController($log, UserService, PaymentService, VehicleService, ProductService, $window, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PaymentWorldpayController);
	    this.userService = UserService;
	    this.paymentService = PaymentService;
	    this.vehicleService = VehicleService;
	    this.productService = ProductService;
	    this.$window = $window;
	    this.$state = $state;
	    this.$log = $log;
	    this.getWallet();
	    this.getWorldpayTokenisableMeansOfPayments();
	    this.getWorldpayNoTokenisableMeansOfPayments();
	    this.isProcessing = false;
	  }
	
	  (0, _createClass3.default)(PaymentWorldpayController, [{
	    key: 'getWallet',
	    value: function getWallet() {
	      var _this = this;
	
	      return this.userService.getWallet().then(function (res) {
	        _this.error = null;
	        _this.walletWorldpay = res.cards;
	      }, function (err) {
	        _this.validForm = false;
	        _this.error = err;
	      });
	    }
	  }, {
	    key: 'getWorldpayTokenisableMeansOfPayments',
	    value: function getWorldpayTokenisableMeansOfPayments() {
	      var _this2 = this;
	
	      return this.paymentService.getWorldpayMeansOfPayments(true).then(function (res) {
	        _this2.error = null;
	        _this2.$log.debug('getWorldpayTokenisableMeansOfPayments', res);
	        _this2.meansTokenisable = res;
	      }, function (err) {
	        _this2.validForm = false;
	        _this2.error = err;
	      });
	    }
	  }, {
	    key: 'getWorldpayNoTokenisableMeansOfPayments',
	    value: function getWorldpayNoTokenisableMeansOfPayments() {
	      var _this3 = this;
	
	      return this.paymentService.getWorldpayMeansOfPayments(false).then(function (res) {
	        _this3.error = null;
	        _this3.$log.debug('getWorldpayNoTokenisableMeansOfPayments', res);
	        _this3.meansNoTokenisable = res;
	      }, function (err) {
	        _this3.validForm = false;
	        _this3.error = err;
	      });
	    }
	  }, {
	    key: 'directPaymentSubmit',
	    value: function directPaymentSubmit() {
	      var _this4 = this;
	
	      this.isProcessing = true;
	      this.purchaseInfos.isFreeProduct = false;
	      this.purchaseInfos.paymentId = this.cardId;
	      this.purchaseInfos.sessionId = 'sessionId'; // TODO - à modifier par la suite
	      var vin = this.vehicleService.getCurrentVin();
	      return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos).then(function (res) {
	        _this4.isProcessing = false;
	        // MAJ SessionStorage
	        if (_this4.purchaseInfos.isPro) {
	          _this4.userService.setCurrentCompany(_this4.purchaseInfos.buyer.company);
	        }
	        _this4.$state.go('managePurchase.confirmation', { productId: _this4.productRef, free: false, status: res.pspPaymentStatus, voucher: _this4.voucherInfos.isPurchaseUsingVoucher, reduction: _this4.voucherInfos.amountReduction, direct: true });
	      }, function (err) {
	        _this4.isProcessing = false;
	        _this4.errorPurchase = {
	          message: 'error.' + err.data.meta.code,
	          cause: err
	        };
	        _this4.$log.debug('buyProduct directPayment worldpay error', err);
	      });
	    }
	  }, {
	    key: 'redirectPaymentTokenisableSubmit',
	    value: function redirectPaymentTokenisableSubmit() {
	      var _this5 = this;
	
	      this.isProcessing = true;
	      this.purchaseInfos.isFreeProduct = false;
	      this.purchaseInfos.paymentMethod = this.selectedMeansTokenisable;
	      this.purchaseInfos.createToken = this.saveCard;
	      var vin = this.vehicleService.getCurrentVin();
	      return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos).then(function (res) {
	        _this5.isProcessing = false;
	        // MAJ SessionStorage
	        if (_this5.purchaseInfos.isPro) {
	          _this5.userService.setCurrentCompany(_this5.purchaseInfos.buyer.company);
	        }
	        _this5.$window.open(res.pspUrl, '_self');
	      }, function (err) {
	        _this5.isProcessing = false;
	        _this5.errorPurchase = {
	          message: 'error.' + err.data.meta.code,
	          cause: err
	        };
	        _this5.$log.debug('buyProduct redirectPaymentTokenisable worldpay error', err);
	      });
	    }
	  }, {
	    key: 'redirectPaymentNoTokenisableSubmit',
	    value: function redirectPaymentNoTokenisableSubmit() {
	      var _this6 = this;
	
	      this.isProcessing = true;
	      this.purchaseInfos.isFreeProduct = false;
	      this.purchaseInfos.paymentMethod = this.selectedMeansNoTokenisable;
	      var vin = this.vehicleService.getCurrentVin();
	      return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos).then(function (res) {
	        _this6.isProcessing = false;
	        // MAJ SessionStorage
	        if (_this6.purchaseInfos.isPro) {
	          _this6.userService.setCurrentCompany(_this6.purchaseInfos.buyer.company);
	        }
	        _this6.$window.open(res.pspUrl, '_self');
	      }, function (err) {
	        _this6.isProcessing = false;
	        _this6.errorPurchase = {
	          message: 'error.' + err.data.meta.code,
	          cause: err
	        };
	        _this6.$log.debug('buyProduct redirectPaymentNoTokenisable worldpay error', err);
	      });
	    }
	  }, {
	    key: 'blockTokenisableControl',
	    value: function blockTokenisableControl() {
	      if (this.paymentNoTokenisable === true) {
	        this.paymentNoTokenisable = !this.paymentNoTokenisable;
	      }
	      this.paymentTokenisable = !this.paymentTokenisable;
	    }
	  }, {
	    key: 'blockNoTokenisableControl',
	    value: function blockNoTokenisableControl() {
	      if (this.paymentTokenisable === true) {
	        this.paymentTokenisable = !this.paymentTokenisable;
	      }
	      this.paymentNoTokenisable = !this.paymentNoTokenisable;
	    }
	  }, {
	    key: 'controlCheckDirectPayment',
	    value: function controlCheckDirectPayment() {
	      if (this.cardId) {
	        this.selectedMeansNoTokenisable = undefined;
	        this.selectedMeansTokenisable = undefined;
	        this.saveCard = undefined;
	      }
	    }
	  }, {
	    key: 'controlCheckTokenisable',
	    value: function controlCheckTokenisable() {
	      if (this.selectedMeansTokenisable) {
	        this.selectedMeansNoTokenisable = undefined;
	        this.cardId = undefined;
	      }
	    }
	  }, {
	    key: 'controlCheckNoTokenisable',
	    value: function controlCheckNoTokenisable() {
	      if (this.selectedMeansNoTokenisable) {
	        this.cardId = undefined;
	        this.selectedMeansTokenisable = undefined;
	        this.saveCard = undefined;
	      }
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.$window.history.back();
	    }
	  }]);
	  return PaymentWorldpayController;
	}();
	
	exports.default = PaymentWorldpayController;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(935);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./payment-worldpay.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./payment-worldpay.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".paymentWorldpay{padding-top:0!important}.cardBloc{margin-bottom:0!important}payment-worldpay .dimmer{position:fixed!important}@media (max-width:360px){.ticket fieldset table.listCard p span:first-child{font-size:.8em!important}}@media (max-width:320px){.ticket fieldset table.listCard p span:first-child{font-size:.7em!important}}", ""]);
	
	// exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentSips = __webpack_require__(937);
	
	var _paymentSips2 = _interopRequireDefault(_paymentSips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('paymentSips', [_angularUiRouter2.default]).component('paymentSips', _paymentSips2.default).name;
	
	exports.default = _module;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentSips = __webpack_require__(938);
	
	var _paymentSips2 = _interopRequireDefault(_paymentSips);
	
	var _paymentSips3 = __webpack_require__(939);
	
	var _paymentSips4 = _interopRequireDefault(_paymentSips3);
	
	__webpack_require__(940);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    productRef: '<',
	    voucherInfos: '<',
	    purchaseInfos: '<',
	    validForm: '=',
	    errorPurchase: '='
	  },
	  template: _paymentSips2.default,
	  controller: _paymentSips4.default
	};
	
	exports.default = component;

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n<fieldset id=\"cardBlocSips\" class=\"cardBloc collapseBloc\" ng-class=\"{'active': $ctrl.showBlock}\" ng-if=\"$ctrl.activeFormSips\">\n  <legend class=\"collapseBt dropDown\" ng-click=\"$ctrl.showBlock=!$ctrl.showBlock\">{{ 'buyProduct.sips.choosePayment' | translate }}</legend>\n\t<div ng-bind-html=\"$ctrl.sipsForm\" class=\"sipsBlock\" ng-if=\"$ctrl.showBlock\"></div>\n  <ul class=\"buttonList reverseMobile\" ng-if=\"$ctrl.showBlock\">\n    <li>\n      <button type=\"button\" ng-click=\"$ctrl.goBack()\" class=\"button cancel\" ga-track-event=\"['SIPS Payment', 'Click', 'Cancel']\">{{ 'common.cancel' | translate }}</button>\n    </li>\n  </ul>\n</fieldset>\n"

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentSipsController = function () {
	  PaymentSipsController.$inject = ["$log", "VehicleService", "ProductService", "VoucherService", "UserService", "Localization", "StoreTypes", "$sce", "$state", "$window", "$location"];
	  function PaymentSipsController($log, VehicleService, ProductService, VoucherService, UserService, Localization, StoreTypes, $sce, $state, $window, $location) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PaymentSipsController);
	    this.vehicleService = VehicleService;
	    this.productService = ProductService;
	    this.voucherService = VoucherService;
	    this.userService = UserService;
	    this.$sce = $sce;
	    this.$state = $state;
	    this.$log = $log;
	    this.$location = $location;
	    this.activeFormSips = false;
	    this.showBlock = true;
	    this.$window = $window;
	    this.isProcessing = false;
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	  }
	
	  (0, _createClass3.default)(PaymentSipsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.buyProductSips();
	    }
	  }, {
	    key: 'buyProductSips',
	    value: function buyProductSips() {
	      var _this = this;
	
	      this.isProcessing = true;
	      var vin = this.vehicleService.getCurrentVin();
	      if (this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.ONE) {
	        this.$window.localStorage.setItem('token', this.$location.search().token);
	      }
	      return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos).then(function (res) {
	        _this.isProcessing = false;
	        _this.response = res;
	        if (_this.response.sipsForm === 'OK') {
	          // FREE Product
	          _this.$log.debug('buyProductSips > isPurchaseVoucher = ' + _this.voucherInfos.isPurchaseUsingVoucher);
	          _this.$state.go('managePurchase.confirmation', { productId: _this.productRef, free: true, status: 'Delivered', voucher: _this.voucherInfos.isPurchaseUsingVoucher, reduction: _this.voucherInfos.amountReduction });
	        } else {
	          _this.activeFormSips = true;
	          _this.sipsForm = _this.$sce.trustAsHtml(_this.response.sipsForm);
	        }
	        // MAJ SessionStorage
	        if (_this.purchaseInfos.isPro) {
	          _this.userService.setCurrentCompany(_this.purchaseInfos.buyer.company);
	        }
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.validForm = false;
	        _this.errorPurchase = {
	          message: 'error.' + err.data.meta.code,
	          cause: err
	        };
	        _this.$log.error('buyProduct sips error', err);
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      var _this2 = this;
	
	      this.$window.history.back();
	      // Annuler la consommation du code voucher
	      if (this.voucherInfos.voucherCode && this.voucherInfos.isPurchaseUsingVoucher === true) {
	        this.isProcessing = true;
	        return this.voucherService.cancelVoucherCode(this.voucherInfos.voucherCode).then(function (res) {
	          _this2.error = null;
	          _this2.isProcessing = false;
	        }, function (err) {
	          _this2.isProcessing = false;
	          _this2.$log.error('error cancelVoucher', err);
	          _this2.error = err;
	        });
	      }
	    }
	  }]);
	  return PaymentSipsController;
	}();
	
	exports.default = PaymentSipsController;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(941);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./payment-sips.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./payment-sips.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".sipsBlock>form{padding-top:0!important}payment-sips .dimmer{position:fixed!important}", ""]);
	
	// exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _confirmation = __webpack_require__(943);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	var _managePurchaseNavbar = __webpack_require__(902);
	
	var _managePurchaseNavbar2 = _interopRequireDefault(_managePurchaseNavbar);
	
	var _managePurchaseTopblock = __webpack_require__(908);
	
	var _managePurchaseTopblock2 = _interopRequireDefault(_managePurchaseTopblock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('confirmation', [_angularUiRouter2.default, _managePurchaseNavbar2.default, _managePurchaseTopblock2.default]).config(["$stateProvider", "$urlMatcherFactoryProvider", function ($stateProvider, $urlMatcherFactoryProvider) {
	  'ngInject';
	
	  $urlMatcherFactoryProvider.type('boolean', {
	    name: 'boolean',
	    decode: function decode(val) {
	      return val === true ? true : val === 'true';
	    },
	    encode: function encode(val) {
	      return val === true;
	    }
	  });
	  $stateProvider.state('managePurchase.confirmation', {
	    url: '/:productId/confirmation?status&order&amount&currency&locale&price&{voucher:boolean}&reduction&{free:boolean}&{direct:boolean}',
	    params: {
	      productId: null
	    },
	    component: 'confirmation',
	    authenticate: true
	  });
	}]).component('confirmation', _confirmation2.default).name;
	
	exports.default = _module;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmation = __webpack_require__(944);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	var _confirmation3 = __webpack_require__(945);
	
	var _confirmation4 = _interopRequireDefault(_confirmation3);
	
	__webpack_require__(946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _confirmation2.default,
	  controller: _confirmation4.default
	};
	
	exports.default = component;

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"limitContent paypage\">\n  <manage-purchase-topblock disable-back=false></manage-purchase-topblock>\n  <manage-purchase-navbar active-tab=\"$ctrl.activeTab\"></manage-purchase-navbar>\n  <div class=\"confirmation card\">\n    <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n    <app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n    <div ng-if=\"$ctrl.status === 'Delivered' || $ctrl.status === 'AUTHORISED' || $ctrl.status === 'CSDBError'\">\n      <h3 ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n    \t\t<span>{{ 'confirmation.congratulations.title' | translate }}</span>\n         {{ 'confirmation.congratulations.text' | translate }}\n    \t</h3>\n    \t<table>\n    \t\t<thead>\n    \t\t\t<tr>\n    \t\t\t\t<th ng-if=\"$ctrl.userService.getPspType() !== 'SIPS' && !$ctrl.$stateParams.free && !$ctrl.$stateParams.direct\">{{ 'confirmation.transactionId' | translate }}</th>\n    \t\t\t\t<th>{{ 'confirmation.product.label' | translate }}</th>\n    \t\t\t\t<th>{{ 'confirmation.product.price' | translate }}</th>\n    \t\t\t</tr>\n    \t\t</thead>\n    \t\t<tbody>\n    \t\t\t<tr>\n            <td ng-if=\"$ctrl.userService.getPspType() !== 'SIPS' && !$ctrl.$stateParams.free && !$ctrl.$stateParams.direct\">\n              {{ $ctrl.transactionId }}\n            </td>\n            <td>{{ $ctrl.product.title }}</td>\n            <td>\n              <strong ng-if=\"!$ctrl.$stateParams.free\" ng-class=\"{'parredPrice': $ctrl.isPurchaseVoucher }\">\n                  {{ $ctrl.pricePay }}\n              </strong>\n              <strong ng-if=\"($ctrl.isPurchaseVoucher && !$ctrl.$stateParams.free) || ($ctrl.isDirectPayment && $ctrl.isPurchaseVoucher)\">{{ $ctrl.amountReduction | translate }}</strong>\n              <strong ng-if=\"$ctrl.$stateParams.free\">{{ 'confirmation.product.free' | translate }}</strong>\n            </td>\n          </tr>\n    \t\t</tbody>\n    \t</table>\n      <p class=\"emailConfirm\" ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n        <span>{{ 'confirmation.mailInvoice' | translate }}</span>\n      </p>\n      <div class=\"updatePage limitContent\">\n        <installation-guide></installation-guide>\n      </div>\n    </div>\n\n    <div>\n      <h3 ng-if=\"$ctrl.status === 'ERROR'\" ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n    \t\t<span>{{ 'common.error' | translate }}</span>\n         {{ 'confirmation.worldpay.problemEncountered' | translate }}\n    \t</h3>\n      <h3 ng-if=\"$ctrl.status === 'REFUSED'\" ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n    \t\t<span>{{ 'confirmation.worldpay.refuse.label' | translate }}</span>\n         {{ 'confirmation.worldpay.refuse.text' | translate }}\n    \t</h3>\n      <h3 ng-if=\"$ctrl.status === 'PENDING'\" ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n        <span>{{ 'confirmation.worldpay.pending.label' | translate }}</span>\n        {{ 'confirmation.worldpay.pending.text' | translate }}\n      </h3>\n      <h3 ng-if=\"$ctrl.status === 'CANCELLED' || $ctrl.status === 'Cancelled'\">\n        <span>{{ 'common.cancel' | translate }}</span>\n        {{ 'confirmation.sips.canceledPayment' | translate }}\n      </h3>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmationController = function () {
	  ConfirmationController.$inject = ["Localization", "ProductService", "VehicleService", "UserService", "PaymentService", "$window", "$location", "$stateParams", "$log", "I18n", "$rootScope", "$scope", "StoreTypes"];
	  function ConfirmationController(Localization, ProductService, VehicleService, UserService, PaymentService, $window, $location, $stateParams, $log, I18n, $rootScope, $scope, StoreTypes) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ConfirmationController);
	    this.isProcessing = true;
	    this.$stateParams = $stateParams;
	    this.productService = ProductService;
	    this.vehicleService = VehicleService;
	    this.userService = UserService;
	    this.i18n = I18n;
	    this.$location = $location;
	    this.$window = $window;
	    this.paymentService = PaymentService;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.StoreTypes = StoreTypes;
	    this.Localization = Localization;
	    this.activeTab = 'confirmation';
	    this.init();
	    this.validatePayment();
	  }
	
	  (0, _createClass3.default)(ConfirmationController, [{
	    key: 'init',
	    value: function init() {
	      if (!this.$stateParams.free && !this.$stateParams.direct) {
	        this.pspType = this.userService.getPspType();
	        this.$location.url(this.$window.location.pathname + this.$window.location.search);
	        this.status = this.$location.search().status;
	        if (this.pspType === 'WORLDPAY') {
	          // case WORLDPAY
	          this.order = this.$location.search().order;
	          this.amount = this.$location.search().amount;
	          this.currency = this.$location.search().currency;
	        } else {
	          // case SIPS
	          this.isPurchaseVoucher = this.$location.search().voucher === 'true';
	          this.amountReduction = this.$location.search().reduction;
	        }
	      }
	    }
	  }, {
	    key: 'validatePayment',
	    value: function validatePayment() {
	      var _this = this;
	
	      // Case Free Product OR direct payment Worldpay
	      if (this.$stateParams.free || this.$stateParams.direct) {
	        this.status = this.$stateParams.status;
	        this.productRef = this.$stateParams.productId;
	        this.isPurchaseVoucher = this.$stateParams.voucher;
	        this.isDirectPayment = this.$stateParams.direct;
	        this.amountReduction = this.$stateParams.reduction;
	        this.manageConfirmation();
	      } else {
	        this.pspType = this.userService.getPspType();
	        if (this.pspType === 'SIPS') {
	          if (this.isInPaymentIFrame()) {
	            this.$log.error('We shouldn\'t be in an iframe here');
	            this.isProcessing = false;
	          } else {
	            this.productRef = this.$stateParams.productId;
	            this.manageConfirmation();
	          }
	          if (this.Localization.getLocalizedAppConfig().type === this.StoreTypes.HELIOS || this.Localization.getLocalizedAppConfig().type === this.StoreTypes.MYRENAULT || this.Localization.getLocalizedAppConfig().type === this.StoreTypes.ONE) {
	            this.$window.localStorage.removeItem('token');
	          }
	        }
	        if (this.pspType === 'WORLDPAY') {
	          this.paymentService.validatePaymentWorldpay(this.order, this.status, this.amount, this.currency, this.$stateParams.mac).then(function (res) {
	            _this.isPurchaseVoucher = res.isPurchaseVoucher;
	            _this.amountReduction = parseFloat(res.amountReduction).toFixed(2) + ' ' + _this.$stateParams.currency;
	            _this.status = res.status;
	            _this.productRef = res.productRef;
	            _this.transactionId = res.transactionId;
	            _this.manageConfirmation();
	          }, function (err) {
	            _this.$log.error('error validatePayment Worldpay', err);
	            _this.error = err;
	            _this.isProcessing = false;
	            _this.safeApply();
	          });
	        }
	      }
	    }
	  }, {
	    key: 'manageConfirmation',
	    value: function manageConfirmation() {
	      var _this2 = this;
	
	      if (this.status === 'Delivered' || this.status === 'AUTHORISED' || this.status === 'CSDBError') {
	        return this.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	          return _this2.productService.getProduct(_this2.productRef, vehicle.vin, _this2.i18n.getLanguage());
	        }).then(function (product) {
	          _this2.product = product;
	          if (_this2.product.isPromoted) {
	            _this2.pricePay = _this2.product.promotedPrice;
	          } else {
	            _this2.pricePay = _this2.product.price;
	          }
	          if (parseFloat(_this2.amountReduction) === 0) {
	            _this2.amountReduction = 'confirmation.product.free';
	          }
	          _this2.isProcessing = false;
	          _this2.productService.initCache();
	          _this2.safeApply();
	        }, function (err) {
	          _this2.$log.error('error manageConfirmation', err);
	          _this2.error = err;
	          _this2.isProcessing = false;
	          _this2.safeApply();
	        });
	      } else {
	        this.$log.debug('debug manageConfirmation', this.status);
	        this.isProcessing = false;
	        this.safeApply();
	      }
	    }
	  }, {
	    key: 'isInPaymentIFrame',
	    value: function isInPaymentIFrame() {
	      return window.top !== window && window.name === 'iframe_payment';
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }]);
	  return ConfirmationController;
	}();
	
	exports.default = ConfirmationController;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(947);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./confirmation.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./confirmation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".parredPrice{text-decoration:line-through}@media (max-width:400px){.confirmation table tbody tr{font-size:11px}}@media (max-width:350px){.confirmation table tbody tr{font-size:9px}}@media (min-width:1024px){.confirmation .lastText{margin:0}}", ""]);
	
	// exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myProfile = __webpack_require__(949);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	var _myGarage = __webpack_require__(977);
	
	var _myGarage2 = _interopRequireDefault(_myGarage);
	
	var _profile = __webpack_require__(1001);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('profileModule', [_angularUiRouter2.default, _myProfile2.default, _myGarage2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile', {
	    url: '/profile',
	    component: 'profilePage',
	    redirectTo: 'profile.myProfile',
	    authenticate: true,
	    myRenaultForbidden: true
	  });
	}]).component('profilePage', _profile2.default).name;
	
	exports.default = _module;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _components = __webpack_require__(950);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _myDetails = __webpack_require__(960);
	
	var _myDetails2 = _interopRequireDefault(_myDetails);
	
	var _myPreferences = __webpack_require__(966);
	
	var _myPreferences2 = _interopRequireDefault(_myPreferences);
	
	var _myProfile = __webpack_require__(972);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myProfileModule', [_angularUiRouter2.default, _components2.default, _myDetails2.default, _myPreferences2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile.myProfile', {
	    url: '/my-profile',
	    component: 'myProfilePage',
	    redirectTo: 'profile.myProfile.myDetails',
	    authenticate: true
	  });
	}]).component('myProfilePage', _myProfile2.default).name;
	
	exports.default = _module;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userDetailsForm = __webpack_require__(951);
	
	var _userDetailsForm2 = _interopRequireDefault(_userDetailsForm);
	
	var _userCard = __webpack_require__(957);
	
	var _userCard2 = _interopRequireDefault(_userCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myProfileComponentsModule', [_userDetailsForm2.default, _userCard2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userDetailsForm = __webpack_require__(952);
	
	var _userDetailsForm2 = _interopRequireDefault(_userDetailsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('userDetailsFormModule', []).component('userDetailsForm', _userDetailsForm2.default).name;
	
	exports.default = _module;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userDetailsForm = __webpack_require__(953);
	
	var _userDetailsForm2 = _interopRequireDefault(_userDetailsForm);
	
	var _userDetailsForm3 = __webpack_require__(954);
	
	var _userDetailsForm4 = _interopRequireDefault(_userDetailsForm3);
	
	__webpack_require__(955);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    form: '=',
	    onSubmit: '&',
	    onCancel: '&'
	  },
	  transclude: true,
	  template: _userDetailsForm4.default,
	  controller: _userDetailsForm2.default
	};
	
	exports.default = component;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserDetailsFormController = function () {
	  UserDetailsFormController.$inject = ["$scope", "$rootScope", "I18n"];
	  function UserDetailsFormController($scope, $rootScope, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserDetailsFormController);
	    this.I18n = I18n;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.isProcessing = false;
	  }
	
	  (0, _createClass3.default)(UserDetailsFormController, [{
	    key: 'toggleForm',
	    value: function toggleForm() {
	      if (!this.editMode) {
	        this.editMode = true;
	      }
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this = this;
	
	      this.isProcessing = true;
	      this.success = null;
	      this.error = null;
	      var details = this.form.$$controls.reduce(function (acc, $field) {
	        acc[$field.$name] = _this.form[$field.$name].$modelValue;
	        return acc;
	      }, {});
	
	      this.onSubmit({ details: details }).then(function () {
	        _this.isProcessing = false;
	        _this.success = 'my-profile.my-details.success';
	        _this.editMode = false;
	        _this.safeApply();
	        return _promise2.default.resolve();
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.error = {
	          message: 'my-profile.my-details.error',
	          cause: err
	        };
	        _this.safeApply();
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'cancelForm',
	    value: function cancelForm() {
	      this.editMode = !this.editMode;
	      this.onCancel();
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }]);
	  return UserDetailsFormController;
	}();
	
	exports.default = UserDetailsFormController;

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\" ></app-message>\n<form class=\"edit\"\n      name=\"$ctrl.form\"\n      ng-class=\"{'active': $ctrl.editMode}\"\n      ng-submit=\"$ctrl.submitForm()\">\n  <div class=\"toggle\" ng-class=\"{'arabToggle':  $ctrl.I18n.isArLocale()}\" ng-click=\"$ctrl.toggleForm()\">\n    <ng-transclude></ng-transclude>\n  </div>\n\n  <ul class=\"buttonList maxLarge\" ng-if=\"$ctrl.editMode\">\n    <li>\n      <button type=\"button\"\n              class=\"button cancel\"\n              ng-click=\"$ctrl.cancelForm()\"\n              ga-track-event=\"['My Details', 'Click', 'Cancel']\">\n        {{ 'common.cancel' | translate }}\n      </button>\n    </li>\n    <li>\n      <button type=\"submit\"\n              ng-disabled=\"$ctrl.form.$invalid\"\n              ga-track-event=\"['My Details', 'Click', 'Validate']\">\n        {{ 'common.validate' | translate }}\n      </button>\n    </li>\n  </ul>\n</form>\n"

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(956);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./user-details-form.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./user-details-form.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "user-details-form .active .fieldValue{display:none}user-details-form .active select{display:block}user-details-form select{display:none}div.arabToggle:before{left:1em!important;right:inherit!important}", ""]);
	
	// exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userCard = __webpack_require__(958);
	
	var _userCard2 = _interopRequireDefault(_userCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('userCardModule', []).component('userCard', _userCard2.default).name;
	
	exports.default = _module;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userCard = __webpack_require__(959);
	
	var _userCard2 = _interopRequireDefault(_userCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    card: '<',
	    onRemoveCard: '&'
	  },
	  template: _userCard2.default
	};
	
	exports.default = component;

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	module.exports = "{{ $ctrl.card.cardType }} {{ $ctrl.card.alias | isEmpty }}\n<div>\n  <button ng-hide=\"!$ctrl.showConfirmation\" ng-click=\"$ctrl.onRemoveCard({card:$ctrl.card}); $ctrl.showConfirmation = false\" class=\"confirmDelete\" ga-track-event=\"['My Preferences', 'Click', 'Delete Card']\">{{ 'common.confirm' | translate }}</button>\n  <button ng-hide=\"!$ctrl.showConfirmation\" ng-click=\"$ctrl.showConfirmation = false\" class=\"cancelDelete\">{{ 'common.cancel' | translate }}</button>\n</div>\n<span>{{ $ctrl.card.maskedPan }}</span>\n<button ng-hide=\"$ctrl.showConfirmation\" ng-click=\"$ctrl.showConfirmation = true\" class=\"deleteCard\"></button>\n"

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myDetails = __webpack_require__(961);
	
	var _myDetails2 = _interopRequireDefault(_myDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myDetailsModule', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile.myProfile.myDetails', {
	    url: '/my-details',
	    component: 'myDetailsPage',
	    authenticate: true
	  });
	}]).component('myDetailsPage', _myDetails2.default).name;
	
	exports.default = _module;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myDetails = __webpack_require__(962);
	
	var _myDetails2 = _interopRequireDefault(_myDetails);
	
	var _myDetails3 = __webpack_require__(963);
	
	var _myDetails4 = _interopRequireDefault(_myDetails3);
	
	__webpack_require__(964);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  transclude: true,
	  controller: _myDetails2.default,
	  template: _myDetails4.default
	};
	
	exports.default = component;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyDetailsController = function () {
	  MyDetailsController.$inject = ["UserService", "ValidationRules", "I18n"];
	  function MyDetailsController(UserService, ValidationRules, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyDetailsController);
	    this.userService = UserService;
	    this.validationRules = ValidationRules;
	    this.I18n = I18n;
	    this.isProcessing = true;
	    this.civilities = this.validationRules.civility;
	    this.updatePassword = {};
	    this.isValidOldPassword = true;
	    this.isWrongOldPassword = false;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyDetailsController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.userService.getCurrentUser().then(function (user) {
	        _this.user = user;
	
	        var deleteCivility = true;
	        _this.civilities.forEach(function (civility) {
	          if (_this.user.civility === civility.id) {
	            deleteCivility = false;
	          }
	        });
	
	        if (deleteCivility) {
	          delete _this.user.civility;
	        }
	
	        _this.userDetails = _this.buildDetails();
	        _this.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'buildDetails',
	    value: function buildDetails() {
	      var userDetails = (0, _assign2.default)({}, this.user);
	      if (userDetails.address) {
	        var addressLines = userDetails.address.split('\n');
	        userDetails.address1 = addressLines[0];
	        userDetails.address2 = addressLines[1];
	        userDetails.address3 = addressLines[2];
	        delete userDetails.address;
	      }
	      return userDetails;
	    }
	  }, {
	    key: 'updateUserDetails',
	    value: function updateUserDetails(userDetails) {
	      var _this2 = this;
	
	      return this.userService.update(this.userPayload).then(function (user) {
	        _this2.user = user;
	        _this2.userDetails = _this2.buildDetails();
	        return _promise2.default.resolve(user);
	      }, function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword() {
	      var _this3 = this;
	
	      return this.userService.changePassword(this.updatePassword.oldPassword, this.updatePassword.newPassword).then(function (success) {
	        _this3.updatePassword = {};
	        return _promise2.default.resolve(success);
	      }, function (err) {
	        _this3.error = err;
	        if (_this3.error.data.meta.code === 524) {
	          _this3.errorCode = _this3.error.data.meta.code;
	        }
	        if (_this3.error.data.meta.statusCode === 403) {
	          _this3.isWrongOldPassword = true;
	        }
	        return _promise2.default.reject(err);
	      });
	    }
	
	    /**
	     * validate old password
	     * it should be match with old password patter or with checkPassword WS
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'validateOldPassword',
	    value: function validateOldPassword() {
	      var _this4 = this;
	
	      this.isValidOldPassword = true;
	      if (this.updatePassword.oldPassword && this.updatePassword.oldPassword.length >= 8 && this.updatePassword.oldPassword.length <= 32) {
	        var isMatchOldPattern = this.updatePassword.oldPassword.match(this.validationRules.password.pattern);
	        if (isMatchOldPattern === null) {
	          this.userService.checkPassword(this.updatePassword.oldPassword).then(function (valid) {
	            _this4.isValidOldPassword = true;
	            return _promise2.default.resolve();
	          }, function (err) {
	            _this4.isValidOldPassword = false;
	            return _promise2.default.reject(err);
	          });
	        }
	      }
	      return this.isValidOldPassword;
	    }
	  }, {
	    key: 'cancelAddressForm',
	    value: function cancelAddressForm() {
	      if (this.user.address) {
	        var addressLines = this.user.address.split('\n');
	        this.userDetails.address1 = addressLines[0];
	        this.userDetails.address2 = addressLines[1];
	        this.userDetails.address3 = addressLines[2];
	      }
	      this.userDetails.zipCode = this.user.zipCode;
	      this.userDetails.city = this.user.city;
	    }
	  }, {
	    key: 'userPayload',
	    get: function get() {
	      var user = (0, _assign2.default)({}, this.userDetails);
	      if (user.address1) {
	        user.address = [user.address1, user.address2, user.address3].join('\n');
	        delete user.address1;
	        delete user.address2;
	        delete user.address3;
	      }
	      return user;
	    }
	  }]);
	  return MyDetailsController;
	}();
	
	exports.default = MyDetailsController;

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n\n<user-details-form form=\"$ctrl.civilityForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.civility = $ctrl.user.civility\">\n  <div class=\"formField ticket\">\n    <label for=\"_civility\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.civility.label' | translate }}</span>\n      <span ng-if=\"$ctrl.user.civility\" class=\"fieldValue\">{{ 'common.fields.civilities.' + $ctrl.user.civility | translate }}</span>\n      <span ng-if=\"!$ctrl.user.civility\" class=\"fieldValue\"></span>\n    </label>\n    <div class=\"selectBloc\" ng-class=\"{ 'errorField' : profileForm.civility.$invalid && (profileForm.civility.$touched || profileForm.$submitted) }\">\n      <select id=\"_civility\"\n              ng-model=\"$ctrl.userDetails.civility\"\n              name=\"civility\"\n              ng-required=\"true\"\n              ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n        <option value=\"\">{{ 'common.fields.civility.select' | translate }}</option>\n        <option ng-repeat=\"civility in $ctrl.civilities\" value=\"{{civility.id}}\">{{ civility.translationKey | translate }}</option>\n      </select>\n    </div>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.civilityForm.civility.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.civility.validation.required' | translate }}</p>\n    </div>\n  </div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.firstNameForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.firstName = $ctrl.user.firstName\">\n  <div class=\"formField\">\n    <label for=\"_firstName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.firstName.label' | translate }}</span>\n      <span class=\"fieldValue\">{{ $ctrl.user.firstName }}</span>\n    </label>\n    <input id=\"_firstName\"\n           ng-model=\"$ctrl.userDetails.firstName\"\n           name=\"firstName\"\n           type=\"text\"\n           ng-required=\"true\"\n           ng-maxlength=\"$ctrl.validationRules.firstName.maxlength\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.firstNameForm.firstName.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.firstName.validation.required' | translate }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.firstName.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.firstName.maxlength } }}</p>\n    </div>\n  </div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.lastNameForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.lastName = $ctrl.user.lastName\">\n  <div class=\"formField\">\n    <label for=\"_lastName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.lastName.label' | translate }}</span>\n      <span class=\"fieldValue\">{{ $ctrl.user.lastName }}</span>\n    </label>\n    <input type=\"text\"\n           id=\"_lastName\"\n           name=\"lastName\"\n           ng-model=\"$ctrl.userDetails.lastName\"\n           ng-required=\"true\"\n           ng-maxlength=\"$ctrl.validationRules.firstName.maxlength\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.lastNameForm.lastName.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.lastName.validation.required' | translate }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.firstName.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.lastName.maxlength } }}</p>\n    </div>\n  </div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.addressForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.cancelAddressForm()\">\n  <div class=\"formField\">\n    <label for=\"_address1\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.address.label' | translate }}</span>\n      <span ng-if=\"$ctrl.user.address\" class=\"fieldValue\">{{ $ctrl.user.address }}</span>\n      <span ng-if=\"$ctrl.user.zipCode || $ctrl.user.city\" class=\"fieldValue padFieldValue\">{{ $ctrl.user.zipCode }} {{ $ctrl.user.city }}</span>\n    </label>\n    <input type=\"text\"\n           id=\"_address1\"\n           name=\"address1\"\n           ng-model=\"$ctrl.userDetails.address1\"\n           ng-maxlength=\"$ctrl.validationRules.address1.maxlength\"\n           ng-required=\"$ctrl.userDetails.address2 || $ctrl.userDetails.address3\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.addressForm.address1.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.address1.validation.required' | translate }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.address1.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.address1.maxlength } }}</p>\n    </div>\n  </div>\n  <div class=\"formField\">\n    <input id=\"_address2\"\n           ng-model=\"$ctrl.userDetails.address2\"\n           name=\"address2\"\n           type=\"text\"\n           ng-maxlength=\"$ctrl.validationRules.address2.maxlength\"\n           ng-required=\"$ctrl.userDetails.address3\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.addressForm.address2.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.address2.validation.required' | translate }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.address2.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.address2.maxlength } }}</p>\n    </div>\n  </div>\n  <div class=\"formField\">\n    <input id=\"_address3\"\n           ng-model=\"$ctrl.userDetails.address3\"\n           name=\"address3\"\n           type=\"text\"\n           ng-maxlength=\"$ctrl.validationRules.address3.maxlength\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.addressForm.address3.$error\">\n      <p ng-message=\"maxlength\">{{ 'common.fields.address3.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.address3.maxlength } }}</p>\n    </div>\n  </div>\n  <div class=\"formField hideOnInactive\">\n    <label for=\"_zipCode\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.zipCode.label' | translate }}</span>\n    </label>\n    <input type=\"text\"\n           id=\"_zipCode\"\n           name=\"zipCode\"\n           ng-model=\"$ctrl.userDetails.zipCode\"\n           ng-maxlength=\"$ctrl.validationRules.zipCode.maxlength\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.addressForm.zipCode.$error\">\n      <p ng-message=\"maxlength\">{{ 'common.fields.zipCode.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.zipCode.maxlength } }}</p>\n    </div>\n  </div>\n  <div class=\"formField hideOnInactive\">\n    <label for=\"_city\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.city.label' | translate }}</span>\n    </label>\n    <input type=\"text\"\n           id=\"_city\"\n           name=\"city\"\n           ng-model=\"$ctrl.userDetails.city\"\n           ng-maxlength=\"$ctrl.validationRules.city.maxlength\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" />\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.addressForm.city.$error\">\n      <p ng-message=\"maxlength\">{{ 'common.fields.city.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.city.maxlength } }}</p>\n    </div>\n  </div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.homePhoneForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.homePhone = $ctrl.user.homePhone\">\n<div class=\"formField\">\n  <label for=\"_homePhone\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n    <span>{{ 'common.fields.homePhone.label' | translate }}</span>\n    <span class=\"fieldValue\">{{ $ctrl.user.homePhone }}</span>\n  </label>\n  <input type=\"text\"\n         id=\"_homePhone\"\n         name=\"homePhone\"\n         ng-model=\"$ctrl.userDetails.homePhone\"\n         ng-pattern=\"$ctrl.validationRules.phoneNumber.pattern\"\n         ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" />\n  <div class=\"field-errors hideOnInactive\"\n       ng-messages=\"$ctrl.homePhoneForm.homePhone.$error\">\n    <p ng-message=\"pattern\">{{ 'common.fields.homePhone.validation.pattern' | translate }}</p>\n  </div>\n</div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.businessPhoneForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.businessPhone = $ctrl.user.businessPhone\">\n<div class=\"formField\">\n  <label for=\"_businessPhone\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n    <span>{{ 'common.fields.businessPhone.label' | translate }}</span>\n    <span class=\"fieldValue\">{{ $ctrl.user.businessPhone }}</span>\n  </label>\n  <input type=\"text\"\n         id=\"_businessPhone\"\n         name=\"businessPhone\"\n         ng-model=\"$ctrl.userDetails.businessPhone\"\n         ng-pattern=\"$ctrl.validationRules.phoneNumber.pattern\"\n         ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" />\n  <div class=\"field-errors hideOnInactive\"\n       ng-messages=\"$ctrl.businessPhoneForm.businessPhone.$error\">\n    <p ng-message=\"pattern\">{{ 'common.fields.businessPhone.validation.pattern' | translate }}</p>\n  </div>\n</div>\n</user-details-form>\n\n<h2 class=\"sectionTitle\">{{ 'common.fields.logins.label' | translate }}</h2>\n\n<user-details-form form=\"$ctrl.emailForm\"\n                   on-submit=\"$ctrl.updateUserDetails(userDetails)\"\n                   on-cancel=\"$ctrl.userDetails.email = $ctrl.user.email\">\n  <div class=\"formField\">\n    <label for=\"_email\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.email.label' | translate }}</span>\n      <span class=\"fieldValue\">{{ $ctrl.user.email }}</span>\n    </label>\n    <input type=\"email\"\n           id=\"_email\"\n           name=\"email\"\n           ng-model=\"$ctrl.userDetails.email\"\n           ng-required=\"true\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"/>\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.emailForm.email.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.email.validation.required' | translate }}</p>\n      <p ng-message=\"email\">{{ 'common.fields.email.validation.invalid' | translate }}</p>\n    </div>\n  </div>\n</user-details-form>\n\n<user-details-form form=\"$ctrl.passwordForm\"\n                   on-submit=\"$ctrl.changePassword()\">\n  <div class=\"formField hideOnInactive\">\n    <label for=\"_oldPassword\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.oldPassword.label' | translate }}</span>\n    </label>\n    <input id=\"_oldPassword\"\n           name=\"oldpassword\"\n           type=\"password\"\n           ng-model=\"$ctrl.updatePassword.oldPassword\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n           ng-change=\"$ctrl.validateOldPassword()\"\n           required\n    />\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.passwordForm.oldpassword.$error\"\n         ng-if=\"$ctrl.passwordForm.oldPassword.$touched || $ctrl.passwordForm.$submitted\">\n        <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n        <p ng-show=\"!$ctrl.isValidOldPassword\" class=\"field-errors\">{{ 'common.fields.password.validation.pattern' | translate }}</p>\n      <div class=\"field-errors\">\n        <p ng-show=\"$ctrl.isWrongOldPassword\">{{ 'common.fields.oldPassword.validation.wrong' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"formField\">\n    <label for=\"_newPassword\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.newPassword.label' | translate }}</span>\n      <span class=\"fieldValue\">********</span>\n    </label>\n    <input id=\"_newPassword\"\n           name=\"newPassword\"\n           type=\"password\"\n           ng-model=\"$ctrl.updatePassword.newPassword\"\n           ng-minlength=\"$ctrl.validationRules.password.minlength\"\n           ng-maxlength=\"$ctrl.validationRules.password.maxlength\"\n           ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\"\n           required\n           different-from=\"$ctrl.updatePassword.oldPassword\"\n           check-password\n    />\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.passwordForm.newPassword.$error\">\n      <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n      <p ng-message=\"minlength\">{{ 'common.fields.password.validation.minlength' | translate: { minlength: $ctrl.validationRules.password.minlength } }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.password.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.password.maxlength } }}</p>\n      <p ng-message=\"checkPassword\">{{ 'common.fields.password.validation.pattern' | translate }}</p>\n      <p ng-message=\"differentFrom\">{{ 'common.fields.password.validation.different' | translate }}</p>\n    </div>\n  </div>\n\n  <div class=\"form-field hideOnInactive\">\n    <label for=\"_newPasswordConfirmation\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      <span>{{ 'common.fields.passwordConfirmation.label' | translate }}</span>\n    </label>\n    <input id=\"_newPasswordConfirmation\"\n           name=\"newPasswordConfirmation\"\n           type=\"password\"\n           ng-model=\"$ctrl.updatePassword.newPasswordConfirmation\"\n           ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n           required\n           compare-to=\"$ctrl.updatePassword.newPassword\"\n    />\n    <div class=\"field-errors hideOnInactive\"\n         ng-messages=\"$ctrl.passwordForm.newPasswordConfirmation.$error\"\n         ng-if=\"$ctrl.passwordForm.newPasswordConfirmation.$touched || $ctrl.passwordForm.$submitted\">\n      <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n      <p ng-message=\"compareTo\">{{ 'common.fields.password.validation.compareTo' | translate }}</p>\n    </div>\n  </div>\n</user-details-form>\n"

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(965);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-details.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "my-details-page .hideOnInactive{display:none!important}my-details-page form.active .hideOnInactive{display:block!important}user-details-form form.active label span{margin:.5em 0 0!important}user-details-form form label span.fieldValue{white-space:pre-wrap!important;min-height:17px;font-size:.9em;margin-top:.2em}user-details-form form label span.fieldValue+.padFieldValue{margin-top:.5em}h2.sectionTitle{margin-top:2.5em!important}div.form-field.hideOnInactive{margin-bottom:0!important}", ""]);
	
	// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myPreferences = __webpack_require__(967);
	
	var _myPreferences2 = _interopRequireDefault(_myPreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myPreferencesModule', [_angularUiRouter2.default]).filter('isEmpty', function () {
	  return function (aliasCard) {
	    if (aliasCard) {
	      return '"' + aliasCard + '"';
	    }
	  };
	}).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile.myProfile.myPreferences', {
	    url: '/my-preferences',
	    component: 'myPreferencesPage',
	    authenticate: true
	  });
	}]).component('myPreferencesPage', _myPreferences2.default).name;
	
	exports.default = _module;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myPreferences = __webpack_require__(968);
	
	var _myPreferences2 = _interopRequireDefault(_myPreferences);
	
	var _myPreferences3 = __webpack_require__(969);
	
	var _myPreferences4 = _interopRequireDefault(_myPreferences3);
	
	__webpack_require__(970);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  controller: _myPreferences2.default,
	  template: _myPreferences4.default
	};
	
	exports.default = component;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPreferencesController = function () {
	  MyPreferencesController.$inject = ["$state", "UserService", "VehicleService", "ValidationRules", "CookiesService", "$location", "$anchorScroll", "$scope", "$rootScope"];
	  function MyPreferencesController($state, UserService, VehicleService, ValidationRules, CookiesService, $location, $anchorScroll, $scope, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyPreferencesController);
	    this.$state = $state;
	    this.userService = UserService;
	    this.vehicleService = VehicleService;
	    this.validationRules = ValidationRules;
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.cookiesService = CookiesService;
	
	    // Init. default values
	    this.isProcessing = true;
	    this.cards = [];
	
	    // Async loading...
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyPreferencesController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.userService.getCurrentUser().then(function (user) {
	        _this.user = user;
	        _this.optInATCProfile = user.optInATCProfile;
	        // Load user wallet...
	        return _this.userService.getWallet();
	      }).then(function (resp) {
	        _this.cards = resp.cards;
	        _this.pspType = resp.pspType;
	        _this.isProcessing = false;
	        _this.error = null;
	        _this.safeApply();
	        return _this.cards;
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.safeApply();
	        return err;
	      });
	    }
	  }, {
	    key: 'removeCard',
	    value: function removeCard(card) {
	      var _this2 = this;
	
	      this.isProcessing = true;
	      this.success = null;
	      this.error = null;
	      return this.userService.removeCardFromWallet(card.id, this.pspType).then(function (resp) {
	        _this2.cards = resp.cards;
	        _this2.isProcessing = false;
	        _this2.success = 'my-profile.my-credit-cards.delete.success';
	        _this2.error = null;
	        _this2.$location.hash('appMessage');
	        _this2.$anchorScroll();
	        (0, _jquery2.default)('[id="appMessage"]').focus();
	        _this2.safeApply();
	      }, function (err) {
	        _this2.isProcessing = false;
	        _this2.error = {
	          message: 'my-profile.my-credit-cards.delete.error',
	          cause: err
	        };
	        _this2.$location.hash('appMessage');
	        _this2.$anchorScroll();
	        (0, _jquery2.default)('[id="appMessage"]').focus();
	        _this2.safeApply();
	      });
	    }
	  }, {
	    key: 'submitOptins',
	    value: function submitOptins() {
	      var _this3 = this;
	
	      this.isProcessing = true;
	      var optins = { optInATCProfile: this.optInATCProfile };
	      return this.userService.update((0, _assign2.default)({}, this.user, optins)).then(function (user) {
	        _this3.isProcessing = false;
	        _this3.user = user;
	        _this3.optInATCProfile = user.optInATCProfile;
	        _this3.success = 'my-profile.my-alerts.success';
	        _this3.error = null;
	        _this3.$location.hash('appMessage');
	        _this3.$anchorScroll();
	        (0, _jquery2.default)('[id="appMessage"]').focus();
	        _this3.safeApply();
	      }, function (err) {
	        _this3.isProcessing = false;
	        _this3.error = {
	          message: 'profile.my-alerts.error',
	          cause: err
	        };
	        _this3.$location.hash('appMessage');
	        _this3.$anchorScroll();
	        (0, _jquery2.default)('[id="appMessage"]').focus();
	        _this3.safeApply();
	      });
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'openCookiesBanner',
	    value: function openCookiesBanner() {
	      this.cookiesService.requestEdit = true;
	    }
	  }]);
	  return MyPreferencesController;
	}();
	
	exports.default = MyPreferencesController;

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n\n<app-message id=\"appMessage\" success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\" ></app-message>\n\n<h3 class=\"cardTitle\">{{ 'my-profile.my-alerts.title' | translate }}</h3>\n\n<form name=\"optinsForm\" ng-submit=\"$ctrl.submitOptins()\">\n  <p class=\"whishlist paddingLight\">{{ 'my-profile.my-alerts.desc' | translate }}</p>\n  <ul class=\"CheckboxList\">\n    <li>\n      <label for=\"optin\" class=\"checkBox\">\n        <input id=\"optin\" type=\"checkbox\" ng-model=\"$ctrl.optInATCProfile\">\n        <span>{{ 'my-profile.my-alerts.fields.optin.label' | translate }}</span>\n      </label>\n    </li>\n  </ul>\n  <p class=\"paddingLight\">\n  <button type=\"submit\" ga-track-event=\"['My Preferences', 'Click', 'Validate']\">{{ 'common.validate' | translate }}</button>\n  </p>\n</form>\n\n<div>\n  <h3>{{ 'my-profile.my-cookies.title' | translate }}</h3>\n  <p>{{ 'my-profile.my-cookies.manage' | translate }}</p>\n  <button type=\"submit\" ng-click=\"$ctrl.openCookiesBanner()\">{{ 'cookiesConsent.open' | translate }}</button>\n</div>\n\n<div ng-if=\"$ctrl.cards.length\">\n  <h3>{{ 'my-profile.my-credit-cards.title' | translate }}</h3>\n  <p class=\"whishlist paddingLight\">{{ 'my-profile.my-credit-cards.desc' | translate }}</p>\n  <ul class=\"cards delete\">\n    <li ng-repeat=\"card in $ctrl.cards\">\n      <user-card card=\"card\" on-remove-card=\"$ctrl.removeCard(card)\"></user-card>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(971);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-preferences.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-preferences.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "h3.cardTitle{padding-top:.5em}.tabs ul.cards{margin:1em 0}.tabs ul.cards li{padding:1em 1.2em;border-bottom:1px solid #6c6c6c;position:relative;display:block;width:100%;text-align:left}.tabs ul.cards li div{display:inline-block;float:right}.tabs ul.cards li span{display:block;font-size:.75em;color:#999;margin-top:.2em}.tabs ul.cards li button{width:auto;float:right;margin:auto;margin-top:-7%;padding:12px;position:static}.tabs ul.cards li button.deleteCard{display:block}.tabs ul.cards li button.deleteCard:before{top:1em;font-family:icon-Renault-Global;speak:none;color:#fc3;position:absolute;cursor:pointer;content:\"\\E674\";font-size:1.4em;right:.9em}.tabs ul.cards li button.cancelDelete,.tabs ul.cards li button.confirmDelete{display:inline-block;padding:.5em;font-size:.9em;font-family:Renault Regular,Helvetica,Arial,sans-serif}.tabs ul.cards li button.cancelDelete{background:#ececec}.tabs ul.cards li button.confirmDelete{color:#fff;background:#bd3632}", ""]);
	
	// exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myProfile = __webpack_require__(973);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	var _myProfile3 = __webpack_require__(974);
	
	var _myProfile4 = _interopRequireDefault(_myProfile3);
	
	__webpack_require__(975);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  controller: _myProfile2.default,
	  template: _myProfile4.default
	};
	
	exports.default = component;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyProfileController = function () {
	  MyProfileController.$inject = ["UserService", "I18n"];
	  function MyProfileController(UserService, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyProfileController);
	    this.I18n = I18n;
	    this.userService = UserService;
	    this.isProcessing = true;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyProfileController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.userService.getCurrentUser().then(function (user) {
	        _this.user = user;
	        _this.isProcessing = false;
	      });
	    }
	  }]);
	  return MyProfileController;
	}();
	
	exports.default = MyProfileController;

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = "<h2>{{ 'my-profile.title' | translate }}</h2>\n\n<p class=\"userName\">{{ $ctrl.user.firstName }} {{ $ctrl.user.lastName }}</p>\n\n<div class=\"tabs\">\n  <div class=\"tabTitles\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n    <a ui-sref=\"profile.myProfile.myDetails\" ui-sref-active=\"active\" ga-track-event=\"['My Profile', 'Click', 'My Details']\">\n      <span>{{ 'my-profile.my-details.title' | translate }}</span>\n    </a>\n    <a ui-sref=\"profile.myProfile.myPreferences\" ui-sref-active=\"active\" ga-track-event=\"['My Profile', 'Click', 'My Preferences']\">\n      <span>{{ 'my-profile.my-preferences.title' | translate }}</span>\n    </a>\n  </div>\n  <div class=\"tabContent\">\n    <ui-view />\n  </div>\n</div>\n"

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(976);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-profile.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-profile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "my-profile-page .tabTitles{padding:0 1em;display:flex}my-profile-page .tabTitles a{position:relative;text-decoration:none;flex:1;padding:.7em .5em;background:#ececec}my-profile-page .tabTitles a.active{background-color:#262625;color:#fff}my-profile-page .tabTitles a.active:before{position:absolute;bottom:-10px;left:calc(50% + -13px);content:\"\";width:0;height:0;border-style:solid;border-width:10px 13px 0;border-color:#262625 transparent transparent}@media (max-width:420px){.userName{width:300px}}", ""]);
	
	// exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _components = __webpack_require__(978);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _addVehicle = __webpack_require__(989);
	
	var _addVehicle2 = _interopRequireDefault(_addVehicle);
	
	var _myGarage = __webpack_require__(995);
	
	var _myGarage2 = _interopRequireDefault(_myGarage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myGarageModule', [_angularUiRouter2.default, _components2.default, _addVehicle2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile.myGarage', {
	    url: '/my-garage',
	    params: { vin: null },
	    component: 'myGaragePage',
	    authenticate: true
	  });
	}]).component('myGaragePage', _myGarage2.default).name;
	
	exports.default = _module;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _deleteVehicle = __webpack_require__(979);
	
	var _deleteVehicle2 = _interopRequireDefault(_deleteVehicle);
	
	var _editVehicle = __webpack_require__(983);
	
	var _editVehicle2 = _interopRequireDefault(_editVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myGarageComponentsModule', [_deleteVehicle2.default, _editVehicle2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _deleteVehicle = __webpack_require__(980);
	
	var _deleteVehicle2 = _interopRequireDefault(_deleteVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myGarageDeleteVehicleModule', []).component('myGarageDeleteVehicle', _deleteVehicle2.default).name;
	
	exports.default = _module;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deleteVehicle = __webpack_require__(981);
	
	var _deleteVehicle2 = _interopRequireDefault(_deleteVehicle);
	
	var _deleteVehicle3 = __webpack_require__(982);
	
	var _deleteVehicle4 = _interopRequireDefault(_deleteVehicle3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    onConfirm: '&'
	  },
	  template: _deleteVehicle2.default,
	  controller: _deleteVehicle4.default
	};
	
	exports.default = component;

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"popin\" ng-class=\"{'active': $ctrl.showDeleteBtn}\">\n  <button class=\"button delete\" ng-click=\"$ctrl.activeDeleteMode()\" ga-track-event=\"['My Garage', 'Click', 'Delete Vehicle']\">\n    <span>{{ 'my-garage.delete-vehicle.title' | translate }}</span>\n  </button>\n  <p aria-hidden=\"true\">{{ 'my-garage.delete-vehicle.text' | translate }}</p>\n  <ul class=\"buttonList maxLarge\" aria-hidden=\"true\">\n    <li>\n      <button class=\"button cancel\" ng-click=\"$ctrl.showDeleteBtn=false\" ga-track-event=\"['Delete Vehicle', 'Click', 'Cancel']\">\n        {{ 'common.cancel' | translate }}\n      </button>\n    </li>\n    <li>\n      <button type=\"submit\" ng-click=\"$ctrl.handleSubmit()\" ga-track-event=\"['Delete Vehicle', 'Click', 'Validate']\">\n        {{ 'common.validate' | translate }}\n      </button>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteVehicleController = function () {
	  DeleteVehicleController.$inject = ["$scope", "$rootScope"];
	  function DeleteVehicleController($scope, $rootScope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DeleteVehicleController);
	    this.$rootScope = $rootScope;
	    $scope.$on('deleteVehicle:close', function () {
	      _this.showDeleteBtn = false;
	    });
	  }
	
	  (0, _createClass3.default)(DeleteVehicleController, [{
	    key: 'activeDeleteMode',
	    value: function activeDeleteMode() {
	      this.$rootScope.$broadcast('editVehicle:close');
	      this.showDeleteBtn = !this.showDeleteBtn;
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this2 = this;
	
	      this.onConfirm().then(function () {
	        _this2.showDeleteBtn = false;
	      });
	    }
	  }]);
	  return DeleteVehicleController;
	}();
	
	exports.default = DeleteVehicleController;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _editVehicle = __webpack_require__(984);
	
	var _editVehicle2 = _interopRequireDefault(_editVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myGarageEditVehicleModule', []).component('myGarageEditVehicle', _editVehicle2.default).name;
	
	exports.default = _module;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _editVehicle = __webpack_require__(985);
	
	var _editVehicle2 = _interopRequireDefault(_editVehicle);
	
	var _editVehicle3 = __webpack_require__(986);
	
	var _editVehicle4 = _interopRequireDefault(_editVehicle3);
	
	__webpack_require__(987);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '<',
	    onConfirm: '&'
	  },
	  template: _editVehicle2.default,
	  controller: _editVehicle4.default
	};
	
	exports.default = component;

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports = "<h2 ng-if=\"!$ctrl.editMode\">\n  <span>{{ $ctrl.vehicle.friendlyName }}</span>\n  <button class=\"editBt\" ng-click=\"$ctrl.activeEditMode()\" ga-track-event=\"['My Garage', 'Click', 'Edit Vehicle']\">\n    <span class=\"txtHidden\">{{ 'myGarage.editVehicle.title' | translate }}</span>\n  </button>\n</h2>\n\n<form ng-if=\"$ctrl.editMode\"\n  class=\"carEditName\"\n  name=\"editVehicleForm\"\n  ng-submit=\"$ctrl.submitForm(this)\"\n  ng-class=\"{'active': $ctrl.editMode}\">\n  <h2>\n    <span>{{ $ctrl.vehicle.friendlyName }}</span>\n  </h2>\n  <div class=\"form-field\">\n    <input type=\"text\"\n           name=\"friendlyName\"\n           placeholder=\"My Renault\"\n           ng-model=\"$ctrl.friendlyName\"\n           ng-maxlength=\"$ctrl.validationRules.friendlyName.maxlength\"\n           ng-required=\"true\" />\n    <div class=\"field-errors\"\n         ng-messages=\"editVehicleForm.friendlyName.$error\"\n         ng-if=\"editVehicleForm.friendlyName.$touched || editVehicleForm.$submitted\">\n      <p ng-message=\"required\">{{ 'common.fields.friendlyName.validation.required' | translate }}</p>\n      <p ng-message=\"maxlength\">{{ 'common.fields.friendlyName.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.friendlyName.maxlength } }}</p>\n    </div>\n  </div>\n  <ul class=\"buttonList maxLarge\">\n    <li>\n      <button type=\"button\"\n              class=\"button cancel\"\n              ng-click=\"$ctrl.cancelForm()\"\n              ga-track-event=\"['Edit Vechile', 'Click', 'Cancel']\">\n        {{ 'common.cancel' | translate }}\n      </button>\n    </li>\n    <li>\n      <button type=\"submit\" ng-disabled=\"editVehicleForm.$invalid\" ga-track-event=\"['Edit Vechile', 'Click', 'Validate']\">\n        {{ 'common.validate' | translate }}\n      </button>\n    </li>\n  </ul>\n</form>\n"

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditVehicleController = function () {
	  EditVehicleController.$inject = ["ValidationRules", "$scope", "$rootScope"];
	  function EditVehicleController(ValidationRules, $scope, $rootScope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EditVehicleController);
	    this.validationRules = ValidationRules;
	    this.$rootScope = $rootScope;
	    $scope.$on('editVehicle:close', function () {
	      _this.editMode = false;
	    });
	  }
	
	  (0, _createClass3.default)(EditVehicleController, [{
	    key: 'submitForm',
	    value: function submitForm(form) {
	      var _this2 = this;
	
	      if (form.editVehicleForm.$valid) {
	        this.onConfirm({ name: this.friendlyName }).then(function () {
	          _this2.editMode = false;
	        });
	      }
	    }
	  }, {
	    key: 'activeEditMode',
	    value: function activeEditMode() {
	      this.$rootScope.$broadcast('deleteVehicle:close');
	      this.friendlyName = this.vehicle.friendlyName;
	      this.editMode = !this.editMode;
	    }
	  }, {
	    key: 'cancelForm',
	    value: function cancelForm() {
	      this.editMode = !this.editMode;
	      this.friendlyName = this.vehicle.friendlyName;
	    }
	  }]);
	  return EditVehicleController;
	}();
	
	exports.default = EditVehicleController;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(988);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./edit-vehicle.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./edit-vehicle.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "my-garage-edit-vehicle form.active{background-color:#ececec;margin:1em 2em;padding:0 1em}my-garage-edit-vehicle form.active .form-field{margin:0}my-garage-edit-vehicle form.active h2{margin-bottom:0!important}my-garage-edit-vehicle h2 button:after{content:\"\\E61B\";font-family:icon-Renault-Global;speak:none;color:#fc3;font-size:.8em;padding-bottom:.1em;border-bottom:3px solid #fc3}", ""]);
	
	// exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _addVehicle = __webpack_require__(990);
	
	var _addVehicle2 = _interopRequireDefault(_addVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('addVehiclePageModule', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile.myGarageAdd', {
	    url: '/my-garage/add',
	    component: 'addVehiclePage',
	    authenticate: true
	  });
	}]).component('addVehiclePage', _addVehicle2.default).name;
	
	exports.default = _module;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _addVehicle = __webpack_require__(991);
	
	var _addVehicle2 = _interopRequireDefault(_addVehicle);
	
	var _addVehicle3 = __webpack_require__(992);
	
	var _addVehicle4 = _interopRequireDefault(_addVehicle3);
	
	__webpack_require__(993);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _addVehicle4.default,
	  controller: _addVehicle2.default
	};
	
	exports.default = component;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddVehicleController = function () {
	  AddVehicleController.$inject = ["$rootScope", "$state", "VehicleService", "IdsService", "ValidationRules", "I18n"];
	  function AddVehicleController($rootScope, $state, VehicleService, IdsService, ValidationRules, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AddVehicleController);
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.I18n = I18n;
	    this.vehicleService = VehicleService;
	    this.idsService = IdsService;
	    this.validationRules = ValidationRules;
	    this.vehicle = {};
	
	    // Init. proccessing value
	    this.isProcessing = false;
	  }
	
	  (0, _createClass3.default)(AddVehicleController, [{
	    key: 'addVehicle',
	    value: function addVehicle() {
	      var _this = this;
	
	      this.isProcessing = true;
	      this.vehicle.vin = this.vehicle.vin.toUpperCase();
	      return this.vehicleService.addVehicle(this.vehicle).then(function () {
	        _this.vehicleService.getCurrentUserVehicles(false).then(function () {
	          _this.isProcessing = false;
	          _this.$rootScope.$broadcast('vehicles:update');
	          _this.idsService.encode(_this.vehicle.vin).then(function (svin) {
	            _this.vehicleService.setCurrentSelectedVehicle(svin).then(function () {
	              return _this.$state.go('profile.myGarage', {
	                vin: svin
	              });
	            });
	          });
	        });
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.error = {
	          message: 'my-garage.addVehicleForm.error',
	          cause: err
	        };
	      });
	    }
	  }]);
	  return AddVehicleController;
	}();
	
	exports.default = AddVehicleController;

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight\">\n  <app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n  <app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\"></app-message>\n  <h2>\n    <span>{{ 'my-garage.addVehicleForm.title' | translate }}</span>\n  </h2>\n\n  <form name=\"addVehicleForm\" ng-submit=\"$ctrl.addVehicle()\" style=\"max-width: 400px;margin: auto;\" >\n    <div class=\"form-field\">\n      <label for=\"_friendlyName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.friendlyName.label' | translate }}</label>\n      <input id=\"_friendlyName\"\n             name=\"friendlyName\"\n             type=\"text\"\n             placeholder=\"my Renault\"\n             ng-model=\"$ctrl.vehicle.friendlyName\"\n             ng-maxlength=\"$ctrl.validationRules.friendlyName.maxlength\"\n             ng-required=\"true\"\n             ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\" />\n      <div class=\"field-errors\"\n           ng-messages=\"addVehicleForm.friendlyName.$error\"\n           ng-if=\"addVehicleForm.friendlyName.$touched || addVehicleForm.$submitted\">\n        <p ng-message=\"required\">{{ 'common.fields.friendlyName.validation.required' | translate }}</p>\n        <p ng-message=\"maxlength\">{{ 'common.fields.friendlyName.validation.maxlength' | translate: { maxlength: $ctrl.validationRules.friendlyName.maxlength } }}</p>\n      </div>\n      <input-tooltip ng-class=\"{'arabDirectionTooltip':  $ctrl.I18n.isArLocale()}\" title=\"common.fields.friendlyName.label\" name=\"common.fields.friendlyName.label\" text=\"common.fields.friendlyName.help\">\n      </input-tooltip>\n    </div>\n\n    <div class=\"form-field\">\n      <label for=\"_vin\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.vin.label' | translate }}</label>\n      <input id=\"_vin\"\n             name=\"vin\"\n             type=\"text\"\n             class=\"txtUppercase\"\n             placeholder=\"00000000000000000\"\n             ng-model=\"$ctrl.vehicle.vin\"\n             ng-minlength=\"$ctrl.validationRules.vin.length\"\n             ng-maxlength=\"$ctrl.validationRules.vin.length\"\n             ng-required=\"true\"\n             ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n             check-vin />\n      <div class=\"field-errors\"\n           ng-messages=\"addVehicleForm.vin.$error\"\n           ng-if=\"addVehicleForm.vin.$touched || addVehicleForm.$submitted\">\n        <p ng-message=\"required\">{{ 'common.fields.vin.validation.required' | translate }}</p>\n        <p ng-message=\"maxlength || minlength\">{{ 'common.fields.vin.validation.length' | translate: { length: $ctrl.validationRules.vin.length } }}</p>\n        <p ng-message=\"checkVin\">{{ 'common.fields.vin.validation.notfound' | translate }}</p>\n      </div>\n      <input-tooltip ng-class=\"{'arabDirectionTooltip':  $ctrl.I18n.isArLocale()}\" title=\"common.fields.vin.label\" name=\"common.fields.vin.label\" text=\"common.fields.vin.help\">\n      </input-tooltip>\n    </div>\n\n    <ul class=\"buttonList maxLarge\">\n      <li>\n        <a class=\"button cancel\" ui-sref=\"profile.myGarage\" ga-track-event=\"['Add Vehicle', 'Click', 'Cancel']\">\n          {{ 'common.cancel' | translate }}\n        </a>\n      </li>\n      <li>\n        <button type=\"submit\" ng-disabled=\"addVehicleForm.$invalid\" ga-track-event=\"['Add Vehicle', 'Click', 'Validate']\">\n          {{ 'common.validate' | translate }}\n        </button>\n      </li>\n    </ul>\n  </form>\n</div>\n"

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(994);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./add-vehicle.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./add-vehicle.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "add-vehicle-page .pageContent{overflow:visible}", ""]);
	
	// exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myGarage = __webpack_require__(996);
	
	var _myGarage2 = _interopRequireDefault(_myGarage);
	
	var _myGarage3 = __webpack_require__(998);
	
	var _myGarage4 = _interopRequireDefault(_myGarage3);
	
	__webpack_require__(999);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myGarage4.default,
	  controller: _myGarage2.default
	};
	
	exports.default = component;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(997);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _findIndex2 = __webpack_require__(878);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyGarageController = function () {
	  MyGarageController.$inject = ["UserService", "VehicleService", "$state", "$stateParams", "$rootScope", "$location", "$anchorScroll", "$timeout", "$scope", "MetricsService"];
	  function MyGarageController(UserService, VehicleService, $state, $stateParams, $rootScope, $location, $anchorScroll, $timeout, $scope, MetricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyGarageController);
	    this.isProcessing = true;
	    this.vehicleService = VehicleService;
	    this.metricsService = MetricsService;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.$scope = $scope;
	    this.isProcessing = true;
	    this.vehicles = [null];
	    this.$scope.$watch('$ctrl.vehicleIndex', this.vehicleIndexChanged());
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyGarageController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentUserVehicles().then(function (vehicles) {
	        _this.isProcessing = false;
	        _this.vehicles = [].concat((0, _toConsumableArray3.default)(vehicles), [null]);
	        var addedVin = _this.$stateParams.vin;
	        if (addedVin && (addedVin.length === 17 || addedVin.length === 64)) {
	          var index = (0, _findIndex3.default)(_this.vehicles, ['vin', addedVin]);
	          if (index === -1) {
	            _this.setVehicleIndex(0);
	          } else {
	            _this.success = 'my-garage.addVehicleForm.success';
	            _this.setVehicleIndex(index);
	            _this.$location.hash('appMessage');
	          }
	        }
	        return _this.metricsService.endPageLoadTime(200);
	      });
	    }
	  }, {
	    key: 'setVehicleIndex',
	    value: function setVehicleIndex(index) {
	      var _this2 = this;
	
	      // FIXME Hack while waiting for PR to be merged https://github.com/revolunet/angular-carousel/pull/312
	      this.$timeout(function () {
	        _this2.vehicleIndex = index;
	      }, 500);
	    }
	  }, {
	    key: 'vehicleIndexChanged',
	    value: function vehicleIndexChanged() {
	      var _this3 = this;
	
	      return function () {
	        _this3.$rootScope.$broadcast('editVehicle:close');
	        _this3.$rootScope.$broadcast('deleteVehicle:close');
	      };
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this4 = this;
	
	      return this.vehicleService.getCurrentUserVehicles(false).then(function (vehicles) {
	        _this4.vehicles = [].concat((0, _toConsumableArray3.default)(vehicles), [null]);
	        _this4.isProcessing = false;
	        _this4.$rootScope.$broadcast('vehicles:update');
	      });
	    }
	  }, {
	    key: 'getCurrentVehicleProductsUrl',
	    value: function getCurrentVehicleProductsUrl() {
	      if (this.currentVehicle) {
	        return this.$state.href('vehicle', { vin: this.currentVehicle.vin, sync: true });
	      }
	    }
	  }, {
	    key: 'getVehicleImage',
	    value: function getVehicleImage(vehicle) {
	      // TODO how to extract model code from vehicle
	      // We have tu update the API to have better dataset when an user is connected
	      return vehicle && vehicle.modelCode ? 'img/photos/vehicles/' + vehicle.modelCode + '.png' : 'img/photos/vehicule.gif';
	    }
	  }, {
	    key: 'deleteCurrentVehicle',
	    value: function deleteCurrentVehicle() {
	      var _this5 = this;
	
	      this.isProcessing = true;
	      return this.vehicleService.deleteVehicle(this.currentVehicle.vin).then(function (success) {
	        _this5.isProcessing = false;
	        _this5.success = 'my-garage.delete-vehicle.success';
	        _this5.error = null;
	        _this5.vehicles.splice(_this5.vehicleIndex, 1);
	        if (_this5.vehicleIndex > 0) {
	          _this5.vehicleIndex--;
	        }
	        _this5.refresh();
	        _this5.$location.hash('appMessage');
	        _this5.$anchorScroll();
	        // TODO fixme $('[id="appMessage"]').focus()
	      }, function (err) {
	        _this5.isProcessing = false;
	        _this5.error = {
	          message: 'my-garage.delete-vehicle.error',
	          cause: err
	        };
	        _this5.$location.hash('appMessage');
	        _this5.$anchorScroll();
	        // TODO fixme $('[id="appMessage"]').focus()
	      });
	    }
	  }, {
	    key: 'editCurrentVehicle',
	    value: function editCurrentVehicle(name) {
	      var _this6 = this;
	
	      this.isProcessing = true;
	      var v = (0, _assign2.default)({}, this.currentVehicle, { name: name });
	      return this.vehicleService.editVehicle(v).then(function (success) {
	        _this6.isProcessing = false;
	        _this6.success = 'my-garage.edit-vehicle.success';
	        _this6.error = null;
	        _this6.refresh();
	      }, function (err) {
	        _this6.isProcessing = false;
	        _this6.error = {
	          message: 'my-garage.edit-vehicle.error',
	          cause: err
	        };
	      });
	    }
	  }, {
	    key: 'currentVehicle',
	    get: function get() {
	      return this.vehicles[this.vehicleIndex];
	    }
	  }]);
	  return MyGarageController;
	}();
	
	exports.default = MyGarageController;

/***/ }),
/* 997 */,
/* 998 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-message id=\"appMessage\" success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\"></app-message>\n<h2 ng-if=\"!$ctrl.currentVehicle\">\n  <span>\n    <a ui-sref=\"profile.myGarageAdd\" ga-track-event=\"['My Garage', 'Click', 'Add Vehicle']\">\n      {{ 'my-garage.addVehicleForm.title' | translate }}\n    </a>\n  </span>\n</h2>\n<my-garage-edit-vehicle vehicle=\"$ctrl.currentVehicle\" on-confirm=\"$ctrl.editCurrentVehicle(name)\" ng-if=\"$ctrl.currentVehicle\"></my-garage-edit-vehicle>\n<my-garage-add-vehicle ng-if=\"!$ctrl.currentVehicle\"></my-garage-add-vehicle>\n<div class=\"vehicleView\">\n  <span class=\"carNumber\" ng-if=\"$ctrl.currentVehicle\">({{ $ctrl.vehicleIndex + 1 }} / {{ $ctrl.vehicles.length - 1 }})</span>\n  <span class=\"carNumber\" ng-if=\"!$ctrl.currentVehicle\"></span>\n  <div class=\"indicators\"\n       ng-if=\"$ctrl.vehicles.length > 1\"\n       rn-carousel-indicators\n       slides=\"$ctrl.vehicles\"\n       rn-carousel-index=\"$ctrl.vehicleIndex\">\n  </div>\n  <ul class=\"elements vehicleImg\"\n      rn-carousel-controls\n      rn-carousel\n      rn-carousel-pause-on-hover\n      rn-carousel-index=\"$ctrl.vehicleIndex\">\n    <li ng-repeat=\"vehicle in $ctrl.vehicles\">\n      <img ng-src=\"{{ $ctrl.getVehicleImage(vehicle) }}\" fallback-src=\"img/photos/vehicule.gif\"/>\n    </li>\n  </ul>\n</div>\n<my-garage-delete-vehicle on-confirm=\"$ctrl.deleteCurrentVehicle()\" ng-if=\"$ctrl.currentVehicle\"></my-garage-delete-vehicle>\n<a class=\"button link\"\n  ng-if=\"$ctrl.currentVehicle\"\n  ng-href=\"{{$ctrl.getCurrentVehicleProductsUrl()}}\"\n  ga-track-event=\"['My Garage', 'Click', 'Products Link']\">\n  <span>{{ 'my-garage.products-link' | translate }}</span>\n</a>\n"

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1000);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-garage.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-garage.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "my-garage-page{white-space:normal!important}my-garage-page h2{font-size:2.5em!important;position:sticky;font-family:Renault Bold,Helvetica,Arial,sans-serif;padding:.5em!important}my-garage-page h2>span{max-width:80%;padding-right:.5em;display:inline-block;overflow:hidden;text-overflow:ellipsis}my-garage-page .carNumber{display:block;text-align:center;font-size:.8em;color:#999;font-family:Renault Light,Helvetica,Arial,sans-serif;height:14px}my-garage-page .indicators{position:relative;text-align:center}my-garage-page .rn-carousel-indicator span{color:#cdcdcd;font-size:1.5em}my-garage-page .rn-carousel-indicator span.active{color:#ffd949}@media (max-width:600px){my-garage-page .rn-carousel-control{display:none}}my-garage-page .rn-carousel-control-prev:before{content:\"\"!important;background:url(\"/img/previous.png\") no-repeat 0 0;display:block;width:100px;height:100px}my-garage-page .rn-carousel-control-next:before{content:\"\"!important;background:url(\"/img/next.png\") no-repeat 0 0;display:block;width:100px;height:100px}my-garage-page .popin{max-width:400px;margin:1em auto 2em;padding:0 .9em}my-garage-page .popin.active{background-color:#eae9e7;border-radius:.5em;box-shadow:0 2px 1px 0 #9b9b9b}my-garage-page .popin.active .delete{margin-bottom:1em}my-garage-page .popin.active p{display:block;font-size:.95em;line-height:1.5em}my-garage-page .popin.active .buttonList{display:table;width:100%}my-garage-page .popin .buttonList,my-garage-page .popin p{display:none}my-garage-page a.button.link{border-top:2px solid #aaa;padding:.75em 2.5em .7em;margin:0!important;text-align:center}my-garage-page a.button.link:after{color:#fc3!important}my-garage-page .vehicleView{position:relative}my-garage-page .vehicleView ul li{text-align:center}my-garage-page .vehicleView ul li img{max-width:100%}my-garage-page .editBt{position:sticky;top:40%;transform:translateX(-3%) translateY(-30%)}@media (min-width:600px){my-garage-page ul.vehicleImg{height:240px}}@media (min-width:400px) and (max-width:599px){my-garage-page ul.vehicleImg{height:180px}}@media (max-width:399px){my-garage-page ul.vehicleImg{height:120px}}", ""]);
	
	// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profile = __webpack_require__(1002);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(1003);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	__webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _profile4.default,
	  controller: _profile2.default
	};
	
	exports.default = component;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileController = function () {
	  ProfileController.$inject = ["UserService"];
	  function ProfileController(UserService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProfileController);
	    this.userService = UserService;
	    this.isProcessing = true;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(ProfileController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.userService.getCurrentUser().then(function (user) {
	        _this.user = user;
	        _this.isProcessing = false;
	      });
	    }
	  }]);
	  return ProfileController;
	}();
	
	exports.default = ProfileController;

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <div class=\"limitContent2\">\n    <section class=\"card profilNav\">\n      <img src=\"img/avatar.png\" width=\"90\" height=\"90\" alt=\"Picto profil\" />\n      <h2 class=\"txtUppercase\">{{ $ctrl.user.firstName }} {{ $ctrl.user.lastName }}</h2>\n      <a ui-sref=\"profile.myProfile\" ui-sref-active=\"active\" class=\"profil\" ga-track-event=\"['Profile', 'Click', 'My Profile']\">{{ 'my-profile.title' | translate }}</a>\n      <br/>\n      <a ui-sref=\"profile.myGarage\" ui-sref-active=\"active\" class=\"profil\" ga-track-event=\"['Profile', 'Click', 'My Garage']\">{{ 'my-garage.title' | translate }}</a>\n    </section>\n    <div class=\"slider floatedLeft desk\">\n      <section class=\"primary card\">\n        <ui-view />\n      </section>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1005);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profile.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "profile-page .profilNav .profil{text-decoration:none;padding:.4em 0;display:inline-block}profile-page .profilNav .profil.active{font-weight:700}profile-page a.button.cancel{background:#000;color:#fff}profile-page a.button.cancel:after{content:\"\\E60E\"}profile-page a.button.cancel:hover{background-color:#666}profile-page section.primary.card{padding-bottom:0!important}profile-page .userName{overflow:hidden;text-overflow:ellipsis}@media (min-width:600px){profile-page section.primary.card{min-height:602px}}@media (max-width:599px){profile-page section.primary.card{min-height:450px}}@media (max-width:400px){profile-page section.primary.card{min-height:400px}}profile-page .txtUppercase{overflow:hidden;text-overflow:ellipsis}@media (max-width:420px){profile-page .txtUppercase{width:160px}}", ""]);
	
	// exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _registration = __webpack_require__(1007);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	var _myProfile = __webpack_require__(1009);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	var _myToolbox = __webpack_require__(1017);
	
	var _myToolbox2 = _interopRequireDefault(_myToolbox);
	
	var _myRlink = __webpack_require__(1021);
	
	var _myRlink2 = _interopRequireDefault(_myRlink);
	
	var _registration3 = __webpack_require__(1033);
	
	var _registration4 = _interopRequireDefault(_registration3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('registration', [_angularUiRouter2.default, _myProfile2.default, _myToolbox2.default, _myRlink2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('registration', {
	    url: '/registration',
	    component: 'registration',
	    redirectTo: 'registration.myProfile',
	    myRenaultForbidden: true,
	    authenticatedForbidden: true
	  });
	}]).component('registration', _registration2.default).service('RegistrationHelper', _registration4.default).name;
	
	exports.default = _module;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registration = __webpack_require__(1008);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _registration2.default
	};
	
	exports.default = component;

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight classicArea\">\n  <ui-view autoscroll=\"true\"/>\n</div>\n"

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myProfile = __webpack_require__(1010);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	var _registrationContactsBlock = __webpack_require__(1013);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myProfile', [_angularUiRouter2.default, _registrationContactsBlock2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('registration.myProfile', {
	    url: '/my-profile?civility&lastName&firstName&email&model&friendlyName&vin',
	    component: 'myProfile',
	    params: {
	      password: null
	    }
	  });
	}]).component('myProfile', _myProfile2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myProfile = __webpack_require__(1011);
	
	var _myProfile2 = _interopRequireDefault(_myProfile);
	
	var _myProfile3 = __webpack_require__(1012);
	
	var _myProfile4 = _interopRequireDefault(_myProfile3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myProfile2.default,
	  controller: _myProfile4.default
	};
	
	exports.default = component;

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports = "<section id=\"profileSection\" class=\"limitContent\">\n  <ul class=\"stepBar card\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n    <li class=\"active\"><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Profile']\"><span>{{ 'registration.navbar.myProfile' | translate }}</span></a></li>\n    <li><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Rlink']\"><span>{{ 'registration.navbar.myRlink' | translate }}</span></a></li>\n    <li><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Toolbox']\"><span>{{ 'registration.navbar.myToolbox' | translate }}</span></a></li>\n  </ul>\n  <p class=\"bottomButtonBar\" ng-if=\"!$ctrl.isIframe\">\n    <a class=\"button right next\" href=\"#\"><button class=\"uppercase\" ng-disabled=\"profileForm.$invalid\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Profile', 'Click', 'Mobile Continue']\">{{ 'common.continue' | translate }}</button></a>\n  </p>\n  <form name=\"profileForm\" class=\"card\" novalidate>\n    <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n    <div class=\"miniContent\">\n      <h1>\n        {{ 'registration.profileForm.title' | translate }}\n      </h1>\n      <div class=\"form-field\">\n      </div>\n      <div class=\"form-field\">\n        <label for=\"_civility\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.civility.label' | translate }}</label>\n        <div class=\"selectBloc\" ng-class=\"{ 'errorField' : profileForm.civility.$invalid && (profileForm.civility.$touched || profileForm.$submitted) }\">\n          <select id=\"_civility\"\n                  ng-model=\"$ctrl.profile.civility\"\n                  name=\"civility\"\n                  ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n                  required>\n            <option value=\"\">{{ 'common.fields.civility.select' | translate }}</option>\n            <option ng-repeat=\"civility in $ctrl.civilities\" value=\"{{civility.id}}\">{{ civility.translationKey | translate }}</option>\n          </select>\n        </div>\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.civility.$error\"\n             ng-if=\"profileForm.civility.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.civility.validation.required' | translate }}</p>\n        </div>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_lastName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.lastName.label' | translate }}</label>\n        <input id=\"_lastName\"\n               ng-model=\"$ctrl.profile.lastName\"\n               name=\"lastName\"\n               type=\"text\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required\n               ng-maxlength=\"$ctrl.ValidationRules.lastName.maxlength\"/>\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.lastName.$error\"\n             ng-if=\"profileForm.lastName.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.lastName.validation.required' | translate }}</p>\n          <p ng-message=\"maxlength\">{{ 'common.fields.lastName.validation.maxlength' | translate: { maxlength: $ctrl.ValidationRules.lastName.maxlength } }}</p>\n        </div>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_firstName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.firstName.label' | translate }}</label>\n        <input id=\"_firstName\"\n               ng-model=\"$ctrl.profile.firstName\"\n               name=\"firstName\"\n               type=\"text\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required\n               ng-maxlength=\"$ctrl.ValidationRules.firstName.maxlength\"/>\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.firstName.$error\"\n             ng-if=\"profileForm.firstName.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.firstName.validation.required' | translate }}</p>\n          <p ng-message=\"maxlength\">{{ 'common.fields.firstName.validation.maxlength' | translate: { maxlength: $ctrl.ValidationRules.firstName.maxlength } }}</p>\n          <p ng-message=\"email\">{{ 'common.fields.email.validation.invalid' | translate }}</p>\n        </div>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_email\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.email.label' | translate }}</label>\n        <input id=\"_email\"\n               ng-model=\"$ctrl.profile.email\"\n               name=\"email\"\n               type=\"email\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required/>\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.email.$error\"\n             ng-if=\"profileForm.email.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.email.validation.required' | translate }}</p>\n          <p ng-message=\"email\">{{ 'common.fields.email.validation.invalid' | translate }}</p>\n        </div>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_password\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.password.label' | translate }}</label>\n        <input id=\"_password\"\n               ng-model=\"$ctrl.profile.password\"\n               name=\"password\"\n               type=\"password\"\n               ng-minlength=\"$ctrl.ValidationRules.password.minlength\"\n               ng-maxlength=\"$ctrl.ValidationRules.password.maxlength\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required\n               check-password />\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.password.$error\"\n             ng-if=\"profileForm.password.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n          <p ng-message=\"minlength\">{{ 'common.fields.password.validation.minlength' | translate: { minlength: $ctrl.ValidationRules.password.minlength } }}</p>\n          <p ng-message=\"maxlength\">{{ 'common.fields.password.validation.maxlength' | translate: { maxlength: $ctrl.ValidationRules.password.maxlength } }}</p>\n          <p ng-message=\"checkPassword\">{{ 'common.fields.password.validation.pattern' | translate }}</p>\n        </div>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_passwordConfirmation\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.passwordConfirmation.label' | translate }}</label>\n        <input id=\"_passwordConfirmation\"\n               ng-model=\"$ctrl.profile.passwordConfirmation\"\n               name=\"passwordConfirmation\"\n               type=\"password\"\n               ng-minlength=\"$ctrl.ValidationRules.password.minlength\"\n               ng-maxlength=\"$ctrl.ValidationRules.password.maxlength\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required\n               compare-to=\"$ctrl.profile.password\"/>\n        <div class=\"field-errors\"\n             ng-messages=\"profileForm.passwordConfirmation.$error\"\n             ng-if=\"profileForm.passwordConfirmation.$touched || profileForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n          <p ng-message=\"minlength\">{{ 'common.fields.password.validation.minlength' | translate: { minlength: $ctrl.ValidationRules.password.minlength } }}</p>\n          <p ng-message=\"maxlength\">{{ 'common.fields.password.validation.maxlength' | translate: { maxlength: $ctrl.ValidationRules.password.maxlength } }}</p>\n          <p ng-message=\"compareTo\">{{ 'common.fields.password.validation.compareTo' | translate }}</p>\n        </div>\n      </div>\n      <ul class=\"buttonList maxLarge form-field tablet desktop\" ng-class=\"{'iframeMode': $ctrl.isIframe}\">\n        <li>\n          <button type=\"submit\" ng-disabled=\"$ctrl.isProcessing || profileForm.$invalid\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Profile', 'Click', 'Continue']\">{{ 'common.continue' | translate }}</button>\n        </li>\n      </ul>\n    </div>\n  </form>\n</section>\n<registration-contacts-block></registration-contacts-block>\n"

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyProfileController = function () {
	  MyProfileController.$inject = ["Localization", "ValidationRules", "RegistrationHelper", "$state", "$scope", "$stateParams", "$location", "$anchorScroll", "I18n", "StoreTypes"];
	  function MyProfileController(Localization, ValidationRules, RegistrationHelper, $state, $scope, $stateParams, $location, $anchorScroll, I18n, StoreTypes) {
	    'ngInject';
	
	    // Set injections
	
	    (0, _classCallCheck3.default)(this, MyProfileController);
	    this.ValidationRules = ValidationRules;
	    this.RegistrationHelper = RegistrationHelper;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.I18n = I18n;
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	
	    this.isProcessing = false;
	
	    this.profile = {};
	    this.civilities = this.ValidationRules.civility;
	
	    this.checkStep1Params();
	  }
	
	  /**
	   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, password and mobile phone
	   * If one of these is incorr, the user is redirected to step 1
	   */
	
	
	  (0, _createClass3.default)(MyProfileController, [{
	    key: 'checkStep1Params',
	    value: function checkStep1Params() {
	      var civilityChecked = this.RegistrationHelper.checkCivility(this.$stateParams.civility);
	      var firstNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.firstName, this.ValidationRules.firstName.maxlength);
	      var lastNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.lastName, this.ValidationRules.lastName.maxlength);
	      var emailChecked = this.RegistrationHelper.checkEmail(this.$stateParams.email);
	      var passwordChecked = this.RegistrationHelper.checkPassword(this.$stateParams.password);
	      this.profile.civility = civilityChecked ? this.$stateParams.civility : undefined;
	      this.profile.firstName = firstNameChecked ? this.$stateParams.firstName : undefined;
	      this.profile.lastName = lastNameChecked ? this.$stateParams.lastName : undefined;
	      this.profile.email = emailChecked ? this.$stateParams.email : undefined;
	      this.profile.password = passwordChecked ? this.$stateParams.password : undefined;
	      this.profile.passwordConfirmation = passwordChecked ? this.$stateParams.password : undefined;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      if (this.$scope.profileForm.$valid) {
	        return this.$state.go('registration.myRlink', {
	          civility: this.profile.civility,
	          firstName: this.profile.firstName,
	          lastName: this.profile.lastName,
	          email: this.profile.email,
	          password: this.profile.password,
	          model: this.$stateParams.model,
	          friendlyName: this.$stateParams.friendlyName,
	          vin: this.$stateParams.vin
	        });
	      } else {
	        // Hack for mobile submit button
	        this.$scope.profileForm.$submitted = true;
	        // Scroll to first invalid element
	        (0, _jquery2.default)('[name="' + this.$scope.profileForm.$name + '"]').find('.ng-invalid:visible:first').focus();
	      }
	    }
	  }, {
	    key: 'isIframe',
	    get: function get() {
	      return this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.RSITE || this.type === this.StoreTypes.ONE;
	    }
	  }]);
	  return MyProfileController;
	}();
	
	exports.default = MyProfileController;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _registrationContactsBlock = __webpack_require__(1014);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('registrationContactsBlock', []).component('registrationContactsBlock', _registrationContactsBlock2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registrationContactsBlock = __webpack_require__(1015);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	var _registrationContactsBlock3 = __webpack_require__(1016);
	
	var _registrationContactsBlock4 = _interopRequireDefault(_registrationContactsBlock3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _registrationContactsBlock2.default,
	  controller: _registrationContactsBlock4.default
	};
	
	exports.default = component;

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports = "<aside class=\"phoneTimes limitContent\">\n  <h1>{{ 'registration.confirmation.phone' | translate }}</h1>\n  <h5>{{ 'registration.confirmation.indication' | translate }}</h5>\n  <p class=\"availability\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <h1>{{ 'common.contact.country1.contactPhone' | translate }}</h1>\n  <a href=\"mailto:{{ 'common.contact.country1.email.value' | translate }}\" target=\"_blank\">{{ 'common.contact.country1.email.label' | translate }}</a>\n  </p>\n  <p class=\"availability\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <h1>{{ 'common.contact.country2.contactPhone' | translate }}</h1>\n  <a href=\"mailto:{{ 'common.contact.country2.email.value' | translate }}\" target=\"_blank\">{{ 'common.contact.country2.email.label' | translate }}</a>\n  </p>\n  <p class=\"availability\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <h1>{{ 'common.contact.country3.contactPhone' | translate }}</h1>\n  <a href=\"mailto:{{ 'common.contact.country3.email.value' | translate }}\" target=\"_blank\">{{ 'common.contact.country3.email.label' | translate }}</a>\n  </p>\n  <p class=\"availability\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <h1>{{ 'common.contact.country4.contactPhone' | translate }}</h1>\n  <a href=\"mailto:{{ 'common.contact.country4.email.value' | translate }}\" target=\"_blank\">{{ 'common.contact.country4.email.label' | translate }}</a>\n  </p>\n</aside>\n"

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationContactsBlockController = function RegistrationContactsBlockController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, RegistrationContactsBlockController);
	};
	
	exports.default = RegistrationContactsBlockController;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myToolbox = __webpack_require__(1018);
	
	var _myToolbox2 = _interopRequireDefault(_myToolbox);
	
	var _registrationContactsBlock = __webpack_require__(1013);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myToolbox', [_angularUiRouter2.default, _registrationContactsBlock2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('registration.myToolbox', {
	    url: '/my-toolbox?civility&lastName&firstName&email&model&friendlyName&vin',
	    params: {
	      password: null
	    },
	    component: 'myToolbox'
	  });
	}]).component('myToolbox', _myToolbox2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myToolbox = __webpack_require__(1019);
	
	var _myToolbox2 = _interopRequireDefault(_myToolbox);
	
	var _myToolbox3 = __webpack_require__(1020);
	
	var _myToolbox4 = _interopRequireDefault(_myToolbox3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myToolbox2.default,
	  controller: _myToolbox4.default
	};
	
	exports.default = component;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"limitContent\">\n  <ul class=\"stepBar card\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n    <li class=\"finish\" ng-class=\"{'finishAr': $ctrl.I18n.isArLocale()}\"><a href=\"#\" ng-click=\"$ctrl.backToStep1()\" ga-track-event=\"['Registration Navbar', 'Click', 'My Profile']\"><span>{{ 'registration.navbar.myProfile' | translate }}</span></a></li>\n    <li class=\"finish\" ng-class=\"{'finishAr': $ctrl.I18n.isArLocale()}\"><a href=\"#\" ng-click=\"$ctrl.backToStep2()\" ga-track-event=\"['Registration Navbar', 'Click', 'My Rlink']\"><span>{{ 'registration.navbar.myRlink' | translate }}</span></a></li>\n    <li class=\"active\"><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Toolbox']\"><span>{{ 'registration.navbar.myToolbox' | translate }}</span></a></li>\n  </ul>\n  <p class=\"bottomButtonBar\" ng-if=\"!$ctrl.isIframe\">\n    <a class=\"button left back\" href=\"#\" ng-click=\"$ctrl.backToStep2()\" ga-track-event=\"['Register My Toolbox', 'Click', 'Mobile Previous']\">{{ 'common.back' | translate }}</a>\n    <a class=\"button right next\" href=\"#\"><button class=\"uppercase\" ng-disabled=\"toolboxForm.$invalid\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Toolbox', 'Click', 'Mobile Finish']\">{{ 'common.finish' | translate }}</button></a>\n  </p>\n  <form name=\"toolboxForm\" class=\"card\" novalidate>\n    <div class=\"miniContent\">\n      <p class=\"miniModel\">\n        <img class=\"radiusCircle\" ng-src=\"/img/models/{{$ctrl.$stateParams.model}}.jpg\" title=\"{{ 'registration.myRlink.form.image.alt.' + $ctrl.$stateParams.model | translate }}\" alt=\"{{ 'registration.myRlink.form.image.alt.' + $ctrl.$stateParams.model | translate }}\" />\n        <span>\n          {{ 'registration.myRlink.form.' + $ctrl.$stateParams.model | translate }}\n        </span>\n      </p>\n      <h1>\n        {{ 'registration.toolboxForm.title' | translate }}\n      </h1>\n      <div class=\"form-field\" id=\"errorMessage\">\n        <p class=\"errorMessageTop\" ng-class=\"{ 'active' : $ctrl.error }\">\n          {{ $ctrl.error.message | translate }}\n        </p>\n      </div>\n      <div class=\"form-field\">\n        <label for=\"_friendlyName\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.friendlyName.label' | translate }}</label>\n        <input id=\"_friendlyName\"\n               name=\"friendlyName\"\n               type=\"text\"\n               placeholder=\"my Renault\"\n               ng-model=\"$ctrl.vehicle.friendlyName\"\n               ng-maxlength=\"$ctrl.ValidationRules.friendlyName.maxlength\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required />\n        <div class=\"field-errors\"\n             ng-messages=\"toolboxForm.friendlyName.$error\"\n             ng-if=\"toolboxForm.friendlyName.$touched || toolboxForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.friendlyName.validation.required' | translate }}</p>\n          <p ng-message=\"maxlength\">{{ 'common.fields.friendlyName.validation.maxlength' | translate: { maxlength: $ctrl.ValidationRules.friendlyName.maxlength } }}</p>\n        </div>\n        <input-tooltip ng-class=\"{'arabDirectionTooltip':  $ctrl.I18n.isArLocale()}\" title=\"common.fields.friendlyName.label\" name=\"common.fields.friendlyName.label\" text=\"common.fields.friendlyName.help\">\n        </input-tooltip>\n      </div>\n\n      <div class=\"form-field\">\n        <label for=\"_vin\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.vin.label' | translate }}</label>\n        <input id=\"_vin\"\n               name=\"vin\"\n               type=\"text\"\n               placeholder=\"00000000000000000\"\n               class=\"txtUppercase\"\n               ng-model=\"$ctrl.vehicle.vin\"\n               ng-minlength=\"$ctrl.ValidationRules.vin.length\"\n               ng-maxlength=\"$ctrl.ValidationRules.vin.length\"\n               ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n               required\n               check-vin />\n        <div class=\"field-errors\"\n             ng-messages=\"toolboxForm.vin.$error\"\n             ng-if=\"toolboxForm.vin.$touched || toolboxForm.$submitted\">\n          <p ng-message=\"required\">{{ 'common.fields.vin.validation.required' | translate }}</p>\n          <p ng-message=\"minlength || maxlength\">{{ 'common.fields.vin.validation.length' | translate: { length: $ctrl.ValidationRules.vin.length } }}</p>\n          <p ng-message=\"checkVin\">{{ 'common.fields.vin.validation.notfound' | translate }}</p>\n        </div>\n        <input-tooltip ng-class=\"{'arabDirectionTooltip':  $ctrl.I18n.isArLocale()}\" title=\"common.fields.vin.label\" name=\"common.fields.vin.label\" text=\"common.fields.vin.help\">\n        </input-tooltip>\n      </div>\n\n      <figure class=\"toolbox\">\n        <img class=\"sizeAjust\" src=\"{{$ctrl.toolboxInfos.imageUrl}}\" alt=\"Ecran Toolbox\" width=\"550\" height=\"202\" />\n        <figcaption ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n          {{ $ctrl.toolboxInfos.titleKey | translate }}\n        </figcaption>\n      </figure>\n      <p class=\"toolboxText\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n        {{ $ctrl.toolboxInfos.descriptionKey | translate }}\n      </p>\n      <p class=\"toolboxDown\">\n        <a ng-href=\"{{$ctrl.toolboxInfos.windowsUrl}}\" target=\"_blank\" class=\"button\" ga-track-event=\"['Register My Toolbox', 'Click', 'Download for Windows']\">{{ 'registration.toolboxForm.fields.download.windows' | translate }}</a>\n        <a ng-href=\"{{$ctrl.toolboxInfos.osxUrl}}\" target=\"_blank\" class=\"button\" ga-track-event=\"['Register My Toolbox', 'Click', 'Download for Mac']\">{{ 'registration.toolboxForm.fields.download.osx' | translate }}</a>\n      </p>\n\n      <ul class=\"buttonList maxLarge tablet desktop\" ng-class=\"{'iframeMode': $ctrl.isIframe}\">\n        <li>\n          <a class=\"button dark previous\"><button class=\"uppercase\" ng-click=\"$ctrl.backToStep2()\" style=\"min-width:0; outline:none;\" ga-track-event=\"['Register My Profile', 'Click', 'Previous']\">{{ 'common.back' | translate }}</button></a>\n        </li>\n        <li>\n          <button type=\"submit\" ng-disabled=\"$ctrl.isProcessing || toolboxForm.$invalid\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Toolbox', 'Click', 'Finish']\">{{ 'common.finish' | translate }}</button>\n        </li>\n      </ul>\n    </div>\n  </form>\n</section>\n<registration-contacts-block></registration-contacts-block>\n"

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _find2 = __webpack_require__(798);
	
	var _find3 = _interopRequireDefault(_find2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyToolboxController = function () {
	  MyToolboxController.$inject = ["Localization", "ValidationRules", "HelpersService", "RegistrationHelper", "RegistrationService", "$scope", "$state", "$stateParams", "$location", "I18n", "StoreTypes"];
	  function MyToolboxController(Localization, ValidationRules, HelpersService, RegistrationHelper, RegistrationService, $scope, $state, $stateParams, $location, I18n, StoreTypes) {
	    'ngInject';
	
	    // Set injections
	
	    (0, _classCallCheck3.default)(this, MyToolboxController);
	    this.appConfig = Localization.getLocalizedAppConfig();
	    this.ValidationRules = ValidationRules;
	    this.HelpersService = HelpersService;
	    this.RegistrationHelper = RegistrationHelper;
	    this.RegistrationService = RegistrationService;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.I18n = I18n;
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	
	    this.profile = {};
	    this.vehicle = {};
	
	    this.checkStep1Params();
	    this.checkStep2Params();
	    this.checkStep3Params();
	  }
	
	  /**
	   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, password and mobile phone
	   * If one of these is incorr, the user is redirected to step 1
	   */
	
	
	  (0, _createClass3.default)(MyToolboxController, [{
	    key: 'checkStep1Params',
	    value: function checkStep1Params() {
	      var civilityChecked = this.RegistrationHelper.checkCivility(this.$stateParams.civility);
	      var firstNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.firstName, this.ValidationRules.firstName.maxlength);
	      var lastNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.lastName, this.ValidationRules.lastName.maxlength);
	      var emailChecked = this.RegistrationHelper.checkEmail(this.$stateParams.email);
	      var passwordChecked = this.RegistrationHelper.checkPassword(this.$stateParams.password);
	      if (civilityChecked && firstNameChecked && lastNameChecked && emailChecked && passwordChecked) {
	        this.profile.civility = civilityChecked ? this.$stateParams.civility : undefined;
	        this.profile.firstName = firstNameChecked ? this.$stateParams.firstName : undefined;
	        this.profile.lastName = lastNameChecked ? this.$stateParams.lastName : undefined;
	        this.profile.email = emailChecked ? this.$stateParams.email : undefined;
	        this.profile.password = passwordChecked ? this.$stateParams.password : undefined;
	      } else {
	        return this.$state.go('registration.myProfile', { profile: undefined });
	      }
	    }
	
	    /**
	     * Verify state params relative to step 2 - My Rlink
	     *
	     * @return {Promise} go back to step 2 if the model is not in the configuration
	     */
	
	  }, {
	    key: 'checkStep2Params',
	    value: function checkStep2Params() {
	      if (!this.$stateParams.model || !this.RegistrationHelper.checkModel(this.$stateParams.model, this.appConfig.rlinkModels)) {
	        return this.$state.go('registration.myRlink', { model: undefined });
	      } else {
	        this.toolboxInfos = (0, _find3.default)(this.appConfig.rlinkModels, ['id', this.$stateParams.model]).toolbox;
	      }
	    }
	
	    /**
	     * Verify state params relative to step 3 - My Toolbox : Friendly Name, VIN and MUID
	     * If one of these is correct, the form is filled with it
	     */
	
	  }, {
	    key: 'checkStep3Params',
	    value: function checkStep3Params() {
	      var friendlyNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.friendlyName, this.ValidationRules.friendlyName.maxlength);
	      var vinChecked = this.RegistrationHelper.checkVin(this.$stateParams.vin);
	      this.vehicle.friendlyName = friendlyNameChecked ? this.$stateParams.friendlyName : undefined;
	      this.vehicle.vin = vinChecked ? this.$stateParams.vin : undefined;
	    }
	  }, {
	    key: 'backToStep1',
	    value: function backToStep1() {
	      return this.$state.go('registration.myProfile', {
	        civility: this.$stateParams.civility,
	        firstName: this.$stateParams.firstName,
	        lastName: this.$stateParams.lastName,
	        email: this.$stateParams.email,
	        model: this.$stateParams.model,
	        friendlyName: this.vehicle.friendlyName,
	        vin: this.vehicle.vin
	      });
	    }
	  }, {
	    key: 'backToStep2',
	    value: function backToStep2() {
	      return this.$state.go('registration.myRlink', {
	        civility: this.$stateParams.civility,
	        firstName: this.$stateParams.firstName,
	        lastName: this.$stateParams.lastName,
	        email: this.$stateParams.email,
	        password: this.$stateParams.password,
	        model: this.$stateParams.model,
	        friendlyName: this.vehicle.friendlyName,
	        vin: this.vehicle.vin
	      });
	    }
	  }, {
	    key: 'completeProfile',
	    value: function completeProfile() {
	      this.profile.friendlyName = this.vehicle.friendlyName;
	      this.profile.vin = this.vehicle.vin;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (this.$scope.toolboxForm.$valid) {
	        this.completeProfile();
	        this.isProcessing = true;
	        return this.RegistrationService.register(this.profile).then(function (success) {
	          _this.success = success;
	          _this.isProcessing = false;
	          return _this.$state.go('registrationConfirmation', { email: _this.profile.email });
	        }, function (err) {
	          _this.error = {
	            message: 'error.' + err.data.meta.code,
	            cause: err
	          };
	          _this.$location.hash('errorMessage');
	          _this.isProcessing = false;
	        });
	      } else {
	        // Hack for mobile submit button
	        this.$scope.toolboxForm.$submitted = true;
	        // Scroll to first invalid element
	        (0, _jquery2.default)('[name="' + this.$scope.toolboxForm.$name + '"]').find('.ng-invalid:visible:first').focus();
	      }
	    }
	  }, {
	    key: 'openTooltip',
	    value: function openTooltip($event) {
	      this.HelpersService.openTooltip($event.currentTarget);
	    }
	  }, {
	    key: 'closeTooltip',
	    value: function closeTooltip() {
	      this.HelpersService.closeTooltip();
	    }
	  }, {
	    key: 'isIframe',
	    get: function get() {
	      return this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.RSITE || this.type === this.StoreTypes.ONE;
	    }
	  }]);
	  return MyToolboxController;
	}();
	
	exports.default = MyToolboxController;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myRlink = __webpack_require__(1022);
	
	var _myRlink2 = _interopRequireDefault(_myRlink);
	
	var _myRlinkModel = __webpack_require__(1027);
	
	var _myRlinkModel2 = _interopRequireDefault(_myRlinkModel);
	
	var _registrationContactsBlock = __webpack_require__(1013);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myRlink', [_angularUiRouter2.default, _myRlinkModel2.default, _registrationContactsBlock2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('registration.myRlink', {
	    url: '/my-rlink?civility&lastName&firstName&email&model&friendlyName&vin',
	    params: {
	      password: null
	    },
	    component: 'myRlink'
	  });
	}]).component('myRlink', _myRlink2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myRlink = __webpack_require__(1023);
	
	var _myRlink2 = _interopRequireDefault(_myRlink);
	
	var _myRlink3 = __webpack_require__(1024);
	
	var _myRlink4 = _interopRequireDefault(_myRlink3);
	
	__webpack_require__(1025);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myRlink2.default,
	  controller: _myRlink4.default
	};
	
	exports.default = component;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"limitContent\">\n  <ul class=\"stepBar card\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n    <li class=\"finish\" ng-class=\"{'finishAr': $ctrl.I18n.isArLocale()}\"><a href=\"#\" ng-click=\"$ctrl.backToStep1()\" ga-track-event=\"['Registration Navbar', 'Click', 'My Profile']\"><span>{{ 'registration.navbar.myProfile' | translate }}</span></a></li>\n    <li class=\"active\"><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Rlink']\"><span>{{ 'registration.navbar.myRlink' | translate }}</span></a></li>\n    <li><a href=\"#\" ga-track-event=\"['Registration Navbar', 'Click', 'My Toolbox']\"><span>{{ 'registration.navbar.myToolbox' | translate }}</span></a></li>\n  </ul>\n  <p class=\"bottomButtonBar\" ng-if=\"!$ctrl.isIframe\">\n    <a class=\"button left back\" href=\"#\" ng-click=\"$ctrl.backToStep1()\" ga-track-event=\"['Register My Toolbox', 'Click', 'Mobile Previous']\">{{ 'common.back' | translate }}</a>\n    <a class=\"button right next\" href=\"#\">\n      <button class=\"uppercase\" ng-disabled=\"!$ctrl.model\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Rlink', 'Click', 'Mobile Continue']\">{{ 'common.continue' | translate }}</button>\n    </a>\n  </p>\n  <form class=\"card models\" novalidate>\n    <h1>\n      {{ 'registration.myRlink.title' | translate }}\n    </h1>\n    <ul>\n      <my-rlink-model ng-repeat=\"rlinkModel in $ctrl.rlinkModels\"\n        id='{{rlinkModel.id}}'\n        type=\"{{rlinkModel.type}}\"\n        title=\"{{rlinkModel.title}}\"\n        model=\"$ctrl.model\">\n      </my-rlink-model>\n    </ul>\n    <ul class=\"buttonList maxLarge tablet desktop\" ng-class=\"{'iframeMode': $ctrl.isIframe}\">\n      <li>\n        <a class=\"button dark previous\"><button class=\"uppercase\" ng-click=\"$ctrl.backToStep1()\" ga-track-event=\"['Register My Profile', 'Click', 'Previous']\">{{ 'common.back' | translate }}</button></a>\n      </li>\n      <li>\n        <button type=\"submit\" ng-disabled=\"!$ctrl.model\" ng-click=\"$ctrl.submit()\" ga-track-event=\"['Register My Rlink', 'Click', 'Continue']\">{{ 'common.continue' | translate }}</button>\n      </li>\n    </ul>\n  </form>\n</section>\n<registration-contacts-block></registration-contacts-block>\n"

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyRlinkController = function () {
	  MyRlinkController.$inject = ["Localization", "RegistrationHelper", "$state", "$stateParams", "I18n", "StoreTypes"];
	  function MyRlinkController(Localization, RegistrationHelper, $state, $stateParams, I18n, StoreTypes) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyRlinkController);
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.RegistrationHelper = RegistrationHelper;
	    this.I18n = I18n;
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	    this.rlinkModels = Localization.getLocalizedAppConfig().rlinkModels;
	
	    this.checkStep1Params();
	    this.checkStep2Params();
	  }
	
	  /**
	   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, mobile phone
	   * If one of these is incorr, the user is redirected to step 1
	   */
	
	
	  (0, _createClass3.default)(MyRlinkController, [{
	    key: 'checkStep1Params',
	    value: function checkStep1Params() {
	      if (!this.RegistrationHelper.checkCivility(this.$stateParams.civility) || !this.$stateParams.firstName || !this.$stateParams.lastName || !this.RegistrationHelper.checkEmail(this.$stateParams.email) || !this.$stateParams.password) {
	        return this.$state.go('registration.myProfile', { profile: undefined });
	      } else {
	        this.profile = {
	          civility: this.$stateParams.civility,
	          firstName: this.$stateParams.firstName,
	          lastName: this.$stateParams.lastName,
	          email: this.$stateParams.email,
	          password: this.$stateParams.password
	        };
	      }
	    }
	
	    /**
	     * Verify state params relative to step 2 - My Rlink
	     *
	     * @return {Promise} set the model if it has already been selected
	     */
	
	  }, {
	    key: 'checkStep2Params',
	    value: function checkStep2Params() {
	      if (this.$stateParams.model && this.RegistrationHelper.checkModel(this.$stateParams.model, this.rlinkModels)) {
	        this.model = this.$stateParams.model;
	      } else if (this.$stateParams.model) {
	        return this.$state.go('registration.myRlink', { model: undefined });
	      }
	    }
	  }, {
	    key: 'backToStep1',
	    value: function backToStep1() {
	      return this.$state.go('registration.myProfile', {
	        civility: this.$stateParams.civility,
	        firstName: this.$stateParams.firstName,
	        lastName: this.$stateParams.lastName,
	        email: this.$stateParams.email,
	        password: this.$stateParams.password,
	        model: this.model,
	        friendlyName: this.$stateParams.friendlyName,
	        vin: this.$stateParams.vin
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var params = {};
	      if (this.model === this.$stateParams.model) {
	        params = {
	          model: this.model,
	          friendlyName: this.$stateParams.friendlyName,
	          vin: this.$stateParams.vin,
	          civility: this.$stateParams.civility,
	          firstName: this.$stateParams.firstName,
	          lastName: this.$stateParams.lastName,
	          email: this.$stateParams.email,
	          password: this.$stateParams.password
	        };
	      } else {
	        params = {
	          model: this.model,
	          civility: this.$stateParams.civility,
	          firstName: this.$stateParams.firstName,
	          lastName: this.$stateParams.lastName,
	          email: this.$stateParams.email,
	          password: this.$stateParams.password
	        };
	      }
	      return this.$state.go('registration.myToolbox', params);
	    }
	  }, {
	    key: 'isIframe',
	    get: function get() {
	      return this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.RSITE || this.type === this.StoreTypes.ONE;
	    }
	  }]);
	  return MyRlinkController;
	}();
	
	exports.default = MyRlinkController;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1026);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-rlink.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./my-rlink.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "my-rlink form ul{overflow:visible}my-rlink button:disabled{opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\"}button[disabled],input[disabled]{cursor:default}.iframeMode{display:table!important}.iframeModeModel{display:block!important}.iframeModeModel button{min-width:220px!important}", ""]);
	
	// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myRlinkModel = __webpack_require__(1028);
	
	var _myRlinkModel2 = _interopRequireDefault(_myRlinkModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myRlinkModel', []).component('myRlinkModel', _myRlinkModel2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myRlinkModel = __webpack_require__(1029);
	
	var _myRlinkModel2 = _interopRequireDefault(_myRlinkModel);
	
	var _myRlinkModel3 = __webpack_require__(1030);
	
	var _myRlinkModel4 = _interopRequireDefault(_myRlinkModel3);
	
	__webpack_require__(1031);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    id: '@',
	    type: '@',
	    title: '@',
	    model: '='
	  },
	  template: _myRlinkModel2.default,
	  controller: _myRlinkModel4.default
	};
	
	exports.default = component;

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	module.exports = "<li>\n  <input tabindex=\"-1\" class=\"txtHidden\" name=\"rlinkModel\" id=\"{{$ctrl.id}}\" type=\"radio\">\n  <div class=\"modelType\" tabindex=\"0\" ng-class=\"{'focus': $ctrl.model===$ctrl.id}\">\n    <div class=\"tootipBox\">\n      <span class=\"rlink\">\n        {{ 'registration.myRlink.form.' + $ctrl.id | translate }}\n      </span>\n      <div class=\"tooltip\">\n        <button class=\"open radiusCircle\" type=\"button\" ng-click=\"$ctrl.openTooltip($event)\" ga-track-event=\"['Register My Rlink', 'Click', 'Open Tooltip']\">\n          <span class=\"txtHidden\">{{ 'registration.help.info' | translate }}</span>\n        </button>\n        <div class=\"tooltipMessage\">\n          <button type=\"button\" ng-click=\"$ctrl.closeTooltip()\" ga-track-event=\"['Register My Rlink', 'Click', 'Close Tooltip']\">\n            <span>{{ 'common.close' | translate }}</span>\n          </button>\n          <h5>{{ 'common.help' | translate }}</h5>\n          <p ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n            {{ 'registration.help.text' | translate }}\n          </p>\n        </div>\n      </div>\n    </div>\n    <span class=\"direction\">\n      {{ 'registration.myRlink.form.'+ $ctrl.type + '.' + $ctrl.title | translate }}\n    </span>\n    <p class=\"mobile\" ng-class=\"{'arabDirection': $ctrl.I18n.isArLocale()}\">\n      {{ 'registration.help.mobileText' | translate }}\n    </p>\n    <img class=\"radiusCircle\" ng-class=\"{'focus': $ctrl.model===$ctrl.id}\" ng-src=\"/img/models/{{$ctrl.id}}.jpg\" title=\"{{ 'registration.myRlink.form.image.alt.' + $ctrl.id | translate }}\" alt=\"{{ 'registration.myRlink.form.image.alt.' + $ctrl.id | translate }}\" ng-click=\"$ctrl.model=$ctrl.id\">\n  </div>\n</li>\n"

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyRlinkModelController = function () {
	  MyRlinkModelController.$inject = ["HelpersService", "I18n"];
	  function MyRlinkModelController(HelpersService, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyRlinkModelController);
	    this.HelpersService = HelpersService;
	    this.I18n = I18n;
	  }
	
	  (0, _createClass3.default)(MyRlinkModelController, [{
	    key: 'openTooltip',
	    value: function openTooltip($event) {
	      this.HelpersService.openTooltip($event.currentTarget);
	    }
	  }, {
	    key: 'closeTooltip',
	    value: function closeTooltip() {
	      this.HelpersService.closeTooltip();
	    }
	  }]);
	  return MyRlinkModelController;
	}();
	
	exports.default = MyRlinkModelController;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1032);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-rlink-model.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-rlink-model.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".models my-rlink-model:first-child{margin-top:0}@media (min-width:600px){.models my-rlink-model:first-child{display:block;margin:0 0 40px}}@media (min-width:1024px){.models my-rlink-model:first-child{margin:0 5em 0 0;display:inline-block}}.modelType.focus{font-family:Renault Bold,Helvetica,Arial,sans-serif;outline:none}.modelType.focus>p{font-family:Renault Regular,Helvetica,Arial,sans-serifs}img.focus{border-color:#fc0!important}", ""]);
	
	// exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _map2 = __webpack_require__(1034);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _includes2 = __webpack_require__(1041);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationHelper = function () {
	  RegistrationHelper.$inject = ["Localization", "ValidationRules", "VehicleService", "UserService"];
	  function RegistrationHelper(Localization, ValidationRules, VehicleService, UserService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RegistrationHelper);
	    this.appConfig = Localization.getLocalizedAppConfig();
	    this.ValidationRules = ValidationRules;
	    this.VehicleService = VehicleService;
	    this.UserService = UserService;
	  }
	
	  /**
	   * Verify that the model is into the list.
	   * @param {string} model - model name
	   * @param {object} models - a list of models
	   * @return {boolean} model status in the configuration
	   */
	
	
	  (0, _createClass3.default)(RegistrationHelper, [{
	    key: 'checkModel',
	    value: function checkModel(model, models) {
	      if (!models) return false;
	      return model ? (0, _includes3.default)((0, _map3.default)(models, 'id'), model) : false;
	    }
	
	    /**
	     * Verify that the VIN exists
	     *
	     * @param {string} vin - VIN
	     * @return {Promise} vin online status
	     */
	
	  }, {
	    key: 'checkVin',
	    value: function checkVin(vin) {
	      if (vin && vin.length === 17) {
	        return this.VehicleService.checkVin(vin).then(function () {
	          return _promise2.default.resolve(true);
	        }, function () {
	          return _promise2.default.resolve(false);
	        });
	      }
	      return _promise2.default.resolve(false);
	    }
	
	    /**
	     * Verify that the MUID is well formated
	     *
	     * @param {string} muid - muid
	     * @return {boolean} true if the MUID matches the pattern, false otherwise
	     */
	
	  }, {
	    key: 'checkMuid',
	    value: function checkMuid(muid) {
	      var muidRegex = new RegExp(this.ValidationRules.muid.pattern);
	      return muid && muidRegex.test(muid);
	    }
	
	    /**
	     * Verify if the civility is into the list
	     *
	     * @param {string} civility - civility
	     * @return {boolean} true if the civility is in the list, false otherwise
	     */
	
	  }, {
	    key: 'checkCivility',
	    value: function checkCivility(civility) {
	      return civility ? (0, _includes3.default)((0, _map3.default)(this.ValidationRules.civility, 'id'), civility) : false;
	    }
	
	    /**
	     * Verify that the email is well formated
	     *
	     * @param {string} email - email
	     * @return {boolean} true if the email matches the pattern, false otherwise
	     */
	
	  }, {
	    key: 'checkEmail',
	    value: function checkEmail(email) {
	      var emailRegex = new RegExp(this.ValidationRules.email.pattern);
	      return email && emailRegex.test(email);
	    }
	
	    /**
	     * Verify that a property contains less than a given number of characters
	     *
	     * @param {string} prop - property to test
	     * @param {number} length - max length
	     * @return {boolean} true if the property contains at most the number of characters wanted, false otherwise
	     */
	
	  }, {
	    key: 'checkMaxLength',
	    value: function checkMaxLength(prop, length) {
	      return prop && prop.length <= length;
	    }
	
	    /**
	     * Verify that the phone number is well formated
	     *
	     * @param {string} phoneNumber - phone number
	     * @return {boolean} true if the phone number matches the pattern, false otherwise
	     */
	
	  }, {
	    key: 'checkPhoneNumber',
	    value: function checkPhoneNumber(phoneNumber) {
	      var phoneNumberRegex = new RegExp(this.ValidationRules.phoneNumber.pattern);
	      return phoneNumber && phoneNumberRegex.test(phoneNumber);
	    }
	
	    /**
	     * Verify password
	     *
	     * @param {string} password - password
	     * @return {Promise} password complexity
	     */
	
	  }, {
	    key: 'checkPassword',
	    value: function checkPassword(password) {
	      if (password && password.length >= 8 && password.length <= 32) {
	        return this.UserService.checkPassword(password).then(function (res) {
	          return _promise2.default.resolve(true);
	        }, function () {
	          return _promise2.default.resolve(false);
	        });
	      }
	      return _promise2.default.resolve(false);
	    }
	  }]);
	  return RegistrationHelper;
	}();
	
	exports.default = RegistrationHelper;

/***/ }),
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _registrationConfirmation = __webpack_require__(1049);
	
	var _registrationConfirmation2 = _interopRequireDefault(_registrationConfirmation);
	
	var _registrationContactsBlock = __webpack_require__(1013);
	
	var _registrationContactsBlock2 = _interopRequireDefault(_registrationContactsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('registrationConfirmation', [_angularUiRouter2.default, _registrationContactsBlock2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('registrationConfirmation', {
	    url: '/registration/confirm?email',
	    component: 'registrationConfirmation',
	    myRenaultForbidden: true,
	    authenticatedForbidden: true
	  });
	}]).component('registrationConfirmation', _registrationConfirmation2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registrationConfirmation = __webpack_require__(1050);
	
	var _registrationConfirmation2 = _interopRequireDefault(_registrationConfirmation);
	
	var _registrationConfirmation3 = __webpack_require__(1051);
	
	var _registrationConfirmation4 = _interopRequireDefault(_registrationConfirmation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _registrationConfirmation2.default,
	  controller: _registrationConfirmation4.default
	};
	
	exports.default = component;

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	module.exports = "<main id=\"container\">\n  <div class=\"pageContent paddingLight\">\n    <h2 ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">{{ 'registration.confirmation.confirm' | translate }}</h2>\n    <p class=\"txtCenter txtLight\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n      {{ 'registration.confirmation.description' | translate }}\n    </p>\n    <p class=\"emailSent miniContent\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n      <strong class=\"txtTruncated\">{{ $ctrl.email }}</strong>\n      {{ 'registration.confirmation.activate' | translate }}\n    </p>\n    <registration-contacts-block></registration-contacts-block>\n  </div>\n</main>\n"

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationConfirmationController = function RegistrationConfirmationController($state, $stateParams, I18n) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, RegistrationConfirmationController);
	  this.$state = $state;
	  this.I18n = I18n;
	  this.$stateParams = $stateParams;
	  if (this.$stateParams.email) {
	    this.email = this.$stateParams.email;
	  } else {
	    this.$state.go('registration');
	  }
	};
	RegistrationConfirmationController.$inject = ["$state", "$stateParams", "I18n"];
	
	exports.default = RegistrationConfirmationController;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _resetPassword = __webpack_require__(1053);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('resetPassword', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('resetPassword', {
	    url: '/reset_password',
	    component: 'resetPassword',
	    myRenaultForbidden: true,
	    authenticatedForbidden: true
	  });
	}]).component('resetPassword', _resetPassword2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resetPassword = __webpack_require__(1054);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPassword3 = __webpack_require__(1055);
	
	var _resetPassword4 = _interopRequireDefault(_resetPassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _resetPassword2.default,
	  controller: _resetPassword4.default
	};
	
	exports.default = component;

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight\" ng-if=\"!$ctrl.isReset\">\n  <h2>{{ 'resetPassword.forgotPassword' | translate }}</h2>\n  <p class=\"txtCenter microContent\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n    {{ 'resetPassword.information' | translate }}\n  </p>\n  <form name=\"resetPasswordForm\" class=\"miniContent separator\" ng-submit=\"$ctrl.resetPassword(this)\" novalidate>\n    <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n    <p class=\"errorMessageTop\" ng-class=\"{ 'active' : $ctrl.error }\">\n      <span ng-if=\"$ctrl.errorCode\">{{ 'error.'+$ctrl.errorCode+'.description' | translate }}</span>\n      <span ng-if=\"!$ctrl.errorCode\">{{ 'resetPassword.error' | translate }}</span>\n    </p>\n    <div class=\"formGroup\">\n      <label for=\"loginField\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.email.label' | translate }}</label>\n      <input ng-class=\"{ 'errorField' : resetPasswordForm.email.$invalid && resetPasswordForm.$submitted, 'arabDirection':  $ctrl.I18n.isArLocale() }\" id=\"loginField\" ng-model=\"$ctrl.email\" name=\"email\" type=\"email\" required>\n      <p class=\"errorMessage\" ng-show= \"resetPasswordForm.email.$invalid && resetPasswordForm.$submitted\">\n        <span ng-show=\"resetPasswordForm.email.$error.required\">{{ 'common.fields.email.validation.required' | translate }}</span>\n        <span ng-show=\"resetPasswordForm.email.$error.email\">{{ 'common.fields.email.validation.invalid' | translate }}</span>\n      </p>\n    </div>\n    <button type=\"submit\" ng-disabled=\"$ctrl.isProcessing\" ga-track-event=\"['Reset Password', 'Click', 'Continue']\">{{ 'common.continue' | translate }}</button>\n    <a ui-sref=\"authentication\" class=\"button back\" ga-track-event=\"['Reset Password', 'Click', 'Back']\">{{ 'common.return' | translate }}</a>\n  </form>\n</div>\n<div class=\"pageContent paddingLight\" ng-if=\"$ctrl.isReset\">\n  <h2>  {{ 'resetPassword.forgotPassword' | translate }} </h2>\n  <p class=\"emailSent miniContent\">\n    <strong class=\"txtTruncated\">{{ $ctrl.email }}</strong>\n    {{ 'resetPassword.resetLink' | translate }}\n  </p>\n  <p class=\"txtCenter txtUppercase\">\n    <a ui-sref=\"home\" ga-track-event=\"['Reset Password', 'Click', 'Back']\">{{ 'common.return' | translate }}</a>\n  </p>\n  <registration-contacts-block></registration-contacts-block>\n</div>\n"

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPasswordController = function () {
	  ResetPasswordController.$inject = ["UserService", "$state", "$stateParams", "I18n"];
	  function ResetPasswordController(UserService, $state, $stateParams, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ResetPasswordController);
	    this.I18n = I18n;
	    this.UserService = UserService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.isProcessing = false;
	    this.isReset = false;
	  }
	
	  (0, _createClass3.default)(ResetPasswordController, [{
	    key: 'resetPassword',
	    value: function resetPassword(form) {
	      var _this = this;
	
	      if (form.resetPasswordForm.$valid) {
	        this.isProcessing = true;
	        return this.UserService.resetPassword({ email: this.email }).then(function (success) {
	          _this.isReset = true;
	          _this.isProcessing = false;
	          return _promise2.default.resolve(success);
	        }, function (err) {
	          _this.error = err;
	          if (_this.error.data.meta.code === 524) {
	            _this.errorCode = _this.error.data.meta.code;
	          }
	          _this.isProcessing = false;
	        });
	      }
	    }
	  }]);
	  return ResetPasswordController;
	}();
	
	exports.default = ResetPasswordController;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _catalog = __webpack_require__(1057);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	var _manageMyRlink = __webpack_require__(1112);
	
	var _manageMyRlink2 = _interopRequireDefault(_manageMyRlink);
	
	var _productDetails = __webpack_require__(1217);
	
	var _productDetails2 = _interopRequireDefault(_productDetails);
	
	var _vehicle = __webpack_require__(1223);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('vehicle', [_angularUiRouter2.default, _catalog2.default, _manageMyRlink2.default, _productDetails2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle', {
	    url: '/vehicle/:vin?token',
	    component: 'vehicle',
	    authenticate: true,
	    params: {
	      sync: true
	    },
	    redirectTo: function redirectTo(trans) {
	      var svc = trans.injector().get('VehicleService');
	      var vin = trans.params().vin;
	      var sync = trans.params().sync;
	      var $rootScope = trans.injector().get('$rootScope');
	      $rootScope.$broadcast('globalSpinner:on');
	      if (sync) {
	        console.debug('Sync todo');
	        return svc.synchronizeVehicleInfoAndRights(vin).then(function () {
	          console.log('Info and rights synchronized', vin);
	        }).catch(function () {
	          console.error('Info and rights not synchronized', vin);
	        }).finally(function () {
	          return svc.setCurrentSelectedVehicle(vin, false);
	        }).then(function () {
	          console.log('Goto vehicle page', vin);
	          $rootScope.$broadcast('globalSpinner:off');
	          return _promise2.default.resolve('vehicle.catalog');
	        }).catch(function (err) {
	          console.error('Unable to switch vehicle', err);
	          $rootScope.$broadcast('globalSpinner:off');
	          return _promise2.default.resolve('home');
	        });
	      } else {
	        console.debug('Sync not needed');
	        return svc.setCurrentSelectedVehicle(vin, false).then(function () {
	          console.log('Goto vehicle page', vin);
	          $rootScope.$broadcast('globalSpinner:off');
	          return _promise2.default.resolve('vehicle.catalog');
	        }).catch(function (err) {
	          console.error('Unable to switch vehicle', err);
	          $rootScope.$broadcast('globalSpinner:off');
	          return _promise2.default.resolve('home');
	        });
	      }
	    }
	  });
	}]).component('vehicle', _vehicle2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _catalog = __webpack_require__(1058);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	var _components = __webpack_require__(1062);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _catalogContent = __webpack_require__(1108);
	
	var _catalogContent2 = _interopRequireDefault(_catalogContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('catalog', [_angularUiRouter2.default, _components2.default, _catalogContent2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.catalog', {
	    url: '/catalog',
	    component: 'catalog',
	    redirectTo: 'vehicle.catalog.appsAndServices',
	    authenticate: true
	  });
	}]).component('catalog', _catalog2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _catalog = __webpack_require__(1059);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	__webpack_require__(1060);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _catalog2.default
	};
	
	exports.default = component;

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <rlink-apps-status></rlink-apps-status>\n  <carousel></carousel>\n  <div class=\"limitContent\">\n    <section class=\"choiceApp\">\n      <h2>{{ 'catalog.newAppWish' | translate }}</h2>\n      <div class=\"tabAppCarto\">\n        <ui-view />\n      </div>\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1061);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./catalog.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./catalog.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "catalog .pageContent{overflow:inherit!important}catalog .classicArea:before{box-shadow:none}catalog .paddingLight{padding-left:0;padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _carousel = __webpack_require__(1063);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _catalogNavbar = __webpack_require__(1069);
	
	var _catalogNavbar2 = _interopRequireDefault(_catalogNavbar);
	
	var _productCategories = __webpack_require__(1075);
	
	var _productCategories2 = _interopRequireDefault(_productCategories);
	
	var _productFilters = __webpack_require__(1081);
	
	var _productFilters2 = _interopRequireDefault(_productFilters);
	
	var _productTile = __webpack_require__(1085);
	
	var _productTile2 = _interopRequireDefault(_productTile);
	
	var _products = __webpack_require__(1091);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _productsBasket = __webpack_require__(1098);
	
	var _productsBasket2 = _interopRequireDefault(_productsBasket);
	
	var _durationPrice = __webpack_require__(1102);
	
	var _durationPrice2 = _interopRequireDefault(_durationPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('catalog.components', [_carousel2.default, _catalogNavbar2.default, _productCategories2.default, _productFilters2.default, _productTile2.default, _products2.default, _productsBasket2.default, _durationPrice2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(774);
	
	__webpack_require__(775);
	
	__webpack_require__(777);
	
	var _carousel = __webpack_require__(1064);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('carousel', ['angular-carousel']).component('carousel', _carousel2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _carousel = __webpack_require__(1065);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _carousel3 = __webpack_require__(1066);
	
	var _carousel4 = _interopRequireDefault(_carousel3);
	
	__webpack_require__(1067);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _carousel2.default,
	  controller: _carousel4.default
	};
	
	exports.default = component;

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"limitContent\" ng-if=\"$ctrl.banners.length\">\n  <div class=\"card carousel apps\">\n    <ul class=\"elements\" rn-carousel-duration=\"300\" rn-carousel rn-carousel-pause-on-hover rn-carousel-auto-slide=\"$ctrl.duration\" rn-carousel-controls-allow-loop rn-carousel-index=\"carouselIndex\" >\n      <li ng-repeat=\"banner in $ctrl.banners\">\n        <style scoped>\n          @media (max-width: 599px){\n            .slide-{{$index}}{\n              background-image:url(banners/{{$ctrl.getBannerUrl(banner, 'small')}});\n            }\n          }\n          @media (min-width: 600px) and (max-width: 959px){\n            .slide-{{$index}}{\n              background-image:url(banners/{{$ctrl.getBannerUrl(banner, 'medium')}});\n            }\n          }\n          @media (min-width: 960px){\n            .slide-{{$index}}{\n              background-image:url(banners/{{$ctrl.getBannerUrl(banner, '')}});\n            }\n          }\n        </style>\n        <div class=\"autoresize\" ng-class=\"'slide-' + $index\">\n        <aside class=\"popinChoice eltInitHeight\">\n          <h1>\n            {{banner.productName}}\n          </h1>\n          <p>\n          </p>\n          <ul class=\"buttonList\">\n            <li>\n              <a class=\"button\" ui-sref=\"vehicle.productDetails({ref: '{{banner.productRef}}'})\" ng-if=\"banner.productRef\" ga-track-event=\"['Carousel', 'Click', 'Discover Product {{ banner.productRef | escapeSingleQuote }}']\">{{ 'catalog.carousel.discoverButton' | translate }}</a>\n              <a class=\"button\" ng-href=\"{{banner.urlLinked}}\" ng-if=\"banner.urlLinked\" ga-track-event=\"['Carousel', 'Click', 'Discover Link {{ banner.urlLinked | escapeSingleQuote }}']\">{{ 'catalog.carousel.discoverButton' | translate }}</a>\n            </li>\n          </ul>\n        </aside>\n      </div>\n      </li>\n      <div class=\"indicators\" rn-carousel-indicators ng-if=\"$ctrl.banners.length > 1\" slides=\"$ctrl.banners\" rn-carousel-index=\"carouselIndex\"></div>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselController = function () {
	  CarouselController.$inject = ["BannerService", "VehicleService", "DeviceService"];
	  function CarouselController(BannerService, VehicleService, DeviceService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CarouselController);
	    this.vehicleService = VehicleService;
	    this.bannerService = BannerService;
	    this.deviceService = DeviceService;
	
	    this.banners = [];
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(CarouselController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	        _this.vehicle = vehicle;
	        _this.bannerService;
	        var params = {
	          huType: vehicle.huType,
	          display: _this.deviceService.getAtcDeviceId(),
	          vin: vehicle.vin
	        };
	        return _this.bannerService.getBanners(params);
	      }).then(function (data) {
	        _this.banners = data.banners;
	        _this.duration = data.duration;
	      });
	    }
	  }, {
	    key: 'getBannerUrl',
	    value: function getBannerUrl(banner, size) {
	      if (banner.bannerUrl != null) {
	        if (size === '') {
	          return banner.bannerUrl;
	        } else {
	          var extIdx = banner.bannerUrl.lastIndexOf('.');
	          return banner.bannerUrl.slice(0, extIdx) + '_' + size + banner.bannerUrl.slice(extIdx);
	        }
	      }
	    }
	  }]);
	  return CarouselController;
	}();
	
	exports.default = CarouselController;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1068);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./carousel.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./carousel.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:599px){carousel .carousel{height:272px}}@media (min-width:600px){carousel .carousel{height:460px}}", ""]);
	
	// exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _catalogNavbar = __webpack_require__(1070);
	
	var _catalogNavbar2 = _interopRequireDefault(_catalogNavbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('catalogNavbar', [_angularUiRouter2.default]).component('catalogNavbar', _catalogNavbar2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _catalogNavbar = __webpack_require__(1071);
	
	var _catalogNavbar2 = _interopRequireDefault(_catalogNavbar);
	
	var _catalogNavbar3 = __webpack_require__(1072);
	
	var _catalogNavbar4 = _interopRequireDefault(_catalogNavbar3);
	
	__webpack_require__(1073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _catalogNavbar2.default,
	  controller: _catalogNavbar4.default
	};
	
	exports.default = component;

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"toggle\" ng-click=\"$ctrl.open = !$ctrl.open\"></button>\n<ul ng-class=\"{'open': $ctrl.open, 'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <li ng-repeat=\"type in $ctrl.types track by type.id\" >\n    <a role=\"tab\"\n       ui-sref=\"vehicle.catalog.{{type.id}}()\"\n       ui-sref-active=\"active\" ga-track-event=\"['My Catalog', 'Click', '{{ type.label | translate | escapeSingleQuote }}']\">\n       {{ type.label | translate }}\n    </a>\n  </li>\n</ul>\n"

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogNavbarController = function CatalogNavbarController(I18n) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, CatalogNavbarController);
	  this.I18n = I18n;
	  this.types = [{
	    id: 'appsAndServices',
	    label: 'catalog.type.appsAndServices'
	  }, {
	    id: 'maps',
	    label: 'catalog.type.maps'
	  }];
	};
	CatalogNavbarController.$inject = ["I18n"];
	
	exports.default = CatalogNavbarController;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1074);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./catalog-navbar.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./catalog-navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".tabAppCarto catalog-navbar>ul{text-align:center;white-space:nowrap;width:100%}.tabAppCarto catalog-navbar>ul li{display:inline-block;position:relative;margin:0 1.5%;width:47%}.tabAppCarto catalog-navbar>ul li a{text-decoration:none;display:block;text-transform:uppercase;padding:.3em 1em;text-align:center;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-bottom:.3em}.tabAppCarto catalog-navbar>ul li a:before{content:\"\";z-index:0;width:100%;position:absolute;border-bottom:3px solid #000;left:0;bottom:0}.tabAppCarto catalog-navbar>ul li a.active,.tabAppCarto catalog-navbar>ul li a[aria-selected=true]{font-family:Renault Bold,Helvetica,Arial,sans-serif;text-overflow:inherit;padding:.3em 0}.tabAppCarto catalog-navbar>ul li a.active:before,.tabAppCarto catalog-navbar>ul li a[aria-selected=true]:before{border-bottom-color:#fc0}.tabAppCarto catalog-navbar>ul li a,.tabAppCarto catalog-navbar>ul li a.visited,.tabAppCarto catalog-navbar>ul li a:link{color:#aeaeaf}.tabAppCarto catalog-navbar>ul li a.active,.tabAppCarto catalog-navbar>ul li a:focus,.tabAppCarto catalog-navbar>ul li a:hover,.tabAppCarto catalog-navbar>ul li a[aria-selected=true],.tabAppCarto catalog-navbar>ul li a[aria-selected=true]:link,.tabAppCarto catalog-navbar>ul li a[aria-selected=true]:visited{color:#000}@media (min-width:500px){.tabAppCarto catalog-navbar>ul li{width:37%}}@media (min-width:600px){.tabAppCarto catalog-navbar>ul li{width:47.5%}}@media (min-width:600px){.tabAppCarto catalog-navbar>ul li a,.tabAppCarto catalog-navbar>ul li a[aria-selected=true]{font-family:Renault Regular,Helvetica,Arial,sans-serif;font-size:1.8em}}@media (min-width:600px){.tabAppCarto catalog-navbar>ul li a:before,.tabAppCarto catalog-navbar>ul li a[aria-selected=true]:before{border-bottom-width:4px}}@media (min-width:700px){.tabAppCarto catalog-navbar>ul li{margin:0 .5em;width:auto}.tabAppCarto catalog-navbar>ul li a[aria-selected=true]{padding:.3em 1em}}", ""]);
	
	// exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productCategories = __webpack_require__(1076);
	
	var _productCategories2 = _interopRequireDefault(_productCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('productCategories', []).component('productCategories', _productCategories2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productCategories = __webpack_require__(1077);
	
	var _productCategories2 = _interopRequireDefault(_productCategories);
	
	var _productCategories3 = __webpack_require__(1078);
	
	var _productCategories4 = _interopRequireDefault(_productCategories3);
	
	__webpack_require__(1079);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    categories: '<'
	  },
	  controller: _productCategories2.default,
	  template: _productCategories4.default
	};
	
	exports.default = component;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductCategoriesController = function () {
	  ProductCategoriesController.$inject = ["$state", "I18n"];
	  function ProductCategoriesController($state, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductCategoriesController);
	    this.$state = $state;
	    this.I18n = I18n;
	  }
	
	  (0, _createClass3.default)(ProductCategoriesController, [{
	    key: 'active',
	    value: function active(category) {
	      return this.$state.is('vehicle.catalog.appsAndServices', { category: category.ref.toLowerCase() });
	    }
	  }]);
	  return ProductCategoriesController;
	}();
	
	exports.default = ProductCategoriesController;

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"toggle\" ng-click=\"$ctrl.open = !$ctrl.open\"></button>\n<ul ng-class=\"{'open': $ctrl.open}\" class=\"mobile\" ng-click=\"$ctrl.open = !$ctrl.open\">\n  <li ng-repeat=\"category in $ctrl.categories | orderBy: 'weight' track by category.id\" ng-if=\"$ctrl.active(category)\">\n    <a role=\"tab\"\n       ui-sref=\"{{ category.sref }}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Apps & Services Categories', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n  <li ng-repeat=\"category in $ctrl.categories | orderBy: 'weight' track by category.id\" ng-if=\"!$ctrl.active(category)\">\n    <a role=\"tab\"\n       ui-sref=\"{{ category.sref }}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Apps & Services Categories', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n</ul>\n<ul ng-class=\"{'open': $ctrl.open, 'arabDirection':  $ctrl.I18n.isArLocale()}\" class=\"desktop\" ng-click=\"$ctrl.open = !$ctrl.open\">\n  <li ng-repeat=\"category in $ctrl.categories | orderBy: 'weight' track by category.id\">\n    <a role=\"tab\"\n       ui-sref=\"{{ category.sref }}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Apps & Services Categories', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n</ul>\n"

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1080);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./product-categories.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./product-categories.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:600px){manage-my-rlink-categories>ul.desktop,product-categories>ul.desktop{display:table}manage-my-rlink-categories>ul.mobile,product-categories>ul.mobile{display:none}}@media (max-width:600px){manage-my-rlink-categories>ul.desktop,product-categories>ul.desktop{display:none}}manage-my-rlink-categories>button.toggle,product-categories>button.toggle{position:absolute;top:20px;right:20px;color:#fff;z-index:999}manage-my-rlink-categories>button.toggle:after,product-categories>button.toggle:after{content:\"\\E618\";font-family:icon-Renault-Global;vertical-align:middle;font-size:.7em;display:inline-block}manage-my-rlink-categories>ul,product-categories>ul{overflow:visible}manage-my-rlink-categories>ul.open>li>a,product-categories>ul.open>li>a{display:block!important}manage-my-rlink-categories>ul>li,product-categories>ul>li{display:block}manage-my-rlink-categories>ul>li:first-child>a,product-categories>ul>li:first-child>a{border-top:none}manage-my-rlink-categories>ul>li>a,product-categories>ul>li>a{position:relative;display:none;background-color:#f3f3f3;text-align:center;font-size:1em;text-transform:uppercase;white-space:nowrap;padding:1.4em 1em;font-family:Renault Bold,Helvetica,Arial,sans-serif;overflow:visible;border-top:1px solid #fff;border-radius:.1em}manage-my-rlink-categories>ul>li>a:focus,manage-my-rlink-categories>ul>li>a:hover,product-categories>ul>li>a:focus,product-categories>ul>li>a:hover{text-decoration:underline}manage-my-rlink-categories>ul>li>a p,product-categories>ul>li>a p{text-decoration:none;text-overflow:ellipsis;overflow:hidden}manage-my-rlink-categories>ul>li>a,manage-my-rlink-categories>ul>li>a:link,manage-my-rlink-categories>ul>li a:visited,product-categories>ul>li>a,product-categories>ul>li>a:link,product-categories>ul>li a:visited{color:#000;text-decoration:none}manage-my-rlink-categories>ul>li>a.active,product-categories>ul>li>a.active{color:#fff;display:block;background-color:#262626}manage-my-rlink-categories>ul>li>a.active:before,product-categories>ul>li>a.active:before{content:\"\";position:absolute;bottom:-8px;left:50%;margin-left:-9px;width:0;height:0;border-style:solid;border-width:8px 9px 0;border-color:#262626 transparent transparent}@media (min-width:600px){manage-my-rlink-categories>button.toggle,product-categories>button.toggle{display:none}manage-my-rlink-categories>ul,product-categories>ul{display:table;width:100%;border-bottom:1px solid #a8a8a8;table-layout:fixed}manage-my-rlink-categories>ul>li,product-categories>ul>li{display:table-cell;text-align:center}manage-my-rlink-categories>ul>li[role=tabpanel],product-categories>ul>li[role=tabpanel]{position:absolute;left:0;top:0;z-index:0;width:100%}manage-my-rlink-categories>ul>li>a,product-categories>ul>li>a{display:block;border-top:none;font-size:1.2em;padding:.9em .8em;background-color:#f3f3f3}manage-my-rlink-categories>ul>li>a,manage-my-rlink-categories>ul>li>a:link,manage-my-rlink-categories>ul>li a:visited,product-categories>ul>li>a,product-categories>ul>li>a:link,product-categories>ul>li a:visited{color:#000}manage-my-rlink-categories>ul>li>a.active,manage-my-rlink-categories>ul>li>a[aria-selected=true],manage-my-rlink-categories>ul>li>a[aria-selected=true]:link,manage-my-rlink-categories>ul>li>a[aria-selected=true]:visited,product-categories>ul>li>a.active,product-categories>ul>li>a[aria-selected=true],product-categories>ul>li>a[aria-selected=true]:link,product-categories>ul>li>a[aria-selected=true]:visited{color:#fff;background-color:#262626}manage-my-rlink-categories>ul>li>a[aria-selected=false],product-categories>ul>li>a[aria-selected=false]{display:block}}", ""]);
	
	// exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productFilters = __webpack_require__(1082);
	
	var _productFilters2 = _interopRequireDefault(_productFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('productFilters', []).component('productFilters', _productFilters2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productFilters = __webpack_require__(1083);
	
	var _productFilters2 = _interopRequireDefault(_productFilters);
	
	var _productFilters3 = __webpack_require__(1084);
	
	var _productFilters4 = _interopRequireDefault(_productFilters3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    filter: '='
	  },
	  template: _productFilters2.default,
	  controller: _productFilters4.default
	};
	
	exports.default = component;

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter collapseBloc\" ng-class=\"{ 'active': $ctrl.displayFilter }\">\n  <button class=\"collapseBt dropDown\"\n    ng-click=\"$ctrl.displayFilter = !$ctrl.displayFilter\"\n    title=\"{{ 'common.clickToUnfoldMenu' | translate }}\"\n    ga-track-event=\"['My Catalog', 'Click', 'Show/Hide Filter']\">\n    {{ 'catalog.product.filter' | translate }}\n  </button>\n  <div class=\"collapse\" ng-hide=\"!$ctrl.displayFilter\" style=\"display: block;\">\n    <ul class=\"radioList\">\n      <li ng-repeat=\"filter in $ctrl.filters\" >\n        <label class=\"radio\" for=\"filter-{{filter}}\">\n          <input ng-model=\"$ctrl.filter\" value=\"{{filter}}\" name=\"filter\" type=\"radio\">\n          <span ng-click=\"$ctrl.handleChangeFilter(filter)\">{{ 'catalog.product.filters.' + filter | translate }}</span>\n        </label>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductFiltersController = function () {
	  ProductFiltersController.$inject = ["Localization"];
	  function ProductFiltersController(Localization) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductFiltersController);
	    this.displayFilter = false;
	    var freeProductsOnly = Localization.getLocalizedAppConfig().freeProductsOnly;
	    var filters = ['all'];
	    if (!freeProductsOnly) {
	      filters.push('paid', 'free');
	    }
	    filters.push('pack');
	    this.filters = filters;
	  }
	
	  (0, _createClass3.default)(ProductFiltersController, [{
	    key: 'handleChangeFilter',
	    value: function handleChangeFilter(filter) {
	      this.filter = filter;
	    }
	  }]);
	  return ProductFiltersController;
	}();
	
	exports.default = ProductFiltersController;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productTile = __webpack_require__(1086);
	
	var _productTile2 = _interopRequireDefault(_productTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('productTile', []).component('productTile', _productTile2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productTile = __webpack_require__(1087);
	
	var _productTile2 = _interopRequireDefault(_productTile);
	
	var _productTile3 = __webpack_require__(1088);
	
	var _productTile4 = _interopRequireDefault(_productTile3);
	
	__webpack_require__(1089);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    product: '<'
	  },
	  template: _productTile2.default,
	  controller: _productTile4.default
	};
	
	exports.default = component;

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.banner\" class=\"headband\">\n  <span>{{ $ctrl.banner | translate }}</span>\n</div>\n<span class=\"productTileIllustration\"><img ng-src=\"{{ $ctrl.illustration }}\" alt=\"{{ $ctrl.product.title }}\" fallback-src=\"/img/products/icon/sample.gif\"/></span>\n<a ng-if=\"!$ctrl.product.group\" ui-sref=\"vehicle.productDetails({ref: '{{$ctrl.product.ref}}'})\" class=\"infosProd\" ga-track-event=\"['My Catalog', 'Click', 'Product Details {{ $ctrl.product.title | escapeSingleQuote }}']\">\n  <span class=\"title\" title=\"{{ $ctrl.product.title }}\">{{ $ctrl.product.title }}</span>\n  <div class=\"price\">\n    <del ng-if=\"$ctrl.isPromotion\" class=\"crossout\">{{ $ctrl.product.price | price | translate }}</del>\n    <span class=\"cost\">{{ $ctrl.actualPrice | price | translate }}</span>\n  </div>\n</a>\n\n<div ng-if=\"$ctrl.product && $ctrl.product.group && $ctrl.shortGroup\" ng-repeat=\"item in $ctrl.product.group\">\n  <a ng-if=\"item.ref === $ctrl.product.ref\" ui-sref=\"vehicle.productDetails({ref: '{{item.ref}}', group: {{$ctrl.shortGroup}}})\" class=\"infosProd\" ga-track-event=\"['My Catalog', 'Click', 'Product Details {{ $ctrl.product.title | escapeSingleQuote }}']\">\n    <span class=\"title\" title=\"{{ $ctrl.product.title }}\">{{ $ctrl.product.title }}</span>\n    <div class=\"price\">\n      <span class=\"crossout\">{{ $ctrl.duration | translate: { duration: $ctrl.product.duration } }}</span>\n    </div>\n  </a>\n</div>\n\n<duration-price product=\"$ctrl.product\" on-duration-change=\"$ctrl.onUpdateDuration(item)\" ng-if=\"$ctrl.product && $ctrl.product.group\"></duration-price>\n<products-basket product=\"$ctrl.product\"></products-basket>\n"

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductTileController = function () {
	  ProductTileController.$inject = ["$state", "ProductUtilsService", "$log"];
	  function ProductTileController($state, ProductUtilsService, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductTileController);
	    this.$state = $state;
	    this.$log = $log;
	    this.productUtilsService = ProductUtilsService;
	    this.selected = false;
	  }
	
	  (0, _createClass3.default)(ProductTileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.product.group) {
	        this.shortGroup = [];
	        this.product.group.forEach(function (item) {
	          _this.shortGroup.push({ ref: item.ref, duration: item.duration });
	        });
	      }
	    }
	  }, {
	    key: 'onUpdateDuration',
	    value: function onUpdateDuration(item) {
	      this.selected = true;
	      var group = this.product.group;
	      this.product = (0, _assign2.default)({}, item);
	      this.product.group = group;
	    }
	  }, {
	    key: 'illustration',
	    get: function get() {
	      return this.productUtilsService.getIllustration(this.product);
	    }
	  }, {
	    key: 'banner',
	    get: function get() {
	      return this.productUtilsService.getBanner(this.product);
	    }
	  }, {
	    key: 'duration',
	    get: function get() {
	      return this.productUtilsService.getDuration(this.product, this.selected);
	    }
	  }, {
	    key: 'actualPrice',
	    get: function get() {
	      return this.productUtilsService.getActualPrice(this.product);
	    }
	  }, {
	    key: 'isPromotion',
	    get: function get() {
	      return this.productUtilsService.isPromotion(this.product);
	    }
	  }]);
	  return ProductTileController;
	}();
	
	exports.default = ProductTileController;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1090);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./product-tile.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./product-tile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "product-tile{display:inline-block;max-width:170px}product-tile img{max-width:100%;padding:2px}product-tile a.infosProd span{overflow:hidden;text-overflow:ellipsis}product-tile a.infosProd .title{height:2.4em;font-size:.8em;line-height:.8em;display:-webkit-box;-webkit-line-clamp:3}product-tile .productTileIllustration{-webkit-border-top-left-radius:.2em;-webkit-border-top-right-radius:.2em;-moz-border-radius-topleft:.2em;-moz-border-radius-topright:.2em;border-top-left-radius:.2em;border-top-right-radius:.2em;background-color:#000;display:block;position:relative}product-tile .productTileIllustration img{position:relative;top:50%;transform:translateY(-50%)}@media (min-width:300px){product-tile .productTileIllustration{width:115px;height:86px}product-tile a.infosProd span{line-height:1em;height:2em;max-width:100px}}@media (min-width:650px){product-tile .productTileIllustration{width:170px;height:127px}product-tile a.infosProd span{max-width:170px}product-tile a.infosProd .title{height:2em;font-size:1em;line-height:1em;-webkit-line-clamp:2}}product-tile .headband{display:block;z-index:1}product-tile .headband span{left:.5em;top:1.5em}@media (min-width:650px){product-tile .headband span{left:-7px;top:18px}}", ""]);
	
	// exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _products = __webpack_require__(1092);
	
	var _products2 = _interopRequireDefault(_products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('products', []).component('products', _products2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _products = __webpack_require__(1093);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _products3 = __webpack_require__(1094);
	
	var _products4 = _interopRequireDefault(_products3);
	
	__webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    category: '<',
	    filter: '<'
	  },
	  template: _products2.default,
	  controller: _products4.default
	};
	
	exports.default = component;

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-error error=\"$ctrl.error\" title=\"product.errors.fetch\"></app-error>\n<p class=\"noProduct\" ng-if=\"!$ctrl.pages || $ctrl.pages.length === 0\">{{ 'catalog.product.no_product' | translate }}</p>\n<div ng-if=\"!$ctrl.error && $ctrl.pages && $ctrl.pages.length > 0\" class=\"product-pages\">\n  <ul rn-carousel rn-carousel-index=\"$ctrl.pageIndex\">\n    <li ng-repeat=\"page in $ctrl.pages\" class=\"products\" ng-show=\"$ctrl.pageIndex === $index\">\n      <ul>\n        <li ng-repeat=\"product in page track by product.ref\">\n          <product-tile product=\"product\"></product-tile>\n        </li>\n      </ul>\n    </li>\n  </ul>\n  <div class=\"rn-carousel-controls\">\n    <span class=\"rn-carousel-control rn-carousel-control-prev\" ng-click=\"$ctrl.previousIndex()\" ng-if=\"$ctrl.pageIndex > 0 || false\"></span>\n    <span class=\"rn-carousel-control rn-carousel-control-next\" ng-click=\"$ctrl.nextIndex()\" ng-if=\"$ctrl.pageIndex < $ctrl.pages.length - 1 || false\"></span>\n  </div>\n  <div class=\"indicators\" rn-carousel-indicators ng-if=\"$ctrl.pages.length > 1\" slides=\"$ctrl.pages\" rn-carousel-index=\"$ctrl.pageIndex\"></div>\n</div>\n"

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(1095);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsController = function () {
	  ProductsController.$inject = ["ProductService", "VehicleService", "DeviceService", "MetricsService", "I18n", "$scope", "$log", "$timeout", "$state", "$rootScope"];
	  function ProductsController(ProductService, VehicleService, DeviceService, MetricsService, I18n, $scope, $log, $timeout, $state, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductsController);
	    this.isProcessing = true;
	    this.vehicleService = VehicleService;
	    this.productService = ProductService;
	    this.deviceService = DeviceService;
	    this.metricsService = MetricsService;
	    this.i18n = I18n;
	    this.$log = $log;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this._filter = 'all';
	
	    $scope.$on('width:resized', function () {
	      $log.debug('width resized fired');
	      $timeout(function () {
	        $state.reload();
	      });
	    });
	
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(ProductsController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	        if (!vehicle) {
	          _this.$log.error('Unable to get current selected vehicle.');
	          return _promise2.default.reject('Unable to get current selected vehicle.');
	        }
	        _this.vehicle = vehicle;
	        _this.fetchProducts();
	      });
	    }
	  }, {
	    key: 'fetchProducts',
	    value: function fetchProducts() {
	      var _this2 = this;
	
	      if (!this.category || !this.vehicle) {
	        return null;
	      }
	      this.isProcessing = true;
	      var params = {
	        locale: this.i18n.getLanguage(),
	        category: this.category.id,
	        filter: this.filter,
	        vin: this.vehicle.vin,
	        devicename: this.vehicle.deviceName,
	        deviceversion: this.vehicle.deviceVersion,
	        nbItemPerPage: 1000,
	        page: 1,
	        order: 'asc'
	      };
	      this.productService.getProducts(params).then(function (products) {
	        var nbItemPerPage = _this2.nbItemPerPage;
	        var _products = products.items.map(function (product) {
	          if (product.group) {
	            product.group = product.group.sort(function (a, b) {
	              return parseFloat(a.price.slice(0, -4)) - parseFloat(b.price.slice(0, -4));
	            });
	            var group = product.group;
	            product = (0, _assign2.default)({}, product.group[0]);
	            product.group = group;
	          }
	          return (0, _extends3.default)({}, product, {
	            sref: 'product.detail({id: \'' + product.id + '\'})'
	          });
	        });
	        var pages = [];
	        while (_products.length > 0) {
	          var chunk = _products.splice(0, nbItemPerPage);
	          pages.push(chunk);
	        }
	        _this2.pages = pages;
	        _this2.isProcessing = false;
	        _this2.error = null;
	        _this2.safeApply();
	        return _this2.metricsService.endPageLoadTime(200);
	      }, function (err) {
	        _this2.isProcessing = false;
	        _this2.$log.error(err);
	        _this2.error = err;
	        _this2.safeApply();
	        return _this2.metricsService.endPageLoadTime(500);
	      });
	    }
	  }, {
	    key: 'previousIndex',
	    value: function previousIndex() {
	      this.hideProductDurationTooltip();
	      this.pageIndex--;
	    }
	  }, {
	    key: 'nextIndex',
	    value: function nextIndex() {
	      this.hideProductDurationTooltip();
	      this.pageIndex++;
	    }
	  }, {
	    key: 'hideProductDurationTooltip',
	    value: function hideProductDurationTooltip() {
	      this.$rootScope.$broadcast('productDurationTooltip:closed');
	      (0, _jquery2.default)('products .product-pages > ul').css('overflow', 'hidden');
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'nbItemPerPage',
	    get: function get() {
	      if (this.deviceService.isSmallScreen()) {
	        return 4;
	      } else if (this.deviceService.isMediumScreen()) {
	        return 6;
	      }
	      return 8;
	    }
	  }, {
	    key: 'filter',
	    set: function set(filter) {
	      this.pageIndex = 0;
	      if (this._filter !== filter) {
	        this._filter = filter;
	        if (this.category) {
	          this.fetchProducts();
	        }
	      }
	    },
	    get: function get() {
	      return this._filter;
	    }
	  }, {
	    key: 'category',
	    set: function set(category) {
	      if (!this._category || this._category.id !== category.id) {
	        this._category = category;
	        this.fetchProducts();
	      }
	    },
	    get: function get() {
	      return this._category;
	    }
	  }]);
	  return ProductsController;
	}();
	
	exports.default = ProductsController;

/***/ }),
/* 1095 */,
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1097);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./products.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./products.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "products .products>ul{overflow:visible}products .product-pages>ul{height:24.5em;overflow:hidden}@media (min-width:650px){products .product-pages>ul{height:33em}}products .product-pages .indicators{text-align:center}products .product-pages .indicators span{font-size:1.5em;padding:.1em;color:#cdcdcd;display:inline-block}products .product-pages .indicators span.active{color:#fc3}products .product-pages .rn-carousel-indicator span{color:#cdcdcd;font-size:1.5em}products .product-pages .rn-carousel-indicator span.active{color:#ffd949}products .product-pages .rn-carousel-control-prev{left:-.5em}products .product-pages .rn-carousel-control-next{right:-.2em}products .product-pages .rn-carousel-control-prev:before{content:\"\"!important;background:url(\"/img/previous.png\") no-repeat 0 0;display:block;width:100px;height:100px}products .product-pages .rn-carousel-control-next:before{content:\"\"!important;background:url(\"/img/next.png\") no-repeat 0 0;display:block;width:100px;height:100px}products .product-pages .rn-carousel-control{top:47%}@media (max-width:1000px){products .product-pages .rn-carousel-control{display:none}}@media (min-width:1000px){products .product-pages>ul{z-index:5;width:90%;left:42px}}", ""]);
	
	// exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _productsBasket = __webpack_require__(1099);
	
	var _productsBasket2 = _interopRequireDefault(_productsBasket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('productsBasket', [_angularUiRouter2.default]).component('productsBasket', _productsBasket2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productsBasket = __webpack_require__(1100);
	
	var _productsBasket2 = _interopRequireDefault(_productsBasket);
	
	var _productsBasket3 = __webpack_require__(1101);
	
	var _productsBasket4 = _interopRequireDefault(_productsBasket3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    product: '<'
	  },
	  template: _productsBasket2.default,
	  controller: _productsBasket4.default
	};
	
	exports.default = component;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = "<button ng-if=\"$ctrl.loaded && $ctrl.label && $ctrl.isBuyable\" class=\"basket\" title=\"{{ $ctrl.label | translate}}\" ng-click=\"$ctrl.goPurchase()\" ga-track-event=\"['My Catalog', 'Click', '{{ $ctrl.label | translate | escapeSingleQuote }} _ {{ $ctrl.product.title | escapeSingleQuote }}']\">\n  <img src=\"{{ $ctrl.icon }}\" alt=\"/img/basket.png\"/>\n</button>\n"

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsBasketController = function () {
	  ProductsBasketController.$inject = ["$state", "ProductUtilsService", "VehicleService", "ProductService", "$log"];
	  function ProductsBasketController($state, ProductUtilsService, VehicleService, ProductService, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductsBasketController);
	    this.$state = $state;
	    this.productUtilsService = ProductUtilsService;
	    this.vehicleService = VehicleService;
	    this.productService = ProductService;
	    this.$log = $log;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(ProductsBasketController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.isBuyable = false;
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (v) {
	        if (!v) {
	          return _promise2.default.reject('Unable to get current selected vehicle');
	        }
	        _this.vehicle = v;
	        if (_this.product.infoCode === 7 && _this.productUtilsService.isContent(_this.product)) {
	          return _this.productService.getIsPreviouslyInstalled(_this.product.ref, _this.vehicle.vin);
	        } else {
	          return _promise2.default.resolve(false);
	        }
	      }).then(function (userOwnLastestVersion) {
	        if (userOwnLastestVersion) {
	          _this.infoCode = 0;
	        }
	        _this.isBuyable = _this.productUtilsService.isBuyable(_this.product, _this.vehicle, userOwnLastestVersion);
	        _this.isProcessing = false;
	        return _promise2.default.resolve();
	      }, function (err) {
	        _this.$log.error(err);
	        _this.error = err;
	        _this.isProcessing = false;
	        return _promise2.default.reject();
	      });
	    }
	  }, {
	    key: 'goPurchase',
	    value: function goPurchase() {
	      var _this2 = this;
	
	      var productId = this.product.ref;
	      return this.checkDeviceTotalSpace().then(function () {
	        if (_this2.spaceWarning) {
	          return _this2.$state.go('vehicle.productDetails', { ref: productId });
	        } else {
	          return _this2.$state.go('managePurchase.myPurchase', { productId: productId });
	        }
	      });
	    }
	  }, {
	    key: 'checkDeviceTotalSpace',
	    value: function checkDeviceTotalSpace() {
	      var _this3 = this;
	
	      console.log('VIN = ' + this.vehicle.vin);
	      console.log('MUS packageNameMus: ' + this.product.packageNameMus);
	      if (this.product.tomtomId && (this.product.tomtomId.substring(0, 4) === 'map/' || this.product.tomtomId.substring(0, 11) === 'mappackage_')) {
	        console.log('Map ' + this.product.ref + ' has tomtomId = ' + this.product.tomtomId);
	        return this.productService.checkIfMapIsInstallable(this.vehicle.vin, this.product.ref).then(function (response) {
	          console.log('This map is installable: ' + response);
	          if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
	            // console.log('This map is not installable because no mount is big enough for this map')
	            _this3.spaceWarning = true;
	          }
	          return _promise2.default.resolve();
	        });
	      } else if (this.product.packageNameMus && (this.product.packageNameMus.substring(0, 4) === 'map/' || this.product.packageNameMus.substring(0, 11) === 'mappackage_')) {
	        console.log('MUS ' + this.product.ref + ' has packageNameMus = ' + this.product.packageNameMus);
	        return this.productService.checkIfLatestMapIsInstallable(this.vehicle.vin, this.product.ref).then(function (response) {
	          console.log('The latest map available is installable: ' + response);
	          if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
	            // console.log('The latest map available is not installable because no mount is big enough for this map')
	            _this3.spaceWarning = true;
	          }
	          return _promise2.default.resolve();
	        });
	      } else {
	        this.spaceWarning = false;
	        return _promise2.default.resolve();
	      }
	    }
	  }, {
	    key: 'icon',
	    get: function get() {
	      if (this.label === 'productDetails.renew' || this.label === 'productDetails.extend') {
	        return '/img/car.png';
	      } else {
	        return '/img/basket.png';
	      }
	    }
	  }, {
	    key: 'label',
	    get: function get() {
	      return this.productUtilsService.getButtonLabel(this.product);
	    }
	  }]);
	  return ProductsBasketController;
	}();
	
	exports.default = ProductsBasketController;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _durationPrice = __webpack_require__(1103);
	
	var _durationPrice2 = _interopRequireDefault(_durationPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('durationPrice', [_angularUiRouter2.default]).component('durationPrice', _durationPrice2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _durationPrice = __webpack_require__(1104);
	
	var _durationPrice2 = _interopRequireDefault(_durationPrice);
	
	var _durationPrice3 = __webpack_require__(1105);
	
	var _durationPrice4 = _interopRequireDefault(_durationPrice3);
	
	__webpack_require__(1106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    product: '<',
	    onDurationChange: '&'
	  },
	  template: _durationPrice2.default,
	  controller: _durationPrice4.default
	};
	
	exports.default = component;

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"tooltipPrice\">\n  <button class=\"cost\" ng-click=\"$ctrl.onClickCostButton()\" ng-if=\"$ctrl.price\">{{ $ctrl.price | price | translate}}</button>\n  <div class=\"tooltipCostChoice\" ng-class=\"{'active': $ctrl.showTooltip}\">\n    <ul>\n      <li ng-repeat=\"item in $ctrl.product.group\">\n        <input id=\"product-{{item.ref}}-{{item.duration}}\" tabindex=\"-1\" name=\"cost\" type=\"radio\" value=\"item.duration\" ng-click=\"$ctrl.selected = item\">\n        <label for=\"product-{{item.ref}}-{{item.duration}}\" tabindex=\"0\">{{ $ctrl.duration(item) | translate: { duration: item.duration } }} - {{ item.price | price | translate }}</label>\n      </li>\n    </ul>\n    <button type=\"submit\" ng-click=\"$ctrl.onProductSelected()\"><img src=\"img/basket.png\" alt=\"{{ 'catalog.product.duration.select' | translate }}\">{{ 'catalog.product.duration.select' | translate }}</button>\n  </div>\n</div>\n"

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DurationPriceController = function () {
	  DurationPriceController.$inject = ["ProductUtilsService", "$rootScope", "$scope"];
	  function DurationPriceController(ProductUtilsService, $rootScope, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DurationPriceController);
	    this.productUtilsService = ProductUtilsService;
	    this.showTooltip = false;
	    this.$rootScope = $rootScope;
	    $scope.$on('productDurationTooltip:closed', function (event, data) {
	      _this.showTooltip = false;
	    });
	  }
	
	  (0, _createClass3.default)(DurationPriceController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.price = this.productUtilsService.getActualPrice(this.product);
	      this.item = this.product.group[0];
	    }
	  }, {
	    key: 'onClickCostButton',
	    value: function onClickCostButton(event) {
	      var show = this.showTooltip;
	      this.$rootScope.$broadcast('productDurationTooltip:closed');
	      this.showTooltip = !show;
	      (0, _jquery2.default)('products .product-pages > ul').css('overflow', this.showTooltip ? 'visible' : 'hidden');
	    }
	  }, {
	    key: 'onProductSelected',
	    value: function onProductSelected() {
	      if (this.selected) {
	        this.price = this.selected.price;
	        this.onDurationChange({ item: this.selected });
	        this.showTooltip = false;
	        (0, _jquery2.default)('products .product-pages > ul').css('overflow', 'hidden');
	      }
	    }
	  }, {
	    key: 'duration',
	    value: function duration(product) {
	      return this.productUtilsService.getDuration(product, true);
	    }
	  }]);
	  return DurationPriceController;
	}();
	
	exports.default = DurationPriceController;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1107);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./duration-price.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./duration-price.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "duration-price .tooltipCostChoice>ul{overflow:visible;overflow:hidden;position:absolute;bottom:4.2em;left:0;width:100%}duration-price .tooltipCostChoice>ul>li:first-child label:after,duration-price .tooltipCostChoice>ul>li:first-child label:before{display:none;position:absolute;content:\"\";width:0;height:0;border-style:solid}duration-price .tooltipCostChoice>ul>li:first-child label:after{top:-15px;left:30px;border-width:0 15px 15px;border-color:transparent transparent #e2e3e5}duration-price .tooltipCostChoice>ul>li:first-child label:before{top:-16px;left:29px;border-width:0 16px 16px;border-color:transparent transparent #9f9f9f}duration-price .tooltipCostChoice>ul>li{position:relative;display:block;margin-bottom:1px;width:100%;background-color:#fff;background-color:hsla(0,0%,100%,.95)}duration-price .tooltipCostChoice>ul>li:first-child{border-top:none}duration-price .tooltipCostChoice>ul>li:first-child,duration-price .tooltipCostChoice>ul>li:first-child label{-webkit-border-top-right-radius:.3em;-webkit-border-top-left-radius:.3em;-moz-border-radius-topright:.3em;-moz-border-radius-topleft:.3em;border-top-right-radius:.3em;border-top-left-radius:.3em}duration-price .tooltipCostChoice>ul>li:last-child,duration-price .tooltipCostChoice>ul>li:last-child label{-webkit-border-bottom-right-radius:.3em;-webkit-border-bottom-left-radius:.3em;-moz-border-radius-bottomright:.3em;-moz-border-radius-bottomleft:.3em;border-bottom-right-radius:.3em;border-bottom-left-radius:.3em}duration-price button[type=submit]{position:absolute;bottom:.4em;left:0;margin:0;z-index:1;min-width:auto;padding:.5em;border-radius:.3em}duration-price button[type=submit]:after{display:none}duration-price button[type=submit] img{width:2.8em;height:auto;vertical-align:middle}@media (min-width:600px){duration-price .tooltipCostChoice button[type=submit]{left:auto!important}}@media (min-width:600px){duration-price .tooltipCostChoice>ul{overflow:visible;position:relative;bottom:inherit;left:inherit;width:auto}duration-price .tooltipCostChoice>ul>li{border-top:1px solid #656364;background-color:transparent;margin:0}}@media (min-width:600px){duration-price .tooltipCostChoice>ul>li:first-child,duration-price .tooltipCostChoice>ul>li:first-child label{-webkit-border-top-right-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-top-left-radius:0}}@media (min-width:600px){duration-price .tooltipCostChoice>ul>li:last-child,duration-price .tooltipCostChoice>ul>li:last-child label{-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;border-bottom-right-radius:0;border-bottom-left-radius:0}}@media (min-width:600px){duration-price .tooltipCostChoice>ul>li:first-child label:after,duration-price .tooltipCostChoice>ul>li:first-child label:before{display:block}}.products duration-price button.cost{width:6.7em;overflow:hidden;text-overflow:ellipsis}", ""]);
	
	// exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _catalogContent = __webpack_require__(1109);
	
	var _catalogContent2 = _interopRequireDefault(_catalogContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('catalog.content', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.catalog.maps', {
	    url: '/maps/:category',
	    component: 'catalogContent',
	    params: {
	      category: 'maps'
	    },
	    authenticate: true
	  });
	  $stateProvider.state('vehicle.catalog.appsAndServices', {
	    url: '/app-and-services/:category',
	    component: 'catalogContent',
	    params: {
	      category: 'essentials'
	    },
	    authenticate: true
	  });
	}]).component('catalogContent', _catalogContent2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _catalogContent = __webpack_require__(1110);
	
	var _catalogContent2 = _interopRequireDefault(_catalogContent);
	
	var _catalogContent3 = __webpack_require__(1111);
	
	var _catalogContent4 = _interopRequireDefault(_catalogContent3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _catalogContent2.default,
	  controller: _catalogContent4.default
	};
	
	exports.default = component;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n\n<catalog-navbar></catalog-navbar>\n<div class=\"tabClassic card\" role=\"tabpanel\" >\n  <product-categories categories=\"$ctrl.categories\"></product-categories>\n  <div role=\"tabpanel\">\n    <product-filters filter=\"$ctrl.filter\" ng-if=\"$ctrl.catalogType !== 'maps'\"></product-filters>\n    <products category=\"$ctrl.category\" filter=\"$ctrl.filter\" ng-if=\"$ctrl.category\"></products>\n  </div>\n</div>\n"

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(1095);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogContentController = function () {
	  CatalogContentController.$inject = ["VehicleService", "ProductService", "$state", "$stateParams", "$q"];
	  function CatalogContentController(VehicleService, ProductService, $state, $stateParams, $q) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, CatalogContentController);
	    this.catalogType = $state.current.name.split('.')[2];
	    this.categoryRef = $stateParams.category.toUpperCase();
	    this.isProcessing = true;
	    this.filter = 'all';
	    this.categories = [];
	
	    VehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	      // Get the current vehicle or the first in list if not set
	      if (!vehicle) {
	        return _promise2.default.reject();
	      }
	      return ProductService.getProductCategories();
	    }).then(function (categories) {
	      _this.categories = categories.filter(function (category) {
	        // Filter categories regarding the type
	        if (_this.catalogType === 'maps') {
	          return category.ref.match(/^maps/i);
	        } else {
	          return category.ref.match(/^essentials/i) || category.ref.match(/^tools/i) || category.ref.match(/^news/i) || category.ref.match(/^games/i);
	        }
	      }).map(function (category) {
	        return (0, _extends3.default)({}, category, {
	          sref: 'vehicle.catalog.' + _this.catalogType + '({category: \'' + category.ref.toLowerCase() + '\'})',
	          label: 'catalog.product.category.' + category.ref.toLowerCase(),
	          weight: _this.setCategoryWeight(category.ref)
	        });
	      });
	      _this.error = null;
	      _this.isProcessing = false;
	    }, function (err) {
	      _this.isProcessing = false;
	      _this.error = err;
	    });
	  }
	
	  (0, _createClass3.default)(CatalogContentController, [{
	    key: 'setCategoryWeight',
	    value: function setCategoryWeight(categoryRef) {
	      switch (true) {
	        case /^essentials/i.test(categoryRef):
	          return 1;
	        case /^tools/i.test(categoryRef):
	          return 2;
	        case /^news/i.test(categoryRef):
	          return 3;
	        case /^games/i.test(categoryRef):
	          return 4;
	        default:
	          return 0;
	      }
	    }
	  }, {
	    key: 'category',
	    get: function get() {
	      var _this2 = this;
	
	      return this.categories.find(function (cat) {
	        return cat.ref === _this2.categoryRef;
	      });
	    }
	  }]);
	  return CatalogContentController;
	}();
	
	exports.default = CatalogContentController;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _manageMyRlink = __webpack_require__(1113);
	
	var _manageMyRlink2 = _interopRequireDefault(_manageMyRlink);
	
	var _myPurchaseRecords = __webpack_require__(1117);
	
	var _myPurchaseRecords2 = _interopRequireDefault(_myPurchaseRecords);
	
	var _myUpdates = __webpack_require__(1123);
	
	var _myUpdates2 = _interopRequireDefault(_myUpdates);
	
	var _components = __webpack_require__(1141);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('manageMyRlink', [_angularUiRouter2.default, _components2.default, _myPurchaseRecords2.default, _myUpdates2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.manageMyRlink', {
	    url: '/manage',
	    component: 'manageMyRlink',
	    redirectTo: 'vehicle.manageMyRlink.myPurchaseRecords',
	    authenticate: true
	  });
	}]).component('manageMyRlink', _manageMyRlink2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _manageMyRlink = __webpack_require__(1114);
	
	var _manageMyRlink2 = _interopRequireDefault(_manageMyRlink);
	
	__webpack_require__(1115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _manageMyRlink2.default
	};
	
	exports.default = component;

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent classicArea withNav\">\n  <navbar></navbar>\n  <div class=\"limitContent\">\n    <rlink-apps-status></rlink-apps-status>\n    <section class=\"rlinkManage\">\n      <h2>\n        {{ 'manageMyRlink.title' | translate }}\n      </h2>\n      <div class=\"tabAppCarto\">\n        <div id=\"panelApps\" class=\"tabApp tabClassic card\">\n          <manage-my-rlink-categories></manage-my-rlink-categories>\n          <ui-view />\n        </div>\n      </div>\n      <help-block></help-block>\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1116);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./manage-my-rlink.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./manage-my-rlink.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "manage-my-rlink app-message p{margin-top:-.1em}", ""]);
	
	// exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myPurchaseRecords = __webpack_require__(1118);
	
	var _myPurchaseRecords2 = _interopRequireDefault(_myPurchaseRecords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myPurchaseRecords', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.manageMyRlink.myPurchaseRecords', {
	    url: '/history',
	    component: 'myPurchaseRecords',
	    authenticate: true
	  });
	}]).component('myPurchaseRecords', _myPurchaseRecords2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myPurchaseRecords = __webpack_require__(1119);
	
	var _myPurchaseRecords2 = _interopRequireDefault(_myPurchaseRecords);
	
	var _myPurchaseRecords3 = __webpack_require__(1120);
	
	var _myPurchaseRecords4 = _interopRequireDefault(_myPurchaseRecords3);
	
	__webpack_require__(1121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myPurchaseRecords2.default,
	  controller: _myPurchaseRecords4.default
	};
	
	exports.default = component;

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\"></app-message>\n\n<div id=\"panelHistory\" class=\"tabHistory\" aria-labelledby=\"History\" role=\"tabpanel\" aria-hidden=\"false\" aria-expanded=\"true\">\n  <div class=\"historical\">\n    <p ng-if=\"$ctrl.records.length === 0\">{{ 'purchase-record.nothing' | translate }}</p>\n    <ul>\n      <li ng-repeat=\"record in $ctrl.records\" >\n        <purchase-record record=\"record\"></purchase-record>\n      </li>\n    </ul>\n    <a href=\"#\"\n       ng-if=\"$ctrl.isMore\"\n       class=\"button link\"\n       ng-click=\"$ctrl.more()\"\n       ga-track-event=\"['My Purchase Records', 'Click', 'More']\">\n       <span>{{ 'purchase-record.seeMore' | translate }}</span>\n    </a>\n  </div>\n</div>\n"

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPurchaseRecordsController = function () {
	  MyPurchaseRecordsController.$inject = ["SubscriptionService", "VehicleService", "$scope", "$rootScope", "MetricsService"];
	  function MyPurchaseRecordsController(SubscriptionService, VehicleService, $scope, $rootScope, MetricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyPurchaseRecordsController);
	    this.subscriptionService = SubscriptionService;
	    this.vehicleService = VehicleService;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	
	    this.records = [];
	    this.page = 1;
	    this.nbItemPerPage = 4;
	    this.isMore = false;
	    this.isProcessing = true;
	    this.metricsService = MetricsService;
	
	    // Async loading...
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyPurchaseRecordsController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (v) {
	        if (!v) {
	          return _promise2.default.reject();
	        }
	        _this.vehicle = v;
	        var params = {
	          vin: v.vin,
	          page: _this.page,
	          nbItemPerPage: _this.nbItemPerPage
	        };
	        return _this.subscriptionService.getSubscriptions(params);
	      }).then(function (res) {
	        _this.isProcessing = false;
	        _this.error = null;
	        _this.records = _this.records.concat(res.subscriptions);
	        _this.total = res.total;
	        _this.isMore = _this.records.length < _this.total;
	        _this.safeApply();
	        return _promise2.default.resolve(_this.records);
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.error = {
	          message: 'purchase-record.error',
	          cause: err
	        };
	        _this.safeApply();
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'more',
	    value: function more() {
	      this.isProcessing = true;
	      this.page++;
	      this.init();
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }]);
	  return MyPurchaseRecordsController;
	}();
	
	exports.default = MyPurchaseRecordsController;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1122);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-purchase-records.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-purchase-records.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "a.button.link{padding:.75em 2.5em .7em;margin:0!important;text-align:center}a.button.link:after{color:#fc3!important}div.tabHistory div.historical{padding-bottom:0!important}div.tabHistory div.historical p{text-align:center;margin:1.5em}", ""]);
	
	// exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myUpdates = __webpack_require__(1124);
	
	var _myUpdates2 = _interopRequireDefault(_myUpdates);
	
	var _myUpdatesTab = __webpack_require__(1128);
	
	var _myUpdatesTab2 = _interopRequireDefault(_myUpdatesTab);
	
	var _myDevicesTab = __webpack_require__(1132);
	
	var _myDevicesTab2 = _interopRequireDefault(_myDevicesTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myUpdates', [_angularUiRouter2.default, _myUpdatesTab2.default, _myDevicesTab2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.manageMyRlink.myUpdates', {
	    url: '/updates',
	    component: 'myUpdates',
	    redirectTo: 'vehicle.manageMyRlink.myUpdates.myUpdatesTab',
	    authenticate: true
	  });
	}]).component('myUpdates', _myUpdates2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myUpdates = __webpack_require__(1125);
	
	var _myUpdates2 = _interopRequireDefault(_myUpdates);
	
	__webpack_require__(1126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myUpdates2.default
	};
	
	exports.default = component;

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	module.exports = "<ui-view>\n"

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1127);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-updates.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./my-updates.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "a.button.link{border-top:2px solid #aaa;padding:.75em 2.5em .7em;margin:0!important;text-align:center}a.button.link:after{color:#fc3!important}div.tabUpdates div.historical{padding-bottom:0!important}div.tabUpdates div.historical p.manageMyProducts,div.tabUpdates div.historical p.noUpdate{text-align:center;padding:1em}div.tabUpdates div.historical p.manageMyProducts a.button:after,div.tabUpdates div.historical p.noUpdate a.button:after{top:50%;margin-top:-.75em}my-devices-tab p.description{padding:.5em}my-devices-tab a.button.back{background-color:#fc0!important;text-align:center!important;margin:.5em!important;display:inline-block;width:auto}@media (min-width:600px){my-devices-tab a.button.back{padding:.7em 2em}my-devices-tab a.button.back.mobile{display:none}}.hideBox{display:none}.brakeLine{clear:both;display:block}.leftBtn{float:right;padding:1.3em}", ""]);
	
	// exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myUpdatesTab = __webpack_require__(1129);
	
	var _myUpdatesTab2 = _interopRequireDefault(_myUpdatesTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myUpdatesTab', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.manageMyRlink.myUpdates.myUpdatesTab', {
	    component: 'myUpdatesTab',
	    authenticate: true
	  });
	}]).component('myUpdatesTab', _myUpdatesTab2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myUpdatesTab = __webpack_require__(1130);
	
	var _myUpdatesTab2 = _interopRequireDefault(_myUpdatesTab);
	
	var _myUpdatesTab3 = __webpack_require__(1131);
	
	var _myUpdatesTab4 = _interopRequireDefault(_myUpdatesTab3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myUpdatesTab2.default,
	  controller: _myUpdatesTab4.default
	};
	
	exports.default = component;

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.info\"></app-message>\n\n<div id=\"panelUpdates\" class=\"tabUpdates\" aria-labelledby=\"Updates\" role=\"tabpanel\" aria-hidden=\"false\" aria-expanded=\"true\">\n  <div class=\"historical upd\">\n    <p class=\"noUpdate\" ng-if=\"$ctrl.items.length === 0\">{{ 'my-updates.no_updates' | translate }}</p>\n    <ul ng-if=\"$ctrl.items.length > 0\">\n      <li ng-repeat=\"item in $ctrl.items\" >\n        <update-item item=\"item\" on-update-click=\"$ctrl.askForUpdate(item)\"></update-item>\n      </li>\n    </ul>\n    <p class=\"updateAll\" ng-if=\"$ctrl.items.length > 0\">\n      <a href=\"#\" ng-click=\"$ctrl.askForUpdate()\" class=\"button\" ga-track-event=\"['My Updates', 'Click', 'Update All Items']\">\n        <span>\n          {{ 'my-updates.button.ask_for_update_all' | translate }}\n        </span>\n      </a>\n    </p>\n    <p class=\"manageMyProducts\" ng-if=\"!$ctrl.isProcessing\">\n      <a ui-sref=\"vehicle.manageMyRlink.myUpdates.myDevicesTab({vin: '{{$ctrl.vehicle.vin}}'})\" class=\"button\" ga-track-event=\"['My Updates', 'Click', 'Manage my products']\">\n        <span>\n          {{ 'my-updates.button.manage_my_products' | translate }}\n        </span>\n      </a>\n    </p>\n    <a ui-sref=\"installation\" class=\"button link\" ga-track-event=\"['My Updates', 'Click', 'Know More']\">\n      <span>\n        {{ 'my-updates.more_infos' | translate }}\n      </span>\n    </a>\n  </div>\n</div>\n"

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MY_UPDATES_INFO_PREFIX = 'hideMyUpdatesInfo';
	
	var MyUpdatesTabController = function () {
	  MyUpdatesTabController.$inject = ["$log", "ProductService", "VehicleService", "$state", "$scope", "$rootScope", "$window", "MetricsService"];
	  function MyUpdatesTabController($log, ProductService, VehicleService, $state, $scope, $rootScope, $window, MetricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyUpdatesTabController);
	    this.productService = ProductService;
	    this.vehicleService = VehicleService;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	
	    this.items = [];
	    this.isProcessing = true;
	
	    this.$log = $log;
	    this.metricsService = MetricsService;
	    // Async loading...
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyUpdatesTabController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (v) {
	        if (!v) {
	          return _promise2.default.reject();
	        }
	        _this.vehicle = v;
	        _this.$log.debug('getProductsToUpdate');
	        _this.myUpdatesInfo();
	        return _this.productService.getProductsToUpdate(v.vin);
	      }).then(function (res) {
	        _this.isProcessing = false;
	        _this.error = null;
	        _this.items = _this.items.concat(res);
	        _this.safeApply();
	        return _promise2.default.resolve(_this.items);
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.error = {
	          message: 'my-updates.error',
	          cause: err
	        };
	        _this.safeApply();
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'askForUpdate',
	    value: function askForUpdate(item) {
	      var _this2 = this;
	
	      this.success = null;
	      this.isProcessing = true;
	      var ref = item ? item.ref : null;
	      return this.productService.updateProducts(this.vehicle.vin, ref).then(function (res) {
	        _this2.error = null;
	        _this2.isProcessing = false;
	        return _this2.$state.go('installation', { success: 'my-updates.update_success' });
	      }, function (err) {
	        _this2.isProcessing = false;
	        _this2.error = {
	          message: 'my-updates.update_error',
	          cause: err
	        };
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'myUpdatesInfo',
	    value: function myUpdatesInfo() {
	      var huType = this.vehicle.huType;
	      if (huType === 'MM12') {
	        this.info = {
	          cookieKey: MY_UPDATES_INFO_PREFIX + '.mm12',
	          message: 'my-updates.my_updates_info_mm12'
	        };
	      } else if (huType === 'RADNAV') {
	        this.info = {
	          cookieKey: MY_UPDATES_INFO_PREFIX + '.radnav',
	          message: 'my-updates.my_updates_info_radnav'
	        };
	      }
	    }
	  }]);
	  return MyUpdatesTabController;
	}();
	
	exports.default = MyUpdatesTabController;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myDevicesTab = __webpack_require__(1133);
	
	var _myDevicesTab2 = _interopRequireDefault(_myDevicesTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('myDevicesTab', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.manageMyRlink.myUpdates.myDevicesTab', {
	    url: '/devices',
	    component: 'myDevicesTab',
	    authenticate: true
	  });
	}]).component('myDevicesTab', _myDevicesTab2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myDevicesTab = __webpack_require__(1134);
	
	var _myDevicesTab2 = _interopRequireDefault(_myDevicesTab);
	
	var _myDevicesTab3 = __webpack_require__(1135);
	
	var _myDevicesTab4 = _interopRequireDefault(_myDevicesTab3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _myDevicesTab2.default,
	  controller: _myDevicesTab4.default
	};
	
	exports.default = component;

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\"></app-message>\n\n<div id=\"panelUpdates\" class=\"tabUpdates\" aria-labelledby=\"Updates\" role=\"tabpanel\" aria-hidden=\"false\" aria-expanded=\"true\">\n  <div class=\"historical upd\">\n    <ul ng-if=\"$ctrl.devices.length > 0\">\n      <a ui-sref=\"vehicle.manageMyRlink.myUpdates.myUpdatesTab({vin: '{{$ctrl.vehicle.vin}}'})\" class=\"button back\" ga-track-event=\"['My Updates', 'Click', 'Close manage my products']\">\n        <span>\n          {{ 'common.return' | translate }}\n        </span>\n      </a>\n      <p class=\"description\" ng-bind-html=\"$ctrl.descriptionLabel | translate | trustHtml\" />\n      <div class=\"buttons leftBtn\" >\n        <a class=\"button\" ng-if=\"$ctrl.filterBtn\" href=\"\" ng-click=\"$ctrl.makeFiltered()\">{{ 'my-updates.device.filter' | translate }}</a>\n        <a class=\"button show\" ng-if=\"$ctrl.displayAllBtn\" href=\"\" ng-click=\"$ctrl.showAll()\">{{ 'my-updates.device.show_all' | translate }}</a>\n      </div>\n      <div class=\"brakeLine\" />\n      <li ng-repeat=\"device in $ctrl.devices\" ng-class=\"$ctrl.getDeviceStyleClass(device.mountId)\">\n        <device device=\"device\" vehicle=\"$ctrl.vehicle\" sdfilter=\"$ctrl.getSDDeviceStatus(device.mountId)\"  on-synchronize=\"$ctrl.synchronize(device, syncProducts)\" on-filter-action=\"$ctrl.filterAction()\" on-show-hide-before-api-call=\"$ctrl.showHideBeforeApiCall(mountId, show)\"></device>\n      </li>\n      <a ui-sref=\"vehicle.manageMyRlink.myUpdates.myUpdatesTab({vin: '{{$ctrl.vehicle.vin}}'})\" class=\"button back mobile\" ga-track-event=\"['My Updates', 'Click', 'Close manage my products']\">\n        <span>\n          {{ 'common.return' | translate }}\n        </span>\n      </a>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _orderBy2 = __webpack_require__(1136);
	
	var _orderBy3 = _interopRequireDefault(_orderBy2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyDevicesTabController = function () {
	  MyDevicesTabController.$inject = ["$log", "ProductService", "VehicleService", "SDFilterService", "$state", "$scope", "$rootScope", "$anchorScroll"];
	  function MyDevicesTabController($log, ProductService, VehicleService, SDFilterService, $state, $scope, $rootScope, $anchorScroll) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyDevicesTabController);
	    this.productService = ProductService;
	    this.vehicleService = VehicleService;
	    this.sdFilterService = SDFilterService;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	
	    this.devices = [];
	    this.isProcessing = true;
	
	    this.$log = $log;
	    // SD filter
	    this.filterBtn = false;
	    this.displayAllBtn = false;
	    this.sdCartCount = 0;
	    this.sdFilterList = [];
	    this.sdDevicesWithStatusTrue = 0;
	    // Async loading...
	    $anchorScroll();
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(MyDevicesTabController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle(false).then(function (vehicle) {
	        if (!vehicle) {
	          return _promise2.default.reject();
	        }
	        if (vehicle.mandatoryUpdate) {
	          return _this.$state.go('installation');
	        }
	        _this.vehicle = vehicle;
	        _this.descriptionLabel = 'my-updates.device.description';
	        if (vehicle.huType === 'MM12') {
	          _this.descriptionLabel += '.mm12';
	        } else if (vehicle.huType === 'RADNAV') {
	          _this.descriptionLabel += '.radnav';
	        }
	        _this.$log.debug('getProductsOnDevices');
	        return _this.vehicleService.getProductsOnDevices(_this.vehicle.vin);
	      }).then(function (res) {
	        _this.isProcessing = false;
	        _this.error = null;
	        _this.muid = res.muid;
	        _this.devices = (0, _orderBy3.default)(res.deviceMounts.deviceMount, ['mountId'], ['asc']);
	        _this.safeApply();
	        _this.initSDFilterParam();
	        return _promise2.default.resolve(_this.devices);
	      }, function (err) {
	        _this.isProcessing = false;
	        _this.error = {
	          message: 'my-updates.error',
	          cause: err
	        };
	        _this.safeApply();
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'synchronize',
	    value: function synchronize(device, syncProducts) {
	      var _this2 = this;
	
	      // this.$log.debug('Synchronize')
	      this.isProcessing = true;
	      this.error = null;
	      return this.vehicleService.synchronizeDeviceMount(this.vehicle.vin, this.muid, device.mountId, syncProducts).then(function () {
	        // this.$log.debug('Device synchronized')
	        _this2.isProcessing = false;
	        _this2.$state.go('installation');
	      }, function (err) {
	        _this2.$log.error('An error occurred during synchronization');
	        _this2.isProcessing = false;
	        if (err.data && err.data.meta) {
	          // 507 - SC_INSUFFICIENT_STORAGE (insufficient total space)
	          // 419 - SC_INSUFFICIENT_SPACE_ON_RESOURCE (insufficient free space)
	          if (err.data.meta.statusCode === 507 && _this2.vehicle.huType === 'MM12') {
	            _this2.error = {
	              message: 'my-updates.device.synchronization_not_enough_total_space_mm12',
	              cause: err
	            };
	          } else if (err.data.meta.statusCode === 507 && _this2.vehicle.huType === 'RADNAV') {
	            _this2.error = {
	              message: 'my-updates.device.synchronization_not_enough_total_space_radnav',
	              cause: err
	            };
	          } else if (err.data.meta.statusCode === 419) {
	            _this2.error = {
	              message: 'my-updates.device.synchronization_not_enough_free_space',
	              cause: err
	            };
	          }
	        } else {
	          _this2.error = {
	            message: 'my-updates.device.synchronization_error',
	            cause: err
	          };
	        }
	      });
	    }
	  }, {
	    key: 'initSDFilterParam',
	    value: function initSDFilterParam() {
	      var _this3 = this;
	
	      this.sdCartCount = 0;
	      this.sdFilterList = [];
	      this.devices.forEach(function (device) {
	        if (device.mountType === 'SD Card') {
	          _this3.sdCartCount++;
	          _this3.sdFilterList[device.mountId] = true; // display all
	        }
	      });
	      if (this.sdCartCount < 2) {
	        this.sdFilterList = [];
	      } else {
	        this.filterBtn = true;
	        this.getUserSDFilter();
	      }
	    }
	  }, {
	    key: 'applyUserSDFilter',
	    value: function applyUserSDFilter(callRes) {
	      var _this4 = this;
	
	      if (callRes.status === true) {
	        this.filterBtn = true;
	        this.displayAllBtn = false;
	      } else if (callRes.status === false) {
	        this.filterBtn = false;
	        this.displayAllBtn = true;
	      }
	      if (callRes.deviceSDFilterList != null) {
	        callRes.deviceSDFilterList.forEach(function (device) {
	          _this4.sdFilterList[device.mountId] = device.status;
	        });
	      }
	      this.sdDevicesWithStatusTrue = 0;
	      for (var mountId in this.sdFilterList) {
	        if (this.sdFilterList[mountId]) {
	          this.sdDevicesWithStatusTrue++;
	        }
	      }
	      return callRes;
	    }
	  }, {
	    key: 'getUserSDFilter',
	    value: function getUserSDFilter() {
	      var _this5 = this;
	
	      return this.sdFilterService.getUserSDFilter().then(function (res) {
	        return _this5.applyUserSDFilter(res);
	      });
	    }
	  }, {
	    key: 'getSDDeviceStatus',
	    value: function getSDDeviceStatus(mountId) {
	      if (this.sdFilterList[mountId] !== undefined) {
	        if (this.sdFilterList[mountId] === true) {
	          if (this.sdDevicesWithStatusTrue === 1) {
	            // at minimum one should be show
	            return '';
	          }
	          return 'display';
	        } else {
	          if (this.displayAllBtn === true) {
	            return 'hide';
	          }
	          return 'disabled';
	        }
	      }
	      return 'none';
	    }
	  }, {
	    key: 'makeFiltered',
	    value: function makeFiltered() {
	      var _this6 = this;
	
	      return this.sdFilterService.changeUserSDFilterStatus('hide').then(function (res) {
	        return _this6.getUserSDFilter();
	      });
	    }
	  }, {
	    key: 'showAll',
	    value: function showAll() {
	      var _this7 = this;
	
	      return this.sdFilterService.changeUserSDFilterStatus('show').then(function (res) {
	        return _this7.getUserSDFilter();
	      });
	    }
	  }, {
	    key: 'getDeviceStyleClass',
	    value: function getDeviceStyleClass(mountId) {
	      var line = this.getSDDeviceStatus(mountId);
	      if (line === 'hide') {
	        return 'hideBox';
	      }
	      return '';
	    }
	  }, {
	    key: 'filterAction',
	    value: function filterAction() {
	      return this.getUserSDFilter();
	    }
	  }, {
	    key: 'showHideBeforeApiCall',
	    value: function showHideBeforeApiCall(mountId, show) {
	      this.sdFilterList[mountId] = show;
	    }
	  }]);
	  return MyDevicesTabController;
	}();
	
	exports.default = MyDevicesTabController;

/***/ }),
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categories = __webpack_require__(1142);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _purchaseRecord = __webpack_require__(1148);
	
	var _purchaseRecord2 = _interopRequireDefault(_purchaseRecord);
	
	var _updateItem = __webpack_require__(1154);
	
	var _updateItem2 = _interopRequireDefault(_updateItem);
	
	var _collapsableInvoices = __webpack_require__(1159);
	
	var _collapsableInvoices2 = _interopRequireDefault(_collapsableInvoices);
	
	var _device = __webpack_require__(1165);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _progressbar = __webpack_require__(1206);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	var _deviceContent = __webpack_require__(1211);
	
	var _deviceContent2 = _interopRequireDefault(_deviceContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('manage-my-rlink.components', [_categories2.default, _purchaseRecord2.default, _collapsableInvoices2.default, _updateItem2.default, _device2.default, _progressbar2.default, _deviceContent2.default]).name;
	
	exports.default = _module;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _manageMyRlinkCategories = __webpack_require__(1143);
	
	var _manageMyRlinkCategories2 = _interopRequireDefault(_manageMyRlinkCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('manageMyRlinkCategories', [_angularUiRouter2.default]).component('manageMyRlinkCategories', _manageMyRlinkCategories2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _manageMyRlinkCategories = __webpack_require__(1144);
	
	var _manageMyRlinkCategories2 = _interopRequireDefault(_manageMyRlinkCategories);
	
	var _manageMyRlinkCategories3 = __webpack_require__(1145);
	
	var _manageMyRlinkCategories4 = _interopRequireDefault(_manageMyRlinkCategories3);
	
	__webpack_require__(1146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  controller: _manageMyRlinkCategories2.default,
	  template: _manageMyRlinkCategories4.default
	};
	
	exports.default = component;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManageMyRlinkCategoriesController = function () {
	  ManageMyRlinkCategoriesController.$inject = ["$state", "I18n"];
	  function ManageMyRlinkCategoriesController($state, I18n) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManageMyRlinkCategoriesController);
	    this.$state = $state;
	    this.I18n = I18n;
	    this.categories = [{
	      id: 'myPurchaseRecords',
	      label: 'manageMyRlink.categories.history'
	    }, {
	      id: 'myUpdates',
	      label: 'manageMyRlink.categories.updates'
	    }];
	  }
	
	  (0, _createClass3.default)(ManageMyRlinkCategoriesController, [{
	    key: 'active',
	    value: function active(categoryId) {
	      return this.$state.is('vehicle.manageMyRlink.' + categoryId);
	    }
	  }]);
	  return ManageMyRlinkCategoriesController;
	}();
	
	exports.default = ManageMyRlinkCategoriesController;

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"toggle\" ng-click=\"$ctrl.open = !$ctrl.open\"></button>\n<ul ng-class=\"{'open': $ctrl.open}\" class=\"mobile\" ng-click=\"$ctrl.open = !$ctrl.open\">\n  <li ng-repeat=\"category in $ctrl.categories track by category.id\" ng-if=\"$ctrl.active(category.id)\">\n    <a role=\"tab\"\n       ui-sref=\"vehicle.manageMyRlink.{{category.id}}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Manage My Rlink', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n  <li ng-repeat=\"category in $ctrl.categories track by category.id\" ng-if=\"!$ctrl.active(category.id)\">\n    <a role=\"tab\"\n       ui-sref=\"vehicle.manageMyRlink.{{category.id}}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Manage My Rlink', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n</ul>\n<ul ng-class=\"{'open': $ctrl.open, 'arabDirection':  $ctrl.I18n.isArLocale()}\" class=\"desktop\">\n  <li ng-repeat=\"category in $ctrl.categories track by category.id\">\n    <a role=\"tab\"\n       ui-sref=\"vehicle.manageMyRlink.{{category.id}}\"\n       ui-sref-active=\"active\"\n       ga-track-event=\"['Manage My Rlink', 'Click', '{{ category.label | translate | escapeSingleQuote }}']\">\n      <p>{{ category.label | translate }}</p>\n    </a>\n  </li>\n</ul>\n"

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1147);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./manage-my-rlink-categories.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./manage-my-rlink-categories.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _purchaseRecord = __webpack_require__(1149);
	
	var _purchaseRecord2 = _interopRequireDefault(_purchaseRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('purchaseRecord', []).component('purchaseRecord', _purchaseRecord2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _purchaseRecord = __webpack_require__(1150);
	
	var _purchaseRecord2 = _interopRequireDefault(_purchaseRecord);
	
	var _purchaseRecord3 = __webpack_require__(1151);
	
	var _purchaseRecord4 = _interopRequireDefault(_purchaseRecord3);
	
	__webpack_require__(1152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    record: '<'
	  },
	  controller: _purchaseRecord2.default,
	  template: _purchaseRecord4.default
	};
	
	exports.default = component;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PurchaseRecordController = function () {
	  PurchaseRecordController.$inject = ["I18n", "ProductUtilsService"];
	  function PurchaseRecordController(I18n, ProductUtilsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PurchaseRecordController);
	    this.I18n = I18n;
	    this.productUtilsService = ProductUtilsService;
	  }
	
	  (0, _createClass3.default)(PurchaseRecordController, [{
	    key: 'button',
	    get: function get() {
	      var record = this.record;
	
	      return this.productUtilsService.getButtonLabel(record);
	    }
	  }, {
	    key: 'expirationDate',
	    get: function get() {
	      var record = this.record;
	
	      return record && record.expirationDate ? new Date(record.expirationDate) : null;
	    }
	  }, {
	    key: 'purchaseDate',
	    get: function get() {
	      var record = this.record;
	
	      return record && record.purchaseDate ? new Date(record.purchaseDate) : null;
	    }
	  }]);
	  return PurchaseRecordController;
	}();
	
	exports.default = PurchaseRecordController;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	module.exports = "<ul>\n<li class=\"appName\">\n  <img ng-src=\"{{$ctrl.record.icon}}.gif\" fallback-src=\"/img/products/icon/sample.gif\"/>\n  <div>\n    <span class=\"name\">{{$ctrl.record.title}}</span>\n    <collapsable-invoices record=\"$ctrl.record\" orders=\"$ctrl.record.orders\"></collapsable-invoices>\n  </div>\n</li>\n<li class=\"appType\">\n  <p>\n  <span>{{ 'purchase-record.type.' + $ctrl.record.productType | translate }}</span>\n  <span class='status' ng-class=\"$ctrl.record.status\">\n    {{ 'purchase-record.status.' + $ctrl.record.status | translate }}\n  </span>\n  <span ng-if=\"$ctrl.record.duration > 0\" ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n    {{ 'purchase-record.duration' | translate:{duration:$ctrl.record.duration} }}\n    -\n    {{ 'purchase-record.expires' | translate:{date:$ctrl.expirationDate} }}\n  </span>\n  <span ng-if=\"$ctrl.record.duration <= 0\">\n    {{ 'purchase-record.purchased' | translate:{date:$ctrl.purchaseDate} }}\n  </span>\n  </p>\n</li>\n<li class=\"buttons\" ng-if=\"$ctrl.button\">\n  <a ui-sref=\"vehicle.productDetails({ref: '{{$ctrl.record.ref}}'})\" class=\"button\" ga-track-event=\"['My Purchase Records', 'Click', '{{ $ctrl.button | escapeSingleQuote }} {{ $ctrl.record.title | translate | escapeSingleQuote }}']\">{{ $ctrl.button | translate }}</a>\n</li>\n</ul>\n"

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1153);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./purchase-record.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./purchase-record.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "purchase-record>ul{font-size:0}purchase-record>ul>li{font-size:1rem;display:inline-block;vertical-align:middle}purchase-record>ul .status:before{content:\"\";display:inline-block;margin-right:.5em;width:.8em;height:.8em;border-radius:50%}purchase-record>ul .status.FINISHED,purchase-record>ul .status.INACTIVE{color:#c42720}purchase-record>ul .status.FINISHED:before,purchase-record>ul .status.INACTIVE:before{background-color:#c42720}purchase-record>ul .status.ACTIVE{color:#38a104}purchase-record>ul .status.ACTIVE:before{background-color:#38a104}purchase-record>ul .status.INPROGRESS:before{background-color:#ffde00}@media (min-width:900px){purchase-record>ul{display:table;width:100%}purchase-record>ul>li{display:table-cell;vertical-align:middle}}", ""]);
	
	// exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _updateItem = __webpack_require__(1155);
	
	var _updateItem2 = _interopRequireDefault(_updateItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('updateItem', []).component('updateItem', _updateItem2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _updateItem = __webpack_require__(1156);
	
	var _updateItem2 = _interopRequireDefault(_updateItem);
	
	__webpack_require__(1157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    item: '<',
	    onUpdateClick: '&'
	  },
	  template: _updateItem2.default
	};
	
	exports.default = component;

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	module.exports = "<ul>\n  <li class=\"appName\">\n    <img ng-src=\"{{$ctrl.item.icon}}.gif\" fallback-src=\"/img/products/icon/sample.gif\"/>\n    <div>\n      <span class=\"name\">{{$ctrl.item.title}}</span>\n    </div>\n  </li>\n  <li class=\"appType\">\n    <p>\n    <span>{{ 'my-updates.update' | translate }}</span>\n    <span>{{ 'my-updates.new_revision' | translate }} {{ $ctrl.item.newVersion }}</span>\n    </p>\n  </li>\n  <li class=\"buttons\">\n    <a ng-click=\"$ctrl.onUpdateClick({item: $ctrl.item})\" ng-class=\"{ 'disabled': $ctrl.item.mandatory }\" ng-disabled=\"$ctrl.item.mandatory\" class=\"button light top\" ga-track-event=\"['My Updates', 'Click', 'Update {{ $ctrl.item.title | escapeSingleQuote }}']\">\n      {{ 'my-updates.button.ask_for_update' | translate }}\n    </a>\n  </li>\n</ul>\n"

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1158);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./update-item.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./update-item.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "update-item>ul{font-size:0}update-item>ul>li{font-size:1rem;display:inline-block;vertical-align:middle}@media (min-width:900px){update-item>ul{display:table;width:100%}update-item>ul>li{display:table-cell;vertical-align:middle}}a.button.light.top:after{top:.8em}a.button.light.top{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _collapsableInvoices = __webpack_require__(1160);
	
	var _collapsableInvoices2 = _interopRequireDefault(_collapsableInvoices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('collapsableInvoices', []).component('collapsableInvoices', _collapsableInvoices2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collapsableInvoices = __webpack_require__(1161);
	
	var _collapsableInvoices2 = _interopRequireDefault(_collapsableInvoices);
	
	var _collapsableInvoices3 = __webpack_require__(1162);
	
	var _collapsableInvoices4 = _interopRequireDefault(_collapsableInvoices3);
	
	__webpack_require__(1163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    record: '<',
	    orders: '<'
	  },
	  controller: _collapsableInvoices2.default,
	  template: _collapsableInvoices4.default
	};
	
	exports.default = component;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollapasbleInvoicesConroller = function () {
	  CollapasbleInvoicesConroller.$inject = ["$sce", "$timeout", "ProductService", "VehicleService", "UserService", "I18n", "$log", "Localization", "$rootScope", "$scope"];
	  function CollapasbleInvoicesConroller($sce, $timeout, ProductService, VehicleService, UserService, I18n, $log, Localization, $rootScope, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CollapasbleInvoicesConroller);
	    this.$sce = $sce;
	    this.$timeout = $timeout;
	    this.$log = $log;
	    this.productService = ProductService;
	    this.vehicleService = VehicleService;
	    this.userService = UserService;
	    this.I18n = I18n;
	    this.Localization = Localization;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.fold = true;
	    this.loaded = this.init();
	  }
	
	  (0, _createClass3.default)(CollapasbleInvoicesConroller, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (vehicle) {
	        if (!vehicle) {
	          _this.$log.error('Unable to get current selected vehicle.');
	          return _promise2.default.reject('Unable to get current selected vehicle.');
	        }
	        _this.vehicle = vehicle;
	        _this.safeApply();
	      });
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate(str) {
	      return str ? new Date(str) : null;
	    }
	  }, {
	    key: 'downloadInvoice',
	    value: function downloadInvoice(order) {
	      var _this2 = this;
	
	      // TODO change this if invoice dl not working
	      this.isProcessing = true;
	      this.userService.refresh().then(function () {
	        _this2.urlDowloadInvoice = _this2.$sce.trustAsResourceUrl(_this2.productService.getEndpoint() + '/orders/' + order.orderRef + '/invoice');
	        _this2.tokenParam = _this2.userService.getCurrentToken().access_token;
	        _this2.local = _this2.I18n.getLanguage();
	        _this2.country = _this2.Localization.getCountry();
	        _this2.orderRef = order.orderRef;
	        _this2.$timeout(function () {
	          _this2.$rootScope.$broadcast('SubmitInvoiceForm', { formName: order.orderRef });
	        }, 1000);
	        _this2.isProcessing = false;
	        return _promise2.default.resolve();
	      }, function (err) {
	        _this2.isProcessing = false;
	        _this2.$log.debug('refresh failed');
	        return _this2.userService.resetBufferAndLogout(err);
	      });
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }]);
	  return CollapasbleInvoicesConroller;
	}();
	
	exports.default = CollapasbleInvoicesConroller;

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n<div class=\"collapseBloc\" ng-if=\"$ctrl.orders.length > 1 && $ctrl.vehicle\">\n  <button class=\"collapseBt dropDown\"\n          title=\"{{ 'common.fold_unfold' | translate }}\"\n          ng-click=\"$ctrl.fold = !$ctrl.fold\"\n          ga-track-event=\"['My Purchase Records', 'Click', 'Show/Hide Collapsed Invoices _ {{ $ctrl.record.title | escapeSingleQuote }}']\">\n          {{ 'collapsable-invoices.my-invoices' | translate }}\n  </button>\n  <div ng-class=\"{ 'collapse': $ctrl.fold }\">\n    <ul ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\">\n      <li ng-repeat=\"order in $ctrl.orders\" >\n        <a ng-click=\"$ctrl.downloadInvoice(order)\"\n           class=\"download\"\n           href=\"\"\n           ga-track-event=\"['My Purchase Records', 'Click', 'Invoice Download _ {{ $ctrl.record.title | escapeSingleQuote }}']\">\n           {{ 'collapsable-invoices.invoice' | translate:{date:$ctrl.getDate(order.orderDate)} }}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n<a ng-if=\"$ctrl.orders.length === 1 && $ctrl.vehicle\"\n   ng-click=\"$ctrl.downloadInvoice($ctrl.orders[0])\"\n   class=\"download\"\n   href=\"\"\n   ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n   ga-track-event=\"['My Purchase Records', 'Click', 'Invoice Download _ {{ $ctrl.record.title | escapeSingleQuote }}']\">\n   {{ 'collapsable-invoices.invoice' | translate:{date:$ctrl.getDate($ctrl.orders[0].orderDate)} }}\n</a>\n<form method=get action=\"{{$ctrl.urlDowloadInvoice}}\" name=\"{{$ctrl.orderRef}}\" class=\"hide\" target=\"_top\" submit-form>\n\t<input type=hidden name=vin value=\"{{$ctrl.vehicle.vin}}\">\n\t<input type=hidden name=x-locale value=\"{{$ctrl.local}}\">\n\t<input type=hidden name=x-country value=\"{{$ctrl.country}}\">\n\t<input type=hidden name=token value=\"{{$ctrl.tokenParam}}\">\n</form>\n"

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1164);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./collapsable-invoices.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./collapsable-invoices.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "collapsable-invoices form.hide{display:none;width:0;height:0}.historical a.download{display:inline-flex}", ""]);
	
	// exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _device = __webpack_require__(1166);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _progressbar = __webpack_require__(1201);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('device', [_progressbar2.default]).component('device', _device2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _device = __webpack_require__(1167);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _device3 = __webpack_require__(1198);
	
	var _device4 = _interopRequireDefault(_device3);
	
	__webpack_require__(1199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    device: '<',
	    vehicle: '<',
	    sdfilter: '<',
	    onSynchronize: '&',
	    onFilterAction: '&',
	    onShowHideBeforeApiCall: '&'
	  },
	  controller: _device2.default,
	  template: _device4.default
	};
	
	exports.default = component;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cloneDeep2 = __webpack_require__(1168);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _filter2 = __webpack_require__(1196);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceController = function () {
	  DeviceController.$inject = ["$scope", "$rootScope", "SDFilterService", "$log"];
	  function DeviceController($scope, $rootScope, SDFilterService, $log) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DeviceController);
	    this.$rootScope = $rootScope;
	    this.$log = $log;
	    this.sdFilterService = SDFilterService;
	    this.sdfilter = this;
	    this.isProcessing = false;
	    $scope.$on('device-content:close', function (event, data) {
	      _this.showContents = false;
	    });
	  }
	
	  (0, _createClass3.default)(DeviceController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.deviceBeforeSync = (0, _cloneDeep3.default)(this.device);
	    }
	  }, {
	    key: 'toggleContents',
	    value: function toggleContents() {
	      var show = this.showContents;
	      this.$rootScope.$broadcast('device-content:close');
	      this.showContents = !show;
	    }
	  }, {
	    key: 'synchronize',
	    value: function synchronize() {
	      // this.$log.debug('Synchronize')
	      this.isProcessing = true;
	      this.info = null;
	      var device = this.device,
	          deviceBeforeSync = this.deviceBeforeSync;
	
	      var productsToInstall = [];
	      var productsToDelete = [];
	      // this.$log.debug('Device', device)
	      // this.$log.debug('Device before modifications', deviceBeforeSync)
	      device.availableContents.availableContent.forEach(function (availableContent) {
	        var availableContentBeforeSync = (0, _filter3.default)(deviceBeforeSync.availableContents.availableContent, { 'ref': availableContent.ref })[0];
	        // this.$log.debug('availableContentBeforeSync', availableContentBeforeSync)
	        if (availableContent.isInstalled !== availableContentBeforeSync.isInstalled && !availableContent.isLocked) {
	          // this.$log.debug('availableContent.isInstalled', availableContent.isInstalled)
	          // this.$log.debug('availableContentBeforeSync.isInstalled', availableContentBeforeSync.isInstalled)
	          if (availableContent.isInstalled) {
	            productsToInstall.push(availableContent.ref);
	          } else {
	            productsToDelete.push(availableContent.ref);
	          }
	        }
	      });
	      // this.$log.debug('Products to install', productsToInstall)
	      // this.$log.debug('Products to delete', productsToDelete)
	      if (productsToInstall.length === 0 && productsToDelete.length === 0) {
	        this.$log.error('Nothing to synchronize');
	        this.error = {
	          message: 'my-updates.device.synchronization_no_change'
	        };
	      } else {
	        var syncProducts = {
	          productsToInstall: productsToInstall,
	          productsToDelete: productsToDelete
	        };
	        this.$log.debug('Products to synchronize', syncProducts);
	        return this.onSynchronize({ device: device, syncProducts: syncProducts });
	      }
	    }
	  }, {
	    key: 'isDisplayShowBtn',
	    value: function isDisplayShowBtn() {
	      if (this.sdfilter === 'disabled') {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'isDisplayHideBtn',
	    value: function isDisplayHideBtn() {
	      if (this.sdfilter === 'display') {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'isDisabledBox',
	    value: function isDisabledBox() {
	      if (this.sdfilter === 'disabled') {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'showDevice',
	    value: function showDevice() {
	      var _this2 = this;
	
	      this.isProcessing = true;
	      var device = this.device;
	
	      this.onShowHideBeforeApiCall({ mountId: device.mountId, show: true });
	      this.sdFilterService.changeSDDeviceFilterStatus(device.mountId, 'show').then(function (res) {
	        _this2.isProcessing = false;
	        return _this2.onFilterAction();
	      });
	    }
	  }, {
	    key: 'hideDevice',
	    value: function hideDevice() {
	      var _this3 = this;
	
	      this.isProcessing = true;
	      var device = this.device;
	
	      this.onShowHideBeforeApiCall({ mountId: device.mountId, show: false });
	      this.sdFilterService.changeSDDeviceFilterStatus(device.mountId, 'hide').then(function (res) {
	        _this3.isProcessing = false;
	        return _this3.onFilterAction();
	      });
	    }
	  }, {
	    key: 'deviceNameLabel',
	    get: function get() {
	      var device = this.device;
	
	      var deviceNameLabel = void 0;
	      switch (device.mountType) {
	        case 'Internal':
	          deviceNameLabel = 'my-updates.device.mountType.internal';
	          break;
	        case 'SD Card':
	          deviceNameLabel = 'my-updates.device.mountType.sd_card_mm12';
	          break;
	        case 'External memory':
	          deviceNameLabel = 'my-updates.device.mountType.sd_card_radnav';
	          break;
	        default:
	          deviceNameLabel = 'my-updates.device.mountType.internal';
	          break;
	      }
	      return deviceNameLabel;
	    }
	  }, {
	    key: 'space',
	    get: function get() {
	      var device = this.device;
	
	      var space = (device.totalSpace - device.freeSpace + device.reservedSpace) / 1048576; // 1048576 octets is 1 Mo
	      return Math.round(space) + 'Mo';
	    }
	  }, {
	    key: 'totalSpace',
	    get: function get() {
	      var device = this.device;
	
	      var totalSpace = device.totalSpace / 1048576;
	      return Math.round(totalSpace) + 'Mo';
	    }
	  }, {
	    key: 'progressbarSpace',
	    get: function get() {
	      var device = this.device;
	
	      return (device.totalSpace - device.freeSpace + device.reservedSpace) / device.totalSpace * 100;
	    }
	  }, {
	    key: 'mountId',
	    get: function get() {
	      var device = this.device;
	
	      var id = '';
	      if (device.mountType === 'SD Card') {
	        id = device.mountId;
	      }
	      return id;
	    }
	  }, {
	    key: 'progressbarStyle',
	    get: function get() {
	      var type = 'success';
	      if (this.progressbarSpace > 50) type = 'danger';
	      return type;
	    }
	  }, {
	    key: 'availableContents',
	    get: function get() {
	      var device = this.device;
	
	      return device.availableContents.availableContent;
	    }
	  }, {
	    key: 'currentVehicle',
	    get: function get() {
	      var vehicle = this.vehicle;
	
	      return vehicle;
	    }
	  }]);
	  return DeviceController;
	}();
	
	exports.default = DeviceController;

/***/ }),
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */
/***/ (function(module, exports) {

	module.exports = "<app-message error=\"$ctrl.error\" success=\"$ctrl.success\" info=\"$ctrl.info\"></app-message>\n<app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n<ul class=\"device\">\n  <li class=\"deviceName\" ng-class=\"{disableBox: $ctrl.isDisabledBox()}\">\n    <div>\n      <span>{{$ctrl.deviceNameLabel | translate}}</span>\n    </div>\n    <div>\n      <span class=\"sdCardMountLabel\">{{$ctrl.mountId}}</span>\n    </div>\n  </li>\n  <li class=\"deviceSpace\" ng-class=\"{disableBox: $ctrl.isDisabledBox()}\">\n    <div>\n      <span class=\"space\">{{$ctrl.space}} / {{$ctrl.totalSpace}}</span>\n    </div>\n  </li>\n  <li class=\"progressbarSpace\" ng-class=\"{disableBox: $ctrl.isDisabledBox()}\">\n    <progressbar value=\"$ctrl.progressbarSpace\" type=\"$ctrl.progressbarStyle\"></progressbar>\n  </li>\n  <li class=\"buttons\">\n    <a class=\"button show\" ng-show=\"$ctrl.isDisplayShowBtn()\" href=\"\" ng-click=\"$ctrl.showDevice()\">{{ 'my-updates.device.show' | translate }}</a>\n    <a class=\"button\" ng-show=\"$ctrl.isDisplayHideBtn()\" href=\"\" ng-click=\"$ctrl.hideDevice()\" ng-class=\"{disableBox: $ctrl.isDisabledBox()}\">{{ 'my-updates.device.hide' | translate }}</a>\n    <div class=\"buttonSeparator\" />\n    <a class=\"button\" href=\"\" ng-click=\"$ctrl.toggleContents()\" ng-class=\"{open: $ctrl.showContents, disabledButton: $ctrl.isDisabledBox()}\">{{ 'common.manage' | translate }}</a>\n    <a class=\"button synchronize desktop\" href=\"\" ng-click=\"$ctrl.synchronize()\"ng-class=\"{disabledButton: $ctrl.isDisabledBox()}\" ng-show=\"$ctrl.showContents\">{{ 'common.synchronize' | translate }}</a>\n  </li>\n</ul>\n<ul class=\"deviceContents\" ng-show=\"$ctrl.showContents\">\n  <li ng-repeat=\"content in $ctrl.device.availableContents.availableContent\" >\n    <device-content content=\"content\" vehicle=\"$ctrl.currentVehicle\"></device-content>\n  </li>\n</ul>\n<ul class=\"device\">\n  <li class=\"buttons\">\n    <a class=\"button synchronize mobile\" href=\"\" ng-click=\"$ctrl.synchronize()\" ng-show=\"$ctrl.showContents\">{{ 'common.synchronize' | translate }}</a>\n  </li>\n</ul>\n"

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1200);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./device.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./device.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "device>ul.device{font-size:0}device>ul.device>li{font-size:1rem;display:inline-block;vertical-align:middle}device .deviceName{width:100%;font-weight:700}device .deviceSpace{width:100%}device .progressbarSpace{width:50%;margin-left:25%}device .buttons a.button.open:after{content:\"\\E618\"}device .buttons a.button.synchronize{margin-top:.2em}device .buttons .mobile{display:inline-block}device .buttons .desktop{display:none}device .app-message{margin-bottom:.2em}device .disableBox{opacity:.3}device .brakeLine{clear:both;display:block}device .disabledButton{pointer-events:none;cursor:default;opacity:.3}device .sdCardMountLabel{font-size:.7rem;font-weight:700}device .buttonSeparator{padding:2px;clear:both;display:block}@media (max-width:599px){device>ul.device>li{text-align:center}}@media (min-width:600px){device>ul.device{display:table;width:100%}device>ul.device>li{display:table-cell;vertical-align:middle}device .deviceName{width:20%}device .deviceSpace,device .progressbarSpace{width:25%}device .buttons{padding-top:0!important}device .buttons .mobile{display:none}device .buttons .desktop{display:inline-block}}", ""]);
	
	// exports


/***/ }),
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _progressbar = __webpack_require__(1207);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('progressbar', []).component('progressbar', _progressbar2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _progressbar = __webpack_require__(1208);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	__webpack_require__(1209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    value: '<',
	    type: '<'
	  },
	  template: _progressbar2.default
	};
	
	exports.default = component;

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	module.exports = "<uib-progressbar value=\"$ctrl.value\" type=\"{{$ctrl.type}}\"><b>{{$ctrl.value | number:0}}%</b></uib-progressbar>\n"

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1210);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./progressbar.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./progressbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".progress{overflow:hidden;height:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#38a104}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#c00}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}", ""]);
	
	// exports


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _deviceContent = __webpack_require__(1212);
	
	var _deviceContent2 = _interopRequireDefault(_deviceContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('deviceContent', []).component('deviceContent', _deviceContent2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deviceContent = __webpack_require__(1213);
	
	var _deviceContent2 = _interopRequireDefault(_deviceContent);
	
	var _deviceContent3 = __webpack_require__(1214);
	
	var _deviceContent4 = _interopRequireDefault(_deviceContent3);
	
	__webpack_require__(1215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  bindings: {
	    content: '<',
	    vehicle: '<'
	  },
	  controller: _deviceContent2.default,
	  template: _deviceContent4.default
	};
	
	exports.default = component;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sweetalert = __webpack_require__(727);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceContentController = function () {
	  DeviceContentController.$inject = ["$translate"];
	  function DeviceContentController($translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DeviceContentController);
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(DeviceContentController, [{
	    key: 'displayAlert',
	    value: function displayAlert(checked) {
	      var content = this.content,
	          vehicle = this.vehicle;
	
	      if (vehicle.huType === 'MM12' && content.isFactory && !checked) {
	        var alertMessage = this.$translate.instant('my-updates.device.alert_uninstall_factory');
	        console.log('Message to display on swal: ' + alertMessage);
	        (0, _sweetalert2.default)({
	          text: alertMessage,
	          icon: 'warning',
	          dangerMode: true,
	          closeOnClickOutside: false,
	          content: true
	        });
	      }
	      this.checked = !checked;
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      var content = this.content;
	
	      var size = void 0;
	      if (!content.isLocked && content.size) {
	        size = '(' + Math.round(content.size * 10 / 1048576) / 10 + 'Mo)';
	      }
	      return size;
	    }
	  }]);
	  return DeviceContentController;
	}();
	
	exports.default = DeviceContentController;

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"CheckboxList\">\n  <li>\n    <label class=\"checkBox\" ng-class=\"{disabled: $ctrl.content.isLocked}\">\n      <input type=\"checkbox\" ng-model=\"$ctrl.content.isInstalled\"\n        ng-disabled=\"$ctrl.content.isLocked\"\n        ng-click=\"$ctrl.displayAlert($ctrl.checked)\">\n      <span>{{$ctrl.content.title}} {{$ctrl.size}}</span>\n    </label>\n  </li>\n</ul>\n"

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1216);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./device-content.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./device-content.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "device-content li{padding:.2em;margin-left:20%}device-content li input[disabled]{color:#e2e3e4}device-content li input[disabled]+span:before{border-color:#e2e3e4!important}device-content li input[disabled]+span:after{color:#e2e3e4!important}device-content label.checkBox.disabled{cursor:auto}", ""]);
	
	// exports


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _productDetails = __webpack_require__(1218);
	
	var _productDetails2 = _interopRequireDefault(_productDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('productDetails', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle.productDetails', {
	    url: '/product/:ref',
	    params: { group: null },
	    component: 'productDetails',
	    authenticate: true
	  });
	}]).component('productDetails', _productDetails2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productDetails = __webpack_require__(1219);
	
	var _productDetails2 = _interopRequireDefault(_productDetails);
	
	var _productDetails3 = __webpack_require__(1220);
	
	var _productDetails4 = _interopRequireDefault(_productDetails3);
	
	__webpack_require__(1221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  template: _productDetails2.default,
	  controller: _productDetails4.default
	};
	
	exports.default = component;

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <app-message success=\"$ctrl.fakeVar\" error=\"$ctrl.error\" info=\"$ctrl.info\"></app-message>\n  <div class=\"datasheet limitContent\">\n    <p class=\"topBack\">\n      <a class=\"button back prev\" ng-click=\"$ctrl.$window.history.back()\" href=\"#\" ga-track-event=\"['Product Details', 'Click', 'Back']\">{{ 'common.back' | translate }}</a>\n    </p>\n    <div class=\"carUp card\">\n      <p ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n        {{ 'productDetails.RlinkCar' | translate }}\n      </p>\n      <p class=\"modele\">\n        {{ $ctrl.vehicle.friendlyName }}\n      </p>\n    </div>\n    <section class=\"sheet card\">\n      <dl>\n        <dt>\n          <img ng-src=\"{{ $ctrl.product.icon }}.gif\" alt=\"{{ $ctrl.product.title }}\" fallback-src=\"/img/products/icon/sample.gif\"/>\n        </dt>\n        <dd>\n          <span>{{$ctrl.product.title}}</span>\n          <!--<dl>{{$ctrl.product.publisher}}</dl>-->\n          <dl class=\"price from\" ng-if=\"$ctrl.group\">\n            <dd class=\"price\">\n              <strike ng-if=\"$ctrl.isPromotion\">{{ $ctrl.product.price | price | translate }}</strike> {{ $ctrl.actualPrice | price | translate }}\n            </dd>\n            <dd class=\"time\">\n              <select id=\"duration\" name=\"duration\" class=\"open\" ng-change=\"$ctrl.changeProduct()\" ng-model=\"$ctrl.selectedProduct.ref\">\n                <option ng-repeat=\"item in $ctrl.group track by item.ref\" value=\"{{item.ref}}\">{{ $ctrl.getDuration(item) | translate: { duration: item.duration } }}</option>\n              </select>\n            </dd>\n          </dl>\n          <dl class=\"price from noChoice\" ng-if=\"!$ctrl.group\">\n            <dd>\n              <strike ng-if=\"$ctrl.isPromotion\">{{ $ctrl.product.price | price | translate }}</strike> {{ $ctrl.actualPrice | price | translate }}\n            </dd>\n          </dl>\n          <dl class=\"left\">\n            <dt ng-class=\"{'arabDirectionFloat':  $ctrl.i18n.isArLocale()}\">{{ 'productDetails.version' | translate }}</dt>\n            <dd>{{ $ctrl.product.version }}</dd>\n            <dt ng-class=\"{'arabDirectionFloat':  $ctrl.i18n.isArLocale()}\">{{ 'productDetails.updateDate' | translate }}</dt>\n            <dd ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">{{ $ctrl.product.lastUpdateDate | date:'shortDate' }}</dd>\n          </dl>\n          <dl class=\"right\">\n            <dt ng-class=\"{'arabDirectionFloat':  $ctrl.i18n.isArLocale()}\">{{ 'productDetails.productType' | translate }}</dt>\n            <dd>{{ $ctrl.product.productType }}</dd>\n            <dt ng-class=\"{'arabDirectionFloat':  $ctrl.i18n.isArLocale()}\">{{ 'productDetails.requiredSpace' | translate }}</dt>\n            <dd ng-if=\"$ctrl.infoCode == 7\" ng-style=\"{color:'red'}\">{{ $ctrl.size | number:1 }} {{ 'productDetails.memoryUnit' | translate }}</dd>\n            <dd ng-if=\"$ctrl.infoCode != 7\">{{ $ctrl.size | number:1 }} {{ 'productDetails.memoryUnit' | translate }}</dd>\n          </dl>\n        </dd>\n      </dl>\n      <p class=\"warningMessage\" ng-if=\"($ctrl.infoCode != 0 || $ctrl.spaceWarning) && !$ctrl.isProcessing\" ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\" ng-style=\"{color:'red'}\" > {{ $ctrl.warningMessage | translate }}</p>\n      <h2 ng-class=\"{'arabDirection':  $ctrl.i18n.isArLocale()}\">\n        {{ 'productDetails.details' | translate }}\n      </h2>\n      <p class=\"details\" ng-bind-html=\"$ctrl.product.shortDescription | trustHtml\" />\n      <div ng-if=\"$ctrl.isPackOrBundle && $ctrl.packContent\" class=\"filter collapseBloc\" ng-class=\"{ 'active': $ctrl.displayPackContent }\">\n        <button class=\"collapseBt dropDown\" ng-click=\"$ctrl.displayPackContent = !$ctrl.displayPackContent\" ga-track-event=\"['Product Details', 'Click', 'Pack Content {{ $ctrl.product.title | escapeSingleQuote }}']\">\n          {{ 'productDetails.pack' | translate }} {{$ctrl.product.publisher}}\n        </button>\n        <div class=\"collapse packContent\" ng-hide=\"!$ctrl.displayPackContent\">\n          <br>\n          <table>\n            <tr ng-repeat=\"content in $ctrl.packContent\">\n              <td align=\"left\" valign=\"top\">\n                <span>\n                  <img ng-src=\"{{content.icon}}.gif\" alt=\"{{content.title}}\" fallback-src=\"/img/products/icon/sample.gif\"/>\n                </span>\n              </td>\n              <td align=\"left\" valign=\"top\" class=\"packContentInfo\">\n                <b>{{content.title}}</b><br>\n                <i>{{content.publisher}}</i><br>\n                <span ng-bind-html=\"content.shortDescription | trustHtml\" />\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n      <button ng-if=\"$ctrl.loaded && $ctrl.buttonLabel && $ctrl.isBuyable\" ng-click=\"$ctrl.goPurchase()\" class=\"basket\" ga-track-event=\"['Product Details', 'Click', '{{ $ctrl.buttonLabel | translate | escapeSingleQuote }} _ {{ $ctrl.product.title | escapeSingleQuote }}']\">\n        <img src=\"img/basket.png\" alt=\"\">\n        {{ $ctrl.buttonLabel | translate }}\n      </button>\n    </section>\n    <section class=\"description card\">\n      <h2>\n        {{ 'productDetails.description' | translate }}\n      </h2>\n      <div class=\"carousel\">\n        <ul class=\"elements\" rn-carousel rn-carousel-controls-allow-loop rn-carousel-index=\"$ctrl.slideIndex\" ng-if=\"$ctrl.screenshots.length > 0\" >\n          <li ng-repeat=\"screenshot in $ctrl.screenshots\" >\n            <img ng-src=\"{{screenshot}}.gif\" fallback-src=\"/img/no-image.gif\"/>\n          </li>\n        </ul>\n        <ul class=\"controls\">\n          <li class=\"leftArrow\" ng-click=\"$ctrl.slideIndex = $ctrl.slideIndex - 1\" ng-if=\"$ctrl.slideIndex > 0\"><button ga-track-event=\"['Product Details', 'Click', 'Previous Screenshot _ {{ $ctrl.product.title | escapeSingleQuote }}']\"></button></li>\n          <li class=\"rightArrow\" ng-click=\"$ctrl.slideIndex = $ctrl.slideIndex + 1\" ng-if=\"$ctrl.slideIndex < $ctrl.screenshots.length - 1\"><button ga-track-event=\"['Product Details', 'Click', 'Next Screenshot _ {{ $ctrl.product.title | escapeSingleQuote }}']\"></button></li>\n        </ul>\n        <div class=\"indicators\" rn-carousel-indicators ng-if=\"$ctrl.screenshots.length > 1\" slides=\"$ctrl.screenshots\" rn-carousel-index=\"$ctrl.slideIndex\"></div>\n      </div>\n      <p ng-bind-html=\"$ctrl.product.longDescription | trustHtml\" />\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_INFO_PREFIX = 'hideProductInfo';
	
	var ProductDetailsController = function () {
	  ProductDetailsController.$inject = ["ProductService", "IdsService", "VehicleService", "$scope", "$window", "$stateParams", "$state", "$sce", "ProductUtilsService", "I18n", "$rootScope", "$log"];
	  function ProductDetailsController(ProductService, IdsService, VehicleService, $scope, $window, $stateParams, $state, $sce, ProductUtilsService, I18n, $rootScope, $log) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ProductDetailsController);
	    this.isProcessing = true;
	    this.$window = $window;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$log = $log;
	    this.productService = ProductService;
	    this.idsService = IdsService;
	    this.vehicleService = VehicleService;
	    this.i18n = I18n;
	    this.ref = $stateParams.ref.toString();
	    this.group = $stateParams.group;
	    this.$sce = $sce;
	    this.productUtilsService = ProductUtilsService;
	    this.product = {
	      title: ''
	    };
	    if (this.group) {
	      this.selectedProduct = (0, _assign2.default)({}, this.group.find(function (element) {
	        return element.ref === _this.ref;
	      }));
	    }
	    this.spaceWarning = '';
	    this.loaded = this.init();
	
	    $window.scrollTo(0, 0);
	  }
	
	  (0, _createClass3.default)(ProductDetailsController, [{
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      this.isBuyable = false;
	      return this.vehicleService.getCurrentSelectedVehicle().then(function (v) {
	        if (!v) {
	          return _promise2.default.reject('Unable to get current selected vehicle');
	        }
	        _this2.vehicle = v;
	        return _this2.productService.getProduct(_this2.ref, _this2.vehicle.vin, _this2.i18n.getLanguage());
	      }).then(function (product) {
	        _this2.product = product;
	        _this2.screenshots = _this2.productUtilsService.getScreenShots(product.screenshot.split('#'));
	        _this2.size = Number(product.size) / 1048576;
	        _this2.productInfo();
	        if (_this2.product.infoCode === 7 && _this2.productUtilsService.isContent(_this2.product)) {
	          return _this2.productService.getIsPreviouslyInstalled(_this2.ref, _this2.vehicle.vin);
	        } else {
	          return _promise2.default.resolve(false);
	        }
	      }).then(function (userOwnLastestVersion) {
	        if (userOwnLastestVersion) {
	          _this2.infoCode = 0;
	        }
	        _this2.isBuyable = _this2.productUtilsService.isBuyable(_this2.product, _this2.vehicle, userOwnLastestVersion);
	        _this2.isProcessing = false;
	        _this2.safeApply();
	        return _promise2.default.resolve().then(function () {
	          _this2.checkDeviceTotalSpace();
	        });
	      }, function (err) {
	        _this2.$log.error(err);
	        _this2.info = null;
	        _this2.error = err;
	        _this2.product = null;
	        _this2.isProcessing = false;
	        _this2.safeApply();
	        return _promise2.default.reject();
	      });
	    }
	  }, {
	    key: 'safeApply',
	    value: function safeApply() {
	      var phase = this.$rootScope.$$phase;
	      if (phase !== '$apply' && phase !== '$digest') {
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration(item) {
	      return this.productUtilsService.getDuration(item, true);
	    }
	  }, {
	    key: 'changeProduct',
	    value: function changeProduct() {
	      if (this.selectedProduct) {
	        this.ref = this.selectedProduct.ref;
	        this.isProcessing = true;
	        this.$state.go('vehicle.productDetails', { ref: this.ref, group: this.group });
	      }
	    }
	  }, {
	    key: 'goPurchase',
	    value: function goPurchase() {
	      var productId = this.ref;
	      this.$state.go('managePurchase.myPurchase', { productId: productId });
	    }
	  }, {
	    key: 'productInfo',
	    value: function productInfo() {
	      var huType = this.vehicle.huType;
	      if (huType === 'MM12') {
	        this.info = {
	          cookieKey: PRODUCT_INFO_PREFIX + '.mm12.' + this.ref,
	          message: 'productDetails.infoMessage.info_mm12'
	        };
	      } else if (huType === 'RADNAV') {
	        this.info = {
	          cookieKey: PRODUCT_INFO_PREFIX + '.radnav.' + this.ref,
	          message: 'productDetails.infoMessage.info_radnav'
	        };
	      }
	    }
	  }, {
	    key: 'checkDeviceTotalSpace',
	    value: function checkDeviceTotalSpace() {
	      var _this3 = this;
	
	      if (this.product.tomtomId && (this.product.tomtomId.substring(0, 4) === 'map/' || this.product.tomtomId.substring(0, 11) === 'mappackage_')) {
	        console.log('Map ' + this.product.ref + ' has tomtomId = ' + this.product.tomtomId);
	        this.productService.checkIfMapIsInstallable(this.vehicle.vin, this.product.ref).then(function (response) {
	          console.log('This map is installable: ' + response);
	          if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
	            _this3.spaceWarning = 'map';
	            _this3.isBuyable = false;
	          } else if (response === 'DEVICE_UNKNOWN_BY_TOMTOM' || response === 'DEVICE_UNKNOWN_BY_SIG') {
	            _this3.spaceWarning = 'pds';
	            _this3.isBuyable = false;
	          }
	        });
	      } else if (this.product.packageNameMus && (this.product.packageNameMus.substring(0, 4) === 'map/' || this.product.packageNameMus.substring(0, 11) === 'mappackage_')) {
	        console.log('MUS ' + this.product.ref + ' has packageNameMus = ' + this.product.packageNameMus);
	        this.productService.checkIfLatestMapIsInstallable(this.vehicle.vin, this.ref).then(function (response) {
	          console.log('The latest map available is installable: ' + response);
	          if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
	            _this3.spaceWarning = 'mus';
	            _this3.isBuyable = false;
	          } else if (response === 'DEVICE_UNKNOWN_BY_TOMTOM' || response === 'DEVICE_UNKNOWN_BY_SIG') {
	            _this3.spaceWarning = 'pds';
	            _this3.isBuyable = false;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'isPromotion',
	    get: function get() {
	      return this.productUtilsService.isPromotion(this.product);
	    }
	  }, {
	    key: 'actualPrice',
	    get: function get() {
	      return this.productUtilsService.getActualPrice(this.product);
	    }
	  }, {
	    key: 'isPackOrBundle',
	    get: function get() {
	      return this.productUtilsService.isPackOrBundle(this.product);
	    }
	  }, {
	    key: 'buttonLabel',
	    get: function get() {
	      return this.productUtilsService.getButtonLabel(this.product);
	    }
	  }, {
	    key: 'warningMessage',
	    get: function get() {
	      return this.productUtilsService.getWarningMessage(this.product, this.spaceWarning, this.vehicle.huType);
	    }
	  }, {
	    key: 'packContent',
	    get: function get() {
	      return this.productUtilsService.getPackContent(this.product);
	    }
	  }]);
	  return ProductDetailsController;
	}();
	
	exports.default = ProductDetailsController;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1222);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./product-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./product-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, "product-details .sheet>dl:first-child>dt{width:115px;height:86px;background-color:#000;text-align:center;margin-bottom:1em}@media (min-width:600px){product-details .sheet>dl:first-child>dt{width:170px;height:127px}}product-details .sheet>dl:first-child>dt img{width:auto;max-width:100%;max-height:100%;padding:2px;position:relative;top:50%;transform:translateY(-50%);margin-bottom:0}product-details app-message{margin:0}product-details app-message p.info{background-color:#fc3;font-weight:700;padding:1.5em 9% 1.5em 1.5em;margin-bottom:1em;text-align:center}product-details app-message p.info span{padding:0}product-details app-message:empty{margin:0}product-details app-message p>a{right:4%}product-details div.carUp.card p{overflow:hidden;text-overflow:ellipsis}product-details .datasheet .carousel>ul>li>img{max-height:100%;width:auto}@media (max-width:599px){product-details .carousel{height:272px}}@media (min-width:600px){product-details .carousel{height:460px}}product-details .packContent tr>td:first-child{width:115px;height:86px;text-align:center;padding:2px}@media (min-width:600px){product-details .packContent tr>td:first-child{width:170px;margin-bottom:0;height:127px}}product-details .packContent tr>td:first-child span{background-color:#000;height:100%;width:100%;display:block}product-details .packContent tr>td:first-child img{width:auto;height:auto;max-width:100%;padding:2px;position:relative;top:50%;transform:translateY(-50%);margin-bottom:0}product-details .packContent .packContentInfo{word-break:break-word;padding-left:.5em}product-details .warningMessage{clear:both}.prev{background-color:transparent!important}@media (max-width:370px){.datasheet .description>p{width:235px}}.sheet dl.price dd.price{margin-top:0!important}.sheet dl.price{margin-top:.6em!important}", ""]);
	
	// exports


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var component = {
	  template: '<ui-view/>'
	};
	
	exports.default = component;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _changePassword = __webpack_require__(1225);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('changePassword', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('changePassword', {
	    url: '/change-password',
	    component: 'changePassword',
	    authenticate: true
	  });
	}]).component('changePassword', _changePassword2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _changePassword = __webpack_require__(1226);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _changePassword3 = __webpack_require__(1227);
	
	var _changePassword4 = _interopRequireDefault(_changePassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _changePassword2.default,
	  controller: _changePassword4.default
	};
	
	exports.default = component;

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageContent paddingLight\">\n  <h2>{{ 'changePassword.title' | translate }}</h2>\n\n  <form name=\"changePasswordForm\" class=\"miniContent separator\" ng-submit=\"$ctrl.changePassword(this)\" novalidate>\n    <app-spinner ng-if=\"$ctrl.isProcessing\"></app-spinner>\n\n    <div class=\"form-field\">\n      <label for=\"_oldPassword\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.oldPassword.label' | translate }}</label>\n      <input id=\"_oldPassword\"\n             name=\"oldPassword\"\n             type=\"password\"\n             ng-model=\"$ctrl.updatePassword.oldPassword\"\n             ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n             ng-change=\"$ctrl.validateOldPassword()\"\n             required\n      />\n      <div class=\"field-errors hideOnInactive\"\n           ng-messages=\"changePasswordForm.oldPassword.$error\"\n           ng-if=\"changePasswordForm.oldPassword.$touched || changePasswordForm.$submitted\">\n        <p ng-message=\"required\">{{'common.fields.password.validation.required' | translate }}</p>\n        <p ng-show=\"!$ctrl.isValidOldPassword\" class=\"field-errors\">{{ 'common.fields.password.validation.pattern' | translate }}</p>\n      </div>\n      <div class=\"field-errors\">\n        <p ng-show=\"$ctrl.isWrongOldPassword\">{{ 'common.fields.oldPassword.validation.wrong' | translate }}</p>\n      </div>\n    </div>\n\n    <div class=\"form-field\">\n      <label for=\"_newPassword\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.newPassword.label' | translate }}</label>\n      <input id=\"_newPassword\"\n             name=\"newPassword\"\n             type=\"password\"\n             ng-model=\"$ctrl.updatePassword.newPassword\"\n             ng-minlength=\"$ctrl.ValidationRules.password.minlength\"\n             ng-maxlength=\"$ctrl.ValidationRules.password.maxlength\"\n             ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n             required\n             different-from=\"$ctrl.updatePassword.oldPassword\"\n             check-password\n      />\n      <div class=\"field-errors\"\n           ng-messages=\"changePasswordForm.newPassword.$error\"\n           ng-if=\"changePasswordForm.newPassword.$touched || changePasswordForm.$submitted\">\n        <p ng-message=\"required\">{{'common.fields.password.validation.required' | translate }}</p>\n        <p ng-message=\"minlength\">{{ 'common.fields.password.validation.minlength'\n          | translate: {minlength: $ctrl.ValidationRules.password.minlength} }}</p>\n        <p ng-message=\"maxlength\">{{ 'common.fields.password.validation.maxlength'\n          | translate: { maxlength: $ctrl.ValidationRules.password.maxlength} }}</p>\n        <p ng-message=\"checkPassword\">{{ 'common.fields.password.validation.pattern' | translate }}</p>\n        <p ng-message=\"differentFrom\">{{ 'common.fields.password.validation.different' | translate }}</p>\n      </div>\n    </div>\n\n    <div class=\"form-field\">\n      <label for=\"_newPasswordConfirmation\" ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">{{ 'common.fields.passwordConfirmation.label' |\n        translate }}</label>\n      <input id=\"_newPasswordConfirmation\"\n             name=\"newPasswordConfirmation\"\n             type=\"password\"\n             ng-model=\"$ctrl.updatePassword.newPasswordConfirmation\"\n             ng-class=\"{'arabDirection':  $ctrl.I18n.isArLocale()}\"\n             required\n             compare-to=\"$ctrl.updatePassword.newPassword\"\n      />\n      <div class=\"field-errors\"\n           ng-messages=\"changePasswordForm.newPasswordConfirmation.$error\"\n           ng-if=\"changePasswordForm.newPasswordConfirmation.$touched || changePasswordForm.$submitted\">\n        <p ng-message=\"required\">{{ 'common.fields.password.validation.required' | translate }}</p>\n        <p ng-message=\"compareTo\">{{ 'common.fields.password.validation.compareTo' | translate }}</p>\n      </div>\n    </div>\n\n\n    <button type=\"submit\" ng-disabled=\"$ctrl.isProcessing\" ga-track-event=\"['Change Password', 'Click', 'Confirm']\">{{ 'common.confirm' | translate\n      }}\n    </button>\n\n  </form>\n</div>\n"

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangePasswordController = function () {
	  ChangePasswordController.$inject = ["Localization", "ValidationRules", "UserService", "VehicleService", "$state", "$stateParams", "I18n", "$rootScope"];
	  function ChangePasswordController(Localization, ValidationRules, UserService, VehicleService, $state, $stateParams, I18n, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ChangePasswordController);
	    this.I18n = I18n;
	    this.userService = UserService;
	    this.vehicleService = VehicleService;
	    this.validationRules = ValidationRules;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.isProcessing = false;
	    this.updatePassword = {};
	    this.isValidOldPassword = true;
	    this.isWrongOldPassword = false;
	  }
	
	  (0, _createClass3.default)(ChangePasswordController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      if (form.changePasswordForm.$valid) {
	        this.isProcessing = true;
	        this.isValidOldPassword = true;
	        return this.userService.changePassword(this.updatePassword.oldPassword, this.updatePassword.newPassword).then(function (success) {
	          _this.userService.logout().then(function () {
	            return _this.$state.go('home', { success: 'my-updates.update_success' });
	          });
	        }, function (err) {
	          _this.error = err;
	          if (_this.error.data.meta.code === 524) {
	            _this.errorCode = _this.error.data.meta.code;
	          }
	          if (_this.error.data.meta.statusCode === 403) {
	            _this.isWrongOldPassword = true;
	          }
	          _this.isProcessing = false;
	        });
	      }
	    }
	
	    /**
	     * validate old password
	     * it should match the old password patter or with checkPassword WS
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'validateOldPassword',
	    value: function validateOldPassword() {
	      var _this2 = this;
	
	      this.isValidOldPassword = true;
	      if (this.updatePassword.oldPassword && this.updatePassword.oldPassword.length >= 8 && this.updatePassword.oldPassword.length <= 32) {
	        var isMatchOldPattern = this.updatePassword.oldPassword.match(this.validationRules.password.pattern);
	        if (isMatchOldPattern === null) {
	          this.userService.checkPassword(this.updatePassword.oldpassword).then(function (valid) {
	            _this2.isValidOldPassword = true;
	            return _promise2.default.resolve();
	          }, function (err) {
	            _this2.isValidOldPassword = false;
	            return _promise2.default.reject(err);
	          });
	        }
	      }
	      return this.isValidOldPassword;
	    }
	  }]);
	  return ChangePasswordController;
	}();
	
	exports.default = ChangePasswordController;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _banner = __webpack_require__(1229);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _buffer = __webpack_require__(1244);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _countries = __webpack_require__(1245);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _device = __webpack_require__(1246);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _helpers = __webpack_require__(1247);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _ids = __webpack_require__(1248);
	
	var _ids2 = _interopRequireDefault(_ids);
	
	var _payment = __webpack_require__(1249);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _product = __webpack_require__(1250);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productUtils = __webpack_require__(1251);
	
	var _productUtils2 = _interopRequireDefault(_productUtils);
	
	var _registration = __webpack_require__(1252);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	var _subscription = __webpack_require__(1253);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _user = __webpack_require__(1254);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vehicle = __webpack_require__(1255);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _voucher = __webpack_require__(1257);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _voucher3 = __webpack_require__(1258);
	
	var _voucher4 = _interopRequireDefault(_voucher3);
	
	var _metrics = __webpack_require__(1259);
	
	var _metrics2 = _interopRequireDefault(_metrics);
	
	var _sdfilter = __webpack_require__(1260);
	
	var _sdfilter2 = _interopRequireDefault(_sdfilter);
	
	var _documents = __webpack_require__(1261);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	var _cookies = __webpack_require__(1262);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('services', []).service('BannerService', _banner2.default).factory('BufferFactory', _buffer2.default).service('CountriesService', _countries2.default).service('DeviceService', _device2.default).service('HelpersService', _helpers2.default).service('IdsService', _ids2.default).service('PaymentService', _payment2.default).service('ProductService', _product2.default).service('ProductUtilsService', _productUtils2.default).service('RegistrationService', _registration2.default).service('SubscriptionService', _subscription2.default).service('UserService', _user2.default).service('VehicleService', _vehicle2.default).factory('VoucherFactory', _voucher4.default).service('VoucherService', _voucher2.default).service('MetricsService', _metrics2.default).service('SDFilterService', _sdfilter2.default).service('DocumentsService', _documents2.default).service('CookiesService', _cookies2.default).name;
	
	exports.default = _module;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerService = function (_ApiService) {
	  (0, _inherits3.default)(BannerService, _ApiService);
	
	  function BannerService() {
	    (0, _classCallCheck3.default)(this, BannerService);
	    return (0, _possibleConstructorReturn3.default)(this, (BannerService.__proto__ || (0, _getPrototypeOf2.default)(BannerService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BannerService, [{
	    key: 'getBanners',
	
	
	    /**
	     * Get banners.
	     * @param {object} params - parametres needed to retrieve the banners
	     * @return {promise} banners
	     */
	    value: function getBanners(params) {
	      var _this2 = this;
	
	      var inCache = this.getFromCache(params);
	      if (inCache) {
	        // Get result form cache
	        return _promise2.default.resolve(inCache);
	      }
	      return this.get('/catalog/banners', { params: params }).then(function (res) {
	        _this2.$log.info('Fetched banners', res.data);
	        _this2.putInCache(params, res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return BannerService;
	}(_api2.default);
	
	exports.default = BannerService;

/***/ }),
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApiService = function () {
	  ApiService.$inject = ["$log", "$http", "$window", "$rootScope", "Localization", "I18n"];
	  function ApiService($log, $http, $window, $rootScope, Localization, I18n) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ApiService);
	    this.$log = $log;
	    this.$http = $http;
	    this.$window = $window;
	    this.$rootScope = $rootScope;
	    this.endpoint = Localization.getLocalizedAppConfig().endpoint;
	    this.useCache = Localization.getLocalizedAppConfig().useCache;
	    this.defaultHeaders = {
	      'X-Locale': I18n.getLanguage(),
	      'X-Country': Localization.getCountry()
	    };
	    this.initCache();
	
	    $rootScope.$on('user:logout', function (event, data) {
	      _this.initCache();
	    });
	
	    $rootScope.$on('language:changed', function (event, data) {
	      _this.defaultHeaders['X-Locale'] = data;
	    });
	  }
	
	  (0, _createClass3.default)(ApiService, [{
	    key: 'initCache',
	    value: function initCache() {
	      this.cache = {};
	    }
	  }, {
	    key: 'getFromCache',
	    value: function getFromCache(key) {
	      if (!this.useCache) {
	        return null;
	      }
	      // this.$log.debug('Try to get object from cache:', key)
	      key = this._getCacheKey(key);
	      if (this.cache[key]) {
	        // this.$log.debug('Get object from cache:', key)
	        return this.cache[key];
	      }
	      return null;
	    }
	  }, {
	    key: 'putInCache',
	    value: function putInCache(key, obj) {
	      if (!this.useCache) {
	        return null;
	      }
	      // this.$log.debug('Put object into the cache:', key)
	      this.cache[this._getCacheKey(key)] = obj;
	    }
	  }, {
	    key: '_getCacheKey',
	    value: function _getCacheKey(obj) {
	      var str = (0, _stringify2.default)(obj);
	      var hash = 0;
	      if (str.length === 0) return hash;
	      for (var i = 0; i < str.length; i++) {
	        var chr = str.charCodeAt(i);
	        hash = (hash << 5) - hash + chr;
	        hash |= 0; // Convert to 32bit integer
	      }
	      // this.$log.debug('Calculated hash:', hash)
	      return 'h' + hash;
	    }
	  }, {
	    key: '_setDefaultHeaders',
	    value: function _setDefaultHeaders() {
	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      config.headers = (0, _assign2.default)({}, this.defaultHeaders, config.headers);
	      return config;
	    }
	  }, {
	    key: 'post',
	    value: function post(url, body, config) {
	      config = this._setDefaultHeaders(config);
	      return this.$http.post(this.endpoint + url, body, config);
	    }
	  }, {
	    key: 'get',
	    value: function get(url, config) {
	      config = this._setDefaultHeaders(config);
	      return this.$http.get(this.endpoint + url, config);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, body, config) {
	      config = this._setDefaultHeaders(config);
	      return this.$http.put(this.endpoint + url, body, config);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url, config) {
	      config = this._setDefaultHeaders(config);
	      return this.$http.delete(this.endpoint + url, config);
	    }
	  }]);
	  return ApiService;
	}();
	
	exports.default = ApiService;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BufferFactory = function BufferFactory($injector, $log) {
	  'ngInject';
	
	  /** Holds all the requests, so they can be re-requested in future. */
	
	  var buffer = [];
	
	  /** Service initialized later because of circular dependency problem. */
	  var $http = void 0;
	
	  /**
	   * Appends HTTP request configuration object with promise response attached to buffer.
	   * @return {Number} The new length of the buffer.
	   */
	  var append = function append(config, promise) {
	    $log.debug('append', config);
	    return buffer.push({
	      config: config,
	      promise: promise
	    });
	  };
	
	  /**
	   * Abandon or reject all the buffered requests.
	   */
	  var rejectAll = function rejectAll(reason) {
	    $log.debug('rejectAll', reason);
	    return _promise2.default.all(buffer.map(function (buf) {
	      $log.debug('reject', buf);
	      return buf.promise.reject(reason);
	    })).then(function () {
	      $log.debug('rejectAll: cleaning buffer');
	      buffer = [];
	    });
	  };
	
	  /**
	   * Retries all the buffered requests clears the buffer.
	   */
	  var retryAll = function retryAll() {
	    $log.debug('retryAll');
	    return _promise2.default.all(buffer.map(function (buf) {
	      $log.debug('retry', buf);
	      $http = $http || $injector.get('$http');
	      return $http(buf.config).then(buf.promise.resolve, buf.promise.reject);
	    })).then(function () {
	      $log.debug('retryAll: cleaning buffer');
	      buffer = [];
	    });
	  };
	
	  return { append: append, rejectAll: rejectAll, retryAll: retryAll };
	};
	BufferFactory.$inject = ["$injector", "$log"];
	
	exports.default = BufferFactory;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountriesService = function (_ApiService) {
	  (0, _inherits3.default)(CountriesService, _ApiService);
	
	  function CountriesService() {
	    (0, _classCallCheck3.default)(this, CountriesService);
	    return (0, _possibleConstructorReturn3.default)(this, (CountriesService.__proto__ || (0, _getPrototypeOf2.default)(CountriesService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CountriesService, [{
	    key: 'getCountries',
	    value: function getCountries() {
	      return this.get('/countries', {}).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return CountriesService;
	}(_api2.default);
	
	exports.default = CountriesService;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MOBILE_UA = /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/;
	var TABLET_UA = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/;
	
	var DEVICES = {
	  MOBILE: 1,
	  TABLET: 2,
	  DESKTOP: 3
	};
	
	var DeviceService = function () {
	  DeviceService.$inject = ["$rootScope", "$log"];
	  function DeviceService($rootScope, $log) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DeviceService);
	    this.ua = navigator.userAgent.toLowerCase();
	    this.device = DEVICES.DESKTOP;
	    if (TABLET_UA.test(this.ua)) {
	      this.device = DEVICES.TABLET;
	    } else if (MOBILE_UA.test(this.ua)) {
	      this.device = DEVICES.MOBILE;
	    }
	
	    this.windowWidth = this.width;
	    window.addEventListener('resize', function () {
	      // $log.debug('resize event fired')
	      // $log.debug('windowWidth', this.windowWidth)
	      // $log.debug('width', this.width)
	      if (_this.windowWidth !== _this.width) {
	        _this.windowWidth = _this.width;
	        $rootScope.$broadcast('width:resized');
	      }
	    });
	  }
	
	  (0, _createClass3.default)(DeviceService, [{
	    key: 'getAtcDeviceId',
	    value: function getAtcDeviceId() {
	      if (this.isMobile()) {
	        return 2;
	      } else if (this.isTablet()) {
	        return 4;
	      } else {
	        return 1;
	      }
	    }
	  }, {
	    key: 'isSmallScreen',
	    value: function isSmallScreen() {
	      return this.width < 468 || this.width >= 650 && this.width < 664;
	    }
	  }, {
	    key: 'isMediumScreen',
	    value: function isMediumScreen() {
	      return this.width >= 468 && this.width < 598 || this.width >= 664 && this.width < 847;
	    }
	  }, {
	    key: 'isLargeScreen',
	    value: function isLargeScreen() {
	      return this.width >= 598 && this.width < 650 || this.width >= 847;
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return this.device === DEVICES.MOBILE;
	    }
	  }, {
	    key: 'isTablet',
	    value: function isTablet() {
	      return this.device === DEVICES.TABLET;
	    }
	  }, {
	    key: 'isDesktop',
	    value: function isDesktop() {
	      return this.device === DEVICES.DESKTOP;
	    }
	  }, {
	    key: 'width',
	    get: function get() {
	      // return document.body.clientWidth
	      return window.innerWidth;
	    }
	  }]);
	  return DeviceService;
	}();
	
	exports.default = DeviceService;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(899);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpersService = function () {
	  function HelpersService() {
	    (0, _classCallCheck3.default)(this, HelpersService);
	  }
	
	  (0, _createClass3.default)(HelpersService, [{
	    key: 'openTooltip',
	    value: function openTooltip(e) {
	      this.closeTooltip();
	      var $this = (0, _jquery2.default)(e);
	      var message = $this.parent().find('.tooltipMessage');
	      message.css('top', parseInt($this.css('top')) + $this.height() + 15);
	      message.css('left', parseInt($this.css('left')) - message.width() / 2 - 6);
	      message.addClass('active');
	    }
	  }, {
	    key: 'closeTooltip',
	    value: function closeTooltip() {
	      (0, _jquery2.default)('.tooltipMessage.active').removeClass('active');
	    }
	  }]);
	  return HelpersService;
	}();
	
	exports.default = HelpersService;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IdsService = function (_ApiService) {
	  (0, _inherits3.default)(IdsService, _ApiService);
	
	  function IdsService() {
	    (0, _classCallCheck3.default)(this, IdsService);
	    return (0, _possibleConstructorReturn3.default)(this, (IdsService.__proto__ || (0, _getPrototypeOf2.default)(IdsService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(IdsService, [{
	    key: 'encode',
	
	
	    /**
	     * Encode value
	     * @param {String} value Value to encode
	     * @return {Promise} encoded value
	     */
	    value: function encode(value) {
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var cacheKey = 'svalue-' + value;
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get encoded value from cache
	        return _promise2.default.resolve(inCache);
	      }
	      return this.post('/ids/' + value + '/encode', {}, {}).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Decode value
	     * @param {String} value Value to decode
	     * @return {Promise} decoded value
	     */
	
	  }, {
	    key: 'decode',
	    value: function decode(value) {
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var cacheKey = 'svalue-' + value;
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get decoded value from cache
	        return _promise2.default.resolve(inCache);
	      }
	      return this.post('/ids/' + value + '/decode', {}, {}).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return IdsService;
	}(_api2.default);
	
	exports.default = IdsService;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentService = function (_ApiService) {
	  (0, _inherits3.default)(PaymentService, _ApiService);
	
	  function PaymentService() {
	    (0, _classCallCheck3.default)(this, PaymentService);
	    return (0, _possibleConstructorReturn3.default)(this, (PaymentService.__proto__ || (0, _getPrototypeOf2.default)(PaymentService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PaymentService, [{
	    key: 'getWorldpayMeansOfPayments',
	    value: function getWorldpayMeansOfPayments(isTokenisable) {
	      return this.get('/payment/means', {
	        params: {
	          'psptype': 'WORLDPAY',
	          'tokenisable': isTokenisable
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'validatePaymentWorldpay',
	    value: function validatePaymentWorldpay(orderRef, paymentStatus, paymentAmount, paymentCurrency, mac) {
	      return this.get('/payment', {
	        params: {
	          'psptype': 'WORLDPAY',
	          'reference': orderRef,
	          'status': paymentStatus,
	          'amount': paymentAmount,
	          'currency': paymentCurrency
	          // TODO 'mac': mac
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return PaymentService;
	}(_api2.default);
	
	exports.default = PaymentService;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductService = function (_ApiService) {
	  (0, _inherits3.default)(ProductService, _ApiService);
	
	  function ProductService() {
	    (0, _classCallCheck3.default)(this, ProductService);
	    return (0, _possibleConstructorReturn3.default)(this, (ProductService.__proto__ || (0, _getPrototypeOf2.default)(ProductService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProductService, [{
	    key: 'getNumberProductToUpdate',
	
	    /**
	     * Get number of products to update.
	     * @param {String} vin VIN
	     * @param {boolean} useCache Try to get categories from the cache
	     * @return {Promise} number of products to update
	     */
	    value: function getNumberProductToUpdate(vin) {
	      var _this2 = this;
	
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      this.$log.debug('getNumberProductToUpdate', vin);
	      var cacheKey = 'nb-product-' + vin;
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get product form cache
	        return _promise2.default.resolve(inCache);
	      }
	      return this.get('/products/update/count', { params: { vin: vin } }).then(function (res) {
	        _this2.putInCache(cacheKey, res.data);
	        _this2.$log.info('Fetched number of products to update', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get products to update.
	     * @param {String} vin VIN
	     * @return {Promise} products to update
	     */
	
	  }, {
	    key: 'getProductsToUpdate',
	    value: function getProductsToUpdate(vin) {
	      var _this3 = this;
	
	      return this.get('/products/update', { params: { vin: vin } }).then(function (res) {
	        _this3.$log.info('Fetched products to updates', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Ask to update products of a vehicle.
	     * @param {String} vin VIN
	     * @param {String} ref product reference
	     * @return {Promise} update result
	     */
	
	  }, {
	    key: 'updateProducts',
	    value: function updateProducts(vin, ref) {
	      var _this4 = this;
	
	      return this.put('/products/update', null, { params: { vin: vin, ref: ref } }).then(function (res) {
	        _this4.$log.info('Update products requested', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get product categories.
	     * @param {boolean} useCache Try to get categories from the cache
	     * @return {Promise} Promise of the categories
	     */
	
	  }, {
	    key: 'getProductCategories',
	    value: function getProductCategories() {
	      var _this5 = this;
	
	      var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var cacheKey = 'product_categories';
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get categories from cache
	        return _promise2.default.resolve(inCache);
	      } else {
	        // Get categories from the API
	        return this.get('/products/categories').then(function (res) {
	          _this5.putInCache('product_categories', res.data.categories);
	          _this5.$log.info('Fetched product categories');
	          return _promise2.default.resolve(res.data.categories);
	        });
	      }
	    }
	
	    /**
	     * Get products.
	     * @param {object} params request params
	     * @param {boolean} useCache Try to get products from the cache
	     * @return {Promise} Promise of the products
	     */
	
	  }, {
	    key: 'getProducts',
	    value: function getProducts(params) {
	      var _this6 = this;
	
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      this.$log.debug('getProducts', params);
	      var inCache = this.getFromCache(params);
	      if (useCache && inCache) {
	        // Get products form cache
	        return _promise2.default.resolve(inCache);
	      }
	      // Get products from the API
	      return this.get('/products', { params: params }).then(function (res) {
	        _this6.putInCache(params, res.data);
	        _this6.$log.info('Fetched products', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get product.
	     * @param {string} ref Product REF
	     * @param {string} vin VIN
	     * @param {boolean} useCache Try to get products from the cache
	     * @return {Promise} Promise of the products
	     */
	
	  }, {
	    key: 'getProduct',
	    value: function getProduct(ref, vin, locale) {
	      var _this7 = this;
	
	      var useCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var cacheKey = 'product-' + ref + '-' + vin + '-' + locale;
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get product form cache
	        return _promise2.default.resolve(inCache);
	      }
	      // Get product from the API
	      return this.get('/products/' + ref, {
	        params: {
	          'vin': vin
	        }
	      }).then(function (res) {
	        _this7.putInCache(cacheKey, res.data);
	        _this7.$log.info('Fetched product');
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get invoice download URL.
	     * @param {String} productRef Product ref.
	     * @param {String} vin VIN
	     * @return {String} Invoice download URL
	     */
	
	  }, {
	    key: 'getProductInvoiceUrl',
	    value: function getProductInvoiceUrl(productRef, vin, token) {
	      var country = this.defaultHeaders['X-Country'];
	      var locale = this.defaultHeaders['X-Locale'];
	      var tokenParam = token ? '&token=' + token : '';
	      return this.endpoint + '/orders/' + productRef + '/invoice?vin=' + vin + '&x-locale=' + locale + '&x-country=' + country + tokenParam;
	    }
	  }, {
	    key: 'getEndpoint',
	    value: function getEndpoint() {
	      return '' + this.endpoint;
	    }
	  }, {
	    key: 'getIsPreviouslyInstalled',
	    value: function getIsPreviouslyInstalled(productRef, vin) {
	      return this.get('/products/' + productRef + '/previous/installed', {
	        params: {
	          'vin': vin
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'buyProduct',
	    value: function buyProduct(vin, productRef, purchaseInfos, voucherInfos) {
	      return this.post('/products/' + productRef + '/buy', purchaseInfos.buyer, {
	        params: {
	          'vin': vin,
	          'optIn': purchaseInfos.optIn,
	          'cgv': true,
	          'withdrawalRights': purchaseInfos.withdrawalRights ? purchaseInfos.withdrawalRights : false,
	          'free': purchaseInfos.isFreeProduct,
	          'paymentId': purchaseInfos.paymentId ? purchaseInfos.paymentId : null,
	          'createToken': purchaseInfos.createToken ? purchaseInfos.createToken : false,
	          'purchaseVoucher': voucherInfos.isPurchaseUsingVoucher,
	          'voucherCode': voucherInfos.voucherCode ? voucherInfos.voucherCode : null,
	          'amountReduction': voucherInfos.amountReduction ? parseFloat(voucherInfos.amountReduction).toFixed(2) : null,
	          'channel': voucherInfos.canalCode ? voucherInfos.canalCode : null,
	          'sessionId': purchaseInfos.sessionId ? purchaseInfos.sessionId : null,
	          'paymentMethod': purchaseInfos.paymentMethod ? purchaseInfos.paymentMethod : null,
	          'token': purchaseInfos.token ? purchaseInfos.token : null
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'checkIfLatestMapIsInstallable',
	    value: function checkIfLatestMapIsInstallable(vin, musId) {
	      return this.get('/products/mus/' + musId + '/latest/map/installable', {
	        params: {
	          'vin': vin
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'getB2BPrice',
	    value: function getB2BPrice(reference, isoCountryCode) {
	      return this.get('/products/' + reference + '/computeB2BPrice', {
	        params: {
	          'isoCountryCode': isoCountryCode
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'checkIfMapIsInstallable',
	    value: function checkIfMapIsInstallable(vin, reference) {
	      return this.get('/products/' + reference + '/installable', {
	        params: {
	          'vin': vin
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /*
	    return this.post('/users/password', email, {
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      }
	    }).then((res) => {
	      Promise.resolve(res.data)
	    })
	    */
	
	  }]);
	  return ProductService;
	}(_api2.default);
	
	exports.default = ProductService;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductUtilsService = function () {
	  function ProductUtilsService() {
	    (0, _classCallCheck3.default)(this, ProductUtilsService);
	  }
	
	  (0, _createClass3.default)(ProductUtilsService, [{
	    key: 'isPromotion',
	    value: function isPromotion(product) {
	      return product.promotedPrice && product.promotedPrice !== product.price;
	    }
	  }, {
	    key: 'getActualPrice',
	    value: function getActualPrice(product) {
	      if (this.isPromotion(product)) {
	        return product.promotedPrice;
	      }
	      return product.price;
	    }
	  }, {
	    key: 'isFree',
	    value: function isFree(product) {
	      // First replace commas by dots
	      var price = product.price.replace(/,/g, '.');
	      // Check that the price equals 'free' or 0
	      return product.price.match(/free/i) || parseFloat(price) === 0;
	    }
	  }, {
	    key: 'isPromotedFree',
	    value: function isPromotedFree(product) {
	      // First replace commas by dots
	      var promotedPrice = product.promotedPrice.replace(/,/g, '.');
	      // Check that the price equals 'free' or 0
	      return this.product.isPromoted && (product.promotedPrice.match(/free/i) || parseFloat(promotedPrice) === 0);
	    }
	  }, {
	    key: 'getBanner',
	    value: function getBanner(product) {
	      if (product.isPromoted) {
	        return 'catalog.product.banner.promoted';
	      }
	      if (product.isTop) {
	        return 'catalog.product.banner.top';
	      }
	      return null;
	    }
	  }, {
	    key: 'getIllustration',
	    value: function getIllustration(product) {
	      var icon = product.icon || 'default';
	      return '/' + icon + '.gif';
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration(product, selected) {
	      if (!selected) {
	        return 'catalog.product.duration.from';
	      }
	      if (product.duration) {
	        if (product.duration === '1') {
	          return 'catalog.product.duration.month';
	        } else if (product.duration > 1) {
	          return 'catalog.product.duration.months';
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'isPack',
	    value: function isPack(product) {
	      return product.productType === 'RcsPack';
	    }
	  }, {
	    key: 'isMus',
	    value: function isMus(product) {
	      return product.productType === 'RcsMus';
	    }
	  }, {
	    key: 'isPackOrBundle',
	    value: function isPackOrBundle(product) {
	      return product.productType === 'RcsPack' || product.productType === 'RcsBundle';
	    }
	  }, {
	    key: 'isContent',
	    value: function isContent(product) {
	      return product.productType === 'RcsContent';
	    }
	  }, {
	    key: 'isProduct',
	    value: function isProduct(product) {
	      return product.productType === 'RcsProduct';
	    }
	  }, {
	    key: 'isExpired',
	    value: function isExpired(product) {
	      if (product.expirationDate) {
	        return new Date(product.expirationDate) < new Date();
	      }
	      return false;
	    }
	  }, {
	    key: 'getButtonLabel',
	    value: function getButtonLabel(product) {
	      var label = void 0;
	      if (!product.isSerial) {
	        if (product.isPurchasable && product.isPurchased) {
	          if ((this.isPack(product) || this.isMus(product)) && product.isRenewable) {
	            if (this.isSubscriptionInProgress(product) || this.isSubscriptionActive(product) && !this.isExpired(product)) {
	              if (product.isEligibilitySLKrequested && product.isEligibilitySLK || !product.isEligibilitySLKrequested) {
	                label = 'productDetails.extend';
	              }
	            } else {
	              if (product.isEligibilitySLKrequested && product.isEligibilitySLK || !product.isEligibilitySLKrequested) {
	                label = 'productDetails.renew';
	              }
	            }
	          }
	        } else {
	          if (product.isTrialConsumed) {
	            label = 'productDetails.extend';
	          } else if (this.getTryAndBuy(product)) {
	            label = 'productDetails.try';
	          } else {
	            label = 'productDetails.buy';
	          }
	        }
	      }
	      return label;
	    }
	  }, {
	    key: 'getTryAndBuy',
	    value: function getTryAndBuy(product) {
	      return product.isPurchasable && !product.isPurchased && (this.isPack(product) || this.isMus(product)) && parseInt(product.tryDuration) > 0;
	    }
	  }, {
	    key: 'getScreenShots',
	    value: function getScreenShots(screenshotsArray) {
	      var screensArrayFull = [];
	      screenshotsArray.forEach(function (screenshot) {
	        if (screenshot) screensArrayFull.push(screenshot);
	      });
	      if (screensArrayFull.length === 0) {
	        screensArrayFull.push('screen/no-screenshot-available');
	      }
	      return screensArrayFull;
	    }
	  }, {
	    key: 'getWarningMessage',
	    value: function getWarningMessage(product, totalSpaceWarning, huType) {
	      var message = 'productDetails.warningMessage.';
	      if (totalSpaceWarning === 'map' || totalSpaceWarning === 'mus') {
	        message += 'insufficientTotalSpace.' + totalSpaceWarning + '.' + huType;
	      } else if (totalSpaceWarning === 'pds') {
	        message += 'deviceUnknown';
	      } else if (product.isSerial === true) {
	        message += 'actionImpossible';
	      } else {
	        switch (product.infoCode) {
	          case 0:
	            message = null;
	            break;
	          case 1:
	            message += 'missingConnectivity';
	            break;
	          case 2:
	            message += 'requiredApp';
	            break;
	          case 7:
	            message += 'insufficientSpace';
	            break;
	          case 8:
	            message += 'deviceUnknown';
	            break;
	          case 9:
	            if (product.productType === 'BUNDLE') {
	              message += 'requiredSkuMissing.bundle';
	            } else {
	              message += 'requiredSkuMissing.pack';
	            }
	            break;
	          case 10:
	            message += 'requiredSkuMissing.app';
	            break;
	          default:
	            message += 'default';
	            break;
	        }
	      }
	      return message;
	    }
	  }, {
	    key: 'getPackContent',
	    value: function getPackContent(product) {
	      var packContent = void 0;
	      if (this.isPackOrBundle(product) && product.items) {
	        packContent = product.items.item;
	      }
	      return packContent;
	    }
	  }, {
	    key: 'isBuyable',
	    value: function isBuyable(product, car, userOwnLastestVersion) {
	      // console.debug('userOwnLastestVersion:' + JSON.stringify(userOwnLastestVersion))
	      return product.infoCode !== 3 && product.infoCode !== 5 && !this.getParentAppOrConnectivityRequired(product) && !this.getIsDeviceUnknownForContent(product, car) && (this.isMM14(car) || userOwnLastestVersion || !this.isNotEnoughSpaceForContent(product, car.huType));
	    }
	  }, {
	    key: 'isMM14',
	    value: function isMM14(car) {
	      var isMM14 = car.huType && car.huType === 'RADNAV';
	      // console.debug('isMM14:' + isMM14)
	      return isMM14;
	    }
	  }, {
	    key: 'getParentAppOrConnectivityRequired',
	    value: function getParentAppOrConnectivityRequired(product) {
	      var resp = product.infoCode === 1 || product.infoCode === 2 || product.infoCode === 10;
	      // console.debug('getParentAppOrConnectivityRequired:' + resp)
	      return resp;
	    }
	  }, {
	    key: 'getIsDeviceUnknownForContent',
	    value: function getIsDeviceUnknownForContent(product, car) {
	      var resp = product && product.productType && this.isContent(product) && car.isConnected && product.infoCode === 8;
	      // console.debug('getIsDeviceUnknownForContent:' + resp)
	      return resp;
	    }
	  }, {
	    key: 'isNotEnoughSpaceForContent',
	    value: function isNotEnoughSpaceForContent(product, huType) {
	      var resp = false;
	      if (!(huType === 'MM12' && (product.tomtomId && product.tomtomId.substring(0, 4) === 'map/' || product.packageNameMus))) {
	        resp = product && product.productType && this.isContent(product) && product.infoCode === 7;
	      }
	      // console.debug('isNotEnoughSpaceForContent:' + resp)
	      return resp;
	    }
	  }, {
	    key: 'isSubscriptionInProgress',
	    value: function isSubscriptionInProgress(product) {
	      return product.status === 'INPROGRESS';
	    }
	  }, {
	    key: 'isSubscriptionActive',
	    value: function isSubscriptionActive(product) {
	      return product.status === 'ACTIVE';
	    }
	  }]);
	  return ProductUtilsService;
	}();
	
	exports.default = ProductUtilsService;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationService = function (_ApiService) {
	  (0, _inherits3.default)(RegistrationService, _ApiService);
	
	  function RegistrationService() {
	    (0, _classCallCheck3.default)(this, RegistrationService);
	    return (0, _possibleConstructorReturn3.default)(this, (RegistrationService.__proto__ || (0, _getPrototypeOf2.default)(RegistrationService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RegistrationService, [{
	    key: 'register',
	    value: function register(profile) {
	      return this.post('/registration', profile);
	    }
	  }, {
	    key: 'confirmRegistration',
	    value: function confirmRegistration(confirmation) {
	      return this.post('/registration/confirm', confirmation);
	    }
	  }]);
	  return RegistrationService;
	}(_api2.default);
	
	exports.default = RegistrationService;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionService = function (_ApiService) {
	  (0, _inherits3.default)(SubscriptionService, _ApiService);
	
	  function SubscriptionService() {
	    (0, _classCallCheck3.default)(this, SubscriptionService);
	    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionService.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubscriptionService, [{
	    key: 'getSubscriptions',
	
	
	    /**
	     * Get subscriptions.
	     * @param {object} parameters (vin, page and nbItemPerPage)
	     * @return {Promise} Promise of the subscriptions
	     */
	    value: function getSubscriptions(params) {
	      var _this2 = this;
	
	      return this.get('/vehicles/' + params.vin + '/subscriptions', {
	        params: {
	          page: params.page,
	          nbItemPerPage: params.nbItemPerPage
	        }
	      }).then(function (res) {
	        _this2.$log.info('Fetched subscriptions', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get transferable subscriptions.
	     * @param {String} source Source VIN
	     * @param {String} target Target VIN
	     * @return {Promise} Promise of the subscriptions
	     */
	
	  }, {
	    key: 'getTransferableSubscriptions',
	    value: function getTransferableSubscriptions(source, target) {
	      var _this3 = this;
	
	      return this.get('/vehicles/' + source + '/subscriptions/transfer', { params: { vin: target } }).then(function (res) {
	        _this3.$log.info('Fetched transferable subscriptions', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Transfer subscriptions from a vin to another.
	     * @param {String} source Source VIN
	     * @param {String} target Target VIN
	     * @return {Promise} Promise of the transfer
	     */
	
	  }, {
	    key: 'transferSubscriptions',
	    value: function transferSubscriptions(source, target) {
	      var _this4 = this;
	
	      return this.put('/vehicles/' + source + '/subscriptions/transfer', null, { params: { vin: target } }).then(function (res) {
	        _this4.$log.info('Subscriptions transfert requested', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return SubscriptionService;
	}(_api2.default);
	
	exports.default = SubscriptionService;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(615);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserService = function (_ApiService) {
	  UserService.$inject = ["$log", "$http", "$window", "$rootScope", "Localization", "I18n", "$state", "BufferFactory", "StoreTypes", "MyRenaultErrorCodes"];
	  (0, _inherits3.default)(UserService, _ApiService);
	
	  function UserService($log, $http, $window, $rootScope, Localization, I18n, $state, BufferFactory, StoreTypes, MyRenaultErrorCodes) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UserService.__proto__ || (0, _getPrototypeOf2.default)(UserService)).call(this, $log, $http, $window, $rootScope, Localization, I18n));
	
	    _this.$state = $state;
	    _this.BufferFactory = BufferFactory;
	    _this.StoreTypes = StoreTypes;
	    _this.type = Localization.getLocalizedAppConfig().type;
	    _this.myRenaultErrorCodes = MyRenaultErrorCodes;
	    _this.myRenaultErrorUrl = Localization.getLocalizedAppConfig().errorUrl;
	    _this.shopUrl = Localization.getLocalizedAppConfig().shopUrl;
	
	    // Refresh token when 401 status is received from API
	    $rootScope.$on('user:unauthorized', function (event, rejection) {
	      _this.$log.debug('user:unauthorized received');
	      return _this.refresh().then(function () {
	        _this.$log.debug('refresh succeeded');
	        return BufferFactory.retryAll();
	      }, function (err) {
	        _this.$log.debug('refresh failed');
	        return _this.resetBufferAndLogout(err);
	      });
	    });
	
	    $rootScope.$on('service:stopped', function () {
	      _this.$log.debug('service stopped');
	      return _this.BufferFactory.rejectAll().then(function () {
	        _this.$log.debug('buffer rejected');
	        _this.clearSession();
	        return _this.$state.go('home');
	      });
	    });
	
	    $rootScope.$on('service:maintenance', function () {
	      _this.$log.debug('service in maintenance');
	      return _this.BufferFactory.rejectAll().then(function () {
	        _this.$log.debug('buffer rejected');
	        _this.clearSession();
	        return _this.$state.go('maintenance');
	      });
	    });
	    return _this;
	  }
	
	  /**
	   * Login
	   * @param {object} credentials User credentials (email/password)
	   * @return {Promise} Promise of the login
	   */
	
	
	  (0, _createClass3.default)(UserService, [{
	    key: 'login',
	    value: function login(credentials) {
	      var _this2 = this;
	
	      // Empty cache before login
	      this.$rootScope.$broadcast('user:logout');
	      return this.post('/login', credentials, {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function (res) {
	        var _res$data = res.data,
	            access_token = _res$data.access_token,
	            token_type = _res$data.token_type,
	            expires_in = _res$data.expires_in,
	            refresh_token = _res$data.refresh_token;
	        var user = res.data.user;
	
	        _this2.$log.debug('Storing token into session storage', access_token);
	        _this2.$window.sessionStorage.token = (0, _stringify2.default)({
	          access_token: access_token, token_type: token_type, expires_in: expires_in, refresh_token: refresh_token
	        });
	        _this2.$window.sessionStorage.captchaNeeded = false;
	        _this2.$log.debug('Storing user into session storage', user);
	        _this2.$window.sessionStorage.user = (0, _stringify2.default)(user);
	        _this2.$rootScope.$broadcast('user:login', user);
	        return _promise2.default.resolve(user);
	      }, function (err) {
	        _this2.$window.sessionStorage.captchaNeeded = err.data.error === 'Captcha needed';
	        return _promise2.default.reject(err);
	      });
	    }
	
	    /**
	     * Refresh user token
	     * @return {Promise} Promise of the refresh
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this3 = this;
	
	      var token = this.getCurrentToken();
	      if (token) {
	        return this.post('/refresh', {}, {
	          params: {
	            'refreshToken': token.refresh_token
	          }
	        }).then(function (res) {
	          var _res$data2 = res.data,
	              access_token = _res$data2.access_token,
	              token_type = _res$data2.token_type,
	              expires_in = _res$data2.expires_in,
	              refresh_token = _res$data2.refresh_token;
	
	          _this3.$log.debug('Storing token into local storage', access_token);
	          _this3.$window.sessionStorage.token = (0, _stringify2.default)({
	            access_token: access_token, token_type: token_type, expires_in: expires_in, refresh_token: refresh_token
	          });
	          return _promise2.default.resolve();
	        });
	      }
	      return _promise2.default.reject();
	    }
	
	    /**
	     * Logout user
	     * @return {Promise} Promise of the logout
	     */
	
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this4 = this;
	
	      this.$log.debug('logout');
	      return this.get('/logout').then(function (res) {
	        _this4.$log.debug('logout succeeded');
	        _this4.clearSession();
	        return _promise2.default.resolve(res);
	      }, function (err) {
	        _this4.$log.debug('logout failed');
	        _this4.clearSession();
	        return _promise2.default.reject(err);
	      });
	    }
	
	    /**
	     * Remove session and cache information and broadcast logout event
	     */
	
	  }, {
	    key: 'clearSession',
	    value: function clearSession() {
	      var _this5 = this;
	
	      this.$log.debug('clearing session...');
	      this.$window.sessionStorage.removeItem('user');
	      this.$window.sessionStorage.removeItem('token');
	      this.$window.localStorage.removeItem('token');
	      this.$window.sessionStorage.removeItem('vin');
	      this.initCache();
	      this._fetchingCurrentUser = null;
	      this.BufferFactory.rejectAll().then(function () {
	        _this5.$rootScope.$broadcast('user:logout');
	        _this5.$log.debug('session cleared');
	      });
	    }
	
	    /**
	     * Get current logged user.
	     * @param {boolean} useCache Try to get user form cache
	     * @return {Promise} Promise of the current user
	     */
	
	  }, {
	    key: 'getCurrentUser',
	    value: function getCurrentUser() {
	      var _this6 = this;
	
	      var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var cacheKey = 'current_user';
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get current user form cache
	        return _promise2.default.resolve(inCache);
	      }
	      if (this._fetchingCurrentUser) {
	        this.$log.debug('Already fetching current user. Waiting current resolution.');
	        return this._fetchingCurrentUser;
	      }
	
	      this._fetchingCurrentUser = this.get('/users/current').then(function (res) {
	        _this6.putInCache(cacheKey, res.data);
	        _this6.$log.info('Fetched current user', res.data);
	        _this6._fetchingCurrentUser = null;
	        return _promise2.default.resolve(res.data);
	      });
	      return this._fetchingCurrentUser;
	    }
	  }, {
	    key: 'setCurrentUserCountryOfResidence',
	    value: function setCurrentUserCountryOfResidence(country) {
	      var user = JSON.parse(this.$window.sessionStorage.getItem('user'));
	      user.customer.countryOfResidence = country;
	      this.$window.sessionStorage.setItem('user', (0, _stringify2.default)(user));
	      return user;
	    }
	  }, {
	    key: 'getCurrentCompany',
	    value: function getCurrentCompany() {
	      var user = this.$window.sessionStorage.user;
	
	      return JSON.parse(user).company;
	    }
	  }, {
	    key: 'setCurrentCompany',
	    value: function setCurrentCompany(company) {
	      var user = JSON.parse(this.$window.sessionStorage.getItem('user'));
	      user.company = company;
	      this.$window.sessionStorage.setItem('user', (0, _stringify2.default)(user));
	    }
	  }, {
	    key: 'getPspType',
	    value: function getPspType() {
	      var user = this.$window.sessionStorage.user;
	
	      return JSON.parse(user).pspType;
	    }
	  }, {
	    key: 'getCountryOfResidence',
	    value: function getCountryOfResidence() {
	      var user = this.$window.sessionStorage.user;
	
	      return JSON.parse(user).customer.countryOfResidence;
	    }
	
	    /**
	     * Get current token from the session storage
	     * @return {Object} token
	     */
	
	  }, {
	    key: 'getCurrentToken',
	    value: function getCurrentToken() {
	      var token = this.$window.sessionStorage.token;
	
	      return token ? JSON.parse(token) : null;
	    }
	  }, {
	    key: 'getCaptchaNeeded',
	    value: function getCaptchaNeeded() {
	      return this.$window.sessionStorage.captchaNeeded === 'true';
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(email) {
	      // TODO check usage and API
	      return this.post('/public/users/password', email, {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(oldPassword, newPassword) {
	      return this.put('/users/current/password/update', { oldPassword: oldPassword, newPassword: newPassword }).then(function (res) {
	        return _promise2.default.resolve(res);
	      });
	    }
	  }, {
	    key: 'putCountryOfResidence',
	    value: function putCountryOfResidence(newCountry) {
	      return this.put('/users/current/country', null, {
	        params: {
	          'country': newCountry
	        }
	      }).then(function (res) {
	        _promise2.default.resolve(res);
	      });
	    }
	
	    /**
	     * Update current logged user.
	     * @param {Object} payload Update payload
	     * @return {Promise} Promise of the updated user
	     */
	
	  }, {
	    key: 'update',
	    value: function update(payload) {
	      var _this7 = this;
	
	      return this.getCurrentUser().then(function (user) {
	        var update = (0, _assign2.default)({}, user, payload);
	        _this7.$log.info('Updating user:', update);
	        return _this7.put('/users/current', update);
	      })
	      // TODO Update user endpoint should return the updated user
	      .then(function () {
	        return _this7.getCurrentUser(false);
	      });
	    }
	  }, {
	    key: 'resetPasswordConfirmation',
	    value: function resetPasswordConfirmation(email, token) {
	      // TODO check usage and API
	      return this.post('/public/users/password/confirm', { email: email, token: token }, {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      });
	    }
	
	    /**
	     * Get cards of the current user.
	     * @return {Promise} wallet of the current user
	     */
	
	  }, {
	    key: 'getWallet',
	    value: function getWallet() {
	      return this.get('/users/current/wallet').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Remove a card form the current user wallet.
	     * @param {String} id Card ID
	     * @param {String} psptype PSP type
	     * @return {Promise} the deletion result
	     */
	
	  }, {
	    key: 'removeCardFromWallet',
	    value: function removeCardFromWallet(id, psptype) {
	      var _this8 = this;
	
	      return this.delete('/users/current/wallet/cards/' + id, {
	        params: { psptype: psptype }
	      })
	      // TODO Remove card from wallet endpoint should return the updated wallet
	      .then(function () {
	        return _this8.getWallet();
	      });
	    }
	  }, {
	    key: 'countryConcernedByWithdrawalRights',
	    value: function countryConcernedByWithdrawalRights(country) {
	      // TODO check usage and API
	      return this.get('/countries/' + country + '/withdrawal').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'isEuropeanUnionCountry',
	    value: function isEuropeanUnionCountry(country) {
	      // TODO check usage and API
	      return this.get('/countries/' + country + '/europe').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Calls rejectAll method of the buffer factory and the logout method
	     * @param {Object} the optional error
	     */
	
	  }, {
	    key: 'resetBufferAndLogout',
	    value: function resetBufferAndLogout(err) {
	      var _this9 = this;
	
	      return this.BufferFactory.rejectAll(err).then(function () {
	        return _this9.logout().then(function () {
	          return _this9.redirectWhenTokenExpired();
	        }, function () {
	          return _this9.redirectWhenTokenExpired();
	        });
	      });
	    }
	  }, {
	    key: 'redirectWhenTokenExpired',
	    value: function redirectWhenTokenExpired() {
	      this.$log.error('Session expired! Redirecting depending on type...');
	      if (this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.ONE || this.type === this.StoreTypes.MYRENAULT) {
	        this.$window.top.location.href = this.myRenaultErrorUrl + this.myRenaultErrorCodes.SESSION_TIMEOUT;
	        return _promise2.default.reject();
	      } else if (this.type === this.StoreTypes.RSITE) {
	        var REDIRECT_RSITE = 'redirectRsite';
	        this.$window.localStorage[REDIRECT_RSITE] = 'true';
	        this.$window.top.location.href = this.shopUrl;
	        return _promise2.default.reject();
	      } else {
	        return this.$state.go('authentication');
	      }
	    }
	  }, {
	    key: 'isPasswordExpired',
	    value: function isPasswordExpired(lastPasswordUpdate, passwordExpirationDay) {
	      if (lastPasswordUpdate == null) {
	        return true;
	      }
	      var currTime = Date.now();
	      var passwordUpdateTime = Date.parse(lastPasswordUpdate);
	      var dayDiff = parseInt((currTime - passwordUpdateTime) / (24 * 3600 * 1000));
	      return dayDiff >= passwordExpirationDay;
	    }
	  }, {
	    key: 'checkPassword',
	    value: function checkPassword(password) {
	      if (password && password.length >= 8 && password.length <= 32) {
	        return this.get('/public/password/validate', {
	          params: { password: password }
	        }).then(function (res) {
	          return res.data === 'true' ? _promise2.default.resolve(true) : _promise2.default.reject(false);
	        });
	      }
	      return _promise2.default.resolve(true);
	    }
	  }]);
	  return UserService;
	}(_api2.default);
	
	exports.default = UserService;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _hiBase = __webpack_require__(1256);
	
	var _hiBase2 = _interopRequireDefault(_hiBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleService = function (_ApiService) {
	  VehicleService.$inject = ["$log", "$http", "$window", "$rootScope", "Localization", "I18n", "$state", "$sce"];
	  (0, _inherits3.default)(VehicleService, _ApiService);
	
	  function VehicleService($log, $http, $window, $rootScope, Localization, I18n, $state, $sce) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VehicleService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VehicleService.__proto__ || (0, _getPrototypeOf2.default)(VehicleService)).call(this, $log, $http, $window, $rootScope, Localization, I18n));
	
	    _this.$sce = $sce;
	
	    $rootScope.$on('user:logout', function (event, data) {
	      _this._fetchingCurrentUserVehicles = null;
	      _this._synchronizeCurrentUserVehicles = null;
	    });
	    return _this;
	  }
	
	  /**
	   * Synchronize Store / CSDB vehicles
	   * @return {Promise} Promise of the current user vehicles
	   */
	
	
	  (0, _createClass3.default)(VehicleService, [{
	    key: 'synchronizeCurrentUserVehicles',
	    value: function synchronizeCurrentUserVehicles() {
	      var _this2 = this;
	
	      if (this._synchronizeCurrentUserVehicles) {
	        this.$log.debug('Already synchronizing current user vehicles. Waiting current resolution.');
	        return this._synchronizeCurrentUserVehicles;
	      }
	      this._synchronizeCurrentUserVehicles = this.put('/users/current/vehicles/csdb/synchronize').then(function (res) {
	        _this2._synchronizeCurrentUserVehicles = null;
	        _this2.$log.info('Synchronized current user vehicles', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	      return this._synchronizeCurrentUserVehicles;
	    }
	
	    /**
	     * Get vehicles of the current user.
	     * @param {boolean} useCache Try to get vehicles form cache
	     * @return {Promise} Promise of the current user vehicles
	     */
	
	  }, {
	    key: 'getCurrentUserVehicles',
	    value: function getCurrentUserVehicles() {
	      var _this3 = this;
	
	      var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var cacheKey = 'current_vehicles';
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get current vehicles form cache
	        return _promise2.default.resolve(inCache);
	      }
	      if (this._fetchingCurrentUserVehicles) {
	        this.$log.debug('Already fetching current user vehicles. Waiting current resolution.');
	        return this._fetchingCurrentUserVehicles;
	      }
	      this._fetchingCurrentUserVehicles = this.get('/users/current/vehicles').then(function (res) {
	        _this3.putInCache(cacheKey, res.data);
	        _this3._fetchingCurrentUserVehicles = null;
	        _this3.$log.info('Fetched current user vehicles', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	      return this._fetchingCurrentUserVehicles;
	    }
	
	    /**
	     * Get current user selected vehicle.
	     * @param {boolean} useCache Try to get vehicles form cache
	     * @return {Promise} Promise of the current user vehicles
	     */
	
	  }, {
	    key: 'getCurrentSelectedVehicle',
	    value: function getCurrentSelectedVehicle() {
	      var _this4 = this;
	
	      var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      return this.getCurrentUserVehicles(useCache).then(function (vehicles) {
	        if (vehicles.length === 0) {
	          return _promise2.default.resolve(null);
	        }
	        var vin = _this4.$window.sessionStorage.vin;
	
	        var vehicle = vin ? vehicles.find(function (v) {
	          return v.vin === vin;
	        }) : vehicles[0];
	        if (!vehicle) {
	          vehicle = vehicles[0];
	          _this4.$log.info('Switch to vehicle:', vehicle);
	          _this4.$window.sessionStorage.vin = vin;
	        }
	        _this4.$log.info('Fetched current user selected vehicle', vehicle);
	        return _promise2.default.resolve(vehicle);
	      });
	    }
	
	    /**
	     * Set the current selected vehicle.
	     * @param {string} vin VIN to select
	     * @param {boolean} useCache Try to get vehicles form cache
	     * @return {Promise} Promise of the current selected vehicle
	     */
	
	  }, {
	    key: 'setCurrentSelectedVehicle',
	    value: function setCurrentSelectedVehicle(vin) {
	      var _this5 = this;
	
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      return this.getCurrentUserVehicles(useCache).then(function (vehicles) {
	        if (vehicles.length === 0) {
	          return _promise2.default.reject();
	        }
	        var vehicle = vin ? vehicles.find(function (v) {
	          return v.vin === vin;
	        }) : vehicles[0];
	        if (vehicle) {
	          _this5.$log.info('Switch to vehicle:', vehicle);
	          _this5.$window.sessionStorage.vin = vin;
	          return _promise2.default.resolve(vehicle);
	        } else {
	          _this5.$log.error('Unable to switch to vehicle:', vin);
	          return _promise2.default.reject();
	        }
	      });
	    }
	  }, {
	    key: 'getCurrentVin',
	    value: function getCurrentVin() {
	      var vin = this.$window.sessionStorage.vin;
	      return vin;
	    }
	
	    /**
	     * Get vehicle details.
	     * @param {string} vin VIN
	     * @return {Promise} Promise of the vehicle details
	     */
	
	  }, {
	    key: 'getVehicleDetails',
	    value: function getVehicleDetails(vin) {
	      var _this6 = this;
	
	      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var cacheKey = 'v' + vin;
	      var inCache = this.getFromCache(cacheKey);
	      if (useCache && inCache) {
	        // Get vehicle details form cache
	        return _promise2.default.resolve(inCache);
	      }
	      return this.get('/vehicles/' + vin).then(function (res) {
	        _this6.putInCache(cacheKey, res.data);
	        _this6.$log.info('Fetched vehicle', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Add vehicle to the user garage.
	     * @param {Object} vehicle Vehicle payload
	     * @return {Promise} Promise of the vehicle details
	     */
	
	  }, {
	    key: 'addVehicle',
	    value: function addVehicle(vehicle) {
	      var _this7 = this;
	
	      return this.post('/users/current/vehicles', null, {
	        params: {
	          'vin': vehicle.vin,
	          'name': vehicle.friendlyName
	        }
	      }).then(function (res) {
	        _this7.$log.info('Vehicle added', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Edit vehicle of the user garage.
	     * @param {Object} vehicle Vehicle to edit
	     * @return {Promise} Promise of the vehicle details
	     */
	
	  }, {
	    key: 'editVehicle',
	    value: function editVehicle(vehicle) {
	      var _this8 = this;
	
	      this.$log.debug('Updating vehicle', vehicle);
	      return this.put('/vehicles/' + vehicle.vin, null, {
	        params: {
	          'name': vehicle.name
	        }
	      }).then(function (res) {
	        _this8.$log.info('Vehicle edited', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Remove vehicle from the user garage.
	     * @param {Object} vehicle Vehicle to edit
	     * @return {Promise} Promise of the vehicle details
	     */
	
	  }, {
	    key: 'deleteVehicle',
	    value: function deleteVehicle(vin) {
	      var _this9 = this;
	
	      return this.delete('/users/current/vehicles/' + vin).then(function (res) {
	        _this9.$log.info('Vehicle deleted', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'checkVin',
	    value: function checkVin(vin) {
	      return this.get('/public/vehicles/' + vin).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'getVehicles',
	    value: function getVehicles(email) {
	      return this.get('/users/' + email + '/vehicles').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Change GDC Activation Display.
	     * @param {Object} vehicle Vehicle to edit
	     * @return {Promise} Promise of the vehicle details
	     */
	
	  }, {
	    key: 'changeDisplayGdcActivation',
	    value: function changeDisplayGdcActivation(vin) {
	      var _this10 = this;
	
	      this.$log.debug('Updating vehicle', vin);
	      return this.get('/vehicles/' + vin + '/changeDisplayGdcActivation').then(function (res) {
	        _this10.$log.info('Display GDC activation changed', res.data);
	      });
	    }
	
	    /**
	     * Get message to alert new map to install
	     * @param {Object} vin VIN of the vehicle
	     * @return {Promise} Promise of the message
	     */
	
	  }, {
	    key: 'getMapAlertMessage',
	    value: function getMapAlertMessage(vin) {
	      return this.get('/vehicles/' + vin + '/getMapAlertMessage').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Mark alert message as read
	     * @param {string} vin VIN of the vehicle
	     * @param {string} idList list of read messages ID
	     * @return {Promise} Promise
	     */
	
	  }, {
	    key: 'markAlertMessageRead',
	    value: function markAlertMessageRead(vin, idList) {
	      return this.put('/vehicles/' + vin + '/markAlertMessageRead', null, {
	        params: {
	          'idList': idList
	        }
	      }).then(function () {
	        _promise2.default.resolve();
	      });
	    }
	
	    /**
	     * Get products on vehicle devices
	     * @param (string} vin - Identifier of vehicle to delete
	     * @return {Promise} devices
	     */
	
	  }, {
	    key: 'getProductsOnDevices',
	    value: function getProductsOnDevices(vin) {
	      var _this11 = this;
	
	      this.$log.debug('Get products on devices for vehicle', vin);
	      return this.get('/vehicles/' + vin + '/devices').then(function (res) {
	        _this11.$log.debug('Products on devices', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Synchronize vehicle device mounts
	     * @param  {string} vin           - Identifier of vehicle
	     * @param  {string} muid          - MUID of vehicle
	     * @param  {string} mountId       - Mount id to synchronize
	     * @param  {object} syncProducts  - Contains a List of Products to install and List of Products to delete
	     * @return {Promise}
	     */
	
	  }, {
	    key: 'synchronizeDeviceMount',
	    value: function synchronizeDeviceMount(vin, muid, mountId, syncProducts) {
	      var _this12 = this;
	
	      this.$log.debug('Synchronize products for params', vin, muid, mountId, syncProducts);
	      mountId = _hiBase2.default.encode(mountId);
	      return this.post('/vehicles/' + vin + '/devices/' + muid + '/mounts/' + mountId + '/synchronize', syncProducts).then(function (res) {
	        _this12.$log.debug('Device synchronized', res.data);
	        return _promise2.default.resolve();
	      });
	    }
	
	    /**
	     * Synchronize vehicle information and rights
	     * @param  {string} vin           - Identifier of vehicle
	     * @return {Promise}
	     */
	
	  }, {
	    key: 'synchronizeVehicleInfoAndRights',
	    value: function synchronizeVehicleInfoAndRights(vin) {
	      var _this13 = this;
	
	      this.$log.debug('Synchronize info and rights for vin', vin);
	      if (this._synchronizeCurrentUserVehicles) {
	        this.$log.debug('Already synchronizing current user vehicles. Waiting current resolution.');
	        return this._synchronizeCurrentUserVehicles;
	      } else {
	        return this.put('/vehicles/' + vin + '/synchronize').then(function (res) {
	          _this13.$log.debug('Vehicle info and rights synchronized', vin);
	          return _promise2.default.resolve();
	        });
	      }
	    }
	
	    /**
	     * Synchronize user's vehicles information and rights
	     * @return {Promise}
	     */
	
	  }, {
	    key: 'synchronizeVehiclesInfoAndRights',
	    value: function synchronizeVehiclesInfoAndRights() {
	      var _this14 = this;
	
	      this.$log.debug('Synchronize info and rights for all vehicles');
	      return this.put('/users/current/vehicles/synchronize').then(function (res) {
	        _this14.$log.debug('Vehicles info and rights synchronized');
	        return _promise2.default.resolve();
	      });
	    }
	  }]);
	  return VehicleService;
	}(_api2.default);
	
	exports.default = VehicleService;

/***/ }),
/* 1256 */,
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductService = function (_ApiService) {
	  (0, _inherits3.default)(ProductService, _ApiService);
	
	  function ProductService() {
	    (0, _classCallCheck3.default)(this, ProductService);
	    return (0, _possibleConstructorReturn3.default)(this, (ProductService.__proto__ || (0, _getPrototypeOf2.default)(ProductService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProductService, [{
	    key: 'consulteVoucherCode',
	    value: function consulteVoucherCode(voucherCode) {
	      return this.get('/voucher/validate', {
	        params: {
	          'voucherCode': voucherCode
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }, {
	    key: 'cancelVoucherCode',
	    value: function cancelVoucherCode(voucherCode) {
	      return this.put('/voucher/cancel', null, {
	        params: {
	          'voucherCode': voucherCode
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return ProductService;
	}(_api2.default);
	
	exports.default = ProductService;

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VoucherFactory = function VoucherFactory() {
	  // reduction: XX.XX% OR XX.XX OR FREE; priceProduct: 5.99 EUR
	  var getReductionPrice = function getReductionPrice(reduction, priceProduct) {
	    var priceWithReduction = '';
	    var currency = priceProduct.substring(priceProduct.indexOf(' '));
	    if (reduction.toLowerCase() === 'free') {
	      priceWithReduction = '0.00' + currency;
	    } else {
	      var newPrice = 0;
	      if (reduction.endsWith('%')) {
	        newPrice = parseFloat(priceProduct) * (1 - parseFloat(reduction) / 100);
	      } else {
	        newPrice = parseFloat(priceProduct) - parseFloat(reduction);
	      }
	      newPrice = Math.round(newPrice * 100) / 100;
	      if (newPrice <= 0) {
	        priceWithReduction = '0.00' + currency;
	      } else {
	        priceWithReduction = newPrice + currency;
	      }
	    }
	    return priceWithReduction;
	  };
	
	  var validateCountryVoucher = function validateCountryVoucher(countryCode, countryVoucher) {
	    return countryCode.toUpperCase() === countryVoucher;
	  };
	
	  var validateProductRefFromVoucher = function validateProductRefFromVoucher(productList, productRef) {
	    return productList.indexOf(parseInt(productRef)) !== -1;
	  };
	
	  return { getReductionPrice: getReductionPrice, validateCountryVoucher: validateCountryVoucher, validateProductRefFromVoucher: validateProductRefFromVoucher };
	};
	
	exports.default = VoucherFactory;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetricsService = function (_ApiService) {
	  (0, _inherits3.default)(MetricsService, _ApiService);
	
	  function MetricsService() {
	    (0, _classCallCheck3.default)(this, MetricsService);
	    return (0, _possibleConstructorReturn3.default)(this, (MetricsService.__proto__ || (0, _getPrototypeOf2.default)(MetricsService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MetricsService, [{
	    key: 'startPageLoadTime',
	
	
	    /**
	     * start page time
	     */
	    value: function startPageLoadTime() {
	      this.startDate = new Date();
	      this.$log.debug('Start date: ' + this.startDate);
	    }
	
	    /**
	     * end page time and send data
	     * @param status
	     */
	
	  }, {
	    key: 'endPageLoadTime',
	    value: function endPageLoadTime(status) {
	      var _this2 = this;
	
	      var endDate = new Date();
	      this.$log.debug('End date: ' + endDate);
	      if (this.startDate) {
	        var loginCompletedTime = endDate.getTime() - this.startDate.getTime();
	        this.$log.debug('loginCompletedTime: ' + loginCompletedTime);
	        return this.postLoginCompletedTime(loginCompletedTime, status).then(function () {
	          delete _this2.startDate;
	        });
	      } else {
	        this.$log.warn('Error in endPageLoadTime: start date undefined');
	        return _promise2.default.resolve();
	      }
	    }
	
	    /**
	     * Post Login completed time and status.
	     * @param time
	     * @param status
	     * @returns {*|any|Promise.<TResult>}
	     */
	
	  }, {
	    key: 'postLoginCompletedTime',
	    value: function postLoginCompletedTime(time, status) {
	      var _this3 = this;
	
	      this.$log.debug('Post Login completed time and status', time);
	      return this.post('/metrics/login/completed', { 'time': time, 'status': status }, {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function (res) {
	        _this3.$log.info('Post Login metrics completed', res.data);
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return MetricsService;
	}(_api2.default);
	
	exports.default = MetricsService;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SDFilterService = function (_ApiService) {
	  (0, _inherits3.default)(SDFilterService, _ApiService);
	
	  function SDFilterService() {
	    (0, _classCallCheck3.default)(this, SDFilterService);
	    return (0, _possibleConstructorReturn3.default)(this, (SDFilterService.__proto__ || (0, _getPrototypeOf2.default)(SDFilterService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SDFilterService, [{
	    key: 'changeUserSDFilterStatus',
	
	
	    /**
	     * POST status.
	     * @param status New status
	     * @returns {*|any|Promise.<TResult>}
	     */
	    value: function changeUserSDFilterStatus(status) {
	      var _this2 = this;
	
	      this.$log.debug('Edit User Global SD Filter preference');
	      var token = this.getCurrentToken();
	      if (token) {
	        return this.post('/sdfilter/user/status', null, {
	          params: {
	            'token': token.access_token,
	            'status': status
	          }
	        }).then(function (res) {
	          _this2.$log.info(' completed', res.data);
	          return _promise2.default.resolve(res.data);
	        }, function (err) {
	          return _promise2.default.reject(err);
	        });
	      }
	    }
	
	    /**
	     * POST mountId and status.
	     * @param mountId Name of the SD card
	     * @param status New status
	     * @returns {*|any|Promise.<TResult>}
	     */
	
	  }, {
	    key: 'changeSDDeviceFilterStatus',
	    value: function changeSDDeviceFilterStatus(mountId, status) {
	      var _this3 = this;
	
	      this.$log.debug('Edit User SD Filter preferences');
	      var token = this.getCurrentToken();
	      if (token) {
	        return this.post('/sdfilter/device/status', null, {
	          params: {
	            'token': token.access_token,
	            'mountId': mountId,
	            'status': status
	          }
	        }).then(function (res) {
	          _this3.$log.info('completed', res.data);
	          return _promise2.default.resolve(res.data);
	        }, function (err) {
	          return _promise2.default.reject(err);
	        });
	      }
	    }
	
	    /**
	     * GET SD filter for current user
	     * @returns {*}
	     */
	
	  }, {
	    key: 'getUserSDFilter',
	    value: function getUserSDFilter() {
	      this.$log.debug('Get User SD Filter preferences');
	      var token = this.getCurrentToken();
	      return this.get('/sdfilter/user', {
	        params: {
	          'token': token.access_token
	        }
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	
	    /**
	     * Get current token from the session storage
	     * @return {Object} token
	     */
	
	  }, {
	    key: 'getCurrentToken',
	    value: function getCurrentToken() {
	      var token = this.$window.sessionStorage.token;
	
	      return token ? JSON.parse(token) : null;
	    }
	  }]);
	  return SDFilterService;
	}(_api2.default);
	
	exports.default = SDFilterService;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1230);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1234);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1235);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(1243);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsService = function (_ApiService) {
	  (0, _inherits3.default)(DocumentsService, _ApiService);
	
	  function DocumentsService() {
	    (0, _classCallCheck3.default)(this, DocumentsService);
	    return (0, _possibleConstructorReturn3.default)(this, (DocumentsService.__proto__ || (0, _getPrototypeOf2.default)(DocumentsService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DocumentsService, [{
	    key: 'getUntreatedDocuments',
	
	
	    /**
	     * Get documents to treat
	     * @param {String} semail semail to verify
	     */
	    value: function getUntreatedDocuments() {
	      return this.get('/user/legalDocuments/consents').then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	    /**
	     * Send consents to document
	     * @param {String} semail semail to verify
	     * @param {Array<number>} documentIds documents IDs to consents
	     */
	
	  }, {
	    key: 'sendDocumentConsent',
	    value: function sendDocumentConsent(documentIds) {
	      return this.put('/user/legalDocuments/consents', documentIds).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      });
	    }
	  }]);
	  return DocumentsService;
	}(_api2.default);
	
	exports.default = DocumentsService;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COOKIES_CONSENT = 'cookiesConsent';
	
	var CookiesService = function () {
	  CookiesService.$inject = ["Localization", "StoreTypes"];
	  function CookiesService(Localization, StoreTypes) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CookiesService);
	    this.requestEdit = false;
	    this.noConsent = Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE;
	  }
	
	  (0, _createClass3.default)(CookiesService, [{
	    key: 'consentForCookie',
	    value: function consentForCookie(cookieName) {
	      if (this.noConsent) {
	        return false;
	      }
	      var consentValue = this.consent;
	      if (consentValue) {
	        var consentValueForName = consentValue[cookieName];
	        if (consentValueForName) {
	          return consentValueForName;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'consent',
	    get: function get() {
	      try {
	        if (window.localStorage) {
	          if (window.localStorage[COOKIES_CONSENT]) {
	            var parsed = JSON.parse(window.localStorage[COOKIES_CONSENT]);
	            if (typeof parsed === 'boolean') return false; // old consent system
	            if (parsed.lastUpdate) {
	              var today = new Date();
	              today.setMonth(today.getMonth() - 6);
	              if (Date.parse(parsed.lastUpdate) > today) {
	                // not expired
	                return parsed.value;
	              }
	            }
	          }
	        }
	        return false;
	      } catch (e) {
	        return this.cookiesConsent;
	      }
	    },
	    set: function set(value) {
	      try {
	        if (window.localStorage) {
	          window.localStorage[COOKIES_CONSENT] = (0, _stringify2.default)({ 'value': value, 'lastUpdate': new Date() });
	        }
	      } catch (e) {
	        console.log('the quota is insufficient');
	        // on force la fermeture des cookies sans les stocker
	        this.cookiesConsent = value;
	      }
	    }
	  }]);
	  return CookiesService;
	}();
	
	exports.default = CookiesService;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(1264);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(1265);
	
	var _app4 = _interopRequireDefault(_app3);
	
	__webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var component = {
	  restrict: 'E',
	  template: _app2.default,
	  controller: _app4.default
	};
	
	exports.default = component;

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app {{$ctrl.type}}\">\n  <app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n  <!-- link added for Helios iframe integration -->\n  <a ng-if=\"$ctrl.isIframe\" href=\"#\" data-scrolltop-iframe></a>\n  <app-header ng-if=\"$ctrl.showHeader\"></app-header>\n  <document-consent ng-if=\"$ctrl.showDocumentConsent\"></document-consent>\n  <main id=\"container\" ui-view></main>\n  <app-footer ng-if=\"$ctrl.showFooter\"></app-footer>\n  <cookies-consent ng-if=\"$ctrl.showCookiesConsent\"></cookies-consent>\n</div>\n"

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(565);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCUMENT_CONSENT = 'documentConsent';
	
	var AppController = function () {
	  AppController.$inject = ["Localization", "StoreTypes", "CookiesService", "$scope", "$window", "$rootScope"];
	  function AppController(Localization, StoreTypes, CookiesService, $scope, $window, $rootScope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AppController);
	    this.type = Localization.getLocalizedAppConfig().type;
	    this.StoreTypes = StoreTypes;
	    this.$window = $window;
	
	    $rootScope.$on('cookieConsentUpdated', function () {
	      _this.updateCaptchaConsent(CookiesService.consentForCookie('captcha'));
	    });
	
	    $scope.$on('globalSpinner:on', function (event, data) {
	      _this.isProcessing = true;
	    });
	
	    $scope.$on('globalSpinner:off', function (event, data) {
	      _this.isProcessing = false;
	    });
	
	    $scope.$on('checkDocumentConsent:on', function (event, data) {
	      try {
	        if (_this.$window.localStorage) {
	          _this.$window.localStorage[DOCUMENT_CONSENT] = true;
	        }
	      } catch (e) {
	        console.error('Error when processing document consent activation');
	      }
	    });
	
	    $scope.$on('checkDocumentConsent:off', function (event, data) {
	      try {
	        if (_this.$window.localStorage) {
	          _this.$window.localStorage[DOCUMENT_CONSENT] = false;
	        }
	      } catch (e) {
	        console.error('Error when processing document consent activation');
	      }
	    });
	  }
	
	  (0, _createClass3.default)(AppController, [{
	    key: 'updateCaptchaConsent',
	    value: function updateCaptchaConsent(consentValue) {
	      var _this2 = this;
	
	      var scriptElement = document.getElementById('captchaScript');
	      if (!scriptElement && consentValue) {
	        // <script src="https://cdn.polyfill.io/v2/polyfill.js"></script>
	        var loadRecaptcha = function loadRecaptcha() {
	          return _this2.loadScript('https://www.google.com/recaptcha/api.js?onload=vcRecaptchaApiLoaded&render=explicit', function (el) {
	            el.async = true;
	            el.defer = true;
	            el.id = 'polyfill';
	          }).then(function () {
	            console.log('Scripts loaded');
	          });
	        };
	
	        if (!document.getElementById('polyfill')) {
	          this.loadScript('https://cdn.polyfill.io/v2/polyfill.js', function (el) {
	            el.id = 'polyfill';
	          }).then(function () {
	            return loadRecaptcha();
	          });
	        } else {
	          loadRecaptcha();
	        }
	      } else if (!consentValue && scriptElement) {
	        scriptElement.parentElement.removeChild(scriptElement);
	      }
	    }
	  }, {
	    key: 'loadScript',
	    value: function loadScript(url) {
	      var editor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (el) {};
	
	      return new _promise2.default(function (resolve, reject) {
	        var script = document.createElement('script');
	        script.src = url;
	        editor(script);
	        script.onload = resolve;
	        script.onerror = function (e) {
	          return reject(Error(url + ' failed to load'));
	        };
	        document.head.appendChild(script);
	      });
	    }
	  }, {
	    key: 'isIframe',
	    get: function get() {
	      return this.type === this.StoreTypes.HELIOS || this.type === this.StoreTypes.MYRENAULT || this.type === this.StoreTypes.RSITE || this.type === this.StoreTypes.ONE;
	    }
	  }, {
	    key: 'showHeader',
	    get: function get() {
	      return this.type === this.StoreTypes.STANDALONE || this.type === this.StoreTypes.RSITE;
	    }
	  }, {
	    key: 'showFooter',
	    get: function get() {
	      return this.type === this.StoreTypes.STANDALONE;
	    }
	  }, {
	    key: 'showCookiesConsent',
	    get: function get() {
	      return this.type === this.StoreTypes.STANDALONE;
	    }
	  }, {
	    key: 'showDocumentConsent',
	    get: function get() {
	      return this.$window.localStorage && this.$window.localStorage[DOCUMENT_CONSENT] === 'true';
	    }
	  }]);
	  return AppController;
	}();
	
	exports.default = AppController;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1267);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(336)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(335)();
	// imports
	
	
	// module
	exports.push([module.id, ".app{background-color:$lightBgColor}.helios app-footer,.helios app-header .skiplinks,.helios app-header .topHeader,.helios navbar,.myrenault app-footer,.myrenault app-header .skiplinks,.myrenault app-header .topHeader,.myrenault navbar,.one app-footer,.one app-header .skiplinks,.one app-header .topHeader,.one navbar,.rsite app-footer,.rsite app-header .skiplinks,.rsite app-header .topHeader,.rsite app-header header .logo img,.rsite app-header header h1.txtTruncated,.rsite navbar{display:none}@media (min-width:1200px){.rsite app-header header ul.cars{top:2.2em}}.helios app-header,.myrenault app-header,.one app-header{display:none}.myCar{overflow:initial}.uppercase{text-transform:uppercase}.selectBloc.errorField,.selectBloc.errorField:before{border-color:#bd3632;background-color:#ebeae8;color:#bd3632}.checkBox.errorField{color:#bd3632}.checkBox.errorField+.errorMessage,.selectBloc.errorField+.errorMessage{display:block}.form-field{position:relative;margin-bottom:3em}.form-field input.ng-invalid.ng-touched,.form-field input:invalid.ng-touched{border-color:#bd3632;background-color:#ebeae8;color:#bd3632}.field-errors p{color:#bd3632;font-size:.8em;margin-top:.5em;text-align:left}.field-errors p:before{display:inline-block;vertical-align:sub;font-size:1.3em;margin-right:.3em;content:\"\\E602\";font-family:icon-Renault-Global}form.ng-submitted .form-field input.ng-invalid,form.ng-submitted .form-field input:invalid{border-color:#bd3632;background-color:#ebeae8;color:#bd3632}.stepBar+.bottomButtonBar a.button.left:after{right:auto}.carousel .autoresize{width:100%;height:100%;background-size:cover;background-position:50%;background-repeat:no-repeat}.carousel .indicators{text-align:center}.carousel .indicators span{font-size:1.5em;padding:.1em;color:#cdcdcd;display:inline-block}.carousel .indicators span.active{color:#fc3}.arabDirectionFloat{direction:rtl;float:right!important;text-align:right}.stepBar li.finishAr a:after{margin-right:.8em}.arabDirectionDescLeft{direction:rtl;text-align:left!important}.arabDirectionDesc{text-align:right!important;direction:rtl}.arabDirection{direction:rtl}.arabDirectionTooltip{left:-2em;direction:rtl;right:auto}input-tooltip.arabDirectionTooltip tooltip{left:-.35em!important}input-tooltip.arabDirectionTooltip tooltip .tooltipMessage:before{right:100%!important;margin-right:-30px!important}.arabCookiesConsent,.arabDocumentConsent,input-tooltip.arabDirectionTooltip tooltip .tooltipMessage button{right:auto!important;left:0!important}@media (max-width:600px){.arabDirectionTooltip{text-align:right}}", ""]);
	
	// exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(660);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (domain) {
	  document.addEventListener('DOMContentLoaded', function () {
	    var bodyH = 0;
	
	    var listener = function listener(event) {
	      if (event && event.data === 'need_height' || !event) {
	        var message = {
	          type: 'resize',
	          height: document.body.offsetHeight + 50
	        };
	        window.parent.postMessage((0, _stringify2.default)(message), domain);
	      }
	    };
	
	    var scrollTopIframe = function scrollTopIframe(event) {
	      var message = {
	        type: 'scrolltopiframe'
	      };
	      window.parent.postMessage((0, _stringify2.default)(message), domain);
	    };
	
	    var checkForNewHeight = function checkForNewHeight() {
	      var newBodyH = document.body.offsetHeight;
	      if (bodyH !== newBodyH) {
	        bodyH = newBodyH;
	        listener();
	      }
	    };
	
	    if (window.addEventListener) {
	      window.addEventListener('message', listener, false);
	    } else {
	      window.attachEvent('onmessage', listener);
	    }
	
	    document.querySelectorAll('[data-scrolltop-iframe]').forEach(function (element) {
	      element.addEventListener('click', scrollTopIframe);
	    });
	
	    setInterval(checkForNewHeight, 250);
	  });
	};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(564);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _angular = __webpack_require__(473);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(475);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _app = __webpack_require__(558);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _footer = __webpack_require__(620);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _header = __webpack_require__(628);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _buffer = __webpack_require__(1244);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _i18n = __webpack_require__(644);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _localization = __webpack_require__(662);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _maintenance = __webpack_require__(887);
	
	var _maintenance2 = _interopRequireDefault(_maintenance);
	
	var _storeTypes = __webpack_require__(733);
	
	var _storeTypes2 = _interopRequireDefault(_storeTypes);
	
	var _app3 = __webpack_require__(1263);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _cookies = __webpack_require__(1262);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserServiceMock = function UserServiceMock() {
	  (0, _classCallCheck3.default)(this, UserServiceMock);
	
	  this.getCurrentToken = function () {};
	};
	
	var VehicleServiceMock = function VehicleServiceMock() {
	  (0, _classCallCheck3.default)(this, VehicleServiceMock);
	};
	
	_angular2.default.module('maintenance', [_angularUiRouter2.default, _app2.default, _footer2.default, _header2.default, _i18n2.default, _localization2.default, _maintenance2.default, _storeTypes2.default]).config(["$locationProvider", "$qProvider", "$urlRouterProvider", function ($locationProvider, $qProvider, $urlRouterProvider) {
	  'ngInject';
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	  $qProvider.errorOnUnhandledRejections(false);
	  $urlRouterProvider.otherwise('maintenance');
	}]).run(["$log", "Localization", "StoreTypes", "$location", function ($log, Localization, StoreTypes, $location) {
	  'ngInject';
	
	  if (Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE) {
	    $log.info('R-LINK Store embedded in an iframe...');
	    __webpack_require__(1268)(Localization.getLocalizedAppConfig().rootUrl);
	  }
	}]).component('appMaintenance', _app4.default).factory('BufferFactory', _buffer2.default).service('CookiesService', _cookies2.default).service('UserService', UserServiceMock).service('VehicleService', VehicleServiceMock);

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js